(function ()
{
    'use strict';

    angular
        .module('app.users.admin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.users_admin', {
            url    : '/admin_users',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/modules/users/admin/users_admin.html',
                    controller : 'UsersAdminController as vm'
                }
            },
            requiresAuthentication: true,
            resolve: {
                Users: function (apiResolver)
                {
                	return apiResolver.resolve('admin.user.getUsers@get');
                },
                UserProfiles: function (apiResolver)
                {
                	return apiResolver.resolve('admin.user.getUserProfiles@get');
                },
                AsistentesTecnicos: function (apiResolver)
                {
                	return apiResolver.resolve('custom_general.getAsistentesTecnicos@get');
                },
                Sociedades: function (apiResolver)
                {
                	return apiResolver.resolve('hacienda.getSociedades@get');
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.users.admin')
        .controller('UsersDialogController', UsersDialogController);

    /** @ngInject */
    function UsersDialogController($mdDialog, UsersAdminService, User, Users, UserProfiles, AsistentesTecnicos, UsersService, FileUploader, api)
    {
        var vm = this;

        // Data
        vm.title = 'Editar Usuario';
        vm.user = angular.copy(User);
        vm.users = Users;
        vm.asistentes_tecnicos = AsistentesTecnicos;    
        vm.user_profiles = UserProfiles;    
        vm.newUser = false;
        
        if ( !vm.user )
        {
            vm.contact = {
                'name'    : '',
                'cargo'  : '',
                'area': '',
                'email' : '',
                'telefono': '',
            };

            vm.title = 'Nuevo Usuario';
            vm.newUser = true;
        } else {
			//File Uploader        
	        vm.uploaderProfileImage = new FileUploader( {
	        											url: api.utils.uploadFile + "User/" + vm.user.ModuleUser.id + "/profile_pic.json",
														headers: {
													        "X-Auth-Token": UsersService.getCredentials()
													    }
	        										
	        										});        	
        }

        // Methods
        vm.addNewUser = addNewUser;
        vm.deleteUserConfirm = deleteUserConfirm;
        vm.closeDialog = closeDialog;
        vm.saveUser = saveUser;
        vm.showField = showField;

        //////////

        /**
         * Add new contact
         */
        function addNewUser()
        {
        	
			UsersAdminService.newUser(vm.user.ModuleUser).then(function(response) {

				if(response.data) {
					vm.users.push( response.data );
				}
	
			}).catch(function(err) {
				// TODO
			});

            closeDialog();
        }

        /**
         * Save contact
         */
        function saveUser()
        {        	
			UsersAdminService.editUser(vm.user.ModuleUser.id, vm.user.ModuleUser).then(function(response) {

				if(response.data) {
		        	User.ModuleUser.name = response.data.ModuleUser.name;
		        	User.ModuleUser.email = response.data.ModuleUser.email;
		        	User.ModuleUser.telefono = response.data.ModuleUser.telefono;
		        	User.ModuleUser.celular = response.data.ModuleUser.celular;
		        	User.ModuleUser.cstm_nit = response.data.ModuleUser.cstm_nit;
		        	User.ModuleUser.codigo_sap = response.data.ModuleUser.codigo_sap;
		        	User.ModuleUser.asistente_tecnico_id = response.data.ModuleUser.asistente_tecnico_id;
		        	User.AsistenteTecnico.name = response.data.AsistenteTecnico.name;
		        	
		        	vm.uploaderProfileImage.uploadAll();		        	
				}
	
			}).catch(function(err) {
				// TODO
			});

            closeDialog();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteUserConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Esta seguro de eliminar el usuario?')
                .htmlContent('<b>' + vm.user.ModuleUser.name + '</b>')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
            	//Delete contact
				UsersAdminService.deleteUser(vm.user.ModuleUser.id).then(function(response) {
	
					if(response.status) {
						
						vm.users.splice(vm.users.indexOf(User), 1);
					}
		
				}).catch(function(err) {
					// TODO
				});
                

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        
        function showField() {
        	return true;
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.users.admin')
        .controller('SociedadDialogController', SociedadDialogController);

    /** @ngInject */
    function SociedadDialogController($mdDialog, $filter, UsersAdminService, User, Sociedades)
    {
        var vm = this;

        // Data
        vm.title = 'Asignar Sociedades';
        
        vm.user = angular.copy(User);
        vm.Sociedades = Sociedades;
        vm.selected = [];
        
        angular.forEach(User.SociedadsUser, function(e) {
        	var itemSociedadArr = $filter('filter')(vm.Sociedades, {'COD_SAP':e.cod_sap});
        	if(typeof itemSociedadArr[0] !== "undefined") {
        		vm.selected.push( itemSociedadArr[0] );
        	}
        });

        // Methods
        vm.asignarSociedades = asignarSociedades;
        vm.exists = exists;
        vm.closeDialog = closeDialog;
        vm.toggle = toggle;
        

        //////////

  		function exists(item) {
  			//return $filter('filter')(vm.selected, {'COD_SAP':item.COD_SAP}) ? true : false;
			return vm.selected.indexOf(item) > -1;
		}

        /**
         * Add new contact
         */
        function asignarSociedades()
        {
        	
        	var sociedades = [];
        	
        	angular.forEach(vm.selected, function (e) {
        		sociedades.push( e.COD_SAP);
        	});
			UsersAdminService.asignarSociedades(vm.user.ModuleUser.id, sociedades).then(function(response) {
				
				User.SociedadsUser = response.user_info.SociedadsUser;
/*
				if(response.data) {
					vm.users.push( response.data );
				}
*/				
	
			}).catch(function(err) {
				// TODO
			});

            closeDialog();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

		function toggle(item) {
			var idx = vm.selected.indexOf(item);
    		if (idx > -1) {
      			vm.selected.splice(idx, 1);
    		} else {
      			vm.selected.push(item);
			}
		}        

    }
})();
(function() {
  'use strict';

  angular.module('app.hr-evaluation', [])
  .config(config);
  
    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.hr_evaluation', {
            url  : '/evaluate/:employee_process_id/:process_stage_id',
            views: {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/employee_main.html',
                    controller : 'MainController as vm'
                },                
                'toolbar@app.hr_evaluation': {
                    templateUrl: 'app/toolbar/layouts/employee/default.html',
                    controller : 'ToolbarControllerEmployee as vm'
                },
                'content@app.hr_evaluation': {
                    templateUrl: 'app/main/modules/hr-evaluation/hr-evaluation.html',
                    controller : 'HrEvaluationController as vm'
                }
            },
            requiresAuthentication: true
        });
        
    }


})();
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('EvaluationCoreValueSingleDialogController', EvaluationCoreValueSingleDialogController);

    /** @ngInject */
    function EvaluationCoreValueSingleDialogController($mdDialog, HrCoreValueService, Descriptors, Data, UserProfile, Skill, Preferences, EvaluationCurrentProcess, ModuleData, Evaluator) {

        var vm = this;

        vm.closeDialog = closeDialog;
        vm.saveEvaluation = saveEvaluation;
        vm.config = {
            showColaborador: false,
            onlyview: false
        }


        vm.formData = {};


        function closeDialog() {
            $mdDialog.hide();
        }

        function saveEvaluation() {

            var data = serializeData();

            HrCoreValueService.saveEvaluation(data).then(function (response) {
                setEvaluation(response);
                closeDialog();
            }, function (error) {
            });

        }

        function setEvaluation(response) {
            var index = null;
            for (var i in ModuleData.core_value_evaluations) {
                if (ModuleData.core_value_evaluations[i].core_value.id == vm.skill.core_value_id && Evaluator.evaluator.id == ModuleData.core_value_evaluations[i].core_value_evaluator.evaluator.id) {
                    index = i;
                    break;
                }
            }
            if (index == null) {
                ModuleData.core_value_evaluations.push(response);
            } else {
                ModuleData.core_value_evaluations[index] = response;
            }
            Skill.result = response.result;
            Skill.estado = true;
        }

        function serializeData() {
            var data = {};
            data.evaluation_current_process_id = vm.evaluation_current_process_id.id;
            data.finalize = false;
            data.data = {
                core_value_id: vm.skill.core_value_id,
                positive_comment: vm.positive_comment,
                negative_comment: vm.negative_comment,
                descriptors_result: vm.formData
            }; 0

            return data;
        }

        function serializeDataForm() {
            vm.titleTable = serializeTitleTable(vm.preferences);
            vm.bodyTable = seriaalizeBodyTable(vm.titleTable, vm.descriptors);
            setRequiredTextArea(vm.preferences.fields);
            serializeFormData();
        }

        function setRequiredTextArea(fields) {
            var role = Evaluator.role;
            vm.validation = {};
            for (var i in fields) {
                vm.validation[i] = {};
                if (fields[i].required_for && fields[i].required_for.indexOf(role) !== -1) {
                    vm.validation[i].required = true;
                }else{
                    vm.validation[i].required = false;
                }
            }
        }

        function serializeFormData() {
            if (!vm.data) {
                return;
            }
            vm.formData = vm.data.descriptors_result;
            vm.negative_comment = vm.data.negative_comment;
            vm.positive_comment = vm.data.positive_comment;
        }

        function serializeTitleTable(preferences) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });
            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }
        function seriaalizeBodyTable(header, descriptors) {
            var body = [];
            for (var d in descriptors) {
                var objReturn = {};
                objReturn.id = descriptors[d].id;
                objReturn.name = descriptors[d].name;
                objReturn.order = descriptors[d].row_order;
                objReturn.values = angular.copy(header);
                body.push(objReturn);
            }
            return body;
        }


        function init() {
            vm.skill = angular.copy(Skill);
            vm.descriptors = angular.copy(Descriptors);
            vm.data = angular.copy(Data);
            vm.preferences = angular.copy(Preferences);
            vm.userProfile = UserProfile;
            vm.evaluation_current_process_id = angular.copy(EvaluationCurrentProcess);
            serializeDataForm();

        }

        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('EvaluationCoreValueChiefDialogController', EvaluationCoreValueChiefDialogController);

    /** @ngInject */
    function EvaluationCoreValueChiefDialogController($mdDialog, HrCoreValueService, Descriptors, Data, UserProfile, Skill, Preferences, EvaluationCurrentProcess, ModuleData) {

        var vm = this;

        vm.closeDialog = closeDialog;
        
        vm.formData = {
            dataBody : []
        };
        vm.config = {
            onlyview: true
        }


        function closeDialog() {
            $mdDialog.hide();
        }

        function serializeDataForm() {
            vm.titleTable = serializeTitleTable(vm.preferences);
            vm.titleObj = HrCoreValueService.serializeTitleObj(vm.preferences);
            vm.titleColor = HrCoreValueService.setTitleColor(vm.preferences);
            vm.bodyTable = seriaalizeBodyTable(vm.titleTable, vm.descriptors);
            for(var d in vm.data){
                vm.formData.dataBody.push(serializeFormData(vm.data[d]));
            }
        }

        function serializeFormData(data) {

            return {
                skills_evaluator: data.core_value_evaluator,
                descriptors_result:data.descriptors_result,
                negative_comment: data.negative_comment,
                positive_comment: data.positive_comment
            }
        }

        function serializeTitleTable(preferences) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });
            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }
        function seriaalizeBodyTable(header, descriptors) {
            var body = [];
            for (var d in descriptors) {
                var objReturn = {};
                objReturn.id = descriptors[d].id;
                objReturn.name = descriptors[d].name;
                objReturn.order = descriptors[d].row_order;
                objReturn.values = angular.copy(header);
                body.push(objReturn);
            }
            return body;
        }

        function init() {
            vm.skill = angular.copy(Skill);
            vm.descriptors = angular.copy(Descriptors);
            vm.data = angular.copy(Data);
            vm.preferences = angular.copy(Preferences);
            vm.userProfile = UserProfile;
            vm.evaluation_current_process_id = angular.copy(EvaluationCurrentProcess);
            serializeDataForm();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('EvaluationSkillSingleDialogController', EvaluationSkillSingleDialogController);

    /** @ngInject */
    function EvaluationSkillSingleDialogController($mdDialog, HrSkillService, Descriptors, Data, UserProfile, Skill, Preferences, EvaluationCurrentProcess, ModuleData, Evaluator) {

        var vm = this;

        vm.closeDialog = closeDialog;
        vm.saveEvaluation = saveEvaluation;
        vm.config = {
            showColaborador: false,
            onlyview: false
        }


        vm.formData = {};


        function closeDialog() {
            $mdDialog.hide();
        }

        function saveEvaluation() {

            var data = serializeData();

            HrSkillService.saveEvaluation(data).then(function (response) {
                setEvaluation(response);
                closeDialog();
            }, function (error) {
            });

        }

        function setEvaluation(response) {
            var index = null;
            for (var i in ModuleData.skills_evaluations) {
                if (ModuleData.skills_evaluations[i].skill.id == vm.skill.skill_id && Evaluator.evaluator.id == ModuleData.skills_evaluations[i].skills_evaluator.evaluator.id) {
                    index = i;
                    break;
                }
            }
            if (index == null) {
                ModuleData.skills_evaluations.push(response);
            } else {
                ModuleData.skills_evaluations[index] = response;
            }
            Skill.result = response.result;
            Skill.estado = true;
        }

        function serializeData() {

            var data = {};
            data.evaluation_current_process_id = vm.evaluation_current_process_id.id;
            data.finalize = false;
            data.data = {
                skill_id: vm.skill.skill_id,
                positive_comment: vm.positive_comment,
                negative_comment: vm.negative_comment,
                descriptors_result: vm.formData
            }; 0

            return data;
        }

        function serializeDataForm() {
            vm.titleTable = serializeTitleTable(vm.preferences);
            vm.bodyTable = seriaalizeBodyTable(vm.titleTable, vm.descriptors);
            setRequiredTextArea(vm.preferences.fields);
            serializeFormData();
        }

        function setRequiredTextArea(fields) {
            var role = Evaluator.role;
            vm.validation = {};
            vm.has_extra_fields = false;
            for (var i in fields) {
                vm.validation[i] = {};
                if (fields[i].required_for && fields[i].required_for.indexOf(role) !== -1) {
                    vm.validation[i].required = true;
                }else{
                    vm.validation[i].required = false;
                }
            }

            // Valida si la configuracion de la evaluacion tiene campos adicionales
            vm.has_extra_fields = !(Object.keys(vm.validation).length === 0);
        }

        function serializeFormData() {
            if (!vm.data) {
                return;
            }
            vm.formData = vm.data.descriptors_result;
            vm.negative_comment = vm.data.negative_comment;
            vm.positive_comment = vm.data.positive_comment;
        }

        function serializeTitleTable(preferences) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });
            newPreference = newPreference.filter(function (element) {
                if (element.only_for) {
                    if(element.only_for.indexOf(Evaluator.role) != -1){
                        return element;
                    }
                } else {
                    return element;
                }
            });
            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }
        function seriaalizeBodyTable(header, descriptors) {
            var body = [];
            for (var d in descriptors) {
                var objReturn = {};
                objReturn.id = descriptors[d].id;
                objReturn.name = descriptors[d].name;
                objReturn.order = descriptors[d].row_order;
                objReturn.values = angular.copy(header);
                body.push(objReturn);
            }
            return body;
        }

        function init() {
            vm.skill = angular.copy(Skill);
            vm.descriptors = angular.copy(Descriptors);
            vm.data = angular.copy(Data);
            vm.preferences = angular.copy(Preferences);
            vm.userProfile = UserProfile;
            vm.evaluation_current_process_id = angular.copy(EvaluationCurrentProcess);
            serializeDataForm();

        }

        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('EvaluationSkillEtapasNovacionDialogController', EvaluationSkillEtapasNovacionDialogController);

    /** @ngInject */
    function EvaluationSkillEtapasNovacionDialogController($mdDialog, HrSkillService, Descriptors, Data, UserProfile, Skill, Preferences, EvaluationCurrentProcess, ModuleData, Evaluator) {

        var vm = this;

        vm.closeDialog = closeDialog;
        vm.saveEvaluation = saveEvaluation;
        vm.selectedCell = selectedCell;
        vm.config = {
            showColaborador: false,
            onlyview: false
        }


        vm.formData = {};


        function closeDialog() {
            $mdDialog.hide();
        }

        function saveEvaluation() {

            var data = serializeData();

            HrSkillService.saveEvaluation(data).then(function (response) {
                setEvaluation(response);
                closeDialog();
            }, function (error) {
            });

        }

        function setEvaluation(response) {
            var index = null;
            for (var i in ModuleData.skills_evaluations) {
                if (ModuleData.skills_evaluations[i].skill.id == vm.skill.skill_id && Evaluator.evaluator.id == ModuleData.skills_evaluations[i].skills_evaluator.evaluator.id) {
                    index = i;
                    break;
                }
            }
            if (index == null) {
                ModuleData.skills_evaluations.push(response);
            } else {
                ModuleData.skills_evaluations[index] = response;
            }
            Skill.result = response.result;
            Skill.estado = true;
        }

        function serializeData() {

            var data = {};
            data.evaluation_current_process_id = vm.evaluation_current_process_id.id;
            data.finalize = false;
            data.data = {
                skill_id: vm.skill.skill_id,
                positive_comment: vm.positive_comment,
                negative_comment: vm.negative_comment,
                descriptors_result: vm.formData
            }; 0

            return data;
        }

        function serializeDataForm() {
            vm.titleTable = serializeTitleTable(vm.preferences);
            vm.bodyTable = seriaalizeBodyTable(vm.titleTable, vm.descriptors);
            setRequiredTextArea(vm.preferences.fields);
            serializeFormData();
        }

        function setRequiredTextArea(fields) {
            var role = Evaluator.role;
            vm.validation = {};
            for (var i in fields) {
                vm.validation[i] = {};
                if (fields[i].required_for && fields[i].required_for.indexOf(role) !== -1) {
                    vm.validation[i].required = true;
                }

            }
        }

        function serializeFormData() {
            if (!vm.data) {
                return;
            }
            vm.formData = vm.data.descriptors_result;
            vm.negative_comment = vm.data.negative_comment;
            vm.positive_comment = vm.data.positive_comment;
        }

        function serializeTitleTable(preferences) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });
            newPreference = newPreference.filter(function (element) {
                if (element.only_for) {
                    if(element.only_for.indexOf(Evaluator.role) != -1){
                        return element;
                    }
                } else {
                    return element;
                }
            });
            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }
        function seriaalizeBodyTable(header, descriptors) {
            var body = [];
            for (var d in descriptors) {
                var objReturn = {};
                objReturn.id = descriptors[d].id;
                objReturn.name = descriptors[d].name;
                objReturn.order = descriptors[d].row_order;
                objReturn.stages = descriptors[d].novation_stages;
                body.push(objReturn);
            }
            return body;
        }

        function selectedCell(skill, title) {
            if (vm.config.onlyview) {
                return;
            }
            vm.formData[skill.id] = title.value;
        }

        function init() {
            vm.skill = angular.copy(Skill);
            vm.descriptors = angular.copy(Descriptors);
            vm.data = angular.copy(Data);
            vm.preferences = angular.copy(Preferences);
            vm.userProfile = UserProfile;
            vm.evaluation_current_process_id = angular.copy(EvaluationCurrentProcess);
            serializeDataForm();
        }
        init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('EvaluationSkillChiefDialogController', EvaluationSkillChiefDialogController);

    /** @ngInject */
    function EvaluationSkillChiefDialogController($mdDialog, HrSkillService, Descriptors, Data, UserProfile, Skill, Preferences, EvaluationCurrentProcess, ModuleData) {

        var vm = this;

        vm.closeDialog = closeDialog;
        vm.formData = {
            dataBody : []
        };
        vm.config = {
            onlyview: true
        }


        function closeDialog() {
            $mdDialog.hide();
        }

        function serializeDataForm() {
            vm.titleTable = serializeTitleTable(vm.preferences);
            vm.titleObj = HrSkillService.serializeTitleObj(vm.preferences);
            vm.titleColor = HrSkillService.setTitleColor(vm.preferences);
            vm.bodyTable = seriaalizeBodyTable(vm.titleTable, vm.descriptors);
            for(var d in vm.data){
                vm.formData.dataBody.push(serializeFormData(vm.data[d]));
            }
        }

        function serializeFormData(data) {

            return {
                skills_evaluator: data.skills_evaluator,
                descriptors_result:data.descriptors_result,
                negative_comment: data.negative_comment,
                positive_comment: data.positive_comment
            }
        }

        function serializeTitleTable(preferences) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });
            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }
        function seriaalizeBodyTable(header, descriptors) {
            var body = [];
            for (var d in descriptors) {
                var objReturn = {};
                objReturn.id = descriptors[d].id;
                objReturn.name = descriptors[d].name;
                objReturn.order = descriptors[d].row_order;
                objReturn.values = angular.copy(header);
                body.push(objReturn);
            }
            return body;
        }

        function init() {
            vm.skill = angular.copy(Skill);
            vm.descriptors = angular.copy(Descriptors);
            vm.data = angular.copy(Data);
            vm.preferences = angular.copy(Preferences);
            vm.userProfile = UserProfile;
            vm.evaluation_current_process_id = angular.copy(EvaluationCurrentProcess);
            serializeDataForm();
        }

        init();
    }
})();
(function () {
  'use strict';

  angular
    .module('app.hr-evaluation')
    .controller('InscriptionGoalListDialogController', InscriptionGoalListDialogController);

  /** @ngInject */
  function InscriptionGoalListDialogController($mdDialog, HrPersonalDevelopmentService, Personal, ModuleData, UserProfile, LicenseService) {

    var vm = this;

    vm.closeDialog = closeDialog;
    vm.saveGoal = saveGoal;
    vm.dataForm = {};
    vm.saving = false;
    vm.license = LicenseService.getLicenseJson();
    vm.templatePath = _getTemplatePath(vm.license);
    vm.change = change;
    vm.auxYears = [
      {id:1,name:'1 año'},{id:2,name:'2 años'}
    ];

    function _getTemplatePath() {
      var template = "default";
      if (vm.license.module && vm.license.module['hr-personal-development'] && vm.license.module['hr-personal-development']['dialogs']) {
        template = vm.license.module['hr-personal-development']['dialogs']['InscriptionGoalList'] ? vm.license.module['hr-personal-development']['dialogs']['InscriptionGoalList']['template'] : "default";
      }

      return "app/main/modules/hr-evaluation-modules/hr-personal-development/dialogs/inscription-goal-list-dialog/template/"+template+"/default.html";
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function saveGoal() {

      var evaluation_current_process_id = vm.module_data.evaluation_current_process.id;

      vm.saving = true;

      HrPersonalDevelopmentService.saveEvaluation(evaluation_current_process_id, vm.dataForm).then(function (response) {

        var personal = response;
        personal.porcentaje = parseInt(personal.weight);

        if (Personal.id) {
          for (var i in ModuleData.personal_data) {
            var row = ModuleData.personal_data[i];
            if (row.id == Personal.id) {
              ModuleData.personal_data[i] = personal;
              break;
            }
          }
        } else {
          ModuleData.personal_data.push(personal);
        }

        closeDialog();
      }, function (error) {
        vm.saving = false;
      });

    }

    function serializeForm() {
      var personal = angular.copy(vm.personal);

      vm.dataForm.id = personal.id;
      vm.dataForm.objetive = personal.objetive;
      if (ModuleData.evaluation_preferences.required_skill) {
        vm.dataForm.skill_id = personal.skill ? personal.skill.id : 0;
      }

      vm.dataForm.how_to_achieve_it = personal.how_to_achieve_it;
      vm.dataForm.additional_data = personal.additional_data;
      vm.dataForm.weight = isNaN(personal.porcentaje) || !personal.porcentaje ? 0 : parseInt(personal.porcentaje);
    }

    function change(actionValue){
      if(actionValue == 'action_deadline'){
        if(vm.dataForm.additional_data[actionValue] == 1){
          vm.dataForm.additional_data['how_to_achieve_it2'] = "";
        }
      }
    }

    function init() {
      vm.personal = angular.copy(Personal);
      vm.module_data = ModuleData;
      vm.userProfile = UserProfile;
      vm.selectedDefault = true;
      vm.weights = [];
      for (var i = 0; i <= 100; i++) {
        vm.weights.push(i);
      }

      serializeForm();
    }



    init();
  }
})();
(function () {
  'use strict';

  angular
    .module('app.hr-evaluation')
    .controller('EvaluationPersonalDialogController', EvaluationPersonalDialogController);

  /** @ngInject */
  function EvaluationPersonalDialogController($mdDialog, HrPersonalDevelopmentService, Personal, ModuleData, UserProfile) {

    var vm = this;

    vm.closeDialog = closeDialog;
    vm.saveEvaluation = saveEvaluation;
    vm.saving = false;

    function closeDialog() {
      $mdDialog.hide();
    }

    function saveEvaluation() {

      var evaluation_current_process_id = vm.module_data.evaluation_current_process.id;

      var data = serializeData();

      vm.saving = true;

      HrPersonalDevelopmentService.saveEvaluation(evaluation_current_process_id, data).then(function (response) {

        //angular.copy(response, GoalsList[GoalsList.indexOf(Goal)]);
        //GoalsList[GoalsList.indexOf(Goal)]['additional_info'] = vm.goal.additional_info;
        //console.log(response);
        Personal.personal_dev_evaluation_data = response.personal_dev_evaluation_data;
        closeDialog();
      }, function (error) {
        vm.saving = false;
      });

    }

    function serializeData() {
      var key_init = vm.userProfile == 'colab' ? 'colla_' : 'chief_';

      var data = {};

      data['personal_development_id'] = vm.personal.id;
      data[key_init + vm.evaluation_key_data] = vm.evaluation;
      data[key_init + 'comment'] = vm.comments;
      if (vm.id) {
        data['id'] = vm.id;
      }


      return data;

    }

    function serializeDataForm(data) {
      var key_init = vm.userProfile == 'colab' ? 'colla_' : 'chief_';
      if (data.personal_dev_evaluation_data) {
        var newData = data.personal_dev_evaluation_data;
        vm.comments = newData[key_init + 'comment'] ? newData[key_init + 'comment'] : null;
        vm.evaluation = newData[key_init + vm.evaluation_key_data] ? parseInt(newData[key_init + vm.evaluation_key_data]) : null;
        vm.id = newData.id;

      }
    }

    function init() {
      vm.personal = angular.copy(Personal);
      vm.module_data = ModuleData;
      vm.userProfile = UserProfile;
      vm.selectedDefault = true;

      if (vm.module_data.evaluation_options.result_type.type == 'numerical_result') {
        vm.evaluation_type = 'numeric';
        vm.evaluation_key_data = 'num_result';
        vm.evaluation = vm.personal.personal_dev_evaluation_data.colla_num_result;

        //Crear lista de porcentajes de 1 a 100%
        vm.weights = [];
        var min = parseInt(vm.module_data.evaluation_options.result_type.numerical_result.min);
        var max = parseInt(vm.module_data.evaluation_options.result_type.numerical_result.max);

        for (var i = min; i <= max; i++) {
          vm.weights.push(i);
        }
      }

      if (vm.module_data.evaluation_options.result_type.type == 'result_list') {
        vm.result_type = angular.copy(vm.module_data.evaluation_options.result_type);
        vm.evaluation_type = 'lists';
        vm.evaluation_key_data = 'result_lists_item_id';
        vm.evaluation = vm.personal.personal_dev_evaluation_data.colla_result_lists_item_id;
      }

      if (vm.evaluation) {
        vm.selectedDefault = false;
      }


      serializeDataForm(vm.personal);


    }

    init();
  }
})();
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('ImportarDialogDialogController', ImportarDialogDialogController);

    /** @ngInject */
    function ImportarDialogDialogController($mdDialog, HrPersonalDevelopmentService,LicenseService,UtilsService,Data,Key) {

        var vm = this;

        vm.closeDialog = closeDialog;
        vm.saveEvaluation = saveEvaluation;
        vm.importData = importData;


        function closeDialog() {
            $mdDialog.hide();
        }

        function saveEvaluation() {

            var evaluation_current_process_id = vm.module_data.evaluation_current_process.id;

            var data = serializeData();


            HrPersonalDevelopmentService.saveEvaluation(evaluation_current_process_id, data).then(function (response) {

                //angular.copy(response, GoalsList[GoalsList.indexOf(Goal)]);
                //GoalsList[GoalsList.indexOf(Goal)]['additional_info'] = vm.goal.additional_info;
                //console.log(response);
                Personal.personal_dev_evaluation_data = response[0].personal_dev_evaluation_data;
                closeDialog();
            }, function (error) {
            });

        }


        function init() {
            getConfig();
        }

        function getConfig() {
            LicenseService.getOrganizacionUploadConfig().then(function (licenseData) {
                if (licenseData[Key]) {
                    vm.configUpload = licenseData[Key];
                    configSerialize(vm.configUpload);
                } else {
                    UtilsService.showToast("No se encontro la configuración para la importación que desea realizar.");
                    vm.errorLoadingConfig = true;
                }
            }, function (err) {
            });
        }

        function configSerialize(data) {
            vm.title = data.title;
            
            vm.configImportData = data;
            vm.configImportData.Data = Data;
            vm.configImportData.templateUrl = 'app/main/elements/ik-import-data/' + data.template + '/' + data.template + '.html';
            vm.configImportData.config = {
                key: null,
                config: data
            };
        }

        function importData(data){
            $mdDialog.hide(data);
        }

        init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('SelectGoalListDialogController', SelectGoalListDialogController);

    /** @ngInject */
    function SelectGoalListDialogController($mdDialog, HrGoalService, Goal, GoalsList, CompanyGoals, ModuleData)
    {

      var vm = this;

      vm.closeDialog = closeDialog;
      vm.saveGoal = saveGoal;
      vm.savingData = false;

      function closeDialog()
      {
          $mdDialog.hide();
      }

      function saveGoal() {
        vm.savingData = true;
        var evaluation_current_process_id = vm.module_data.evaluation_current_process.id;

        var goalData = {};

        goalData['id'] = vm.goal.id;
        goalData['porcentaje'] = vm.goal.porcentaje;
        goalData['objetivo_id'] = vm.goal.objetivo_id;
        goalData['goals_type_id'] = vm.goal.additional_info.tipo_objetivo;

        for (var i in ModuleData.goals_data) {
          if (ModuleData.goals_data[i].id == Goal.id) {
            goalData.orden = parseInt(i) + 1;
            break;
          }
        }

        HrGoalService.saveGoalSelectGoalDialog(evaluation_current_process_id, goalData).then(function(response) {

          HrGoalService.assignCompanyGoalsValues(response);

          angular.copy(response, GoalsList[GoalsList.indexOf(Goal)]);
          GoalsList[GoalsList.indexOf(Goal)]['additional_info'] = vm.goal.additional_info;

          closeDialog();       
        }, function(error) {
          vm.savingData = false;
        });        
        
      }


      function init() {
        vm.goal = angular.copy(Goal);
        vm.module_data = ModuleData;
        vm.companyGoals = CompanyGoals;
        vm.objetivos_seleccionados = [];

        //Crear lista de porcentajes de 1 a 100%
        vm.weights = [];
        for (var i=1; i<=100; i++) {
          vm.weights.push(i);
        }
        
      }



      init();
    }
})();
(function () {
  'use strict';

  angular
    .module('app.hr-evaluation')
    .controller('InputGoalDialogController', InputGoalDialogController);

  /** @ngInject */
  function InputGoalDialogController($mdDialog, HrGoalService, Goal, GoalsList, ModuleData) {

    var vm = this;

    vm.closeDialog = closeDialog;
    vm.saveGoal = saveGoal;
    vm.savingData = false;

    function closeDialog() {
      $mdDialog.hide();
    }

    function saveGoal() {

      vm.savingData = true;
      var evaluation_current_process_id = vm.module_data.evaluation_current_process.id;

      for (var i in ModuleData.goals_data) {
        if (ModuleData.goals_data[i].id == Goal.id) {
          vm.goal.orden = parseInt(i) + 1;
          break;
        }
      }

      HrGoalService.saveGoal(evaluation_current_process_id, vm.goal).then(function (response) {
        angular.copy(response, GoalsList[GoalsList.indexOf(Goal)]);
        GoalsList[GoalsList.indexOf(Goal)]['additional_info'] = vm.goal.additional_info;

        closeDialog();
      }, function (error) {
        vm.savingData = false;
      });

    }

    function init() {
      vm.goal = angular.copy(Goal);
      vm.module_data = ModuleData;

      //Crear lista de porcentajes de 1 a 100%
      vm.weights = [];
      for (var i = 1; i <= 100; i++) {
        vm.weights.push(i);
      }

    }

    init();
  }
})();
(function () {
  'use strict';

  angular
    .module('app.hr-evaluation')
    .controller('EvaluationGoalDialogController', EvaluationGoalDialogController);

  /** @ngInject */
  function EvaluationGoalDialogController($mdDialog, HrGoalService, Goal, ModuleData, UserProfile) {

    var vm = this;

    vm.closeDialog = closeDialog;
    vm.saveEvaluation = saveEvaluation;
    vm.saving = false;


    function closeDialog() {
      $mdDialog.hide();
    }

    function saveEvaluation() {

      var evaluation_current_process_id = vm.module_data.evaluation_current_process.id;

      var data = serializeData();

      vm.saving = true;

      HrGoalService.saveEvaluation(evaluation_current_process_id, data).then(function (response) {

        //angular.copy(response, GoalsList[GoalsList.indexOf(Goal)]);
        //GoalsList[GoalsList.indexOf(Goal)]['additional_info'] = vm.goal.additional_info;
        //console.log(response);
        Goal.goal_evaluation_data = response.goal_evaluation_data;
        closeDialog();
      }, function (error) {
        vm.saving = false;
      });

    }

    function serializeData(){
      var key_init = vm.userProfile == 'colab' ? 'colla_' : 'chief_';

      var data = {};

      data['objetivos_empleado_id'] = vm.goal.id;
      data['evaluation_type'] = 'follow up';
      data[key_init+vm.evaluation_key_data] = vm.evaluation;
      data[key_init+'comment'] = vm.comments;
      if(vm.id){
        data['id'] = vm.id;
      }


      return data;
      
    }

    function serializeDataForm(data) {
      var key_init = vm.userProfile == 'colab' ? 'colla_' : 'chief_';
      if (data.goal_evaluation_data) {
        var newData = data.goal_evaluation_data;
        vm.comments = newData[key_init+'comment'] ? newData[key_init+'comment'] : null;
        vm.evaluation = newData[key_init+vm.evaluation_key_data] ? parseInt(newData[key_init+vm.evaluation_key_data]) : null;
        vm.id = newData.id;
      }
    }

    function init() {
      vm.goal = angular.copy(Goal);
      vm.module_data = ModuleData;
      vm.userProfile = UserProfile;
      vm.selectedDefault = true;
      if (vm.module_data.evaluation_options.result_type.type == 'numerical_result') {
        vm.evaluation_type = 'numeric';
        vm.evaluation_key_data = 'num_result';
        vm.evaluation = vm.goal.goal_evaluation_data.colla_num_result;

        
        //Crear lista de porcentajes de 1 a 100%
        vm.weights = [];
        var min = parseInt(vm.module_data.evaluation_options.result_type.numerical_result.min);
        var max = parseInt(vm.module_data.evaluation_options.result_type.numerical_result.max);

        for (var i = min; i <= max; i++) {
          vm.weights.push(i);
        }
      }

      if (vm.module_data.evaluation_options.result_type.type == 'result_list') {
        vm.result_type = angular.copy(vm.module_data.evaluation_options.result_type);
        vm.evaluation_type = 'lists';
        vm.evaluation_key_data = 'result_lists_item_id';
        vm.evaluation = vm.goal.goal_evaluation_data.colla_result_lists_item_id;
      }

      if(vm.evaluation){
        vm.selectedDefault = false;
      }

      serializeDataForm(vm.goal);


    }

    init();
  }
})();
(function () {
    'use strict';
  
    angular
      .module('app.hr-evaluation')
      .controller('EvaluationCommentDialogController', EvaluationCommentDialogController);
  
    /** @ngInject */
    function EvaluationCommentDialogController($mdDialog, HrGoalService, Goal, ModuleData, UserProfile) {
  
      var vm = this;
  
      vm.closeDialog = closeDialog;
      vm.saveEvaluation = saveEvaluation;
      vm.saving = false;
  
  
      function closeDialog() {
        $mdDialog.hide();
      }
  
      function saveEvaluation() {
  
        var evaluation_current_process_id = vm.module_data.evaluation_current_process.id;
  
        var data = serializeData();
        
        vm.saving = true;
  
        HrGoalService.saveEvaluation(evaluation_current_process_id, data).then(function (response) {
  
          //angular.copy(response, GoalsList[GoalsList.indexOf(Goal)]);
          //GoalsList[GoalsList.indexOf(Goal)]['additional_info'] = vm.goal.additional_info;
          //console.log(response);
          Goal.goal_evaluation_data = response.goal_evaluation_data;
          closeDialog();
        }, function (error) {
          vm.saving = false;
        });
  
      }
  
      function serializeData(){
        var key_init = vm.userProfile == 'colab' ? 'colla_' : 'chief_';
  
        var data = {};
  
        data['objetivos_empleado_id'] = vm.goal.id;
        data['evaluation_type'] = 'follow up';
        data[key_init+vm.evaluation_key_data] = vm.evaluation;
        data[key_init+'comment'] = vm.comments;
        if(vm.id){
          data['id'] = vm.id;
        }
  
  
        return data;
        
      }
  
      function serializeDataForm(data) {
        var key_init = vm.userProfile == 'colab' ? 'colla_' : 'chief_';
        if (data.goal_evaluation_data) {
          var newData = data.goal_evaluation_data;
          vm.comments = newData[key_init+'comment'] ? newData[key_init+'comment'] : null;
          vm.evaluation = newData[key_init+vm.evaluation_key_data] ? parseInt(newData[key_init+vm.evaluation_key_data]) : null;
          vm.id = newData.id;
        }
      }
  
      function init() {
        vm.goal = angular.copy(Goal);
        vm.module_data = ModuleData;
        vm.userProfile = UserProfile;
        vm.selectedDefault = true;
        if (vm.module_data.evaluation_options.result_type.type == 'numerical_result') {
          vm.evaluation_type = 'numeric';
          vm.evaluation_key_data = 'num_result';
          vm.evaluation = vm.goal.goal_evaluation_data.colla_num_result;
  
          
          //Crear lista de porcentajes de 1 a 100%
          vm.weights = [];
          var min = parseInt(vm.module_data.evaluation_options.result_type.numerical_result.min);
          var max = parseInt(vm.module_data.evaluation_options.result_type.numerical_result.max);
  
          for (var i = min; i <= max; i++) {
            vm.weights.push(i);
          }
        }
  
        if (vm.module_data.evaluation_options.result_type.type == 'result_list') {
          vm.result_type = angular.copy(vm.module_data.evaluation_options.result_type);
          vm.evaluation_type = 'lists';
          vm.evaluation_key_data = 'result_lists_item_id';
          vm.evaluation = vm.goal.goal_evaluation_data.colla_result_lists_item_id;
        }
  
        if(vm.evaluation){
          vm.selectedDefault = false;
        }
  
        serializeDataForm(vm.goal);
  
  
      }
  
      init();
    }
  })();
(function ()
{
    'use strict';

    angular
        .module('app.cstm.organization_employees', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.organization_employees', {
            url  : '/organization_employees',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/organization/employees/organization_employees.html',
                    controller : 'OrganizationEmployeesController as vm'
                }
            },
            requiresAuthentication: true
        });
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.cstm.organization_employees')
        .controller('EmployeeDialogController', EmployeeDialogController);

    /** @ngInject */
    function EmployeeDialogController($mdDialog, UtilsService, organizationService, Employees, Employee)
    {
      var vm = this;

      vm.sendingData = false;

      // Data
      if(Employee.id) {
        vm.action = 'update';
        vm.employee = angular.copy(Employee);
      } else {
        vm.action = 'create';
        vm.employee = {};
      }      

		  //Methods
      vm.closeDialog = closeDialog;
      vm.save = save;

      //////////

      /**
       * Close dialog
       */
      function closeDialog() {
          $mdDialog.hide();
      }

      function _create() {

        vm.sendingData = true;

        organizationService.addEmployee(vm.employee).then(function(response) {
          
          Employees.push(response.employee);

          closeDialog();      
        }).catch(function(err) {
          vm.sendingData = false;
        });

      }

      function save() {
        if(vm.action == 'create') {
          _create();
        } else {
          _update();
        }
      }

      function _update() {

        vm.sendingData = true;

        organizationService.updateEmployee(vm.employee.id, vm.employee).then(function(response) {
          
          angular.copy(response.employee, Employee);

          closeDialog();      
        }).catch(function(err) {
          vm.sendingData = false;
        });

      }
                
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cstm.cstm_evaluation_details', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.cstm_evaluation_details', {
            url  : '/evaluation/view/:employee_process_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/evaluation/evaluation-details/evaluation-details.html',
                    controller : 'CstmEvaluationDetailsController as vm'
                }
            },
            requiresAuthentication: true
        });
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.cstm.cstm_evaluation_details')
        .controller('EvaluationLogDetailDialogController', EvaluationLogDetailDialogController);

    /** @ngInject */
    function EvaluationLogDetailDialogController($mdDialog, logData, UtilsService)
    {
      var vm = this;

      // Data
      vm.logData = logData;

      vm.logContent = JSON.stringify(vm.logData.request_data, null, 2);


		  //Methods
      vm.closeDialog = closeDialog;

      //////////

      /**
       * Close dialog
       */
      function closeDialog()
      {
          $mdDialog.hide();
      }
                
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.page.admin', [
        							'app.page.admin_content'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.admin_page', {
            url  : '/admin_page',
            views: {
                'content@app': {
                    templateUrl: 'app/main/page/admin/page_admin.html',
                    controller : 'PageAdminController as vm'
                }
            },
            resolve: {
                Pages: function (apiResolver)
                {
                	return apiResolver.resolve('admin.page.getList@get');
                    //return msApi.resolve('admin.page.getList@get');
                }
            }  
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.page.admin')
        .controller('PageDialogController', PageDialogController);

    /** @ngInject */
    function PageDialogController($mdDialog, PageService, Page, Pages, PageMenu, msUtils, UtilsService)
    {
    	//Track Google Analytics
        UtilsService.trackPage();        
    	
        var vm = this;

        // Data
        
        vm.templates = PageService.getTemplates();
        vm.page_menu = PageMenu;
        vm.page_order = -1; //Ubicación de la página
        
        vm.title = 'Editar';
        vm.page = angular.copy(Page);
        vm.pages = Pages;
        vm.newPage = false;
        
        if ( !vm.page )
        {
            vm.contact = {
                'name'    : '',
                'cargo'  : '',
                'area': '',
                'email' : '',
                'telefono': '',
            };

            vm.title = 'Nuevo';
            vm.newPage = true;
        }

        // Methods
        vm.addNewPage = addNewPage;
        vm.savePage = savePage;
        vm.deletePageConfirm = deletePageConfirm;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new contact
         */
        function addNewPage()
        {
        	
			PageService.admin_newPage(vm.page, vm.page_order).then(function(response) {

				if(response.data) {
					vm.pages.push( response.data );
				}
	
			}).catch(function(err) {
				// TODO
			});

            closeDialog();
        }

        /**
         * Save contact
         */
        function savePage()
        {        	
			PageService.admin_savePage(vm.page, vm.page_order).then(function(response) {

				if(response.data) {
					Page.Page = angular.copy(response.data.Page);
				}
	
			}).catch(function(err) {
				// TODO
			});

            closeDialog();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deletePageConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Esta seguro de eliminar esta página?')
                .htmlContent('<b>' + vm.page.Page.menu_name + '</b>')
                .ariaLabel('delete page')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
            	//Delete page
				PageService.admin_deletePage(vm.page.Page.id).then(function(response) {
	
					if(response.status) {
						
						vm.pages.splice(vm.pages.indexOf(Page), 1);
					}
		
				}).catch(function(err) {
					// TODO
				});
                

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function() {
	'use strict';

	angular.module('app.users', [
				'app.users.admin',
				'app.users.login',
				'app.users.forgot-password',
				'app.users.reset-password'])
	.config(config);
	
	function config() {

	}


})(); 

(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($mdDialog, $document,UsersService,UtilsService) {
        var vm = this;
        vm.message = null;
        vm.title = "Cambiar contraseña";
        vm.password_anterior_type = "password";
        vm.password_anterior_icon = "icon-eye";

        vm.password_type = "password";
        vm.password_icon = "icon-eye";

        vm.password_confirm_type = "password";
        vm.password_confirm_icon = "icon-eye";
        vm.closeDialog = function () {
            $mdDialog.hide();
        };

        vm.changePassword = function () {
            vm.errors = {};
            vm.message = null;
            UsersService.changePassword(vm.form.password).then(function(response){
                UtilsService.showToast(response.message);
                vm.closeDialog();
            },function(error){
                UtilsService.showToast(error.message, true);
            });
        };

        vm.showPassword = function (password) {
            if (password == "password_type") {
                if (vm.password_type == "text") {
                    vm.password_type = "password";
                    vm.password_icon = "icon-eye";
                } else {
                    vm.password_type = "text";
                    vm.password_icon = "icon-eye-off";
                }
            } else if (password == "password_confirm_type") {
                if (vm.password_confirm_type == "text") {
                    vm.password_confirm_type = "password";
                    vm.password_confirm_icon = "icon-eye";
                } else {
                    vm.password_confirm_type = "text";
                    vm.password_confirm_icon = "icon-eye-off";
                }
            }
        }
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // CMS Modules
            'app.page',
            
            // Custom modules
            'app.cstm',

            // Reportes
            'app.reports',

            //Ikano RH Modules
            'app.hr-evaluation',
            'app.employee',
            
            //Administrador            
            'app.users',
            'app.page.admin',
            'app.text.admin',
            "highcharts-ng",
            'ngDragDrop'
            
        ]);
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .service('DocumentsDialogService', DocumentsDialogService);

    /** @ngInject */
    function DocumentsDialogService($mdDialog, UtilsService, api) {
        var documents = null;
        var service = {
            setDocuments: setDocuments,
            getDocuments: getDocuments
        }

        return service;

        function setDocuments(data) {
            documents = data;
        }

        function getDocuments() {
            return documents;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('DocumentsDialogController', DocumentsDialogController);

    /** @ngInject */
    function DocumentsDialogController($mdDialog, UtilsService,api) {
        var vm = this;

        init();

        //Methods
        vm.donwloadDocument = donwloadDocument;
        vm.closeDialog = closeDialog;

        function init() {
            api.misc.documents.get({},function(response){
                vm.documents = response.data;
            });
        }

        function donwloadDocument(doc){
            api.general.getWindowHttp('GET', 'misc/documents/' + doc.id, {}, null);
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.employee.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.employee_profile', {
            url      : '/employee/profile',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/employee_main.html',
                    controller : 'MainController as vm'
                },                
                'toolbar@app.employee_profile': {
                    templateUrl: 'app/toolbar/layouts/employee/default.html',
                    controller : 'ToolbarControllerEmployee as vm'
                },
                'content@app.employee_profile': {
                    templateUrl: 'app/main/modules/employee/profile/profile.html',
                    controller : 'ProfileController as vm'
                }

            },
            bodyClass: 'profile',
            requiresAuthentication: true,
            permissions: ["view_employee_profile"]
        }).state('app.employee_profile_team', {
            url      : '/employee/:employee_id/profile',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/employee_main.html',
                    controller : 'MainController as vm'
                },                
                'toolbar@app.employee_profile_team': {
                    templateUrl: 'app/toolbar/layouts/employee/default.html',
                    controller : 'ToolbarControllerEmployee as vm'
                },
                'content@app.employee_profile_team': {
                    templateUrl: 'app/main/modules/employee/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: 'profile',
            requiresAuthentication: true,
            permissions: ["view_employee_profile"]
        }).state('app.employee_profile_team_final_stage', {
            url      : '/employee/:employee_id/profile/finalstage',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/employee_main.html',
                    controller : 'MainController as vm'
                },                
                'toolbar@app.employee_profile_team_final_stage': {
                    templateUrl: 'app/toolbar/layouts/employee/default.html',
                    controller : 'ToolbarControllerEmployee as vm'
                },
                'content@app.employee_profile_team_final_stage': {
                    templateUrl: 'app/main/modules/employee/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: 'profile',
            requiresAuthentication: true,
            permissions: ["view_employee_profile"]
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.employee.profile')
        .controller('PictureDialogController', PictureDialogController)
        .directive('onFileChange', onFileChange);
        
    /** @ngInject */   
    function onFileChange($timeout) {
		return {
	        restrict: 'A',
	        link: function (scope, element, attr) {

				var onChangeHandler = scope.$eval( attr.onFileChange );

				element.bind('change', function(evt) {					
					scope.$emit('handleFileSelect', evt);					
				});
	        }
	   };
    }        

    /** @ngInject */
    function PictureDialogController($scope, $mdDialog, userInfo, event, api, UtilsService)
    {
    	//Track Google Analytics
        UtilsService.trackPage();        
    	
    	var vm = this;  

        // Data
        vm.userInfo = userInfo;
		
        // Methods
        vm.handleFileSelect = handleFileSelect;
        vm.selectProfilePicture = selectProfilePicture; 
        vm.closeDialog = closeDialog;
        vm.savePicture = savePicture;                
        
        vm.myImage='';
        vm.myCroppedImage = '';

        var handleFileSelect = $scope.$on('handleFileSelect', function ( event, data)
        {
	          var file = data.currentTarget.files[0];
	          var reader = new FileReader();
	          reader.onload = function (evt) {
	            $scope.$apply(function($scope){
	              vm.userInfo.ModuleUser.avatar = evt.target.result;
	            });
	          };
	          reader.readAsDataURL(file);	
        });  
        
        function selectProfilePicture() {
        	angular.element(document.querySelector('#uploadInput')).click();
        	
        }
        
        /**
         * Save task
         */
        function savePicture()
        {

			vm.userInfo.ModuleUser.avatar = angular.copy(vm.myCroppedImage);

			api.users.uploadProfilePicture.save({profile_pic: vm.userInfo.ModuleUser.avatar},		 
				// Success
	            function (response)
	            {
	            },
	            // Error
	            function (response)
	            {
	            	console.error(response);
				}
	        );
            closeDialog();
        }
                
        /**
         * Close dialog
         */
        function closeDialog()
        {
        	
            $mdDialog.hide();
        }
        
        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cstm.cstm_evaluation', [
          'app.cstm.cstm_evaluation_details'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.cstm_evaluation', {
            url  : '/evaluation',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/evaluation/evaluation.html',
                    controller : 'CstmEvaluationController as vm'
                }
            },
            requiresAuthentication: true
        });
        $stateProvider.state('app.cstm_evaluation_filter', {
            url  : '/evaluation/:tab',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/evaluation/evaluation.html',
                    controller : 'CstmEvaluationController as vm'
                }
            },
            requiresAuthentication: true
        });
        $stateProvider.state('app.cstm_evaluation_edo', {
            url  : '/evaluation_edo',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/evaluation/evaluation_rio.html',
                    controller : 'CstmEvaluationController as vm'
                }
            },
            requiresAuthentication: true
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.cstm.cstm_evaluation')
        .controller('TopicsDialogController', TopicsDialogController);

    /** @ngInject */
    function TopicsDialogController($mdDialog, UtilsService, evaluationService,api,Topic) {
        var vm = this;
        
        vm.topic = Topic;


        /**
         * Methods
         */
        vm.saveTopic = saveTopic;
        vm.closeDialog = closeDialog;

        function saveTopic(){
            if(vm.topic.id){
                updateTopic();
            }else{
                createTopic();
            }
        }

        function createTopic(){
            var dataPost = angular.copy(vm.topic);
            api.evaluations.edoTopics.save(dataPost,function(success){
                $mdDialog.hide(success.data.edo_topic);
            },function(error){
                UtilsService.showToast(error.data.message, true);
                console.error(error);
            })
        }

        function updateTopic(){
            var dataPost = angular.copy(vm.topic);
            api.evaluations.updateTopics.update(dataPost,function(success){
                $mdDialog.hide(success.data.edo_topic);
            },function(error){
                UtilsService.showToast(error.data.message, true);
                console.error(error);
            })
        }

        function closeDialog(){
            $mdDialog.cancel();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cstm.cstm_evaluation')
        .controller('ShowImageDialogController', ShowImageDialogController);

    /** @ngInject */
    function ShowImageDialogController($mdDialog, UtilsService, evaluationService,api,Url,Name) {
        var vm = this;
        
        vm.url = Url;
        vm.name = Name;

        vm.closeDialog = closeDialog;

        function closeDialog(){
            $mdDialog.cancel();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.cstm.cstm_evaluation')
        .controller('MatriculaMassDialogController', MatriculaMassDialogController);

    /** @ngInject */
    function MatriculaMassDialogController($mdDialog, UtilsService, evaluationService, Available, EvaluationSelecteds, PeriodoId, Lists,isEdo) {
        var vm = this;

        init();

        vm.today = moment().toDate();
        //Methods
        vm.closeDialog = closeDialog;
        vm.showActiveFn = showActiveFn;
        vm.save = save;
        vm.getColaborators = getColaborators;
        vm.availableProcessChange = availableProcessChange;
        vm.lists = Lists;
        vm.search = {};
        vm.isEdo = isEdo;

        //////////
        function init() {
            vm.availableProcess = Available;
            vm.evaluationSelecteds = EvaluationSelecteds;
        }

        function availableProcessChange(id) {
            var filter = vm.availableProcess.filter(function (element) {
                return element.id == id;
            });
            vm.availableProcessProcessList = filter.length > 0 ? filter[0].process_list : null;
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        function showActiveFn() {
            if(vm.showActive){
                vm.showActive = false;
            }else{
                vm.showActive = true;
            }
        }

        function getColaborators() {
            if(vm.isEdo){
                vm.search.type_evaluation = 'operativa';
            }
            evaluationService.getActiveNewMassiveProcess(vm.search).then(function (response) {
                vm.colaborators = response.matriculas ? response.matriculas : [];

                vm.evaluationSelecteds = getIdsColaboratos(vm.colaborators);
            }).catch(function (err) {
                vm.sendingData = false;
            });
        }

        function getIdsColaboratos(colaboratos){
            return colaboratos.map(function(element){
                return element.id;
            });
        }

        function save() {

            vm.sendingData = true;

            var dataPost = {
                period_id: PeriodoId,
                employee_processes_id: vm.evaluationSelecteds,
                process_id: vm.search['evaluation_active_process_id'],
                process_lists_item_id: vm.process_lists_item_id,
                process_deadline: moment(vm.process_deadline).toDate()
            }

            if(vm.isEdo){
                dataPost.type_evaluation = 'operativa';
            }

            evaluationService.activeMassiveProcess(dataPost).then(function (response) {

                vm.sendingData = false;

            }).catch(function (err) {
                vm.sendingData = false;
            });

        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.cstm.cstm_evaluation')
    .controller('EvaluationGolDialogController', EvaluationGolDialogController);

  /** @ngInject */
  function EvaluationGolDialogController($mdDialog, UtilsService, evaluationService, WorkingPeriod, Goals, Goal, Areas, CompanyDepartments, Companies, AdditionalData,Types,Positions) {
    var vm = this;

    // Data
    if (Goal.id) {
      vm.action = 'update';
      vm.goal = angular.copy(Goal);
      serializeAdditionalData();
    } else {
      vm.action = 'create';
      vm.goal = {};
    }

    vm.additional_data = AdditionalData;
    vm.areas = Areas;
    vm.CompanyDepartments = CompanyDepartments;
    vm.companies = Companies;
    vm.workingPeriod = WorkingPeriod;
    vm.types = Types;
    vm.positions = Positions;

    //UI/UX Control
    vm.sendingData = null;

    //Methods
    vm.closeDialog = closeDialog;
    vm.deleteGoal = deleteGoal;
    vm.save = save;
    console.log(vm.goal);
    console.log(vm.companies);
    //////////

    /**
     * Close dialog
     */

    function closeDialog() {
      $mdDialog.hide();
    }

    function deleteGoal() {
      $mdDialog.hide();
    }

    function serializeAdditionalData() {
      for (var i in vm.goal.additional_data) {
        vm.goal[i] = vm.goal.additional_data[i];
      }
    }

    function save() {
      vm.sendingData = true;

      if (vm.action == 'update') {
        _updateGoal();
      } else {
        _createGoal();
      }

    }

    function _createGoal() {
      delete(vm.goal.unidad_medida);
      delete(vm.goal.criterio_medicion);
      delete(vm.goal.empresa);
      delete(vm.goal.company_department);
      delete(vm.goal.cargo);
      evaluationService.createCompanyGoal(vm.workingPeriod.id, vm.goal).then(function (response) {

        Goals.push(response.goal);
        vm.sendingData = false;
        closeDialog();
      }).catch(function (err) {
        vm.sendingData = false;
      });

    }

    function _updateGoal() {
      delete(vm.goal.unidad_medida);
      delete(vm.goal.criterio_medicion);
      delete(vm.goal.empresa);
      delete(vm.goal.company_department);
      delete(vm.goal.cargo);
      evaluationService.updateCompanyGoal(vm.goal.id, vm.goal).then(function (response) {
        angular.copy(response.goal, Goal);
        vm.sendingData = false;
        closeDialog();
      }).catch(function (err) {
        vm.sendingData = false;
      });

    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.cstm.cstm_evaluation')
    .controller('EnrollEmployeeDialogController', EnrollEmployeeDialogController);

  /** @ngInject */
  function EnrollEmployeeDialogController($mdDialog, UtilsService, evaluationService, Evaluations, WorkingPeriod, fuseTheming,Operativa) {
    var vm = this;

   

    //Methods
    vm.closeDialog = closeDialog;
    vm.save = save;
    vm.addModule = addModule;
    vm.selectedModule = [];
    vm.showModule = {};
    vm.selectedWeight = {};
    vm.colors = {};

    vm.themes = fuseTheming.themes.active.theme;
    //////////
    function init() {

      //UI/UX Control
      vm.sendingData = null;
      vm.isDataLoaded = null;

      vm.percentages = UtilsService.getArrayNumbers(0, 100);

      //Variable que contiene la información de la matrícula
      vm.enrollData = {};

      vm.colors.primary = vm.themes.primary.color;
      vm.colors.accent = vm.themes.accent.color;
      vm.colors.warn = vm.themes.warn.color;

      evaluationService.getDataToEnrollEmployee(WorkingPeriod.id).then(function (response) {

        vm.areas = response.areas;
        vm.departments = response.departments;
        vm.notEnrolledEmployees = response.notEnrolledEmployees;
        vm.employees = response.employees;
        vm.groups = response.groups;
        vm.positions = response.positions;
        vm.companies = response.companies;
        vm.positionLevels = response.positionLevels;
        vm.modules = response.active_hr_modules;
        vm.isDataLoaded = true;


      }).catch(function (err) {
        // TODO
        vm.isDataLoaded = true;
      });
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function save() {

      vm.sendingData = true;

      var hr_modules = serializeModulePost();

      evaluationService.enrollEmployee(vm.enrollData, WorkingPeriod.id, hr_modules,Operativa).then(function (response) {

        //Agregar la evaluación creada a la lista de evaluaciones
        Evaluations.push(response.employeeProcess);

        vm.sendingData = false;

        closeDialog();
      }).catch(function (err) {
        vm.sendingData = false;
      });

    }

    function addModule(moduleId) {
      var index = vm.selectedModule.indexOf(moduleId);
      if (index == -1) {
        vm.selectedModule.push(moduleId);
      } else {
        vm.selectedModule.splice(index, 1);
      }
    }

    function serializeModulePost() {
      var hrModule = [];
      for (var i in vm.selectedModule) {
        var moduleId = vm.selectedModule[i];
        var dataInser = { hr_module_id: moduleId, weight: vm.selectedWeight[moduleId], module_list_item_id: null };
        if (typeof vm.selectedModuleList !== "undefined" && typeof vm.selectedModuleList[moduleId] !== "undefined") {
          dataInser.module_list_item_id = vm.selectedModuleList[moduleId];
        }
        hrModule.push(dataInser);
      }
      return hrModule;
    }

    init();

  }
})();
(function () {
    'use strict';

    angular
        .module('app.cstm.cstm_evaluation')
        .controller('AddQuestionsDialogController', AddQuestionsDialogController);

    /** @ngInject */
    function AddQuestionsDialogController($mdDialog, UtilsService, evaluationService,api,Questions,QuestionType,Topics,Using) {
        var vm = this;

        
        vm.edo_questions = Questions;
        vm.type_questions = QuestionType;
        vm.topics = Topics;
        vm.closeDialog = closeDialog;
        vm.selectedQuestion = selectedQuestion;

        function selectedQuestion(question){
            $mdDialog.hide(question);
        }

        function closeDialog(){
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.text.admin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.admin_text', {
            url  : '/admin_text/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/page/text/admin/text_admin.html',
                    controller : 'TextAdminController as vm'
                }
            },
            resolve: {
                Text: function (apiResolver, $stateParams)
                {
                	return apiResolver.resolve('admin.text.get@get', {item_id: $stateParams.id});
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.text.admin')
        .factory('TextAdminService', TextAdminService);

    /** @ngInject */
    function TextAdminService($q, api)
    {
        var service = {
        	admin_delete: admin_delete,
        	admin_edit: admin_edit,
        	admin_new: admin_new,
        };

        return service;

        //////////

        function admin_delete(id) {
			var deferred = $q.defer();
			
			api.admin.text.delete.save({
				item_id: id
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;        	
        }
        
        function admin_edit(id, item_data) {
			var deferred = $q.defer();
			
			api.admin.text.edit.save({
				item_id: id,
				item_data: item_data
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;        	
        }
        
        function admin_new(item_data) {
			var deferred = $q.defer();
			
			api.admin.text.new.save({
				item_data: item_data
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;        	
        }
               
    }
}());
(function() {
	'use strict';

	angular.module('app.text.admin')
		.controller('TextAdminController', TextAdminController);

	/** @ngInject */
	function TextAdminController($state, $scope, Text, TextAdminService, UtilsService) {

    	//Track Google Analytics
        UtilsService.trackPage();        

		var vm = this;
		
		//vm.editorOptions = {};

		$scope.opt = {language: 'en'};

        vm.editorOptions = {
            language: 'en',
            'skin': 'moono',
            'extraPlugins': "imagebrowser,mediaembed",
	        "imageBrowser_listUrl": 'http://localhostt:8888/IncaucaProvidencia/api/module_text/browseImages.json',
	        filebrowserImageUploadUrl: 'http://localhostt:8888/IncaucaProvidencia/api/module_text/uploadImage.json',
	        filebrowserUploadUrl: 'http://localhostt:8888/IncaucaProvidencia/api/text/browseFiles',                	            
            filebrowserBrowseUrl: '/api/v1/ckeditor/files',
            toolbarLocation: 'bottom',
            toolbar: 'custom',
            toolbar_custom: [
                { name: 'basicstyles',
                    items: [ 'Bold', 'Italic', 'Strike', 'Underline' ] },
                { name: 'paragraph', items: [ 'BulletedList', 'NumberedList', 'Blockquote' ] },
                { name: 'editing', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
                { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
                { name: 'tools', items: [ 'SpellChecker', 'Maximize' ] },
                { name: 'clipboard', items: [ 'Undo', 'Redo' ] },
                { name: 'styles', items: [ 'Format', 'FontSize', 'TextColor', 'PasteText', 'PasteFromWord', 'RemoveFormat' ] },
                { name: 'insert', items: [ 'Image', 'Table', 'SpecialChar', 'MediaEmbed' ] },'/',
            ]
        };		

		// Data
		vm.Text = Text.item;
		
		//Methods
		vm.save = save;
		
		function save() {

			TextAdminService.admin_edit(vm.Text.ModuleText.id, vm.Text.ModuleText).then(function(response) {

				if(response.data) {
					
					
					var return_page = window.localStorage.getItem('ikc:return_page');
					
					$state.go('app.admin_page_content', {page_url: return_page});
				}
			}).catch(function(err) {
				// TODO
			});			
		}
	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.page.admin_content', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.admin_page_content', {
            url  : '/admin_page_content/:page_url',
            views: {
                'content@app': {
                    templateUrl: 'app/main/page/admin/content/page_content.html',
                    controller : 'PageAdminContentController as vm'
                }
            }
        });
    }

})();
(function() {
	'use strict';

	angular.module('app.page.admin_content')
		.controller('PageAdminContentController', PageAdminContentController);

	/** @ngInject */
	function PageAdminContentController($state, $injector, PageService, UtilsService) {

    	//Track Google Analytics
        UtilsService.trackPage();        

		var vm = this;
		
		vm.pageModules = {};
		vm.pageModules = PageService.getModules();
		
		vm.pageData = {};
		
		vm.adminMode = true;

		var page_url = $state.params.page_url;

		//dom : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

		//Global configuration
		vm.dtOptions = {
			dom : '<"top"f>rt',
			pagingType : 'simple',
			autoWidth : false,
			responsive : true,
			language: UtilsService.getLanguajeDataTable()
		};

		// Data
		
		PageService.getPageLayout(page_url).then(function(data) {

			vm.page_info = data;

			vm.page_layout = vm.page_info.content_layout;
			vm.page_template = 'app/main/page_layouts/' + vm.page_info.page_layout.Page.template + '/' + vm.page_info.page_layout.Page.template + '.html';

			angular.forEach(vm.page_layout, function(value, key) {
				var ModuleServiceName = value.module + 'Service';
				
				// Validar si el servicio existe
				if( $injector.has(ModuleServiceName) ) {
					var Service = $injector.get(ModuleServiceName);

					//Ejecutar la funcion INIT para cada módulo en caso que exista					
					if( eval('(typeof Service.init == "function")') ) {
						//eval('Service.init(vm, value.module, value.id, vm.page_info.page_content[value.module][value.id]["content"], vm.page_info.page_content[value.module][value.id]["params"]);');
					}
				}
			});

		}).catch(function(err) {
			// TODO
		});
		

		//Methods
		vm.moduleAction = moduleAction;
		vm.gotoModuleAdmin = gotoModuleAdmin;
		
		function gotoModuleAdmin(moduleContent) {
			window.localStorage.setItem('ikc:return_page', page_url);
			$state.go('app.admin_text', {id: moduleContent.id});
		}

		function moduleAction(module, action, module_id, params) {
			var ModuleService = module + 'Service';

			var Service = $injector.get(ModuleService);
			eval('Service.' + action + '(vm, module, module_id, params);');
		}
		
	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.users.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.users_reset-password', {
            url      : '/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html'
                },
                'content@app.users_reset-password': {
                    templateUrl: 'app/main/modules/users/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });
    }

})();
(function () {
	'use strict';

	angular
		.module('app.users.reset-password')
		.controller('ResetPasswordController', ResetPasswordController);

	/** @ngInject */
	function ResetPasswordController($state, $scope, $rootScope, UsersService, $mdDialog, UtilsService, $location,LicenseService) {
		//Track Google Analytics
		UtilsService.trackPage();

		var vm = this;

		vm.domain = $rootScope.domain;

		vm.token = $location.search().token;

		LicenseService.getLicense().then(function (licenseData) {
			vm.licenseData = licenseData;
			vm.license = licenseData.license;
		}, function (err) {
		});

		//Esto es para evitar que se quede el splash screen pegado
		$scope.$on('$viewContentAnimationEnded', function (event) {
			if (event.targetScope.$id === $scope.$id) {
				$rootScope.$broadcast('msSplashScreen::remove');
			}
		});

		// Methods
		vm.resetPassword = resetPassword;

		//////////
		function resetPassword(ev) {

			UsersService.resetPassword(vm.new_pass,vm.token).then(function () {
				// Update successful.

				var msgBox = $mdDialog.alert()
					.title('')
					.htmlContent('Contraseña actualizada con éxito')
					.targetEvent(ev)
					.ok('OK');

				$mdDialog
					.show(msgBox)
					.finally(function () {
						$state.go('app.users_login');
					});
			}, function (error) {

				var msgBox = $mdDialog.alert()
					.title('')
					.htmlContent('La información ingresada no es válida, por favor intente de nuevo')
					.targetEvent(ev)
					.ok('OK');

				$mdDialog.show(msgBox);
			});

		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.users')
		.factory('UsersService', UsersService);

	/** @ngInject */
	function UsersService($q, $http, $location, api, UtilsService, fuseTheming,$cookies) {
		var LOCAL_TOKEN_KEY = 'IKANO_RH_JWT';
		var USER_INFO_KEY = 'ikano_rh_ip:user';
		var LICENSE_INFO_KEY = 'IKANO_RH_LICENSE_INFO';
		var IKANO_LICENSE = 'IKANO_RH_LICENSE';
		var SECRET_USER = 'SECRET_USER';
		var MENU_USER = 'MENU_USER';
		var license = null;

		var service = {
			changePassword: changePassword,
			checkPermissionForView: checkPermissionForView,
			getCredentials: getCredentials,
			getLicenseId: getLicenseId,
			getUserInfo: getUserInfo,
			isLogged: isLogged,
			loadUserCredentials: loadUserCredentials,
			login: login,
			logout: logout,
			useCredentials: useCredentials,
			resetPassword: resetPassword,
			sendResetLink: sendResetLink,
			setLicense: setLicense,
			storeUserCredentials: storeUserCredentials,
			storeUserInfo: storeUserInfo,
			userHasPermission: userHasPermission,
			userHasPermissionForView: userHasPermissionForView,
			setLicenseToken: setLicenseToken,
			checkAuth : checkAuth,
			getUserSecret: getUserSecret,
			getMenu:getMenu,
			setUserInfoBtoa: setUserInfoBtoa
			
		};

		return service;

		//////////

		function changePassword(new_password) {
			var deferred = $q.defer();

			api.users.changePassword.save({
				password: new_password
			},
				// Success
				function (response) {

					if (response.status) {
						deferred.resolve(response);
					} else {
						deferred.reject('Change password failed');
					}

				},
				// Error
				function (response) {
					//deferred.reject( response.error ); TODO
					console.error(response);
				});

			return deferred.promise;
		}

		function getCredentials() {
			return window.localStorage.getItem(LOCAL_TOKEN_KEY);
		}

		function getUserInfo() {
			return JSON.parse(window.localStorage.getItem(USER_INFO_KEY));
		}

		function checkPermissionForView(view) {
			if (typeof view.requiresAuthentication !== "undefined" && !view.requiresAuthentication) {
				return true;
			}

			return userHasPermissionForView(view);
		};


		function userHasPermissionForView(view) {
			if (!isLogged()) {
				return false;
			}

			if (typeof view.permissions === "undefined" || !view.permissions || !view.permissions.length) {
				return true;
			}

			return userHasPermission(view.permissions);
		};


		function userHasPermission(permissions) {
			if (!isLogged()) {
				return false;
			}

			var found = false;
			angular.forEach(permissions, function (permission, index) {

				//if ($sessionStorage.user.user_permissions.indexOf(permission) >= 0){
				found = true;
				//    return;
				//}                        
			});

			return found;
		};

		function isLogged() {
			return window.localStorage.getItem(LOCAL_TOKEN_KEY);
			//return firebase.auth().currentUser;
		}

		function loadUserCredentials() {
			var token = window.localStorage.getItem(LOCAL_TOKEN_KEY);
			if (token) {
				useCredentials(token);
			}
		}

		function login(username, password) {
			var deferred = $q.defer();

			api.users.login.get({
				username: username,
				password: password
			},
				// Success
				function (response) {

					if (response.status) {

						storeUserCredentials(response.data.token);
						storeUserInfo(response.data.user);
						storeUserSecret(response.data.secret);
						storeMenu(response.data.menu);
						$cookies.put('group',response.data.user.group.id)
						deferred.resolve(response);

					} else {
						deferred.reject('Login Failed');
					}

				},
				// Error
				function (response) {

					UtilsService.showToast(response.data.message, true);
					deferred.reject(response.data);

					console.error(response);
				});

			return deferred.promise;
		}

		function logout() {
			$http.defaults.headers.common['X-Auth-Token'] = undefined;
			window.localStorage.removeItem(LOCAL_TOKEN_KEY);
			window.localStorage.removeItem(USER_INFO_KEY);
			$cookies.remove('group')
		}

		function useCredentials(token) {

			// Set the token as header for your requests!
			$http.defaults.headers.common['X-Auth-Token'] = token;
		}

		function resetPassword(password,token) {
			var deferred = $q.defer();

			api.users.resetPassword.save({
				token: token,
				password: password
			},
				// Success
				function (response) {

					if (response.status) {
						deferred.resolve(response);
					} else {
						deferred.reject('Reset password failed');
					}

				},
				// Error
				function (response) {
					//deferred.reject( response.error ); TODO
					console.error(response);
				});

			return deferred.promise;
		}

		function sendResetLink(email) {
			var deferred = $q.defer();

			api.users.sendResetLink.save({
				email: email,
			},
				// Success
				function (response) {

					if (response.status) {
						deferred.resolve(response);
					} else {
						deferred.reject('Reset password failed');
					}

				},
				// Error
				function (response) {
					//deferred.reject( response.error ); TODO
					console.error(response);
				});

			return deferred.promise;
		}

		function getLicenseId() {
			return license;
		}

		function setLicense(LicensesData) {
			var currentDomain = $location.host();
			var licenseInfo = LicensesData[currentDomain];
			if (!licenseInfo) {
				return false;
			} else {
				window.localStorage.setItem(LICENSE_INFO_KEY, JSON.stringify(licenseInfo));
				license = licenseInfo.license;

				fuseTheming.setActiveTheme(licenseInfo.license);

				return true;
			}
		}

		function storeUserCredentials(token) {
			window.localStorage.setItem(LOCAL_TOKEN_KEY, token);
			//useCredentials(token);
		}

		function storeUserSecret(secret){
			window.localStorage.setItem(SECRET_USER, secret);
		}

		function storeMenu(menu){
			window.localStorage.setItem(MENU_USER, JSON.stringify(menu));
		}

		function getUserSecret(){
			return window.localStorage.getItem(SECRET_USER);
		}


		function setLicenseToken(token){
			window.localStorage.setItem(IKANO_LICENSE,token);
		}

		function storeUserInfo(userInfo) {
			var infoUser = setUserInfoBtoa(userInfo);
			window.localStorage.setItem(USER_INFO_KEY, JSON.stringify(infoUser));
		}

		function setUserInfoBtoa(userInfo){
			userInfo.user_base = window.btoa(userInfo.username ? userInfo.username : userInfo.cedula);
			userInfo.name_base = window.btoa(userInfo.name);
			userInfo.email_base = window.btoa(userInfo.email ? userInfo.email : userInfo.correo);
			return userInfo;
		}

		function getMenu(){
			return JSON.parse(window.localStorage.getItem(MENU_USER));
		}

		function checkAuth(data){
			var license = window.localStorage.getItem(LOCAL_TOKEN_KEY);
			return license ? true : false;
		}

		

	}
}());
(function ()
{
    'use strict';

    angular
        .module('app.users.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.users_login', {
            url      : '/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.users_login': {
                    templateUrl: 'app/main/modules/users/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login-v2'
        });


    }

})();
(function () {
	'use strict';

	angular.module('app.users.login')
		.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($state, UsersService, $rootScope, UtilsService, evaluationService, LicenseService, api) {

		//Track Google Analytics
		UtilsService.trackPage();

		//UsersService.setLicense(LicensesData);

		var vm = this;

		LicenseService.getLicense().then(function (licenseData) {
			vm.licenseData = licenseData;
			vm.license = licenseData.license;
			LicenseService.setLocalstorage(licenseData);
			api.setBaseUrl(licenseData.api_baseUrl);
			UsersService.setLicenseToken(licenseData.secret);
		}, function (err) {
		});



		//vm.license = $rootScope.license;

		// Data
		var loginInProgress = false;
		vm.form = {};
		vm.loginFailed = false;

		// Methods
		//vm.backendLogin = backendLogin;
		vm.doLogin = doLogin;

		//Eventos
		function init() {
			var license = LicenseService.getLicenseJson();
			if (!license) {
				setTimeout(init, 1000);
			} else {
				vm.licenseData = license;
				vm.license = license.license;
			}
		}
		//////////
		function doLogin(ev) {

			loginInProgress = true;

			UsersService.login(vm.form.email, vm.form.password).then(function (data) {

				//Cargar los periodos disponibles de evaluación
				evaluationService.getPeriods(true).then(function (response) {
					if (data.data.user.group.id == 3) {
						$state.transitionTo('app.employee_profile', {}, {
							reload: true, inherit: false, notify: true
						});
					} else {
						$state.go('app.cstm_evaluation');
					}

				}).catch(function (err) {
				});



				loginInProgress = false;
			}, function (err) {
				vm.loginFailed = true;

				loginInProgress = false;
			});

		}

		init();
	}

})(); 
(function ()
{
    'use strict';

    angular
        .module('app.users.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.users_forgot_password', {
            url      : '/forgot_password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.users_forgot_password': {
                    templateUrl: 'app/main/modules/users/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'login-v2'
        });

    }

})();
(function () {
	'use strict';

	angular
		.module('app.users.forgot-password')
		.controller('ForgotPasswordController', ForgotPasswordController);

	/** @ngInject */
	function ForgotPasswordController($rootScope, UsersService, $mdDialog, UtilsService, LicenseService) {
		//Track Google Analytics
		UtilsService.trackPage();

		//UsersService.setLicense(LicensesData);

		var vm = this;

		LicenseService.getLicense().then(function (licenseData) {
			vm.licenseData = licenseData;
			vm.license = licenseData.license;
		}, function (err) {
		});

		vm.form = {};
		// Methods
		vm.sendLink = sendLink;

		//////////
		function sendLink(ev) {

			UsersService.sendResetLink(vm.form.email).then(function (response) {
				// Update successful.
				var msgBox = $mdDialog.alert()
					.title('')
					.htmlContent('Se ha enviado un mensaje a su correo electrónico con las instrucciones para restablecer su contraseña')
					.targetEvent(ev)
					.ok('OK');

				$mdDialog.show(msgBox);

			}, function (error) {

				var msgBox = $mdDialog.alert()
					.title('')
					.htmlContent('La información ingresada no es válida, por favor intente de nuevo')
					.targetEvent(ev)
					.ok('OK');

				$mdDialog.show(msgBox);
			});
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.users.admin')
        .factory('UsersAdminService', UsersAdminService);

    /** @ngInject */
    function UsersAdminService($q, api)
    {
        var service = {
        	asignarSociedades: asignarSociedades,
        	deleteUser: deleteUser,
        	editUser: editUser,
        	newUser: newUser,
        };

        return service;

        //////////
        
        function asignarSociedades(user_id, sociedades) {
			var deferred = $q.defer();
			
			api.custom_general.asignarSociedades.save({
				user_id: user_id,
				sociedades: sociedades
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});    
			
			return deferred.promise;
        }

        function deleteUser(id) {
			var deferred = $q.defer();
			
			api.admin.user.deleteUser.save({
				user_id: id
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;        	
        }
        
        function editUser(id, user_data) {
			var deferred = $q.defer();
			
			api.admin.user.editUser.save({
				user_id: id,
				user_data: user_data
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;        	
        }
        
        function newUser(user_data) {
        	
			var deferred = $q.defer();
        	
			api.admin.user.newUser.save({
				user_data: user_data
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});
				

			return deferred.promise;        	
        }
               
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.users.admin')
        .controller('UsersAdminController', UsersAdminController);

    /** @ngInject */
    function UsersAdminController($scope, UsersAdminService, $mdDialog, $document, Users, UserProfiles, AsistentesTecnicos, Sociedades, UtilsService)
    {
    	//Track Google Analytics
        UtilsService.trackPage();        

        var vm = this;

        // Data
        vm.users = Users.users;
        vm.asistentes_tecnicos = AsistentesTecnicos.asistentes;
        vm.Sociedades = Sociedades.response_data;
        vm.user_profiles = UserProfiles.user_profiles;

		//Global configuration
		vm.dtOptions = {
			dom : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType : 'simple',
			autoWidth : false,
			language: UtilsService.getLanguajeDataTable(),
			responsive : true
		};

        // Methods
        vm.openDialog = openDialog;
        vm.openDialogSociedades = openDialogSociedades;

        //////////

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openDialog(ev, user)
        {
            $mdDialog.show({
                controller         : 'UsersDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/modules/users/admin/dialogs/usuario/usuario-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    User : user,
                    Users: vm.users,
                    AsistentesTecnicos: vm.asistentes_tecnicos,
                    UserProfiles: vm.user_profiles,
                }
            });
        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openDialogSociedades(ev, user)
        {
            $mdDialog.show({
                controller         : 'SociedadDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/modules/users/admin/dialogs/sociedades/sociedad-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    User : user,
                    Sociedades: vm.Sociedades
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.report', {
            url  : '/report/:report_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/modules/reports/report/report.html',
                    controller : 'ReportController as vm'
                }
            },
            requiresAuthentication: true
        });
        
    }

})();
(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ReportController', ReportController);

    /** @ngInject */
    function ReportController($mdDialog, $document, $state, $scope, $filter, $window, $mdDateLocale, api, DTColumnDefBuilder, UtilsService, $compile, reportService) {
        var vm = this;
        vm.loading = true;
        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Reportes'],
            title: "",
        };

        vm.valueFilter = {};
        vm.valueFilterTmp = {};
        vm.searchFilter = {};
        vm.headersColumn = {};
        vm.filters = [];

        vm.limit = 10;
        vm.pager = {};

        vm.loadingReportData = false;

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('DD/MMMM/YYYY') : '';
        };

        vm.dtOptions = UtilsService.getDataTableOptions()
/*
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<>><"right"<"info"i><"pagination"p>>>',
            responsive: true,
            autoWidth: true,
            sPagingationType: "full_numbers",
            iDisplayLength: 20,
            deferRender: true,
            sorting: false
        };
*/
        $scope.$watch('vm.valueFilterTmp', function (current) {
            if (vm.filters.length == 0) { return; }
            changeDependency(current);
            changeDate(current);
        }, true);

        vm.configFilter = {
            page: 1,
            limit: vm.limit,
            formatolist: 'json',
            formatodownload: 'excel',
            type_report: 'core',
            clase: 'Ikano'
        }

        var currentReport = $state.params.report_id;


        vm.init = function () {
            vm.filtrosinit = {
                "report_name_id": currentReport,
                'page': vm.configFilter.page,
                'per_page': vm.configFilter.limit,
                "formato": vm.configFilter.formatolist,
                "type_report": vm.configFilter.type_report,
                "clase": vm.configFilter.clase,
            }
            getReport(vm.filtrosinit);

        }

        vm.filterByCriteria = function () {
            vm.page = 1;
            vm.valueFilter = angular.copy(vm.valueFilterTmp);
            if (validateDate()) {
                var filter = serializeFilter(vm.configFilter.formatolist);
                getReport(filter);
            } else {
                //IkanoFactory.showAlert("Error", "Hay campos fechas sin valor, por favor validar.");
            }

        };

        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            /*
            vm.pager = paginationService.GetPager(vm.total_results, page, vm.limit);
            if (!noConsult) {
                var filter = serializeFilter(vm.configFilter.formatolist);
                getReport(filter);
            }
            setTimeout(function () {
                createPagination();
            }, 1000);
            */
        }

        vm.resetFilter = function () {
            vm.valueFilter = {};
            vm.valueFilterTmp = {};
            vm.page = 1;
            var filter = serializeFilter(vm.configFilter.formatolist);
            getReport(filter);
        };

        vm.downloadExcel = function () {

          vm.valueFilter = angular.copy(vm.valueFilterTmp);
          var filter = serializeFilter(vm.configFilter.formatodownload);

          //Data
          /*reportService.getReport(filter, true).then(function(response) {

            //$window.open('http://ikanorhapi.ikanosmart.com' + '/' + response.report_filename, "_blank");
            $window.open(api.baseUrl + '/' + response.report_filename, "_blank");

          }).catch(function(err) {
            // TODO
          }); */
          //var url = 'report/getReport'
          api.general.getWindowHttp('GET', 'report/getReport', filter, vm.reportName+'.xls');

/*
            vm.valueFilter = angular.copy(vm.valueFilterTmp);
            var filter = serializeFilter(vm.configFilter.formatodownload);
            AdminService.getServiceReportLevelService(filter, {}, function (response) {
                $window.open(api.general.getUrlBase() + '/' + response.data.report_filename, "_blank");
            },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                },
                false,
                {
                    old: false
                });
                */
        };

        vm.search = function (arr, filter) {
            var arrReturn = [];
            if (filter && filter.length >= 3) {
                return $filter('filter')(arr, filter);
            } else {
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    arrReturn.push(arr[pushIndex]);
                }
            }
            return arrReturn;
        }

        function getReport(filtros) {

          vm.loadingReportData = true;
          //Data
          reportService.getReport(filtros).then(function(response) {

            //Asignar data
            if (vm.filters.length == 0) {
                vm.filters = serializeFilters(response.filters);
            }
            vm.reportName = response.report_name;
            vm.headersColumn = response.data_headers;
            vm.reportData = response.data_results;
            modelPagination(response.total_results);
            vm.loading = false;
            $("input.md-datepicker-input").prop('readonly', true);

            vm.loadingReportData = false;

          }).catch(function(err) {
            // TODO
            vm.loadingReportData = false;
          }); 

        };

        function modelPagination(total_results) {
            vm.total_results = total_results;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function serializeFilter(type, page) {

            var filter = {
                "report_name_id": currentReport,
                "formato": type,
                "type_report": vm.configFilter.type_report,
                "clase": vm.configFilter.clase,
                'per_page': vm.configFilter.limit,
                'page': vm.page
            }
            for (var i in vm.filters) {
                var filternow = vm.filters[i].id;
                filter["filter_" + filternow] = '';
                if (vm.valueFilter[filternow]) {
                    filter["filter_" + filternow] = vm.valueFilter[filternow];
                } else {
                    continue;
                }

                if (vm.filters[i].type == 'DATE' || vm.filters[i].type == 'DATE_BETWEEN') {
                    filter["filter_" + filternow] = moment(vm.valueFilter[filternow]).format('YYYY-MM-DD');
                    continue;
                }

                if (typeof vm.valueFilter[filternow] == 'object') {
                    filter["filter_" + filternow] = vm.valueFilter[filternow].id;
                }
            }
            return filter;
        }

        function serializeFilters(filter) {
            var dependency = [];
            for (var i in filter) {
                if (filter[i].dependency) {
                    /*if(dependency.indexOf(filter.dependency) == -1){
                        dependency.push(filter.dependency);
                    };*/
                    filter[i].show = false;
                } else {
                    filter[i].show = true;
                }
            }
            return filter;
        }

        function createPagination() {
            var elemt = $('.right');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} de {{vm.total_results}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            vm.paginationLoad = true;
        }

        function changeDependency(current) {
            var dependency = vm.filters.filter(function (row) {
                return row.dependency;
            });
            if (dependency.length == 0) {
                return;
            }
            for (var i in vm.filters) {
                for (var j in dependency) {
                    if (vm.valueFilterTmp[dependency[j].dependency] && vm.filters[i].id == dependency[j].id) {
                        vm.filters[i].show = true;
                        break;
                    } else if (!vm.valueFilterTmp[dependency[j].dependency] && vm.filters[i].id == dependency[j].id) {
                        vm.filters[i].show = false;
                        break;
                    }
                }
            }
        }

        function changeDate(current) {
            var date = vm.filters.filter(function (row) {
                return row.type == 'DATE';
            });

            if (date.length == 0) {
                return;
            }


            for (var i in date) {
                getDateBetween(date[i].relation, date[i].id);
            }

        }

        function getDateBetween(id, idOrigin) {
            var date_between = vm.filters.filter(function (row) {
                return (row.type == 'DATE_BETWEEN' && row.id == id);
            });

            if (date_between.length == 0) {
                return;
            }

            if (vm.valueFilterTmp[date_between[0].id]) {

                if (vm.valueFilterTmp[idOrigin]) {
                    if (moment(vm.valueFilterTmp[date_between[0].id]) > moment(vm.valueFilterTmp[idOrigin])) {
                        vm.valueFilterTmp[idOrigin] = '';
                    }
                }

                for (var i in vm.filters) {
                    if (vm.filters[i].id == idOrigin) {
                        vm.filters[i].min_date = vm.valueFilterTmp[date_between[0].id];
                    }
                }
            }
        };

        function validateDate() {
            var date = vm.filters.filter(function (row) {
                return row.type == 'DATE';
            });

            if (date.length == 0) {
                return true;
            }

            for (var i in date) {
                if ((!vm.valueFilterTmp[date[i].id] || vm.valueFilterTmp[date[i].id] == "") && (vm.valueFilterTmp[date[i].relation] && vm.valueFilterTmp[date[i].relation] != "")) {
                    return false;
                }
                if ((!vm.valueFilterTmp[date[i].relation] || vm.valueFilterTmp[date[i].relation] == "") && (vm.valueFilterTmp[date[i].id] && vm.valueFilterTmp[date[i].id] != "")) {
                    return false;
                }
            }

            return true;
        }

        vm.init();

    }
})();

(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrCoreValueService', HrCoreValueService);

    /** @ngInject */
    function HrCoreValueService($q, api, UtilsService, $mdDialog, $document) {

        var lastComment = {};
        var countSend = 0;

        var service = {

            init_valueEvaluation: init_valueEvaluation,
            open_valueEvaluationSingle: open_valueEvaluationSingle,
            open_valueEvaluationChief: open_valueEvaluationChief,
            saveEvaluation: saveEvaluation,
            serializeTitleObj: serializeTitleObj,
            setTitleColor: setTitleColor,
            saveStep_valueEvaluation: saveStep_valueEvaluation,
            init_valueEvaluationApproval: init_valueEvaluationApproval,
            saveStep_valueEvaluationApproval: saveStep_valueEvaluationApproval,
            serializeResultsByRole: serializeResultsByRole

        };

        return service;

        //////////
        function init_valueEvaluation(data) {
            _init_valueEvaluation(data);
        }

        function saveStep_valueEvaluation(data) {
            _init_valueEvaluation(data);
        }

        function init_valueEvaluationApproval(data) {
            _init_valueEvaluationApproval(data);
        }

        function saveStep_valueEvaluationApproval(data) {
            var dataSend = {
                evaluation_current_process_id: data.evaluation_current_process.id,
                finalize: false,
                data: {
                    approved: data.aprobado,
                    comment: data.rejected_comment
                }
            }

            if (!angular.equals(lastComment, {}) &&  countSend > 0) {
                dataSend.data.comment_id = lastComment.id;
            }

            var deferred = $q.defer();

            api.evaluations.saveProcessData.save(dataSend,
                // Success
                function (response) {
                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }
                    if (data.aprobado == false) {
                        countSend = countSend + 1;
                        lastComment = response.data.evaluation_hr_module ? response.data.evaluation_hr_module.comments[0] : {};
                    }
                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function _init_valueEvaluation(data) {

            if(data.error){
                return;
            }

            data.isBoss = data.core_value_evaluator.role === 'chief';

            data.core_values = [];
            data.core_values = data.core_value_profile.map(function (element) {
                var objPush = {
                    id: element.id
                };
                var estado = false;
                var result = null;
                var autoResult = null;
                for (var i in data.core_value_evaluations) {
                    var evaluation = data.core_value_evaluations[i];

                    //BUSCAR AUTOEVALUACION
                    if (element.core_value.id == evaluation.core_value.id && evaluation.core_value_evaluator.role == 'self') {
                        autoResult = evaluation.result;
                    }

                    //Buscar evaluacion por el evaluador
                    if (data.core_value_evaluator.evaluator.id == evaluation.core_value_evaluator.evaluator.id && element.core_value.id == evaluation.core_value.id) {
                        result = evaluation.result;
                        estado = true;
                    }

                }

                var dataSkill = element.core_value;
                objPush.estado = estado;
                objPush.autoResult = autoResult;
                objPush.result = result;
                objPush.core_value_id = dataSkill.id;
                objPush.description = dataSkill.description;
                objPush.name = dataSkill.name;
                objPush.core_value_type = dataSkill.core_value_type;
                objPush.show = data.core_value_descriptors[dataSkill.id];
                return objPush;
            });
            if (data.evaluation_hr_module) {
                data.comments = data.evaluation_hr_module.comments ? data.evaluation_hr_module.comments : [];
            }

            serializeSummary(data);
        }

        function _init_valueEvaluationApproval(data) {
            var evaluations = data.core_value_evaluations;
            countSend = 0;
            var title = serializeTitleTable(data.evaluation_preferences);
            var titleObj = serializeTitleObj(data.evaluation_preferences);
            var titleColor = setTitleColor(data.evaluation_preferences);
            var body = data.core_value_profile.map(function (element) {
                var skillDescriptors = data.core_value_descriptors[element.core_value.id];
                var skillDetail = data.core_value_profile.filter(function (elem) {
                    return elem.core_value_id == element.core_value.id;
                });
                var dataBody = evaluations.filter(function (elem) {
                    return elem.core_value.id == element.core_value.id;
                })
                var objReturn = {
                    skillDescriptors: skillDescriptors,
                    skillDetail: skillDetail.length ? skillDetail[0] : [],
                    dataBody: dataBody.length ? dataBody : {}
                }

                return objReturn;
            });
            data.approvalStructure = {
                title: title,
                body: body,
                titleObj: titleObj,
                titleColor: titleColor
            }

            var noapprobe = data.core_value_evaluations.filter(function (element) {
                return element.is_approved === false;
            });

            var approbe = data.core_value_evaluations.filter(function (element) {
                return element.is_approved === true;
            });

            if (noapprobe.length > 1) {
                data.aprobado = false;
                data.notApprober = noapprobe;
                //data.lastComment = data.evaluation_hr_module.comments[0];
            }
            if (approbe.length > 1) {
                data.aprobado = true;
                data.approbe = approbe;
            }

        }

        function serializeSummary(data) {
            var evaluator = data.core_value_evaluator;
            var evaluations = data.core_value_evaluations.filter(function (element) {
                return element.core_value_evaluator.evaluator.id == evaluator.evaluator.id;
            });

            var title = serializeTitleTable(data.evaluation_preferences);
            var body = data.core_value_profile.map(function (element) {
                var skillDescriptors = data.core_value_descriptors[element.core_value.id];
                var skillDetail = data.core_value_profile.filter(function (elem) {
                    return elem.core_value_id == element.core_value.id;
                });
                var dataBody = evaluations.filter(function (elem) {
                    return elem.core_value.id == element.core_value.id;
                })
                var objReturn = {
                    skillDescriptors: skillDescriptors,
                    skillDetail: skillDetail.length ? skillDetail[0] : [],
                    dataBody: dataBody.length ? dataBody[0] : {}
                }

                return objReturn;
            });
            data.sumaryStructure = {
                title: title,
                body: body
            }
        }

        function serializeTitleTable(preferences) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });
            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }

        function open_valueEvaluationSingle(ev, skill, data, user_profile) {
            var evaluator = data.core_value_evaluator;
            var descriptors = data.core_value_descriptors[skill.core_value_id];
            var evaluations = data.core_value_evaluations.filter(function (element) {
                return element.core_value.id == skill.core_value_id && evaluator.evaluator.id == element.core_value_evaluator.evaluator.id;
            });
            $mdDialog.show({
                controller: 'EvaluationCoreValueSingleDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-value/dialogs/single/single-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Skill: skill,
                    Descriptors: descriptors,
                    Data: evaluations.length > 0 ? evaluations[0] : null,
                    ModuleData: data,
                    UserProfile: user_profile,
                    Preferences: data.evaluation_preferences,
                    EvaluationCurrentProcess: data.evaluation_current_process,
                    Evaluator: evaluator,
                    event: ev
                }
            }).finally(function (e) {
                console.log(e);
            });
        }

        function open_valueEvaluationChief(ev, skill, data, user_profile) {

            var descriptors = data.core_value_descriptors[skill.core_value_id];
            var evaluations = data.core_value_evaluations.filter(function (element) {
                return element.core_value.id == skill.core_value_id;
            });
            $mdDialog.show({
                controller: 'EvaluationCoreValueChiefDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-value/dialogs/chief/chief-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Skill: skill,
                    Descriptors: descriptors,
                    Data: evaluations,
                    ModuleData: data,
                    UserProfile: user_profile,
                    Preferences: data.evaluation_preferences,
                    EvaluationCurrentProcess: data.evaluation_current_process,
                    event: ev,
                    panelClass: 'w-90-p'
                }
            }).finally(function (e) {
                console.log(e);
            });
        }

        function saveEvaluation(data) {
            var deferred = $q.defer();

            api.evaluations.saveProcessData.save(data,
                // Success
                function (response) {
                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }
                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }



        function serializeTitleObj(preferences) {
            var obj = {};
            preferences = preferences.results_scale;
            for (var i in preferences) {
                obj[preferences[i].value] = preferences[i];
            }
            return obj;
        }

        function setTitleColor(preferences) {
            var obj = {};
            var colors = ['#3b701c', '#b2b503', '#f29607', '#e84d10', '#e51313'];
            var colorUse = [];
            preferences = preferences.results_scale;
            for (var i in preferences) {
                for (var c in colors) {
                    if (colorUse.indexOf(colors[c]) == -1) {
                        obj[preferences[i].value] = colors[c];
                        colorUse.push(colors[c]);
                        break;
                    }
                }

            }
            return obj;
        }

        function serializeResultsByRole(dataGlobal){
            var data = dataGlobal.results_by_role.final ? dataGlobal.results_by_role.final : null;
            if(!data){
                return {};
            }
            var header = {};
            var body = {};
            for (var i in data){
                var result = data[i];
                body[i] = {};
                for(var s in dataGlobal.core_value_profile){
                    if(dataGlobal.core_value_profile[s].core_value_id == i){
                        body[i].name = dataGlobal.core_value_profile[s].core_value.name;
                    }
                }
                body[i].data = {};
                for(var r in result){
                    header[result[r].role] =  result[r].role;
                    body[i].data[result[r].role] = result[r].avg_result;
                }
            }
            //return {header:header,body:body};
            return {body:body};
        }
    }
}());

(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrSkillService', HrSkillService);

    /** @ngInject */
    function HrSkillService($q, api, UtilsService, $mdDialog, $document) {

        var lastComment = {};
        var countSend = 0;

        var service = {

            init_skillFollowUpEvaluation: init_skillFollowUpEvaluation,
            open_skillFollowUpEvaluationSingle: open_skillFollowUpEvaluationSingle,
            saveEvaluation: saveEvaluation,
            open_skillFollowUpEvaluationChief: open_skillFollowUpEvaluationChief,
            init_skillFollowUpEvaluationApproval: init_skillFollowUpEvaluationApproval,
            saveStep_skillFollowUpEvaluationApproval: saveStep_skillFollowUpEvaluationApproval,
            saveStep_skillFollowUpEvaluation: saveStep_skillFollowUpEvaluation,
            serializeTitleObj: serializeTitleObj,
            setTitleColor: setTitleColor,
            init_skillEvaluation: init_skillEvaluation,
            saveStep_skillEvaluation: saveStep_skillEvaluation,
            init_skillEvaluationApproval: init_skillFollowUpEvaluationApproval,
            saveStep_skillEvaluationApproval: saveStep_skillFollowUpEvaluationApproval,
            serializeResultsByRole: serializeResultsByRole,
            open_skillFollowUpEvaluationSingleEtapasNovacion: open_skillFollowUpEvaluationSingleEtapasNovacion

        };

        return service;

        //////////
        function init_skillFollowUpEvaluation(data) {
            _init_skillFollowUpEvaluation(data);
        }

        function init_skillEvaluation(data) {
            _init_skillFollowUpEvaluation(data);
        }

        function init_skillFollowUpEvaluationApproval(data) {
            _init_skillFollowUpEvaluationApproval(data);
        }

        function saveStep_skillFollowUpEvaluation(data) {
            _init_skillFollowUpEvaluation(data);
        }

        function saveStep_skillEvaluation(data) {
            _init_skillFollowUpEvaluation(data);
        }

        function _init_skillFollowUpEvaluation(data) {

            //var validacion = data.evaluation_preferences.type_evaluation;
            if (!data.error) {
                serializeDefault(data);
            }

            /*switch (validacion) {
                case 'ETAPAS_NOVACION':
                    serializeEtapaNovacion(data);
                    break;
                default:
                    serializeDefault(data);
                    break;
            }*/


        }

        function serializeDefault(data) {
            data.isBoss = data.skill_evaluator.role === 'chief';

            data.skills = [];
            data.skills = data.skills_profile.map(function (element) {
                var objPush = {
                    id: element.id
                };
                var estado = false;
                var result = null;
                var autoResult = null;
                for (var i in data.skills_evaluations) {
                    var evaluation = data.skills_evaluations[i];

                    //BUSCAR AUTOEVALUACION
                    if (element.skill.id == evaluation.skill.id && evaluation.skills_evaluator.role == 'self') {
                        autoResult = evaluation.result;
                    }

                    //Buscar evaluacion por el evaluador
                    if (data.skill_evaluator.evaluator.id == evaluation.skills_evaluator.evaluator.id && element.skill.id == evaluation.skill.id) {
                        result = evaluation.result;
                        estado = true;
                    }

                }

                var dataSkill = element.skill;
                objPush.estado = estado;
                objPush.autoResult = autoResult;
                objPush.result = result;
                objPush.skill_id = dataSkill.id;
                objPush.description = dataSkill.description;
                objPush.name = dataSkill.name;
                objPush.skill_type = dataSkill.skill_type;
                objPush.show = data.skills_descriptors[dataSkill.id];
                return objPush;
            });
            if (data.evaluation_hr_module) {
                data.comments = data.evaluation_hr_module.comments ? data.evaluation_hr_module.comments : [];
            }


            // data.fullTemplatePath = 'app/main/elements/ik-hr-evaluation-action/hr-skill/skill-evaluation/' + data.evaluation_preferences.type_evaluation == 'ESCALA_FRECUENCIA' ? 'default' : 'etapas_novacion' + '/default.html';
            data.isDefault =  data.evaluation_preferences.type_evaluation == 'ESCALA_FRECUENCIA' ? true : false ;

            serializeSummary(data);
        }

        /*function serializeEtapaNovacion(data) {
            console.log(data);
        }*/

        function serializeSummary(data) {
            var evaluator = data.skill_evaluator;
            var evaluations = data.skills_evaluations.filter(function (element) {
                return element.skills_evaluator.evaluator.id == evaluator.evaluator.id;
            });

            var title = serializeTitleTable(data.evaluation_preferences, evaluator);
            var body = data.skills_profile.map(function (element) {
                var skillDescriptors = data.skills_descriptors[element.skill.id];
                var skillDetail = data.skills_profile.filter(function (elem) {
                    return elem.skill_id == element.skill.id;
                });
                var dataBody = evaluations.filter(function (elem) {
                    return elem.skill.id == element.skill.id;
                })
                var objReturn = {
                    skillDescriptors: skillDescriptors,
                    skillDetail: skillDetail.length ? skillDetail[0] : [],
                    dataBody: dataBody.length ? dataBody[0] : {}
                }

                return objReturn;
            });
            data.sumaryStructure = {
                title: title,
                body: body
            }
        }

        function _init_skillFollowUpEvaluationApproval(data) {
            var evaluations = data.skills_evaluations;
            countSend = 0;
            var title = serializeTitleTable(data.evaluation_preferences);
            var titleObj = serializeTitleObj(data.evaluation_preferences);
            var titleColor = setTitleColor(data.evaluation_preferences);
            var body = data.skills_profile.map(function (element) {
                var skillDescriptors = data.skills_descriptors[element.skill.id];
                var skillDetail = data.skills_profile.filter(function (elem) {
                    return elem.skill_id == element.skill.id;
                });
                var dataBody = evaluations.filter(function (elem) {
                    return elem.skill.id == element.skill.id;
                })
                var objReturn = {
                    skillDescriptors: skillDescriptors,
                    skillDetail: skillDetail.length ? skillDetail[0] : [],
                    dataBody: dataBody.length ? dataBody : {}
                }

                return objReturn;
            });
            data.approvalStructure = {
                title: title,
                body: body,
                titleObj: titleObj,
                titleColor: titleColor
            }

            var noapprobe = data.skills_evaluations.filter(function (element) {
                return element.is_approved === false;
            });

            var approbe = data.skills_evaluations.filter(function (element) {
                return element.is_approved === true;
            });

            if (noapprobe.length > 1) {
                data.aprobado = false;
                data.notApprober = noapprobe;
                //data.lastComment = data.evaluation_hr_module.comments[0];
            }
            if (approbe.length > 1) {
                data.aprobado = true;
                data.approbe = approbe;
            }
            if (!data.skills_approver_comment) {
                data.skills_approver_comment = {};
            }
        }

        function serializeTitleTable(preferences, evaluator) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });
            if (evaluator) {
                newPreference = newPreference.filter(function (element) {
                    if (element.only_for) {
                        if (element.only_for.indexOf(evaluator.role) != -1) {
                            return element;
                        }
                    } else {
                        return element;
                    }
                });
            }
            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }

        function serializeTitleObj(preferences) {
            var obj = {};
            preferences = preferences.results_scale;
            for (var i in preferences) {
                obj[preferences[i].value] = preferences[i];
            }
            return obj;
        }

        function setTitleColor(preferences) {
            var obj = {};
            var colors = ['#3b701c', '#b2b503', '#f29607', '#e84d10', '#e51313'];
            var colorUse = [];
            preferences = preferences.results_scale;
            for (var i in preferences) {
                for (var c in colors) {
                    if (colorUse.indexOf(colors[c]) == -1) {
                        obj[preferences[i].value] = colors[c];
                        colorUse.push(colors[c]);
                        break;
                    }
                }

            }
            return obj;
        }

        function open_skillFollowUpEvaluationSingle(ev, skill, data, user_profile) {

            var evaluator = data.skill_evaluator;
            var descriptors = data.skills_descriptors[skill.skill_id];
            var evaluations = data.skills_evaluations.filter(function (element) {
                return element.skill.id == skill.skill_id && evaluator.evaluator.id == element.skills_evaluator.evaluator.id;
            });
            $mdDialog.show({
                controller: 'EvaluationSkillSingleDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-skill/dialogs/single/single-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Skill: skill,
                    Descriptors: descriptors,
                    Data: evaluations.length > 0 ? evaluations[0] : null,
                    ModuleData: data,
                    UserProfile: user_profile,
                    Preferences: data.evaluation_preferences,
                    EvaluationCurrentProcess: data.evaluation_current_process,
                    Evaluator: evaluator,
                    event: ev
                }
            }).finally(function (e) {
                console.log(e);
            });
        }

        function open_skillFollowUpEvaluationSingleEtapasNovacion(ev, skill, data, user_profile) {
            var evaluator = data.skill_evaluator;
            var descriptors = data.skills_descriptors[skill.skill_id];
            var evaluations = data.skills_evaluations.filter(function (element) {
                return element.skill.id == skill.skill_id && evaluator.evaluator.id == element.skills_evaluator.evaluator.id;
            });
            $mdDialog.show({
                controller: 'EvaluationSkillEtapasNovacionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-skill/dialogs/etapas_novacion/default.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Skill: skill,
                    Descriptors: descriptors,
                    Data: evaluations.length > 0 ? evaluations[0] : null,
                    ModuleData: data,
                    UserProfile: user_profile,
                    Preferences: data.evaluation_preferences,
                    EvaluationCurrentProcess: data.evaluation_current_process,
                    Evaluator: evaluator,
                    event: ev
                }
            }).finally(function (e) {
                console.log(e);
            });
        }

        function open_skillFollowUpEvaluationChief(ev, skill, data, user_profile) {

            var descriptors = data.skills_descriptors[skill.skill_id];
            var evaluations = data.skills_evaluations.filter(function (element) {
                return element.skill.id == skill.skill_id;
            });
            $mdDialog.show({
                controller: 'EvaluationSkillChiefDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-skill/dialogs/chief/chief-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Skill: skill,
                    Descriptors: descriptors,
                    Data: evaluations,
                    ModuleData: data,
                    UserProfile: user_profile,
                    Preferences: data.evaluation_preferences,
                    EvaluationCurrentProcess: data.evaluation_current_process,
                    event: ev,
                    panelClass: 'w-90-p'
                }
            }).finally(function (e) {
                console.log(e);
            });
        }

        function saveEvaluation(data) {
            var deferred = $q.defer();

            api.evaluations.saveProcessData.save(data,
                // Success
                function (response) {
                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }
                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function saveStep_skillFollowUpEvaluationApproval(data) {
            var dataSend = {
                evaluation_current_process_id: data.evaluation_current_process.id,
                finalize: false,
                data: {
                    approved: data.aprobado,
                    comment: data.rejected_comment,
                    approver_comment: data.skills_approver_comment.approver_comment
                }
            }

            if (!angular.equals(lastComment, {}) && data.aprobado == true && countSend > 0) {
                dataSend.data.comment_id = lastComment.id;
            }

            var deferred = $q.defer();

            api.evaluations.saveProcessData.save(dataSend,
                // Success
                function (response) {
                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }
                    if (data.aprobado == false) {
                        countSend = countSend + 1;
                        lastComment = response.data.evaluation_hr_module ? response.data.evaluation_hr_module.comments[0] : {};
                    }
                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function serializeResultsByRole(dataGlobal) {
            var data = dataGlobal.results_by_role.final ? dataGlobal.results_by_role.final : null;
            if (!data) {
                return {};
            }
            var header = {};
            var body = {};
            for (var i in data) {
                var result = data[i];
                body[i] = {};
                for (var s in dataGlobal.skills_profile) {
                    if (dataGlobal.skills_profile[s].skill_id == i) {
                        body[i].name = dataGlobal.skills_profile[s].skill.name;
                    }
                }
                body[i].data = {};
                for (var r in result) {
                    header[result[r].role] = result[r].role;
                    body[i].data[result[r].role] = result[r].avg_result;
                }
            }
            //return {header:header,body:body};
            return { body: body };
        }

    }

}());

(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrPollService', HrPollService);

    /** @ngInject */
    function HrPollService($q, api, UtilsService, $mdDialog, $document) {

        var service = {
            init_pollEvaluation: init_pollEvaluation,
            saveStep_pollEvaluation: saveStep_pollEvaluation,
            serializePollDetail: serializePollDetail
        };

        return service;

        //////////
        function init_pollEvaluation(data) {
            serializePoll(data);
        }

        function serializePoll(data) {

            var questionare = data.questionnaire ? data.questionnaire : {};
            var movilidad = [];
            data.formData = {};

            for (var i in questionare.poll_question_statement) {
                var question = questionare.poll_question_statement[i];
                movilidad.push({
                    id: question.id,
                    question_id: question.poll_question.id,
                    answer_type: question.poll_question.answer_type,
                    answer_list_id: question.poll_question.answer_list_id,
                    name: question.poll_question.name,
                    answer_list: question.poll_question.answer_list_id ? question.poll_question.answer_list : null,
                    comment_is_required: question.poll_question.comment_is_required
                });
            }

            for (var i in data.poll_evaluation.poll_detail) {
                var detail = data.poll_evaluation.poll_detail[i];
                var dataInser = {
                    comment: detail.comment
                };
                if(detail.result_list_item_id){
                    dataInser.result = detail.result_list_item_id;
                } else {
                    try{
                        var isNumber = parseInt(detail.result_text);
                        if(isNaN(isNumber)){
                            dataInser.result = detail.result_text;
                        }else{
                            dataInser.result = isNumber;
                        }
                        
                        
                    }catch(e){
                        dataInser.result = detail.result_text;
                    }
                    /*console.log(angular.isNumber(detail.result_text),detail.result_text);
                    if(angular.isNumber(detail.result_text)){
                        dataInser.result = parseInt(detail.result_text);
                    }else{
                        dataInser.result = detail.result_text;
                    }*/
                }

                data.formData[detail.poll_question_statement_id] = dataInser; 
            }
            
            data.movilidad = movilidad;

        }

        function saveStep_pollEvaluation(data) {
            var evaluation_current_process_id = data.evaluation_current_process.id;
            var results = [];
            var dataPost = {};

            for (var i in data.movilidad) {
                var movilidad = data.movilidad[i];
                var objInsert = {};
                objInsert.poll_question_statement_id = movilidad.id;
                objInsert.comment = data.formData[movilidad.id]? data.formData[movilidad.id].comment : null;
                switch (movilidad.answer_type) {
                    case 'select':
                        objInsert.result_list_item_id = data.formData[movilidad.id] ? data.formData[movilidad.id].result : null;
                        break;
                    default:
                        objInsert.result_text = data.formData[movilidad.id] ? data.formData[movilidad.id].result : null;
                }

                results.push(objInsert);

            }

            dataPost.results = results;

            var deferred = $q.defer();

            api.evaluations.saveProcessData.save({
                evaluation_current_process_id: evaluation_current_process_id,
                finalize: false,
                data: dataPost
            },
                // Success
                function (response) {

                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }

                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function serializePollDetail(data) {
            var movilidad = [];

            for (var i in data.poll_detail) {
                var detail = data.poll_detail[i];
                movilidad.push({
                    id:detail.id,
                    name: detail.poll_question_statement.poll_question.name,
                    comment: detail.comment,
                    result_list_item_id: detail.result_list_item_id,
                    result_text: detail.result_text,
                    result_list_item: detail.result_list_item
                });
            }

            return movilidad;
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrPersonalDevelopmentService', HrPersonalDevelopmentService);

    /** @ngInject */
    function HrPersonalDevelopmentService($q, api, UtilsService, $mdDialog, $document) {
        var service = {
            init_goalFollowUpEvaluation: init_goalFollowUpEvaluation,
            init_goalEvaluation: init_goalEvaluation,
            init_goalInscription: init_goalInscription,
            init_goalApproval: init_goalApproval,
            openEvaluationPersonalDialog: openEvaluationPersonalDialog,
            saveEvaluation: saveEvaluation,
            openInscriptionPersonalDialog: openInscriptionPersonalDialog,
            saveStep_goalApproval: saveStep_goalApproval,
            sendComments: sendComments,
            init_goalEvaluationApproval: init_goalEvaluationApproval
        };

        return service;

        //////////

        function init_goalFollowUpEvaluation(data) {
            _init_goalEvaluation(data);
        }
        function init_goalEvaluation(data) {
            _init_goalEvaluation(data);
        }

        function init_goalEvaluationApproval(data){
            _init_goalEvaluation(data);
        }

        function init_goalInscription(data) {
            _init_goalInscription(data);
        }

        

        function init_goalApproval(data) {
            _init_goalInscription(data);
        }

        function _init_goalEvaluation(data) {
            data.personal_data = [];
            var cont_obj_type = 0;
            var cons_obj = 1;

            var sendCommentProfile = ['chief', 'chiefchief', 'corpchief'];
            var rol = data.evaluation_current_process.evaluation_process_stage_content.evaluator_rol;

            data.config = {
                sendComment: sendCommentProfile.indexOf(rol) != -1 ? true : false
            }

            angular.forEach(data.personal_developments, function (personal) {

                personal['additional_info'] = {};
                personal['additional_info']['cont_label'] = cont_obj_type + "." + cons_obj;
                cons_obj = cons_obj + 1;
                personal.porcentaje = parseInt(personal.weight);
                personal.aprobado = personal.personal_dev_evaluation_data.is_approved != undefined ? personal.personal_dev_evaluation_data.is_approved : true;
                personal.comments = personal.personal_dev_evaluation_data.comments ? personal.personal_dev_evaluation_data.comments : [];
                //personal.lastComment = personal.aprobado ? {} : personal.comments[0];
                if (personal.comments.length > 0) {
                    if (personal.comments[0].empleado.id == data.evaluation_current_process.empleado_id && !personal.aprobado) {
                        personal.lastComment = personal.comments[0];
                    }
                }
                data.personal_data.push(personal);

            });
        }

        function _init_goalInscription(data) {
            data.personal_data = [];
            var cont_obj_type = 0;
            var cons_obj = 1;

            angular.forEach(data.personal_developments, function (personal) {

                personal['additional_info'] = {};
                personal['additional_info']['cont_label'] = cont_obj_type + "." + cons_obj;
                cons_obj = cons_obj + 1;
                personal.porcentaje = parseInt(personal.weight);
                personal.aprobado = personal.is_approved ? personal.is_approved : false;

                if (personal.comments.length > 0) {
                    if (personal.comments[0].empleado.id == data.evaluation_current_process.empleado_id && !personal.aprobado) {
                        personal.lastComment = personal.comments[0];
                    }
                }
                
                data.personal_data.push(personal);
            });
        }


        function openEvaluationPersonalDialog(ev, personal, data, user_profile, position) {
            var PersonalInfo = data.personal_data[data.personal_data.indexOf(personal)];
            user_profile = data.evaluation_current_process.evaluation_process_stage_content ? data.evaluation_current_process.evaluation_process_stage_content.evaluator_rol : null;
            $mdDialog.show({
                controller: 'EvaluationPersonalDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-personal-development/dialogs/evaluation-personal-dialog/evaluation-personal-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Personal: PersonalInfo,
                    ModuleData: data,
                    UserProfile: user_profile,
                    event: ev,
                    position: position
                }
            }).finally(function (e) {

            });
        }

        function openInscriptionPersonalDialog(ev, personal, data, user_profile, position) {
            var PersonalInfo = data.personal_data[data.personal_data.indexOf(personal)];
            $mdDialog.show({
                controller: 'InscriptionGoalListDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-personal-development/dialogs/inscription-goal-list-dialog/inscription-goal-list-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Personal: PersonalInfo ? PersonalInfo : {},
                    ModuleData: data,
                    UserProfile: user_profile,
                    event: ev,
                    position: position
                }
            }).finally(function (e) {

            });
        }

        function saveEvaluation(evaluation_current_process_id, data) {
            var deferred = $q.defer();

            api.evaluations.saveProcessData.save({
                evaluation_current_process_id: evaluation_current_process_id,
                data: data
            },
                // Success
                function (response) {

                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }

                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function saveStep_goalApproval(data) {
            var deferred = $q.defer();
            var approval_data = [];
            var idsGoalsComments = [];

            angular.forEach(data.personal_data, function (personal) {

                var dataSend = { id: personal.id, approve: personal.aprobado, comment: personal.rejected_comment };
                // if (personal.lastComment && personal.aprobado == true && personal.countSend) {
                if (personal.lastComment) {
                    dataSend.comment_id = personal.lastComment.id;
                }

                if (personal.aprobado == false) {
                    idsGoalsComments.push(personal.id);
                }
                approval_data.push(dataSend);
            });


            api.evaluations.saveProcessData.save({
                evaluation_current_process_id: data.evaluation_current_process.id,
                data: approval_data
            },
                // Success
                function (response) {

                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }

                    data.personal_data.map(function (personal) {
                        if (idsGoalsComments.indexOf(personal.id) !== -1) {
                            var commentsFilter = response.data.filter(function (element) { return element.id == personal.id });
                            personal.comments = commentsFilter[0].comments;
                            //if(!personal.lastComment){
                            personal.lastComment = commentsFilter[0].comments[0];
                            /*}else{
                                delete(personal.lastComment);
                            }*/

                            if (!personal.countSend) {
                                personal.countSend = 1;
                            } else {
                                personal.countSend += 1;
                            }
                        }
                    });

                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function sendComments($event, personal, data) {

            var deferred = $q.defer();

            var dataSend = { personal_development_id: personal.id, is_approved: personal.aprobado, comment: personal.rejected_comment };

            if (personal.lastComment) {
                dataSend.comment_id = personal.lastComment.id;
            }

            api.evaluations.saveProcessData.save({
                evaluation_current_process_id: data.evaluation_current_process.id,
                data: dataSend
            },
                // Success
                function (response) {

                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }

                    for (var i in data.personal_developments) {
                        var personals = data.personal_developments[i];
                        if (personals.id == personal.id) {
                            personals.comments = response.data.personal_dev_evaluation_data.comments;
                            personals.lastComment = response.data.personal_dev_evaluation_data.comments[0];

                            if(dataSend.is_approved){
                                personals.lastComment = {};
                              }
                            if (!personals.countSend) {
                                personals.countSend = 1;
                            } else {
                                personals.countSend += 1;
                            }
                        }
                    }
                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }


    }
}());
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrGoalIndicatorService', HrGoalIndicatorService);

    /** @ngInject */
    function HrGoalIndicatorService($q, api, UtilsService, $mdDialog, $document, $state) {
        var service = {
            init_goalFollowUpEvaluation: init_goalFollowUpEvaluation,
            init_goalEvaluation: init_goalEvaluation,
            init_goalInscription: init_goalInscription,
            goImportar: goImportar,
            goImportGoalInscription: goImportGoalInscription
        };

        return service;

        //////////

        function init_goalFollowUpEvaluation(data) {
            _ini_goalFollowUpEvaluation(data);
        }

        function init_goalEvaluation(data) {
            _init_goalEvaluation(data);
        }

        function init_goalInscription(data) {
            _init_goalInscription(data);
        }

        function _ini_goalFollowUpEvaluation(data) {
            data.evaluation_current_process_id = data.evaluation_current_process.id;
            data.key = 'goalFollowUpEvaluation';
        }

        function _init_goalEvaluation(data) {
            data.evaluation_current_process_id = data.evaluation_current_process.id;
            data.key = 'goalEvaluation';
        }

        function _init_goalInscription(data) {
            data.evaluation_current_process_id = data.evaluation_current_process.id;
            data.employee_goals = setEmployeeGoals(data);
            
            data.key = 'goalInscription';
        }

        function setEmployeeGoals(data){
            for (var i in data.employee_goals) {
                var empleado = data.employee_goals[i].empleado;
                var employee = data.employees.filter(function (element) {
                    return element.id == empleado.id;
                });
                data.employee_goals[i].employee = employee.length ? employee[0] : {};
            }
            return data.employee_goals;
        }

        function goImportar($evt, data) {
            $mdDialog.show({
                controller: 'ImportarDialogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-goal-indicator/dialogs/importar-dialog/importar-dialog.html',
                parent: angular.element($document.body),
                targetEvent: $evt,
                clickOutsideToClose: false,
                locals: {
                    Data: data,
                    Key: data.key
                }
            }).then(function (e) {
                if (e) {
                    UtilsService.showToast(e.message);
                    data.employee_indicators = e.employee_indicators;
                }

            });
        }

        function goImportGoalInscription($evt, data) {
            $mdDialog.show({
                controller: 'ImportarDialogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/hr-evaluation-modules/hr-goal-indicator/dialogs/importar-dialog/importar-dialog.html',
                parent: angular.element($document.body),
                targetEvent: $evt,
                clickOutsideToClose: false,
                locals: {
                    Data: data,
                    Key: data.key
                }
            }).then(function (e) {
                if (e) {
                    UtilsService.showToast(e.message);
                    data.employee_goals = setEmployeeGoals(e);
                    var jsonEliminate = e;
                    delete (jsonEliminate.employee_goals);
                    delete (jsonEliminate.employees);
                    data.errors = [];
                    for (var i in jsonEliminate) {
                        if (typeof jsonEliminate[i] == 'object') {
                            if (!angular.equals(jsonEliminate[i].errors, {})) {
                                for(var j in jsonEliminate[i].errors){
                                    var employee = data.employee_goals.filter(function(element){
                                        return element.id == j;
                                    });
                                    data.errors.push({employee:employee[0],error:jsonEliminate[i].errors[j]});
                                }
                            }
                        }
                    }
                }

            });
        }

    }
}());
(function () {
  'use strict';

  angular
    .module('app.hr-evaluation')
    .factory('HrGoalService', HrGoalService);

  /** @ngInject */
  function HrGoalService($q, api, UtilsService, $mdDialog, $document) {
    var service = {
      assignCompanyGoalsValues: assignCompanyGoalsValues,
      openInputGoalDialog: openInputGoalDialog,
      openSelectGoalDialog: openSelectGoalDialog,
      saveEvaluation: saveEvaluation,
      saveGoal: saveGoal,
      saveStep_goalApproval: saveStep_goalApproval,
      sumGoalsWeight: sumGoalsWeight,
      init_goalApproval: init_goalApproval,
      init_goalEvaluation: init_goalEvaluation,
      init_goalEvaluationApproval: init_goalEvaluationApproval,
      init_goalInscription: init_goalInscription,
      openEvaluationGoalDialog: openEvaluationGoalDialog,
      init_goalFollowUpEvaluation: init_goalFollowUpEvaluation,
      init_skillFollowUpEvaluation: init_skillFollowUpEvaluation,
      saveGoalSelectGoalDialog: saveGoalSelectGoalDialog,
      sendComments: sendComments,
      openEvaluationCommentDialog: openEvaluationCommentDialog,
      deleteGoal: deleteGoal
    };

    var lastComments = [];
    var lastCommentsForGoals = {};

    return service;

    //////////
    function init_goalApproval(data) {
      data.goals_data = [];
      var cont_obj_type = 0;
      var cons_obj = 1;
      var current_obj_type = null;

      angular.forEach(data.employee_goals, function (goal) {

        if (goal.goals_type_id != current_obj_type) {
          current_obj_type = goal.goals_type_id;
          cont_obj_type = cont_obj_type + 1;
          cons_obj = 1;
        }
        goal['additional_info'] = {};
        goal['additional_info']['cont_label'] = cont_obj_type + "." + cons_obj;
        cons_obj = cons_obj + 1;

        if (goal.comments.length > 0) {
          if (goal.comments[0].empleado.id == data.evaluation_current_process.empleado_id && !goal.aprobado) {
            goal.lastComment = goal.comments[0];
          }
        }

        if (!angular.isUndefined(goal.objetivo_id) && goal.objetivo_id) {
          assignCompanyGoalsValues(goal);
        }



        data.goals_data.push(goal);

      });

      var goal_types = {};
      goal_types = UtilsService.arrToObjectKey(data.goals_types, 'goal_type');

    }

    function init_goalEvaluation(data) {
      _init_goalEvaluation(data);
    }

    function init_goalEvaluationApproval(data) {
      _init_goalEvaluation(data);
    }

    function init_goalFollowUpEvaluation(data) {
      _init_goalEvaluation(data);
    }

    function init_skillFollowUpEvaluation(data) {
    }

    function _init_goalEvaluation(data) {
      data.goals_data = [];
      var cont_obj_type = 0;
      var cons_obj = 1;
      var current_obj_type = null;
      var sendCommentProfile = ['chief', 'chiefchief', 'corpchief'];
      var rol = data.evaluation_current_process.evaluation_process_stage_content.evaluator_rol;


      data.config = {
        sendComment: sendCommentProfile.indexOf(rol) != -1 ? true : false
      }

      data.boss = sendCommentProfile.indexOf(rol) != -1 ? true : false;


      angular.forEach(data.employee_goals, function (goal) {

        if (goal.goals_type_id != current_obj_type) {
          current_obj_type = goal.goals_type_id;
          cont_obj_type = cont_obj_type + 1;
          cons_obj = 1;
        }
        goal['additional_info'] = {};
        goal['additional_info']['cont_label'] = cont_obj_type + "." + cons_obj;
        cons_obj = cons_obj + 1;

        //Si es un objetivo de empresa, reemplazar la información en los campos del objetivo
        if (!angular.isUndefined(goal.objetivo_id) && goal.objetivo_id) {
          assignCompanyGoalsValues(goal);
        }

        goal.corporate_goals_evaluation = goal.goal_evaluation_data.corporate_goals_evaluation_id ? goal.goal_evaluation_data.corporate_goals_evaluation : null;

        goal.comments = goal.goal_evaluation_data.comments ? goal.goal_evaluation_data.comments : [];
        goal.aprobado = goal.goal_evaluation_data.is_approved != undefined ? goal.goal_evaluation_data.is_approved : true;
        //goal.lastComment = goal.aprobado ? {} : goal.comments[0];
        if (goal.comments.length > 0) {
          if (goal.comments[0].empleado.id == data.evaluation_current_process.empleado_id && !goal.aprobado) {
            goal.lastComment = goal.comments[0];
          }
        }

        data.goals_data.push(goal);

      });


      var goal_types = {};
      goal_types = UtilsService.arrToObjectKey(data.goals_types, 'goal_type');
      //Calcular la suma de las ponderaciones de los objetivos
      data.goals_weight = sumGoalsWeight(data.goals_data);

    }

    function init_goalInscription(data) {
      //Agrupar los objetivos por tipo
      if (!angular.isUndefined(data.employee_goals)) {
        var employee_goals = data.employee_goals;
        data.employee_goals = {};
        angular.forEach(employee_goals, function (goal) {
          if (angular.isUndefined(data.employee_goals[goal.goals_type_id])) {
            data.employee_goals[goal.goals_type_id] = [];
          }

          data.employee_goals[goal.goals_type_id].push(goal);

        });
      }

      //Modificar el array de goal_types para poner el tipo de objetivo como llave del array
      var goal_types = {};
      angular.forEach(data.goals_types, function (goal_type_info) {
        goal_types[goal_type_info.id] = goal_type_info;
      });

      //Construir el array basado en el número de objetivos que tiene que matricular de cada tipo
      var i, cont_obj_type;
      var obj = {};
      cont_obj_type = 1;
      data.goals_data = [];



      angular.forEach(data.configuration_goals, function (e) {
        for (i = 0; i < e.maximo; i++) {

          if (!angular.isUndefined(data.employee_goals[e.goals_type_id]) && data.employee_goals[e.goals_type_id].length > 0) {
            obj = data.employee_goals[e.goals_type_id].shift();
          } else {
            obj = {};
          }

          //Copiar los campos name, meta y additional para los objetivos que son seleccionados de una lista
          if (!angular.isUndefined(obj.objetivo_id) && obj.objetivo_id) {
            assignCompanyGoalsValues(obj);
          }

          obj['additional_info'] = {};
          obj['additional_info']['cont_label'] = cont_obj_type + "." + (i + 1);
          obj['additional_info']['goal_type_info'] = goal_types[e.goals_type_id];
          obj['additional_info']['required'] = (i + 1 <= e.minimo ? true : false);
          obj['additional_info']['tipo_objetivo'] = e.goals_type_id;
          data.goals_data.push(obj);
        }
        cont_obj_type = cont_obj_type + 1;
      });

      console.log(data.goals_data);
      //Calcular la suma de las ponderaciones de los objetivos
      data.goals_weight = sumGoalsWeight(data.goals_data);

    }

    //Copiar los campos name, meta y additional para los objetivos que son seleccionados de una lista
    function assignCompanyGoalsValues(goal) {

      if (!angular.isUndefined(goal.objetivo)) {
        goal.name = goal.objetivo.name;
        goal.meta = goal.objetivo.meta;
        goal.additional_data = goal.objetivo.additional_data;
      }
    }

    function openEvaluationCommentDialog(ev, goal, data, user_profile, position) {
      var GoalInfo = data.goals_data[data.goals_data.indexOf(goal)];
      user_profile = data.evaluation_current_process.evaluation_process_stage_content ? data.evaluation_current_process.evaluation_process_stage_content.evaluator_rol : null;

      $mdDialog.show({
        controller: 'EvaluationCommentDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/modules/hr-evaluation-modules/hr-goal/dialogs/comment-goal-dialog/index.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          Goal: GoalInfo,
          ModuleData: data,
          UserProfile: user_profile,
          event: ev,
          position: position
        }
      }).finally(function (e) {
        data.goals_weight = sumGoalsWeight(data.goals_data);
      });
    }

    function openEvaluationGoalDialog(ev, goal, data, user_profile, position) {
      var GoalInfo = data.goals_data[data.goals_data.indexOf(goal)];
      user_profile = data.evaluation_current_process.evaluation_process_stage_content ? data.evaluation_current_process.evaluation_process_stage_content.evaluator_rol : null;

      $mdDialog.show({
        controller: 'EvaluationGoalDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/modules/hr-evaluation-modules/hr-goal/dialogs/evaluation-goal-dialog/evaluation-goal-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          Goal: GoalInfo,
          ModuleData: data,
          UserProfile: user_profile,
          event: ev,
          position: position
        }
      }).finally(function (e) {
        data.goals_weight = sumGoalsWeight(data.goals_data);
      });
    }

    function openInputGoalDialog(ev, goal, data) {
      var GoalInfo = data.goals_data[data.goals_data.indexOf(goal)];

      $mdDialog.show({
        controller: 'InputGoalDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/modules/hr-evaluation-modules/hr-goal/dialogs/input-goal-dialog/input-goal-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          Goal: GoalInfo,
          GoalsList: data.goals_data,
          ModuleData: data,
          event: ev
        }
      }).finally(function (e) {

        //Sumar la ponderación de todos los objetivos
        data.goals_weight = sumGoalsWeight(data.goals_data);

      });
    }

    function openSelectGoalDialog(ev, goal, data) {
      var GoalInfo = data.goals_data[data.goals_data.indexOf(goal)];

      $mdDialog.show({
        controller: 'SelectGoalListDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/modules/hr-evaluation-modules/hr-goal/dialogs/select-goal-list-dialog/select-goal-list-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          Goal: GoalInfo,
          GoalsList: data.goals_data,
          CompanyGoals: data.available_goals,
          ModuleData: data,
          event: ev
        }
      }).finally(function (e) {

        //Sumar la ponderación de todos los objetivos
        data.goals_weight = sumGoalsWeight(data.goals_data);
      });
    }

    function saveEvaluation(evaluation_current_process_id, data) {
      var deferred = $q.defer();

      /*var evaluationData = {};
      if(userProfile == 'colab') {
        evaluationData['objetivos_empleado_id'] = goal_id;
        evaluationData['colla_num_result'] = evaluation;
        evaluationData['colla_comment'] = comments;
        evaluationData['evaluation_type'] = 'follow up';
        if(id){
          evaluationData['id'] = id;
        }
        
      } else {
        evaluationData['objetivos_empleado_id'] = goal_id;
        evaluationData['chief_num_result'] = evaluation;
        evaluationData['chief_comment'] = comments;
        evaluationData['evaluation_type'] = 'follow up';
        if(id){
          evaluationData['id'] = id;
        }
      }*/

      api.evaluations.saveProcessData.save({
        evaluation_current_process_id: evaluation_current_process_id,
        data: data
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function saveGoal(evaluation_current_process_id, goal) {
      var deferred = $q.defer();
      var goalData = {};
      goalData['id'] = goal.id;
      goalData['name'] = goal.name;
      goalData['meta'] = goal.meta;
      goalData['order'] = goal.order;
      goalData['porcentaje'] = goal.porcentaje;
      goalData['objetivo_id'] = goal.objetivo_id;
      goalData['additional_data'] = goal.additional_data;
      goalData['goals_type_id'] = goal.additional_info.goal_type_info.id;
      goalData['orden'] = goal.orden;

      api.evaluations.saveProcessData.save({
        evaluation_current_process_id: evaluation_current_process_id,
        data: goalData
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function saveGoalSelectGoalDialog(evaluation_current_process_id, goal) {
      var deferred = $q.defer();
      var goalData = goal;

      api.evaluations.saveProcessData.save({
        evaluation_current_process_id: evaluation_current_process_id,
        data: goalData
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function sendComments($event, goal, data) {

      var deferred = $q.defer();

      var dataSend = { objetivos_empleado_id: goal.id, is_approved: goal.aprobado, comment: goal.rejected_comment };
      // if (goal.lastComment && goal.aprobado == true && goal.countSend) {
      if (goal.lastComment) {
        dataSend.comment_id = goal.lastComment.id;
      }


      api.evaluations.saveProcessData.save({
        evaluation_current_process_id: data.evaluation_current_process.id,
        data: dataSend
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          for (var i in data.goals_data) {
            var goals = data.goals_data[i];
            if (goals.id == goal.id) {
              goals.comments = response.data.goal_evaluation_data.comments;
              goals.lastComment = response.data.goal_evaluation_data.comments[0];

              if (dataSend.is_approved) {
                goals.lastComment = {};
              }
              if (!goals.countSend) {
                goals.countSend = 1;
              } else {
                goals.countSend += 1;
              }
            }
          }
          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function saveStep_goalApproval(data) {
      var deferred = $q.defer();
      var approval_data = [];
      var idsGoalsComments = [];

      angular.forEach(data.goals_data, function (goal) {

        var dataSend = { id: goal.id, approve: goal.aprobado, comment: goal.rejected_comment };
        // if (goal.lastComment && goal.aprobado == true && goal.countSend) {
        if (goal.lastComment) {
          dataSend.comment_id = goal.lastComment.id;
        }

        if (goal.aprobado == false) {
          idsGoalsComments.push(goal.id);
        }
        approval_data.push(dataSend);
      });


      api.evaluations.saveProcessData.save({
        evaluation_current_process_id: data.evaluation_current_process.id,
        data: approval_data
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          data.employee_goals = response.data;

          /*for (var i in data.goals_data) {
            var goal = data.goals_data[i];
            if (idsGoalsComments.indexOf(goal.id) !== -1) {

              data.goals_data[i].lastComment = goal.comments[0];
              if(!data.goals_data[i].countSend){
                data.goals_data[i].countSend = 1;
              }else{
                data.goals_data[i].countSend += 1;
              }
            }
          }*/

          data.goals_data.map(function (goal) {
            if (idsGoalsComments.indexOf(goal.id) !== -1) {
              var commentsFilter = response.data.filter(function (element) { return element.id == goal.id });
              goal.comments = commentsFilter[0].comments;
              //if (!goal.aprobado) {
              goal.lastComment = commentsFilter[0].comments[0];
              /*} else {
                delete (goal.lastComment);
              }*/

              if (!goal.countSend) {
                goal.countSend = 1;
              } else {
                goal.countSend += 1;
              }
            }
          });


          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function sumGoalsWeight(goals) {
      var goals_weight = 0;
      angular.forEach(goals, function (goal) {
        if (goal.porcentaje && goal.goals_evaluations_data) {
          goals_weight = parseInt(goals_weight) + ((parseInt(goal.goals_evaluations_data.colla_num_result) * parseInt(goal.porcentaje)) / 100);
        } else if (goal.porcentaje && !goal.goals_evaluations_data) {
          goals_weight = parseInt(goals_weight) + parseInt(goal.porcentaje);
        }
      });

      return goals_weight;
    }

    function deleteGoal(goal, data) {
      console.log(goal);
      var confirm = $mdDialog.confirm()
        .title('¿Confirma que desea eliminar el siguiente objetivo ?')
        .htmlContent(goal.name)
        .ariaLabel('delet')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm).then(function () {

        api.evaluations.saveProcessData.save({
          evaluation_current_process_id: data.evaluation_current_process.id,
          data: {
            id: goal.id,
            delete: true
          }
        },
          // Success
          function (response) {

            if (response.message) {
              UtilsService.showToast(response.message);
            }

            for (var i in data.goals_data) {
              if (data.goals_data[i].id == goal.id) {
                data.goals_data.splice(i,1);
              }
            }
          },
          // Error
          function (response) {
            UtilsService.showToast(response.data.message, true);
          });
      });
    }


  }
}());

(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrFinalCommentService', HrFinalCommentService);

    /** @ngInject */
    function HrFinalCommentService($q, api, UtilsService) {

        var service = {

            init_addComment: init_addComment,
            saveStep_addComment: saveStep_addComment,
            serializeComments: serializeComments

        };

        return service;

        //////////
        function init_addComment(data) {
            var showCommentHistory = ['chief', 'chiefchief', 'corpchief'];
            var rol = data.evaluation_current_process.evaluation_process_stage_content.evaluator_rol;

            data.config = {
                showCommentHistory: showCommentHistory.indexOf(rol) != -1 ? true : false
            }

            data.formData = {};
            data.comments = [];
            data.other_comments = [];
            data.titleComments = [];
            for (var i in data.options) {
                data.comments.push({
                    key: i,
                    label: data.options[i].label,
                    description: data.options[i].description,
                    required: data.options[i].required === undefined ? true : data.options[i].required,
                    order: data.options[i].order
                });
            }

            if (data.own_final_comments.length) {
                for (var i in data.own_final_comments) {
                    var comment = data.own_final_comments[i];

                    if (comment.empleado.id == data.evaluation_current_process.empleado_id) {
                        data.formData[comment.key_name] = comment.comment;
                    }
                }
            }

            if (data.others_final_comments.length) {
                for (var i in data.others_final_comments) {

                    var comment = data.others_final_comments[i];

                    var jsonInsert = {};

                    jsonInsert.empleado = comment.empleado;
                    for(var c in comment.comments){
                        var commentChield = comment.comments[c];
                        jsonInsert[commentChield.key_name] = commentChield.comment;
                    }
                    data.other_comments.push(jsonInsert);
                }
            }

            for(var i in data.options){
                var jsonInsert = {};
                jsonInsert.key = i;
                jsonInsert.title = data.options[i].label;
                jsonInsert.order = data.options[i].order;

                data.titleComments.push(jsonInsert);
            }

        }

        function saveStep_addComment(data) {
            saveComment(null, data);
        }

        function saveComment($evt, data) {
            var deferred = $q.defer();

            if (angular.equals(data.formData, {})) {
                return;
            }
            var postJson = {
                evaluation_current_process_id: data.evaluation_current_process.id,
                finalize: false,
                data: data.formData
            }

            api.evaluations.saveProcessData.save(postJson,
                // Success
                function (response) {
                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }
                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function serializeComments(data) {
            data.comments = [];

            var aux = {};

            for (var i in data.final_comments) {
                var comment = data.final_comments[i];
                var empleado = {
                    evaluator: comment.empleado,
                    comment: comment.comment
                }

                if (aux[comment.key_name]) {

                    data.comments[aux[comment.key_name] - 1].empleados.push(empleado);
                } else {
                    var objInsert = {
                        key: comment.key_name,
                        label: data.options[comment.key_name].label,
                        description: data.options[comment.key_name].description,
                        empleados: []
                    }

                    objInsert.empleados.push(empleado);

                    data.comments.push(objInsert);

                    aux[comment.key_name] = data.comments.length;
                }

            }
            return data;
        }
    }
}());
(function () {
  'use strict';

  angular
      .module('app.hr-evaluation')
      .factory('HrLimitTimeService', HrLimitTimeService);

  /** @ngInject */
  function HrLimitTimeService($q, api, $rootScope, $interval) {
      var limit_time_global_service = null;
      var service = {
        checkTimeLimitCuestionaire: checkTimeLimitCuestionaire,
        startCountdown: startCountdown,
        start: start,
        stop: stop,
        getCountdown: getCountdown
      };

      function startCountdown(edo_object){
        var deferred = $q.defer();
  
        var cuestionaire_start_time = edo_object.evaluation_process_data.HrEDO.edo_evaluation.start_date_time;
        var evaluation_id = edo_object.evaluation_process_data.HrEDO.edo_evaluation.id;
        var minutes = edo_object.evaluation_process_data.HrEDO.edo_preferences.questionnaire_time_limit

        var verification = null;
  
        if(cuestionaire_start_time == null){
          
          api.evaluations.start_edo_evaluation.save({ edo_evaluation_id: evaluation_id },
            // Success
            function (response) {
              verification = service.checkTimeLimitCuestionaire(response.edo_evaluation.start_date_time, minutes)
              deferred.resolve(verification);           
            }, function (error) {
            });
        } else {
          verification = service.checkTimeLimitCuestionaire(cuestionaire_start_time, minutes)
          deferred.resolve(verification); 
        }

        return deferred.promise;
      }

      function checkTimeLimitCuestionaire(baseTime, AddMinutes){
        if(baseTime == null){
          return {status: true, data: null}
        }
  
        var limit_time = new Date(baseTime);
  
        limit_time = new Date(limit_time.getTime() + AddMinutes * 60000);

        limit_time_global_service = limit_time;
  
        if (new Date() > limit_time) {
          return {status: false, data: null}
        } else {
          return {status: true, data: limit_time}
        }
      }

      // Creo el intervalo para que se corra cuando el clietne inicie el cuestionario.
      function start () {
        //Detengo cualquier intervalo activo.
        service.stop(); 
        
        //Guardo la promesa del intervalo para poder detenerlo
        service.promise = $interval(service.getCountdown, 1000);
      };
    
      //Funcion que detiene el intervalo
      function stop () {
        $interval.cancel(service.promise);
      };

      //Funcion para obtener el contador para el tiempo restante.
      function getCountdown() {

        //Obtengo la fechay  hora actual
        var now = new Date().getTime();
          
        //Calculo el tiempo restante.
        var distance = limit_time_global_service - now;

        //Verifico que quede tiempo
        if (distance <= 0) {

          $rootScope.$broadcast('expiredTimeEmmit', {msg: 'Se ha agotado el tiempo para responder el cuestionario.'});

          service.stop();

          return false
        }
          
        //Devuelvo la informacion del tiempo pendiente en un formato legible.
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        $rootScope.$broadcast('updateCronometer', {data: hours + "h " + minutes + "m " + seconds + "s "});
      };

      return service;

      /////////
  }

}());
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrEDOService', HrEDOService);

    /** @ngInject */
    function HrEDOService($q, api, UtilsService, $mdDialog, $document, $filter) {
        var service = {
            init_cuestionario: init_cuestionario,
            getFormulario: getFormulario,
            getQuestions: getQuestions,
            backQuestion: backQuestion,
            nextQuestion: nextQuestion,
            changeSelectAsociacion: changeSelectAsociacion,
            saveQuestion: saveQuestion,
            getFinish: getFinish,
            serializeQuestion: serializeQuestion,
            serializeQuestions: serializeQuestions,
            getEvaluationCurrenProcess: getEvaluationCurrenProcess,
            setConfig: setConfig
        };

        var formulario = {};
        var questions = [];
        var evaluation_current_process = {};
        var index = 0;
        var edoEvaluation = {};
        var config = {};

        function init_cuestionario(data) {
            var questionario = data.edo_questionnaire;
            setEvaluationCurrenProcess(data.evaluation_current_process);
            setEdoEvaluation(data.edo_evaluation);
            setFormulario({ id: questionario.id, label: questionario.label });
            questions = serializeQuestions(questionario.edo_questionnaire_statements);
            return { form: getFormulario(), question: getQuestionsPosition(index), index: readIndex(), total: questions.length };
        }

        function getFinish() {
            return questions.length == edoEvaluation.edo_evaluation_details.length;
        }

        function setEvaluationCurrenProcess(data) {
            evaluation_current_process = data;
        }

        function getEvaluationCurrenProcess() {
            return evaluation_current_process;
        }

        function setEdoEvaluation(data) {
            edoEvaluation = data;
        }

        function setFormulario(data) {
            formulario = data;
        }

        function getFormulario() {
            return formulario;
        }

        function serializeQuestions(data) {
            return data.map(function (element) {
                var jsonInsert = {};
                var edo_answer_choices = element.edo_question.edo_answer_choices;
                var answer_detail = getDataAnswerDetail(element);
                jsonInsert.id = element.id;
                jsonInsert.question_number = element.question_number;
                jsonInsert.question_id = element.edo_question.id;
                jsonInsert.question_text = element.edo_question.question_text;
                jsonInsert.score = element.edo_question.score;
                jsonInsert.graphic_path = element.edo_question.graphic_path;
                jsonInsert.edo_topic = element.edo_question.edo_topic.label;
                jsonInsert.edo_topic_id = element.edo_question.edo_topic.id;
                jsonInsert.edo_question = element.edo_question.edo_question_type.label;
                jsonInsert.edo_question_type = element.edo_question.edo_question_type.name;
                jsonInsert.options = element.edo_question.options;
                jsonInsert.answer_choices = edo_answer_choices;
                jsonInsert.listAnswer = jsonInsert.edo_question_type == 'asociacion' ? jsonToArray(element.edo_question.options.values, answer_detail, edo_answer_choices) : {};
                jsonInsert.answer_include_img = jsonInsert.answer_choices.filter(function (element) { return element.graphic_path });
                jsonInsert.answer_detail = answer_detail;
                return jsonInsert;
            });
        }

        function serializeQuestion(element) {
            var jsonInsert = {};
            var edo_answer_choices = element.edo_answer_choices;
            var answer_detail = getDataAnswerDetail(element);
            jsonInsert.question_id = element.id;
            jsonInsert.question_text = element.question_text;
            jsonInsert.score = element.score;
            jsonInsert.graphic_path = element.graphic_path;
            jsonInsert.edo_topic = element.edo_topic.label;
            jsonInsert.edo_topic_id = element.edo_topic.id;
            jsonInsert.edo_question = element.edo_question_type.label;
            jsonInsert.edo_question_type = element.edo_question_type.name;
            jsonInsert.options = element.options;
            jsonInsert.answer_choices = edo_answer_choices;
            jsonInsert.listAnswer = jsonInsert.edo_question_type == 'asociacion' ? jsonToArray(element.options.values, answer_detail, edo_answer_choices) : {};
            jsonInsert.answer_include_img = jsonInsert.answer_choices.filter(function (element) { return element.graphic_path });
            jsonInsert.answer_detail = answer_detail;
            return jsonInsert;
        }

        function jsonToArray(data, values, edo_answer_choices) {
            var arrReturn = [];
            console.log(values,config);
            if (angular.equals(values, {})) {
                for (var i in data) {
                    var jsonInsert = {};

                    jsonInsert.id = i;
                    jsonInsert.label = data[i].label;
                    jsonInsert.drag = config.isAdmin ? false : true;
                    arrReturn.push(jsonInsert);
                }
                if (!config.isAdmin) {
                    arrReturn = shuffle(arrReturn);
                }

            } else {
                for (var i in edo_answer_choices) {
                    var id_edo = edo_answer_choices[i].id;
                    var value = values[id_edo];
                    var jsonInsert = {};

                    jsonInsert.id = value;
                    jsonInsert.label = data[value].label;
                    jsonInsert.drag = config.isAdmin ? false : true;
                    arrReturn.push(jsonInsert);
                }
            }

            return arrReturn;
        }

        function getDataAnswerDetail(element) {
            if (!edoEvaluation || !edoEvaluation.edo_evaluation_details) {
                return {};
            }
            var data = edoEvaluation.edo_evaluation_details.filter(function (elemen) {
                return elemen.edo_question.id == element.edo_question.id;
            });

            if (element.edo_question.edo_question_type.name == 'respuesta_multiple' && data[0]) {
                var dataMultiple = {};
                for (var i in data[0].answer_detail) {
                    dataMultiple[data[0].answer_detail[i]] = true;
                }
                data[0].answer_detail = dataMultiple;
            }

            return data[0] ? data[0].answer_detail : {};
        }

        function getQuestions() {
            return questions;
        }

        function backQuestion() {
            if (!index) {
                return;
            }
            index -= 1;
            return { question: getQuestionsPosition(index), index: readIndex() };
        }

        function nextQuestion() {
            if (index == (questions.length - 1)) {
                return;
            }
            index += 1;
            return { question: getQuestionsPosition(index), index: readIndex() };
        }

        function getQuestionsPosition(position) {
            return questions[position];
        }

        function readIndex() {
            return index + 1;
        }

        function setConfig(configQuestionaires) {
            console.log(configQuestionaires);
            config = configQuestionaires;
        }

        /**
         * 
         */
        function changeSelectAsociacion(data, option) {
            var dataSelected = data.answer_detail[option.id];
            for (var i in data.answer_detail) {
                if (i != option.id && data.answer_detail[i] == dataSelected) {
                    data.answer_detail[i] = "";
                }
            }
        }

        function saveQuestion(data) {
            var deferred = $q.defer();

            var dataPost = eval('serializePost' + data.edo_question_type + '(data)');
            var JsonStructure = {
                evaluation_current_process_id: evaluation_current_process.id,
                finalize: false,
                data: dataPost
            }
            api.evaluations.saveProcessData.save(JsonStructure, function (success) {
                deferred.resolve(success);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function serializePostrespuesta_unica(data) {
            return {
                edo_question_id: data.question_id,
                answer_detail: data.answer_detail
            }
        }

        function serializePostasociacion(data) {
            var answer_detail = data.answer_detail;

            if (data.options.visible) { //SI TIENE DRAG AND DROP

                answer_detail = {};

                for (var i in data.answer_choices) {
                    answer_detail[data.answer_choices[i].id] = data.listAnswer[i].id;
                }
            }
            return {
                edo_question_id: data.question_id,
                answer_detail: answer_detail
            }
        }

        function serializePostrespuesta_multiple(data) {
            var answer_detail = [];
            for (var i in data.answer_detail) {
                if (data.answer_detail[i]) {
                    answer_detail.push(i);
                }
            }
            return {
                edo_question_id: data.question_id,
                answer_detail: answer_detail
            }
        }

        function serializePostrespuesta_abierta_numerica(data) {
            return {
                edo_question_id: data.question_id,
                answer_detail: data.answer_detail
            }
        }

        function shuffle(array) {
            var currentIndex = array.length, temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            return array;
        }

        return service;

        //////////
    }

}());

(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .factory('HrAssistantObjectiveService', HrAssistantObjectiveService);

    /** @ngInject */
    function HrAssistantObjectiveService($q, api, UtilsService) {

        var service = {

            init_assistantEvaluation: init_assistantEvaluation,
            saveAssistant: saveAssistant,
            serializeTitleTableObj: serializeTitleTableObj,
            serializeTable: serializeTable,
            getSections: getSections,
            serializeDataMultiple: serializeDataMultiple,
            saveStep_assistantEvaluation: saveStep_assistantEvaluation
        };

        return service;

        //////////
        function init_assistantEvaluation(data) {
            _init_assistantEvaluation(data);
        }

        function saveStep_assistantEvaluation(data) {
            saveAssistant(null, data);
        }

        function _init_assistantEvaluation(data) {

            data.formData = {};
            var title = serializeTitleTable(data.evaluation_preferences);
            var sections = serializeTable(getSections(data.questionnaire_sections), data);
            /*sections = sections.map(function (element) {
                var questions = data.questionnaire.question_statement.filter(function (question) {
                    return question.questionnaire_section_id == element.id;
                });

                questions = questions.map(function (question) {
                    return {
                        name: question.question.name,
                        id: question.question.id,
                        active: question.question.is_active,
                        questionnaire_id: question.questionnaire_id,
                        orden: question.row_order,
                        question_statement_id: question.id
                    }
                });

                element.questions = questions;
                return element;
            });*/

            if (!data.assistant_objective_evaluation) {
                data.assistant_objective_evaluation = {
                    assistant_objective_evaluation_detail: []
                }
            }

            data.assistant_objective_evaluation.assistant_objective_evaluation_detail.map(function (element) {
                data.formData[element.question_statement_id] = parseInt(element.result);
            });


            data.assistants = {
                title: title,
                sections: sections,
                data: data.assistant_objective_evaluation.assistant_objective_evaluation_detail
            };

            data.personal_development_responsable_list = data.evaluation_preferences.personal_development_responsable_list;
            data.countComments = getCountCommentArray(data.evaluation_preferences.max_number_personal_developments, data.personal_developments);
        }

        function getCountCommentArray(maxNumber, personal_development) {
            var returnArray = [];
            if (!maxNumber) {
                return returnArray;
            }

            for (var i = 0; i < maxNumber; i++) {
                if (personal_development[i]) {
                    returnArray.push(personal_development[i]);
                } else {
                    returnArray.push({});
                }

            }
            return returnArray;
        }

        function serializeTable(sections, data) {
            sections = sections.map(function (element) {
                var questions = data.questionnaire.question_statement.filter(function (question) {
                    return question.questionnaire_section_id == element.id;
                });

                questions = questions.map(function (question) {
                    return {
                        name: question.question.name,
                        id: question.question.id,
                        active: question.question.is_active,
                        questionnaire_id: question.questionnaire_id,
                        orden: question.row_order,
                        question_statement_id: question.id
                    }
                });

                element.questions = questions;
                return element;
            });




            return sections;
        }

        function serializeTitleTable(preferences) {
            var newPreference = preferences.results_scale.map(function (element) {
                var newElement = element;
                newElement.value = parseInt(element.value);
                return newElement
            });

            return newPreference.sort(function (a, b) {
                if (a.order > b.order) {
                    return 1;
                }
                if (a.order < b.order) {
                    return -1;
                }
                return 0;
            });
        }

        function serializeTitleTableObj(preferences) {
            var obj = {};
            preferences = preferences.results_scale;
            for (var i in preferences) {
                obj[preferences[i].value] = preferences[i];
            }
            return obj;
        }

        function getSections(sections) {
            var sectionsReturnaux = {};
            var sectionsReturn = [];
            for (var i in sections) {
                if (sectionsReturnaux[sections[i].id]) {
                    continue;
                } else {
                    sectionsReturnaux[sections[i].id] = true;
                    sectionsReturn.push(sections[i]);
                }
            }
            return sectionsReturn;
        }

        /**
         * @description 
         *  Retorna un objecto JSON organizado de evaluaciones por perfil
         * @param {Array} evaluations 
         * @returns {Obj} {80:{empleado:{},evaluation:{}}}
         */
        function serializeDataMultiple(evaluations) {
            var objReturn = {};
            var objReturnCollab = {};
            var sectionAux = {};
            var sections = [];
            for (var i in evaluations) {
                var empleado = evaluations[i].empleado;
                var question_statement = evaluations[i].question_statement;
                var question_statement_id = evaluations[i].question_statement_id;
                var result = parseInt(evaluations[i].result);

                if (objReturnCollab[empleado.id]) {
                    objReturnCollab[empleado.id].evaluation[question_statement_id] = result;
                } else {
                    objReturnCollab[empleado.id] = {};
                    objReturnCollab[empleado.id].empleado = empleado;
                    objReturnCollab[empleado.id].evaluation = {};
                    objReturnCollab[empleado.id].evaluation[question_statement_id] = result;
                }

                var objSections = {};

                if (sectionAux[question_statement.questionnaire_section_id] == undefined) {
                    objSections = {
                        id: question_statement.questionnaire_section_id,
                        name: question_statement.questionnaire_section.name,
                        questions: []
                    };

                    objSections.questions.push({
                        id: question_statement.question_id,
                        name: question_statement.question.name,
                        question_statement_id: question_statement_id
                    });
                    sections.push(objSections);
                    sectionAux[question_statement.questionnaire_section_id] = sections.length - 1;
                } else {
                    objSections = sections[sectionAux[question_statement.questionnaire_section_id]];

                    objSections.questions.push({
                        id: question_statement.question_id,
                        name: question_statement.question.name,
                        question_statement_id: question_statement_id
                    });
                }
            }
            objReturn.sections = sections;
            objReturn.collab = objReturnCollab;

            return objReturn;
        }

        function saveAssistant($evt, data) {
            var deferred = $q.defer();

            var retult = serializeFormDataPost(data);
            var personal_developments = serializePersonalDevelopmentsDataPost(data);

            var postJson = {
                evaluation_current_process_id: data.evaluation_current_process.id,
                finalize: false,
                data: {
                    results: retult,
                    personal_developments: personal_developments
                }
            }

            api.evaluations.saveProcessData.save(postJson,
                // Success
                function (response) {
                    if (response.message) {
                        UtilsService.showToast(response.message);
                    }

                    if(response.data.personal_developments){
                        data.countComments = getCountCommentArray(data.evaluation_preferences.max_number_personal_developments, response.data.personal_developments);
                    }
                    
                    deferred.resolve(response.data);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        function serializeFormDataPost(data) {
            var resultReturn = [];
            for (var i in data.formData) {
                resultReturn.push({ question_statement_id: i, result: data.formData[i] });
            }
            return resultReturn;
        }

        function serializePersonalDevelopmentsDataPost(data){
            var resultReturn = [];
            for(var i in data.countComments){
                if(angular.equals(data.countComments[i],{})){
                    continue;
                }
                resultReturn.push(data.countComments[i]);
            }
            return resultReturn;
        }
    }
}());
(function () {
  'use strict';

  angular.module('app.employee.profile').controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($state, UsersService, $mdDialog, $document, UtilsService, organizationService, 
                              LicenseService, evaluationService, fuseTheming, $rootScope, HrSkillService, 
                              HrCoreValueService, api, HrAssistantObjectiveService, HrFinalCommentService, 
                              HrPollService, HrEDOService, $scope, HrLimitTimeService) {

    //Track Google Analytics
    UtilsService.trackPage();

    var vm = this;

    vm.employee_id = $state.params.employee_id;



    if ($state.current.name == 'app.employee_profile_team_final_stage') {
      vm.last_stage_id = true;
    }

    vm.themes = fuseTheming.themes.active.theme;
    vm.colors = {};

    vm.licenseData = LicenseService.getLicenseJson();
    vm.license = vm.licenseData.license;
    vm.chartOptions = {
      title: {
        text: 'Temperature data'
      },
      xAxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },

      series: [{
        data: [29.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4]
      }]
    };

    init();

    // Data
    vm.mainUserInfo = UsersService.getUserInfo();
    vm.changePassButton = "ACEPTAR";
    vm.updatingPass = false;

    // Methods
    vm.changePassword = changePassword;
    vm.goToProcess = goToProcess;
    vm.openPictureDialog = openPictureDialog;
    vm.showEvaluation = showEvaluation;
    vm.sendMessage = sendMessage;
    vm.donwloadPDF = donwloadPDF;
    vm.backToPerfil = backToPerfil;

    vm.getPositionDetail = getPositionDetail;
    vm.enablePositionDetails = LicenseService.getModuleEnable('position_details');

    //Cuestionario
    vm.configQuestionario = {isAdmin:false};
    vm.loadingEvo = true;
    vm.nextQuestion = nextQuestion;
    vm.backQuestion = backQuestion;
    vm.startCountdown = startCountdown;
    vm.expiredTimeCuestionaire = expiredTimeCuestionaire;

    vm.cronometer = '';
    vm.cuestionaireHasTime = true;

    function changePassword(ev) {

      if (!vm.updatingPass) {

        UsersService.changePassword(vm.current_pass, vm.new_pass).then(function () {
          // Update successful.

          var msgBox = $mdDialog.alert()
            .title('')
            .htmlContent('Contraseña actualizada con éxito')
            .targetEvent(ev)
            .ok('OK');

          $mdDialog.show(msgBox);


          vm.changePassButton = "ACEPTAR";
          vm.updatingPass = false;

        }, function (error) {
          vm.changePassButton = "ACEPTAR";
          vm.updatingPass = false;
        });
      }

    }

    function goToProcess(matricula_id, process) {
      localStorage.setItem('pedingActivitie', JSON.stringify(process));
      $state.go('app.hr_evaluation', { employee_process_id: matricula_id, process_stage_id: process.stage.id });
    }

    function backToPerfil() {

      $state.go('app.employee_profile');
    }

    function openPictureDialog(ev) {
      $mdDialog.show({
        controller: 'PictureDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/modules/users/profile/dialog/picture-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          userInfo: vm.mainUserInfo,
          event: ev
        }
      });
    }

    function showEvaluation(employeeProcessId) {
      vm.loadingEvaluationData = true;

      evaluationService.getEvaluationData(employeeProcessId).then(function (response) {

        if (response.evaluation_data.HrSkill && !response.evaluation_data.HrSkill.error) {
          response.evaluation_data.HrSkill = serializeDataSkill(response.evaluation_data.HrSkill);
        }

        if (response.evaluation_data.HrCoreValue && !response.evaluation_data.HrCoreValue.error) {
          response.evaluation_data.HrCoreValue = serializeDataCoreValue(response.evaluation_data.HrCoreValue);
        }

        if (response.evaluation_data.HrAssistantObjective && !response.evaluation_data.HrAssistantObjective.error) {
          response.evaluation_data.HrAssistantObjective = serializeDataAssistant(response.evaluation_data.HrAssistantObjective);
        }

        if (response.evaluation_data.HrFinalComment && !response.evaluation_data.HrFinalComment.error) {
          response.evaluation_data.HrFinalComment = serializeHrFinalCommentHistory(response.evaluation_data.HrFinalComment);
        }

        if (response.evaluation_data.HrPoll && !response.evaluation_data.HrPoll.error) {
          response.evaluation_data.HrPoll = serializeHrPollHistory(response.evaluation_data.HrPoll);
        }




        vm.evaluationData = response;
        vm.evaluationData.chartOptions = UtilsService.getChartHistory(response);


        vm.loadingEvaluationData = false;

        vm.showEvaluationHistoryData = true;

      }).catch(function (err) {
        vm.loadingEvaluationData = false;
      });
    }

    /*
    * Agrupa por etapa las actividades que tiene pendientes el colaborador
    */
    function _groupActivitiesByStage(pendingActivities) {

      var activities = {};

      var roles = ['colab', 'chief', 'chiefchief', 'corpchief', 'direct', 'peer', 'other'];
      var haveActivies = false;
      angular.forEach(roles, function (rol) {
        activities[rol] = {};


        if (!angular.isUndefined(pendingActivities[rol])) {
          var activitiesByPeriod = pendingActivities[rol].sort(function (ac_a, ac_b) {
            ac_b.evaluation.matricula.periodo.id - ac_a.evaluation.matricula.periodo.id
          });

          angular.forEach(activitiesByPeriod, function (activity) {
            activity.process.rol = rol;
            var stage_id = activity.process.stage.id;
            var period_id = activity.evaluation.matricula.periodo.id;

            if (angular.isUndefined(activities[rol][period_id])) {
              activities[rol][period_id] = {};
            }

            if(angular.isUndefined(activities[rol][period_id][stage_id])) {
              activities[rol][period_id][stage_id] = {};
              activities[rol][period_id][stage_id]['name'] = activity.process.stage.name;
              activities[rol][period_id][stage_id]['process_name'] = activity.process.name;
              activities[rol][period_id][stage_id]['period'] =  {
                id: activity.evaluation.matricula.periodo.id,
                name: activity.evaluation.matricula.periodo.name
              };
              activities[rol][period_id][stage_id]['content'] = []
            }

            activities[rol][period_id][stage_id]['content'].push(activity);
          });
        }

        if (!angular.equals(activities[rol], {})) {
          haveActivies = true;
        }

      });

      if (vm.messages) {
        haveActivies = true;
      }
      vm.haveActivies = haveActivies;
      return activities;
    }

    function initColors() {
      vm.colors.primary = vm.themes.primary.color;
      vm.colors.accent = vm.themes.accent.color;
      vm.colors.warn = vm.themes.warn.color;
    }

    function init() {

      //Evaluatins_history
      vm.employeeCardTemplate = 'app/main/elements/ik-employee-team-card/default/default.html';
      vm.evaluationResultCardTemplate = 'app/main/elements/ik-evaluation-result-card/default/default.html';
      vm.hrGoalViewCardTemplate = 'app/main/elements/ik-hr-goal-card/default/default.html';
      vm.evaluationResultListTemplate = 'app/main/elements/ik-hr-goal-result-list/default/default.html';
      vm.evaluationDataTemplate = 'app/main/elements/ik-evaluation-data/default/default.html';

      //Current_evaliation
      vm.currentEvaluationData = [];
      vm.currentEvaluationTemplate = {};
      vm.currentEvaluationTemplate.HrGoal = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrGoal/default.html';
      vm.currentEvaluationTemplate.HrPersonalDevelopment = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrPersonalDevelopment/default.html';
      vm.currentEvaluationTemplate.HrSkill = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrSkill/default.html';
      vm.currentEvaluationTemplate.HrGoalIndicator = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrGoalIndicator/default.html';
      vm.currentEvaluationTemplate.HrCoreValue = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrCoreValue/default.html';
      vm.currentEvaluationTemplate.HrAssistantObjective = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrAssistantObjective/default.html';
      vm.currentEvaluationTemplate.HrFinalComment = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrFinalComment/default.html';
      vm.currentEvaluationTemplate.HrPoll = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrPoll/default.html';

      //Default view
      vm.evaluationResultViewType = 'list';

      //UI/UX Indicador de carga de información de la evaluación
      vm.loadingEvaluationData = false;

      localStorage.removeItem('pedingActivities');

      evaluationService.getEmployeeWorkTeam(vm.employee_id).then(function (response) {
        vm.workTeam = response;
      }).catch(function (err) {
      });

      evaluationService.getEmployeeProfile(vm.employee_id).then(function (response) {

        vm.employeeProfile = response['employee'];
        vm.evaluationsHistory = response['evaluation_history'];
        vm.currentEvaluation = response['current_evaluation'];
        vm.evFinalCurrentAuto = 0.0;
        vm.evFinalCurrent = 0.0;
        for (var i in vm.currentEvaluation.evaluation_hr_modules) {
          var evaluation = vm.currentEvaluation.evaluation_hr_modules[i];
          if (!evaluation.hr_module.has_evaluation) {
            continue;
          }
          var evFinalCurrentAuto = (evaluation.weight * parseFloat(evaluation.auto_evaluation)) / 100;
          var evFinalCurrent = (evaluation.weight * parseFloat(evaluation.final_evaluation)) / 100;

          vm.evFinalCurrentAuto = vm.evFinalCurrentAuto + evFinalCurrentAuto;
          vm.evFinalCurrent = vm.evFinalCurrent + evFinalCurrent;
        }
        setMessages(vm.currentEvaluation.messages);
        //vm.pendingActivities = response['pending_activities'];

        initLists(vm.currentEvaluation.evaluation_data);
        $rootScope.$broadcast('mysecret',{secret:response.secret_cv,user:UsersService.setUserInfoBtoa(vm.employeeProfile.empleado)});
      }).catch(function (err) {
      });

      evaluationService.getPendingActivities().then(function (response) {
        vm.pendingActivities = _groupActivitiesByStage(response);
        getAutoload(response);
      }).catch(function (err) {
      });

      vm.currentEvaluation = {};
      vm.currentEvaluation.hrGoal = [
        { name: 'Objetivo 1' },
        { name: 'Objetivo 2' }
      ];

      initColors();
    }

    function getAutoload(data) {
      var pending = data.colab;
      if (pending && pending.length) {
        if (pending[0].process.stage.autoload) {
          vm.pendingActiviti = pending[0];
          getEmployeeProcessData(vm.pendingActiviti);
        } else {
          vm.loadingEvo = false;
        }

      } else {
        vm.loadingEvo = false;
      }
    }

    function getEmployeeProcessData(data) {
      evaluationService.getEmployeeProcessData(data.evaluation.matricula.id, data.process.stage.id)
      .then(function (response) {
        vm.edo_complete = response;
        $rootScope.$emit('miperfil::hide', true);
        HrEDOService.setConfig(vm.configQuestionario);
        vm.edo = HrEDOService.init_cuestionario(response.evaluation_process_data.HrEDO);
        //vm.emptyEdo = HrEDOService.getFinish();
        vm.loadingEvo = false;

        //Verifico que el cuestionario todavia tenga tiempo.
        var cuestionaire_start_time = response.evaluation_process_data.HrEDO.edo_evaluation.start_date_time;
        var minutes = response.evaluation_process_data.HrEDO.edo_preferences.questionnaire_time_limit

        var verification = HrLimitTimeService.checkTimeLimitCuestionaire(cuestionaire_start_time, minutes);

        vm.cuestionaireHasTime = verification.status;
      }, function (error) {
      });
    }

    function initLists(evaluationData) {
      var arrReturn = [];
      for (var e in evaluationData) {
        if (eval('typeof serialize' + e + ' == "function"')) {
          eval('serialize' + e + '(evaluationData[e])');
        }

      }

    }

    function serializeHrGoal(data) {
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrGoal);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;

      if (!objReturn.data.employee_goals.length) {
        objReturn.hide = true;
      }

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrPersonalDevelopment(data) {
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrPersonalDevelopment);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;



      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrSkill(data) {
      data = serializeDataSkill(data);
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrSkill);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;
      vm.currentEvaluationData.push(objReturn);
    }

    function serializeDataAssistant(data) {
      var title = HrAssistantObjectiveService.serializeTitleTableObj(data.evaluation_preferences);

      var dataMultiple = HrAssistantObjectiveService.serializeDataMultiple(data.assistant_objective_evaluation.assistant_objective_evaluation_detail);

      data.data = {
        title: title,
        sections: dataMultiple.sections,
        info: dataMultiple.collab,
        personal_developments: data.personal_developments,
        personal_development_responsable_list: data.evaluation_preferences.personal_development_responsable_list
      };
      return data;
    }

    function serializeHrCoreValue(data) {
      data = serializeDataCoreValue(data);
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrCoreValue);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;
      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrAssistantObjective(data) {

      var title = HrAssistantObjectiveService.serializeTitleTableObj(data.evaluation_preferences);

      var dataMultiple = HrAssistantObjectiveService.serializeDataMultiple(data.assistant_objective_evaluation.assistant_objective_evaluation_detail);

      var objReturn = {};

      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrAssistantObjective);
      objReturn.data = {
        title: title,
        sections: dataMultiple.sections,
        info: dataMultiple.collab,
        personal_developments: data.personal_developments,
        personal_development_responsable_list: data.evaluation_preferences.personal_development_responsable_list
      };
      objReturn.title = data.hr_module.name;
      vm.currentEvaluationData.push(objReturn);
    }

    function serializeDataSkill(data) {
      var evaluations = data.skills_evaluations;
      data.evaluation_preferences = data.evaluation_options.final;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var titleObj = serializeTitleObjSkill(data.evaluation_preferences);
      var titleObjColor = HrSkillService.setTitleColor(data.evaluation_preferences);
      var body = data.skills_profile.map(function (element) {
        var skillDescriptors = data.skills_descriptors[element.skill.id];
        var skillDetail = data.skills_profile.filter(function (elem) {
          return elem.skill_id == element.skill.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.skill.id == element.skill.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody : {}

        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body,
        titleObj: titleObj,
        titleObjColor: titleObjColor,
        results_by_role: HrSkillService.serializeResultsByRole(data)
      }

      return data;
    }

    function serializeDataCoreValue(data) {
      var evaluations = data.core_value_evaluations;
      data.evaluation_preferences = data.evaluation_options.follow_up;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var titleObj = serializeTitleObjSkill(data.evaluation_preferences);
      var titleObjColor = HrCoreValueService.setTitleColor(data.evaluation_preferences);
      var body = data.core_value_profile.map(function (element) {
        var skillDescriptors = data.core_value_descriptors[element.core_value.id];
        var skillDetail = data.core_value_profile.filter(function (elem) {
          return elem.core_value_id == element.core_value.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.core_value.id == element.core_value.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody : {}
        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body,
        titleObj: titleObj,
        titleObjColor: titleObjColor,
        results_by_role: HrCoreValueService.serializeResultsByRole(data)
      }
      return data;
    }

    function serializeDataSkillSigle(data) {
      data.evaluation_preferences = data.evaluation_options.follow_up;
      var evaluations = data.skills_evaluations;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var body = data.skills_profile.map(function (element) {
        var skillDescriptors = data.skills_descriptors[element.skill.id];
        var skillDetail = data.skills_profile.filter(function (elem) {
          return elem.skill_id == element.skill.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.skill.id == element.skill.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody[0] : {}
        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body
      }
      return data;
    }

    function serializeDataCoreValueSigle(data) {
      data.evaluation_preferences = data.evaluation_options.follow_up;
      var evaluations = data.core_value_evaluations;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var body = data.core_value_profile.map(function (element) {
        var skillDescriptors = data.core_value_descriptors[element.core_value.id];
        var skillDetail = data.core_value_profile.filter(function (elem) {
          return elem.core_value_id == element.core_value.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.core_value.id == element.core_value.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody[0] : {}
        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body
      }
      return data;
    }

    function serializeTitleTableSkill(preferences) {
      var newPreference = preferences.results_scale.map(function (element) {
        var newElement = element;
        newElement.value = parseInt(element.value);
        return newElement
      });
      return newPreference.sort(function (a, b) {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      });
    }

    function serializeTitleObjSkill(preferences) {
      var obj = {};
      preferences = preferences.results_scale;
      for (var i in preferences) {
        obj[preferences[i].value] = preferences[i];
      }
      return obj;
    }

    function serializeHrGoalIndicator(data) {

      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrGoalIndicator);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrFinalComment(data) {
      var objReturn = {
        data: HrFinalCommentService.serializeComments(data),
        title: data.hr_module.name,
        template: angular.copy(vm.currentEvaluationTemplate.HrFinalComment)
      };

      if (!objReturn.data.comments.length) {
        objReturn.hide = true;
      }

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrFinalCommentHistory(data) {
      data = HrFinalCommentService.serializeComments(data);

      return data;
    }

    function serializeHrPoll(data) {
      data.movilidad = HrPollService.serializePollDetail(data.poll_evaluation);

      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrPoll);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;
      if (!data.movilidad.length) {
        objReturn.hide = true;
      }
      vm.currentEvaluationData.push(objReturn);
      return data;
    }

    function serializeHrPollHistory(data) {
      data.movilidad = HrPollService.serializePollDetail(data.poll_evaluation);

      return data;
    }

    function setMessages(messages) {
      var messageValid = messages.filter(function (element) {
        return !element.status;
      });
      vm.messages = messageValid;
    }

    function sendMessage(message, messageValue) {
      var data = {
        id: message.id,
        result: messageValue
      }

      evaluationService.sendMessages(data).then(function (resolve) {
        message.status = resolve.status;
      });
    }

    function donwloadPDF(process_id) {
      process_id = process_id ? process_id : vm.currentEvaluation.id
      api.general.getWindowHttp('GET', '/evaluation/' + process_id + '/pdf', {}, process_id + '.pdf');
    }

    function getPositionDetail(position) {
      organizationService.getPositionDetail(position.id).then(function (response) {
        vm.positionSelected = position;
        vm.positionDetail = response;
        showPositionDetail({});
      });
    }

    function showPositionDetail(config) {
      $mdDialog.show({
        controller: 'PositionDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/services/dialogs/position-detail/position-detail-dialog.html',
        clickOutsideToClose: false,
        locals: {
          Position: vm.positionSelected,
          PositionDetail: vm.positionDetail,
          Config: config
        }
      });
    }


    /**
     * POSITION DETAIL
     */

    function nextQuestion(finalize) {

      if (finalize) {
        HrEDOService.saveQuestion(vm.edo.question).then(function (response) {
          var process = HrEDOService.getEvaluationCurrenProcess();
          evaluationService.finalizeEvaluationProcess(process.id).then(function (response) {
            showDialogFinalizeQuestions();
            HrLimitTimeService.stop();
          });
        });

      } else {
        HrEDOService.saveQuestion(vm.edo.question);
        var data = HrEDOService.nextQuestion();
        setEdo(data);
      }


    }

    function showDialogFinalizeQuestions() {
      var confirm = $mdDialog.confirm()
        .title('La evaluación ha finalizado con éxito')
        .htmlContent('')
        .ariaLabel('delet')
        .ok('Cerrar');

      $mdDialog.show(confirm).then(function () {
        vm.emptyEdo = true;
      });
    }

    function backQuestion() {
      HrEDOService.saveQuestion(vm.edo.question);
      var data = HrEDOService.backQuestion();
      setEdo(data);
    }

    function setEdo(data) {
      for (var i in data) {
        vm.edo[i] = data[i];
      }
    }

    ////////// Cronometro Cuestionario
    function startCountdown(){

      HrLimitTimeService.startCountdown(vm.edo_complete)
        .then(function (response) {
          
          if(!response.status){
            vm.expiredTimeCuestionaire('Se ha superado el límite de tiempo')
          }

          HrLimitTimeService.start();
          vm.cuestionaireStart = true;
          vm.cuestionaireHasTime = true;
      });
    }

    //Destuir el intervalo cuando se salga del scope
    $scope.$on('$destroy', function() {
      HrLimitTimeService.stop();
    });

    $scope.$on('expiredTimeEmmit', function(event, args) {
      vm.expiredTimeCuestionaire(args.msg)
    });

    $scope.$on('updateCronometer', function(event, args) {
      vm.cronometer = args.data;
    });

    function expiredTimeCuestionaire(message){
      var confirm = $mdDialog.confirm()
          .title(message)
          .htmlContent('')
          .ariaLabel('delet')
          .ok('Cerrar');
        
      $mdDialog.show(confirm).then(function () {
        vm.cuestionaireHasTime = false;
      });
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.cstm.organization_upload', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.organization_upload', {
            url  : '/organization_upload/:key',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/organization/upload/upload.html',
                    controller : 'OrganizationUploadController as vm'
                }
            },
            requiresAuthentication: true
        });
        
    }

})();
(function () {
    'use strict';

    angular
        .module('app.cstm.organization_upload')
        .controller('OrganizationUploadController', OrganizationUploadController)
        .service('OrganizationUploadService', OrganizationUploadService);

    function OrganizationUploadService() {
        var data = {};
        var LOCALSTORAGEKEY = 'upload_organization';

        return {
            setData: setData,
            getData: getData,
            removeData: removeData
        }

        function setData(dataSet) {
            data = dataSet;
            localStorage.setItem(LOCALSTORAGEKEY,JSON.stringify(data));
        }

        function getData() {
            if (angular.equals(data,{})) {
                data = localStorage.getItem(LOCALSTORAGEKEY);
                if(data){
                    data = JSON.parse(data);
                }
            }
            return data;
        }

        function removeData() {
            localStorage.removeItem(LOCALSTORAGEKEY);
        }
    }

    /** @ngInject */
    function OrganizationUploadController(LicenseService, $state, UtilsService,OrganizationUploadService) {
        var vm = this;
        vm.key = $state.params.key;
        vm.errorLoadingConfig = false;
        vm.data = OrganizationUploadService.getData();

        function _init() {
            getConfig();
        }

        function getConfig() {
            LicenseService.getOrganizacionUploadConfig().then(function (licenseData) {
                if (licenseData[vm.key]) {
                    vm.configUpload = licenseData[vm.key];
                    configSerialize(vm.configUpload);
                } else {
                    UtilsService.showToast("No se encontro la configuración para la importación que desea realizar.");
                    vm.errorLoadingConfig = true;
                }
            }, function (err) {
            });
        }

        function configSerialize(data) {
            vm.title = data.title;

            vm.configImportData = data;
            vm.configImportData.Data = vm.data && vm.data[vm.key] ? vm.data[vm.key] : {};
            vm.configImportData.templateUrl = 'app/main/elements/ik-import-data/' + data.template + '/' + data.template + '.html';
            vm.configImportData.config = {
                key: vm.key,
                config: data
            };
        }

        _init();

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cstm.organization_employees')
        .controller('OrganizationEmployeesController', OrganizationEmployeesController);

    /** @ngInject */
    function OrganizationEmployeesController($location, $mdDialog, $document, UtilsService, organizationService,$state)
    {
      //Track Google Analytics
      UtilsService.trackPage();        
      
      var vm = this;

      vm.isDataLoaded = false;
      vm.sendindData = {};
      vm.inactiveEmployees = null;
      vm.employees = null;

      vm.goImport = goImport;

      //Opciones del data table - paginacion
      vm.dtOptions = UtilsService.getDataTableOptions();

      //Cargar información
      organizationService.getOrganizationEmployees().then(function(response) {
        vm.employees = response.employees;
        vm.isDataLoaded = true;  
      }).catch(function(err) {
        // TODO
        vm.isDataLoaded = true;
      });  

      //Methods
      vm.activateEmployee = activateEmployee;
      vm.loadInactiveEmployees = loadInactiveEmployees;
      vm.openEmployeeDialog = openEmployeeDialog;
      vm.removeEmployee = removeEmployee;
      vm.resetPassword = resetPassword;

      function activateEmployee(ev, employee) {
        var confirm = $mdDialog.confirm()
                                        .title('Confirma que desea activar a:')
                                        .htmlContent('<b>' + employee.name + '</b>')
                                        .ariaLabel('delet')
                                        .targetEvent(ev)
                                        .ok('OK')
                                        .cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
          
          vm.sendindData[employee.id] = true;

          organizationService.activateEmployee(employee.id).then(function(response) {
            //Retirar de la lista de inactivos
            vm.inactiveEmployees.splice(vm.inactiveEmployees.indexOf(employee), 1);
            vm.sendindData[employee.id] = false;

            //Agregar a la lista de activos
            vm.employees.push(employee);
          }).catch(function(err) {
            vm.sendindData[employee.id] = false;
          });                
        });        
      }

      function loadInactiveEmployees() {
        organizationService.getInactiveEmployees().then(function(response) {
          vm.inactiveEmployees = response.inactiveEmployees;
        }).catch(function(err) {
          // TODO
          vm.isDataLoaded = true;
        });          
      }

      function openEmployeeDialog(ev, employee)
      {
        $mdDialog.show({
          controller         : 'EmployeeDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/custom_modules/organization/employees/dialogs/employee/employee-dialog.html',
          parent             : angular.element($document.find('#content-container')),
          targetEvent        : ev,
          clickOutsideToClose: false,
          locals             : {
            Employees:   vm.employees,
            Employee:    employee
          }
        });
      }  

      function removeEmployee(ev, employee) {

        var confirm = $mdDialog.confirm()
                                        .title('Confirma que desea retirar a:')
                                        .htmlContent('<b>' + employee.name + '</b>')
                                        .ariaLabel('delet')
                                        .targetEvent(ev)
                                        .ok('OK')
                                        .cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
          
          vm.sendindData[employee.id] = true;

          organizationService.removeEmployee(employee.id).then(function(response) {
            vm.employees.splice(vm.employees.indexOf(employee), 1);

            //Si la lista de colaboradores inactivos esta cargada, agregar el empleado inactivo
            if(vm.inactiveEmployees) {
              vm.inactiveEmployees.push(employee);
            }

            vm.sendindData[employee.id] = false;
          }).catch(function(err) {
          });                
        });

      }
      
      function resetPassword(ev,employee){
        organizationService.resetPasswordEmployee(employee.id).then(function(response) {
          
        }).catch(function(err) {
          // TODO
          vm.isDataLoaded = true;
        });          
      }

      function goImport(){
        $state.go('app.organization_upload',{key:'structure_employees_import'});
      }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.cstm.cstm_evaluation_details')
    .controller('CstmEvaluationDetailsController', CstmEvaluationDetailsController);

  /** @ngInject */
  function CstmEvaluationDetailsController($state, $mdDialog, $document, UtilsService, organizationService, evaluationService, HrSkillService, api, HrAssistantObjectiveService, HrFinalCommentService, HrPollService, HrCoreValueService, LicenseService) {
    //Track Google Analytics
    UtilsService.trackPage();

    var vm = this;
    vm.employee_process_id = $state.params.employee_process_id;
    vm.process_deadline = null;
    vm.moduleSelected = {};
    vm.editform = {};

    vm.today = moment().toDate();

    // Data
    init();

    vm.getLastState = LicenseService.getLastState();

    //Opciones del DataTable
    vm.dtOptions = UtilsService.getDataTableOptions();
    vm.dtOptionsNoPaginate = UtilsService.getDataTableOptions('no-paginate');

    //Methods
    vm.activateNewProcess = activateNewProcess;
    vm.deleteEmployeeProcess = deleteEmployeeProcess;
    vm.enableEditionForm = enableEditionForm;
    vm.openLogDetailDialog = openLogDetailDialog;
    vm.saveMatInfoStructure = saveMatInfoStructure;
    vm.saveMatProcess = saveMatProcess;
    vm.showEvaluation = showEvaluation;
    vm.availableProcessChange = availableProcessChange;
    vm.donwloadPDF = donwloadPDF;
    vm.addHrModule = addHrModule;
    vm.deleteHrModule = deleteHrModule;
    vm.editModulo = editModulo;
    vm.viewPositionDetail = viewPositionDetail;
    vm.enablePositionDetails = LicenseService.getModuleEnable('position_details');
    vm.addSkillEvaluator = addSkillEvaluator;
    vm.deleteHrSkillEvaluator = deleteHrSkillEvaluator;

    function init() {

      //Evaluatins_history
      vm.employeeCardTemplate = 'app/main/elements/ik-employee-team-card/default/default.html';
      vm.evaluationResultCardTemplate = 'app/main/elements/ik-evaluation-result-card/default/default.html';
      vm.hrGoalViewCardTemplate = 'app/main/elements/ik-hr-goal-card/default/default.html';
      vm.evaluationResultListTemplate = 'app/main/elements/ik-hr-goal-result-list/default/default.html';
      vm.evaluationDataTemplate = 'app/main/elements/ik-evaluation-data/default/default.html';

      //Current_evaliation
      vm.currentEvaluationData = [];
      vm.currentEvaluationTemplate = {};
      vm.currentEvaluationTemplate.HrGoal = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrGoal/default.html';
      vm.currentEvaluationTemplate.HrPersonalDevelopment = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrPersonalDevelopment/default.html';
      vm.currentEvaluationTemplate.HrSkill = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrSkill/default.html';
      vm.currentEvaluationTemplate.HrGoalIndicator = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrGoalIndicator/default.html';
      vm.currentEvaluationTemplate.HrPoll = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrPoll/default.html';
      vm.currentEvaluationTemplate.HrAssistantObjective = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrAssistantObjective/default.html';
      vm.currentEvaluationTemplate.HrFinalComment = 'app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrFinalComment/default.html';

      //Default view
      vm.evaluationResultViewType = 'list';

      //Contiene la información del formulario habilitado para edición
      vm.showForm = {};
      vm.formLoading = {};

      //UI/UX indica si se esta consultando la información de una evaluación
      vm.loadingEvaluationInfo = false;
      vm.showEvaluationHistoryData = false;

      vm.isDataLoaded = false;
      evaluationService.getEvaluationDetails(vm.employee_process_id).then(function (response) {

        vm.evaluationInfo = response.employeeProcess;
        vm.evaluationInfo.updateGoals = false;

        if (vm.evaluationInfo.process_deadline) {
          vm.evaluationInfo.process_deadline = moment(vm.evaluationInfo.process_deadline).toDate();
        }

        vm.evaluationLog = response.evaluationLog;
        vm.processStagesOptions = response.processStagesOptions;
        vm.evaluationData = response.evaluationData;
        vm.employeeProcessHistory = response.employeeProcessHistory;
        vm.skillsProfile = response.skillsProfile;
        vm.availableProcess = response.availableProcess;
        vm.skill_evaluation_preferences = response.skill_evaluation_preferences
        vm.core_value_ev_preferences = response.core_value_ev_preferences

        vm.skillsEvaluators = serializeEvaluators(response.skills_evaluators, vm.skill_evaluation_preferences);
        vm.coreValueProfile = response.core_value_profile;
        vm.coreValueEvaluators = serializeEvaluators(response.core_value_evaluators, vm.core_value_ev_preferences);
        if (vm.evaluationInfo.evaluation_active_process) {
          vm.listsProcessLists = getProcessList(vm.evaluationInfo.evaluation_active_process.id);
        }

        vm.hr_modules = response.hr_modules;
        vm.hr_modules_assing = serializeHrModuleAssing(vm.hr_modules, response.employeeProcess.evaluation_hr_modules);
        vm.hr_modules_free = getModulesFree(vm.hr_modules, vm.hr_modules_assing);

        vm.evaluationsHistory = response.employeeProcessHistory;
        vm.evaluation_process_stage = vm.isDataLoaded = true;

        vm.evFinalCurrentAuto = 0.0;
        vm.evFinalCurrent = 0.0;
        for (var i in response.employeeProcess.evaluation_hr_modules) {
          var evaluation = response.employeeProcess.evaluation_hr_modules[i];
          if (!evaluation.hr_module.has_evaluation) {
            continue;
          }
          var evFinalCurrentAuto = (evaluation.weight * parseFloat(evaluation.auto_evaluation)) / 100;
          var evFinalCurrent = (evaluation.weight * parseFloat(evaluation.final_evaluation)) / 100;

          vm.evFinalCurrentAuto = vm.evFinalCurrentAuto + evFinalCurrentAuto;
          vm.evFinalCurrent = vm.evFinalCurrent + evFinalCurrent;
        }


        initLists(vm.evaluationData);
      }).catch(function (err) {
        // TODO
        vm.isDataLoaded = true;
      });
    }

    function serializeHrModuleAssing(modules, modulesUsing) {
      return modulesUsing.map(function (element) {
        var module = modules.filter(function (elm) {
          return elm.id == element.hr_module.id;
        });

        element.module = module[0];
        return element;
      });
    }

    function getModulesFree(modules, modulesUsing) {
      var modulesFree = [];
      modules.map(function (element) {
        var module = modulesUsing.filter(function (elm) {
          return element.id == elm.module.id;
        });

        if (!module.length) {
          modulesFree.push(element);
        }
      });
      return modulesFree;
    }

    function addHrModule() {
      var obj = {
        employee_process_id: vm.employee_process_id,
        hr_module_id: vm.moduleSelected.module.id,
        hr_module_weight: vm.moduleSelected.weigth,
        hr_module_list_item_id: vm.moduleSelected.list
      }
      evaluationService.addHrModule(obj).then(function (response) {
        vm.showForm.mat_module = false;
        if (vm.editform.mat_module) {
          vm.editform.mat_module = false;
          updateModule(obj.hr_module_id, response);
        } else {
          addModule(response);
        }
        vm.moduleSelected = {};
      }, function (error) {
        console.log(error);
      });
    }

    function addSkillEvaluator(){

      var obj = {
        matricula_id: vm.employee_process_id,
        role: vm.evSkills.rol,
        evaluator_id: vm.evSkills.employee
      };

      api.evaluations.add_skill_evaluator.save(obj,function(response){
        UtilsService.showToast(response.message);
        vm.showForm['ev_skills'] = false;
        var evaluator = response.data;
        var role = vm.skill_evaluation_preferences.evaluator_roles_available.filter(function (element) {
          return element.key == evaluator.role;
        });
        evaluator.rol = role[0];
        vm.skillsEvaluators.push(evaluator);
      },function(error){
        console.log(error);
        UtilsService.showToast(error.error.message,true);
      })
    }

    function deleteHrSkillEvaluator(evaluator,index){
      var obj = {
        matricula_id: vm.employee_process_id,
        evaluator_id: evaluator.evaluator.id
      }

      api.evaluations.remove_skill_evaluator.delete(obj,function(response){
        UtilsService.showToast(response.message);
        vm.skillsEvaluators.splice(index,1);
      },function(error){
        console.log(error);
        UtilsService.showToast(error.error.message,true);
      });
    }

    function deleteHrModule(module, ev) {
      var confirm = $mdDialog.confirm()
        .title('¿Esta seguro de eliminar la información registrada en el módulo ' + module.name + '?')
        .htmlContent('')
        .ariaLabel('delet')
        .targetEvent(ev)
        .ok('CONFIRMAR')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var obj = {
          employee_process_id: vm.employee_process_id,
          hr_module_id: module.id
        }
        evaluationService.remove_hr_module(obj).then(function (response) {
          deleteModule(module.id);
          vm.hr_modules_free = getModulesFree(vm.hr_modules, vm.hr_modules_assing);
        }, function (error) {
          console.log(error);
        });
      });

    }

    function editModulo(module) {
      vm.showForm.mat_module = true;
      vm.editform.mat_module = true;
      vm.moduleSelected.module = module.module;
      vm.moduleSelected.weigth = module.weight;
      vm.moduleSelected.list = module.module_list_item_id;
    }

    function updateModule(module_id, data) {
      for (var i in vm.hr_modules_assing) {
        var module = vm.hr_modules_assing[i];
        if (module.hr_module.id == module_id) {
          vm.hr_modules_assing[i].weight = data.weight;
          if (data.module_list_item_id) {
            vm.hr_modules_assing[i].module_list_item_id = data.module_list_item_id;
            vm.hr_modules_assing[i].module_list_item = data.module_list_item;
          }
          break;
        }
      }
    }

    function addModule(data) {
      vm.hr_modules_assing.push(data);
      vm.hr_modules_assing = serializeHrModuleAssing(vm.hr_modules, vm.hr_modules_assing);
      vm.hr_modules_free = getModulesFree(vm.hr_modules, vm.hr_modules_assing);
    }

    function deleteModule(module_id) {
      for (var i in vm.hr_modules_assing) {
        if (vm.hr_modules_assing[i].hr_module.id == module_id) {
          vm.hr_modules_assing.splice(i, 1);
        }
      }
    }

    function initLists(evaluationData) {
      var arrReturn = [];
      for (var e in evaluationData) {
        if (eval('typeof serialize' + e + ' == "function"')) {
          eval('serialize' + e + '(evaluationData[e])');
        }

      }

    }

    function serializeHrGoal(data) {
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrGoal);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;

      if (!objReturn.data.employee_goals.length) {
        objReturn.hide = true;
      }

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrPersonalDevelopment(data) {
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrPersonalDevelopment);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrSkill(data) {
      data = serializeDataSkill(data);
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrSkill);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;
      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrAssistantObjective(data) {

      var title = HrAssistantObjectiveService.serializeTitleTableObj(data.evaluation_preferences);

      var dataMultiple = HrAssistantObjectiveService.serializeDataMultiple(data.assistant_objective_evaluation.assistant_objective_evaluation_detail);

      var objReturn = {};

      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrAssistantObjective);
      objReturn.data = {
        title: title,
        sections: dataMultiple.sections,
        info: dataMultiple.collab,
        personal_developments: data.personal_developments,
        personal_development_responsable_list: data.evaluation_preferences.personal_development_responsable_list
      };
      objReturn.title = data.hr_module.name;
      vm.currentEvaluationData.push(objReturn);
    }

    function serializeDataSkill(data) {
      var evaluations = data.skills_evaluations;
      data.evaluation_preferences = data.evaluation_options.follow_up;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var titleObj = serializeTitleObjSkill(data.evaluation_preferences);
      var titleObjColor = HrSkillService.setTitleColor(data.evaluation_preferences);
      var body = data.skills_profile.map(function (element) {
        var skillDescriptors = data.skills_descriptors[element.skill.id];
        var skillDetail = data.skills_profile.filter(function (elem) {
          return elem.skill_id == element.skill.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.skill.id == element.skill.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody : {}
        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body,
        titleObj: titleObj,
        titleObjColor: titleObjColor,
        results_by_role: HrSkillService.serializeResultsByRole(data)
      }

      return data;
    }

    function serializeDataSkillSigle(data) {
      data.evaluation_preferences = data.evaluation_options.follow_up;
      var evaluations = data.skills_evaluations;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var body = data.skills_profile.map(function (element) {
        var skillDescriptors = data.skills_descriptors[element.skill.id];
        var skillDetail = data.skills_profile.filter(function (elem) {
          return elem.skill_id == element.skill.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.skill.id == element.skill.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody[0] : {}
        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body
      }
      return data;
    }


    function serializeDataAssistant(data) {
      var title = HrAssistantObjectiveService.serializeTitleTableObj(data.evaluation_preferences);

      var dataMultiple = HrAssistantObjectiveService.serializeDataMultiple(data.assistant_objective_evaluation.assistant_objective_evaluation_detail);

      data.data = {
        title: title,
        sections: dataMultiple.sections,
        info: dataMultiple.collab,
        personal_developments: data.personal_developments,
        personal_development_responsable_list: data.evaluation_preferences.personal_development_responsable_list
      };
      return data;
    }

    function serializeHrCoreValue(data) {
      data = serializeDataCoreValue(data);
      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrCoreValue);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;
      vm.currentEvaluationData.push(objReturn);
    }

    function serializeDataCoreValue(data) {
      var evaluations = data.core_value_evaluations;
      data.evaluation_preferences = data.evaluation_options.follow_up;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var titleObj = serializeTitleObjSkill(data.evaluation_preferences);
      var titleObjColor = HrCoreValueService.setTitleColor(data.evaluation_preferences);
      var body = data.core_value_profile.map(function (element) {
        var skillDescriptors = data.core_value_descriptors[element.core_value.id];
        var skillDetail = data.core_value_profile.filter(function (elem) {
          return elem.core_value_id == element.core_value.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.core_value.id == element.core_value.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody : {}
        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body,
        titleObj: titleObj,
        titleObjColor: titleObjColor,
        results_by_role: HrCoreValueService.serializeResultsByRole(data)
      }
      return data;
    }

    function serializeDataCoreValueSigle(data) {
      data.evaluation_preferences = data.evaluation_options.follow_up;
      var evaluations = data.core_value_evaluations;
      var title = serializeTitleTableSkill(data.evaluation_preferences);
      var body = data.core_value_profile.map(function (element) {
        var skillDescriptors = data.core_value_descriptors[element.core_value.id];
        var skillDetail = data.core_value_profile.filter(function (elem) {
          return elem.core_value_id == element.core_value.id;
        });
        var dataBody = evaluations.filter(function (elem) {
          return elem.core_value.id == element.core_value.id;
        })
        var objReturn = {
          skillDescriptors: skillDescriptors,
          skillDetail: skillDetail.length ? skillDetail[0] : [],
          dataBody: dataBody.length ? dataBody[0] : {}
        }

        return objReturn;
      });
      data.skillStructure = {
        title: title,
        body: body
      }
      return data;
    }

    function serializeTitleTableSkill(preferences) {
      var newPreference = preferences.results_scale.map(function (element) {
        var newElement = element;
        newElement.value = parseInt(element.value);
        return newElement
      });
      return newPreference.sort(function (a, b) {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      });
    }

    function serializeTitleObjSkill(preferences) {
      var obj = {};
      preferences = preferences.results_scale;
      for (var i in preferences) {
        obj[preferences[i].value] = preferences[i];
      }
      return obj;
    }

    function serializeHrGoalIndicator(data) {

      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrGoalIndicator);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeEvaluators(evaluators, preferences) {
      if (!evaluators) {
        return [];
      }
      return evaluators.map(function (evaluator) {
        var role = preferences.evaluator_roles_available.filter(function (element) {
          return element.key == evaluator.role;
        });
        evaluator.rol = role[0];
        return evaluator;
      });
    }

    function serializeHrFinalComment(data) {
      var objReturn = {
        data: HrFinalCommentService.serializeComments(data),
        title: data.hr_module.name,
        template: angular.copy(vm.currentEvaluationTemplate.HrFinalComment)
      };

      if (!objReturn.data.comments.length) {
        objReturn.hide = true;
      }

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrFinalCommentHistory(data) {
      data = HrFinalCommentService.serializeComments(data);

      return data;
    }

    function serializeHrPoll(data) {
      data.movilidad = HrPollService.serializePollDetail(data.poll_evaluation);


      var objReturn = {};
      objReturn.template = angular.copy(vm.currentEvaluationTemplate.HrPoll);
      objReturn.data = data;
      objReturn.title = data.hr_module.name;

      if (!data.movilidad.length) {
        objReturn.hide = true;
      }

      vm.currentEvaluationData.push(objReturn);
    }

    function serializeHrPollHistory(data) {
      data.movilidad = HrPollService.serializePollDetail(data.poll_evaluation);

      return data;
    }

    function activateNewProcess(ev) {

      var confirm = $mdDialog.confirm()
        .title('')
        .htmlContent("<div class='text-center'><span class='text-l font-weight-600'>¿Confirma que desea activar el proceso?</span></div>")
        .ariaLabel('delet')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        evaluationService.activateNewProcess(vm.evaluationInfo.periodo_id, vm.employee_process_id, vm.new_process, vm.process_deadline, vm.process_lists_item_id).then(function (response) {
          vm.evaluationInfo = response.employeeProcess;
          if (vm.evaluationInfo.process_deadline) {
            vm.evaluationInfo.process_deadline = moment(vm.evaluationInfo.process_deadline).toDate();
          }
        }).catch(function (err) {

        });

      });

    }

    function deleteEmployeeProcess(ev) {

      var confirm = $mdDialog.confirm()
        .title('Confirma que desea eliminar la evaluación de:')
        .htmlContent('<b>' + vm.evaluationInfo.empleado.name + '</b>')
        .ariaLabel('delet')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        evaluationService.deleteEvaluation(vm.employee_process_id).then(function (response) {

          $state.go('app.cstm_evaluation');

        }).catch(function (err) {

        });

      });
    }

    function enableEditionForm(formId) {

      vm.formLoading[formId] = true;

      if (formId == 'mat_info') {
        _enableEditionEmployee();
      } else if (formId == 'mat_process') {
        _enableEditionProcess();
      } else if (formId == 'mat_module') {
        if (vm.showForm[formId]) {
          vm.showForm[formId] = false;
        } else {
          vm.showForm[formId] = true;
        }
      } else if (formId == "ev_skills") {
        api.misc.get_lists.get({model_name:'empleado',filter_estado:1},function(response){
          vm.showForm['ev_skills'] = true;
          vm.listEmployees = response.data;
        },function(error){
          console.log(error);
          UtilsService.showToast(error.error.message,true);
        });
      }
    }

    function _enableEditionEmployee() {

      organizationService.getOrganizationStructure(vm.evaluationInfo.periodo_id).then(function (response) {

        //Asignar data

        vm.organizationAreas = response.areas;
        vm.organizationDepartments = response.departments;
        vm.organizationEmployees = response.employees;
        vm.organizationPositions = response.positions;
        vm.organizationCompanies = response.companies;
        vm.organizationPositionLevels = response.positionLevels;
        vm.groups = response.groups;


        vm.showForm['mat_info'] = true;
        vm.formLoading['mat_info'] = false;
      }).catch(function (err) {
        vm.formLoading['mat_info'] = false;
      });
    }

    function _enableEditionProcess() {
      vm.showForm['mat_process'] = true;
      vm.formLoading['mat_process'] = false;

    }

    function availableProcessChange(id) {

      var filter = vm.availableProcess.filter(function (element) {
        return element.id == id;
      });

      vm.availableProcessProcessList = filter.length > 0 ? filter[0].process_list : null;

    }

    function getProcessList(evaluationId) {
      if (vm.availableProcess.length == 0) {
        return [];
      }
      var availableProcess = vm.availableProcess.filter(function (element) {
        return element.id == evaluationId;
      });

      if (availableProcess.length == 0) {
        return [];
      }

      return availableProcess[0].process_list ? availableProcess[0].process_list.lists_items : [];
    }

    function openLogDetailDialog(ev, logData) {
      $mdDialog.show({
        controller: 'EvaluationLogDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/custom_modules/evaluation/evaluation-details/dialogs/evaluation-log-detail/evaluation-log-detail-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          logData: logData
        }
      });
    }

    function saveMatInfoStructure(ev) {

      var data = {
        area_id: vm.evaluationInfo.area_id,
        jefe_id: vm.evaluationInfo.jefe_id,
        jefe_jefe_id: vm.evaluationInfo.jefe_jefe_id,
        jefe_corporativo_id: vm.evaluationInfo.jefe_corporativo_id,
        empresa_id: vm.evaluationInfo.empresa_id,
        company_department_id: vm.evaluationInfo.company_department_id,
        cargo_id: vm.evaluationInfo.cargo_id,
        nivel: vm.evaluationInfo.nivel,
        grupo: vm.evaluationInfo.grupo,
        update_goals: vm.evaluationInfo.updateGoals
      };

      evaluationService.changeMatStructureInfo(vm.employee_process_id, data).then(function (response) {

        //Mostrar mensaje resultado de la operación
        UtilsService.showToast(response.message, response.status);

        //Actualizar datos locales con la respuesta del API
        vm.evaluationInfo = response.employeeProcess;
        vm.skillsEvaluators = serializeEvaluators(response.skills_evaluators, vm.skill_evaluation_preferences);
        vm.coreValueEvaluators = serializeEvaluators(response.core_value_evaluators, vm.core_value_ev_preferences);

        if (vm.evaluationInfo.process_deadline) {
          vm.evaluationInfo.process_deadline = moment(vm.evaluationInfo.process_deadline).toDate();
        }
        //Finalizar modo de edición del formulario
        vm.showForm['mat_info'] = false;

      }).catch(function (err) {
        // TODO
      });

    }

    function saveMatProcess(ev) {

      evaluationService.changeProcessStage(vm.employee_process_id, vm.evaluationInfo.evaluation_process_stage_id, vm.evaluationInfo.process_deadline).then(function (response) {

        //Actualizar datos locales con la respuesta del API
        vm.evaluationInfo = response.employeeProcess;
        if (vm.evaluationInfo.process_deadline) {
          vm.evaluationInfo.process_deadline = moment(vm.evaluationInfo.process_deadline).toDate();
        }
        //Finalizar modo de edición del formulario
        vm.showForm['mat_process'] = false;

        //Mostrar mensaje resultado de la operación
        //UtilsService.showToast(response.message, response.status);

      }).catch(function (err) {
        // TODO
      });

    }

    function showEvaluation(employeeProcessId) {
      vm.loadingEvaluationInfo = true;

      evaluationService.getEvaluationData(employeeProcessId).then(function (response) {

        if (response.evaluation_data.HrSkill && !response.evaluation_data.HrSkill.error) {
          response.evaluation_data.HrSkill = serializeDataSkill(response.evaluation_data.HrSkill);
        }

        if (response.evaluation_data.HrAssistantObjective && !response.evaluation_data.HrAssistantObjective.error) {
          response.evaluation_data.HrAssistantObjective = serializeDataAssistant(response.evaluation_data.HrAssistantObjective);
        }

        if (response.evaluation_data.HrCoreValue && !response.evaluation_data.HrCoreValue.error) {
          response.evaluation_data.HrCoreValue = serializeDataCoreValue(response.evaluation_data.HrCoreValue);
        }

        if (response.evaluation_data.HrFinalComment && !response.evaluation_data.HrFinalComment.error) {
          response.evaluation_data.HrFinalComment = serializeHrFinalCommentHistory(response.evaluation_data.HrFinalComment);
        }

        if (response.evaluation_data.HrPoll && !response.evaluation_data.HrPoll.error) {
          response.evaluation_data.HrPoll = serializeHrPollHistory(response.evaluation_data.HrPoll);
        }


        //Actualizar datos locales con la respuesta del API
        vm.evaluationHistoryData = response;
        vm.evaluationHistoryData.chartOptions = UtilsService.getChartHistory(response);

        vm.loadingEvaluationInfo = false;

        vm.showEvaluationHistoryData = true;

      }).catch(function (err) {
        vm.loadingEvaluationInfo = false;
      });

    }

    function donwloadPDF(process_id) {
      process_id = process_id ? process_id : vm.employee_process_id
      api.general.getWindowHttp('GET', '/evaluation/' + process_id + '/pdf', {}, process_id + '.pdf');
    }

    function viewPositionDetail(position_id) {
      organizationService.getPositionDetail(position_id).then(function (response) {
        vm.positionDetail = response;
        showPositionDetail({});
      });
    }

    function showPositionDetail(config) {
      $mdDialog.show({
        controller: 'PositionDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/services/dialogs/position-detail/position-detail-dialog.html',
        clickOutsideToClose: false,
        locals: {
          Position: vm.positionSelected,
          PositionDetail: vm.positionDetail,
          Config: config
        }
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'datatables',
                'xeditable',
                'slickCarousel',
                'thatisuday.ng-image-gallery',
                'textAngular',
                'angularFileUpload',
                'ngImgCrop',
                'ngCkeditor',
                'moment-picker',
                'treeControl',
                'ngFileSaver'
            ]);
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('PositionDetailDialogController', PositionDetailDialogController);

    /** @ngInject */
    function PositionDetailDialogController($mdDialog, UtilsService,Position,PositionDetail,Config,organizationService,api) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.position = Position;
        vm.positionDetail = angular.copy(PositionDetail);
        vm.isEmpty = angular.equals(vm.positionDetail,{});
        vm.config = Config;
        vm.saveForm = saveForm;
        vm.publishPositionDetail = publishPositionDetail;
        vm.downloadFile = downloadFile;

        vm.loadingSave = false;
        vm.loadingDownload = false;        
        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }

        function downloadFile() {
            vm.loadingDownload = true;
            var url = '/organization/position/'+vm.positionDetail.cargo.id+'/details_pdf';
            api.general.getWindowHttp('GET',url).then(function(response){
                vm.loadingDownload = false;
            });
        }

        function saveForm(){
            // console.log(vm.positionDetail);
            vm.loadingSave = true;
            organizationService.updatePositionDetail({id:vm.position.id,data:vm.positionDetail.position_details.data}).then(function(response){
                UtilsService.showToast("Se ha actualizado el borrador correctamente.");
                $mdDialog.hide(response);
            });
        }

        function publishPositionDetail(){
            vm.loadingSave = true;
            organizationService.publishPositionDetail({id:vm.position.id,data:vm.positionDetail.position_details.data}).then(function(response){
                UtilsService.showToast("Se publico correctamente el borrador.");
                $mdDialog.hide(response);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.hr-evaluation')
        .controller('goalCommentsDialogController', goalCommentsDialogController);

    /** @ngInject */
    function goalCommentsDialogController($mdDialog, data) {

        var vm = this;

        vm.closeDialog = closeDialog;
        vm.saveComment = saveComment;

        vm.rejected_comment = data.lastComment ? data.lastComment.comment : '';



        function closeDialog() {
            $mdDialog.cancel();
        }

        function saveComment() {
            $mdDialog.hide({ rejected_comment: vm.rejected_comment });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarControllerEmployee', ToolbarControllerEmployee);

    /** @ngInject */
    function ToolbarControllerEmployee($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, UsersService, NotificationService, evaluationService, $mdDialog, $document) {
        var vm = this;

        //Contiene los indicadores de las notificaciones
        vm.tabIndicators = NotificationService.getNotificationIndicators();
        vm.license = {};

        setTimeout(function () {
            vm.license = $rootScope.licenseData.license;
            vm.user_manual_code = $rootScope.licenseData.user_manual_code ? $rootScope.licenseData.user_manual_code.colaborador : null;
        }, 1000);


        
        // Data
        $rootScope.global = {
            search: ''
        };

        vm.showLogout = false;

        if ($state.current.name == 'app.employee_profile') {
            vm.showLogout = true;
        }

        vm.userInfo = UsersService.getUserInfo();
        vm.userInfoHV = vm.userInfo;
        vm.secret_user = UsersService.getUserSecret();

        $rootScope.$on('mysecret',function(evt,data){
            vm.userInfoHV = data.user;
            vm.secret_user = data.secret;
        });

        vm.bodyEl = angular.element('body');

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.searchResultClick = searchResultClick;
        vm.goIndexEmployee = goIndexEmployee;
        vm.openChangePasswordDialog = openChangePasswordDialog;
        vm.goShowHv = goShowHv;
        vm.goManualUser = goManualUser;
        vm.openDocumentsDialog = openDocumentsDialog;
        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Get the selected language directly from angular-translate module setting
            //vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            $translate.use('es');
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            UsersService.logout();
            $state.go('app.users_login');
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                }
                else {
                    $state.go(item.state);
                }
            }
        }

        function goIndexEmployee() {
            $state.transitionTo('app.employee_profile', {}, {
                reload: true, inherit: false, notify: true
            });
        }

        function goShowHv(){
            var userInfo = vm.userInfoHV;
            var secret_user = vm.secret_user;
            var url = "http://pallomaro.ikanosmart.com/ikano/loginPallomaro/"+userInfo.user_base+"/"+userInfo.name_base+"/"+userInfo.email_base+"/"+secret_user;
            var a = document.createElement('a');
            a.style = "display: none";
            a.href = url;
            a.target = '_blank';
            a.click();
        }

        function goManualUser(){
            var url = "http://usermanual.ikanosmart.com/manual/"+vm.user_manual_code;
            var a = document.createElement('a');
            a.style = "display: none";
            a.href = url;
            a.target = '_blank';
            a.click();
        }

        function openChangePasswordDialog(ev) {
            $mdDialog.show({
                controller: 'ChangePasswordController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/users/dialogs/change-password/change-password.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev
                }
            });
        }

        function openDocumentsDialog(ev){
            $mdDialog.show({
                controller: 'DocumentsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/misc/dialog/documents/documents-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev
                }
            });
        }
    }

})();
(function() {
	'use strict';

	angular.module('app.page.admin')
		.controller('PageAdminController', PageAdminController);

	/** @ngInject */
	function PageAdminController($state, Pages, PageService, UtilsService, $mdDialog, $document) {

    	//Track Google Analytics
        UtilsService.trackPage();        

		var vm = this;

		//Global configuration
		vm.dtOptions = {
			dom : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType : 'simple',
			autoWidth : false,
			responsive : true,
			language: UtilsService.getLanguajeDataTable()
		};

		// Data
		vm.Pages = Pages.list;
		vm.PageMenu = Pages.page_menu;

		//Methods
		vm.openPageDialog = openPageDialog;
		
        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openPageDialog(ev, page)
        {
            $mdDialog.show({
                controller         : 'PageDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/page/admin/dialogs/page/page-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    Page : page,
                    Pages : vm.Pages,
                    PageMenu : vm.PageMenu
                }
            });
        }
	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.reports', [
                                'app.report'
                ])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.reports', {
            url  : '/reports',
            views: {
                'content@app': {
                    templateUrl: 'app/main/modules/reports/reports.html',
                    controller : 'ReportsController as vm'
                }
            },
            requiresAuthentication: true
        });
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .factory('reportService', reportService);

    /** @ngInject */
    function reportService($q, api, UtilsService)
    {      
      var dataLoaded = false;
      var cacheData = {};

      var service = {
        getReport      : getReport,
        getReportList  : getReportList
      };

      return service;

      ////////// 
      function getReport(filters, download) {
        var deferred = $q.defer();

        var format = download ? 'excel' : 'html';

        api.reports.getReport.get(filters,
        // Success
        function(response) {

          if(response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response);
        },
        // Error
        function(response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });          

        return deferred.promise; 
      }

      function getReportList() {
        var deferred = $q.defer();

        api.reports.getReportList.get({},
        // Success
        function(response) {

          if(response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response);
        },
        // Error
        function(response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });          

        return deferred.promise; 
      }      
    }
}());
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsController', ReportsController);

    /** @ngInject */
    function ReportsController($mdDialog, $document, $state, $scope, $filter, $window, $mdDateLocale, api, DTColumnDefBuilder, UtilsService, $compile, reportService) {
        var vm = this;

        vm.reports = null;

        vm.init = init;

        function init() {
          //Data
          reportService.getReportList().then(function(response) {
            vm.reports = response.data;

          }).catch(function(err) {
            // TODO
          });           
        }


        vm.init();

    }
})();
(function () {
  'use strict';

  angular
    .module('app.hr-evaluation')
    .controller('HrEvaluationController', HrEvaluationController);

  /** @ngInject */
  function HrEvaluationController($state, $injector, UtilsService, evaluationService, fuseTheming, $window, $rootScope, LicenseService, api) {

    var vm = this;

    var employee_process_id = $state.params.employee_process_id;
    var process_stage_id = $state.params.process_stage_id;

    var process_employee = JSON.parse(localStorage.getItem('pedingActivitie'));

    var rolChief = ['chief', 'chiefchief', 'corpchief']

    vm.themes = fuseTheming.themes.active.theme;
    vm.colors = {};

    /*$rootScope.$on('changeSelectedIndex',function(evt,params){
      console.log(params);
    });*/

    //Si no se especifica el template, se asume template = default
    vm.templates = {};
    vm.templates['HrGoal'] = {};
    vm.templates['HrGoal']['goalInscription'] = 'default';
    vm.templates['HrGoal']['goalApproval'] = 'default';
    vm.templates['HrGoal']['goalEvaluation'] = 'default';
    vm.templates['HrPersonalDevelopment'] = {};
    vm.currentTabPosition = 0;

    vm.callFunc = callFunc;

    vm.moduleSummaryResults = [];
    vm.finalizeEvaluationProcess = finalizeEvaluationProcess;
    vm.getProcessSummary = getProcessSummary;
    vm.saveStep = saveStep;
    vm.goStep = goStep;
    vm.goStepTab = goStepTab;

    vm.allowFinalize = true;
    vm.loadingInit = true;

    vm.licenseConfig = LicenseService.getLocalstorage();

    vm.license = {};

    setTimeout(function () {
      vm.license = $rootScope.licenseData.license;
    }, 500);


    function callFunc(module, action, params) {
      var ModuleService = module + 'Service';
      var Service = $injector.get(ModuleService);
      if (eval('(typeof Service.' + action + ' == "function")')) {
        eval('Service.' + action + '.apply(null, params);');
        /*evalresult.then(function(response){
          console.log(response);
        },function(reject){
          redirectTab(null,msWizard,null);
          console.log(msWizard.selectedIndex,vm.currentTabPosition);
          msWizard.selectedIndex = vm.currentTabPosition;
        });*/
      }
      getSummaryResult(vm.evaluationProcessData[module].evaluation_current_process);
    }

    function initColors() {
      vm.colors.primary = vm.themes.primary.color;
      vm.colors.accent = vm.themes.accent.color;
      vm.colors.warn = vm.themes.warn.color;
    }

    function finalizeEvaluationProcess() {

      var processes_id = [];

      angular.forEach(vm.evaluationProcessActions, function (info, module) {
        if (typeof vm.evaluationProcessData[module]['evaluation_current_process'] !== "undefined") {
          processes_id.push(vm.evaluationProcessData[module]['evaluation_current_process']['id']);
        }
      });

      evaluationService.finalizeEvaluationProcess(processes_id).then(function (response) {

        if (process_employee.stage.is_last_stage_period && rolChief.indexOf(process_employee.rol) != -1) {
          $state.go('app.employee_profile_team_final_stage', { employee_id: vm.employeeProfile.empleado.id });
        } else {
          $state.go('app.employee_profile');
        }

      }, function (error) {
      });
    }

    function getProcessSummary(msWizard) {
      vm.loadingSummary = true;
      setTimeout(function () {
        evaluationService.getProcessSummary(employee_process_id, process_stage_id).then(function (response) {
          vm.loadingSummary = false;
          vm.summaryData = response;

          vm.allowFinalize = true;

          for (var i in vm.summaryData.evaluation_process_summary) {
            var data = vm.summaryData.evaluation_process_summary[i];
            if (data.errors.length > 0) {
              vm.allowFinalize = false;
              break;
            }
          }

          vm.currentTabPosition = msWizard.selectedIndex;

          //saveStep(vm.currentTabPosition,msWizard,null);

        }, function (error) {
          vm.loadingSummary = false;
        });
      }, 1000);

    }

    function saveStep(position) {

      var stepInfo = vm.evaluationSteps[position];
      callFunc(stepInfo.module, "saveStep_" + stepInfo.action, [vm.evaluationProcessData[stepInfo.module]]);
      //redirectTab(position, msWizard, direction);

    }

    function redirectTab(position, msWizard, direction) {
      if (direction == 'previous') {
        msWizard.previousStep();
      } else if (direction == 'next') {
        msWizard.nextStep();
      }
      $('#content').animate({ scrollTop: 0 }, 200);
    }

    function init() {
      evaluationService.getEmployeeProcessData(employee_process_id, process_stage_id).then(function (response) {
        vm.employeeProfile = response.matricula;
        vm.evaluationProcessActions = response.evaluation_process_actions;
        vm.evaluationProcessData = response.evaluation_process_data;

        vm.evaluationSteps = [];
        angular.forEach(vm.evaluationProcessActions, function (step, module) {
          step['module'] = module;
          vm.evaluationSteps.push(step);
        });

        var key = Object.keys(response.evaluation_process_data);
        getSummaryResult(response.evaluation_process_data[key[0]].evaluation_current_process);

        vm.loadingInit = false;
      }, function (error) {
      });

      initColors();
    }

    function getSummaryResult(evaluation_current_process) {
      if(!evaluation_current_process){
        return;
      }
      
      api.evaluations.summary_results.get({ current_process_id: evaluation_current_process.id }, function (response) {
        var chiefs = ['chief', 'chiefchief', 'corpchief'];
        var rol = evaluation_current_process.evaluation_process_stage_content.evaluator_rol;
        var key = 'self';
        if (chiefs.indexOf(rol) != -1) {
          key = 'final';
        }
        vm.moduleSummaryResultsFinal = response.data.final_result;
        vm.moduleSummaryResults = [];
        for (var i in response.data.hr_modules) {
          var module = response.data.hr_modules[i];
          var jsonInsert = {
            label: module.name,
            data: module[key+'_evaluation']
          };
          vm.moduleSummaryResults.push(jsonInsert);
        }

      });
    }

    function goStep(position, msWizard, direction) {
      var totalSteps = msWizard.totalSteps();
      var lastStepIndex = totalSteps - 1;
      var nextStepIndex = direction == 'next' ? position + 1 : position - 1;

      if (position != lastStepIndex) {
        saveStep(position);
      }

      if (nextStepIndex == lastStepIndex) {
        getProcessSummary(msWizard);
      }

      redirectTab(position, msWizard, direction);

      vm.currentTabPosition = nextStepIndex;
    }

    function goStepTab(msWizard) {
      var totalSteps = msWizard.totalSteps();
      var lastStepIndex = totalSteps - 1;

      if (vm.currentTabPosition != lastStepIndex) {
        saveStep(vm.currentTabPosition);
      }

      if (msWizard.selectedIndex == lastStepIndex) {
        getProcessSummary(msWizard);
      }

      vm.currentTabPosition = msWizard.selectedIndex;
    }

    init();

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cstm.cstm_organization', [
          'app.cstm.organization_employees',
          'app.cstm.organization_upload'  ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.cstm_organization', {
            url  : '/organization',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/organization/organization.html',
                    controller : 'CstmOrganizationController as vm'
                }
            },
            requiresAuthentication: true
        });
        $stateProvider.state('app.cstm_organization_filter', {
            url  : '/organization/:tab',
            views: {
                'content@app': {
                    templateUrl: 'app/main/custom_modules/organization/organization.html',
                    controller : 'CstmOrganizationController as vm'
                }
            },
            requiresAuthentication: true
        });
        
    }

})();
(function () {
  'use strict';

  angular
    .module('app.cstm.cstm_organization')
    .factory('organizationService', organizationService);

  /** @ngInject */
  function organizationService($q, api, UtilsService) {
    var dataLoaded = false;
    var cacheData = {};

    var service = {
      activateEmployee: activateEmployee,
      addArea: addArea,
      addDepartment: addDepartment,
      addPosition: addPosition,
      addEmployee: addEmployee,
      getInactiveEmployees: getInactiveEmployees,
      getOrganizationEmployees: getOrganizationEmployees,
      getOrganizationStructure: getOrganizationStructure,
      getOrganizationChart: getOrganizationChart,
      removeEmployee: removeEmployee,
      updateEmployee: updateEmployee,
      updateArea: updateArea,
      updateDepartment: updateDepartment,
      updatePosition: updatePosition,
      resetPasswordEmployee: resetPasswordEmployee,
      getPositionDetail: getPositionDetail,
      updatePositionDetail: updatePositionDetail,
      publishPositionDetail: publishPositionDetail
    };

    return service;

    ////////// 
    function activateEmployee(employeeId) {
      var deferred = $q.defer();

      api.organization.activateEmployee.save({
        employee_id: employeeId
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function addArea(name) {
      var deferred = $q.defer();

      api.organization.addArea.save({
        name: name
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function addDepartment(name) {
      var deferred = $q.defer();

      api.organization.addDepartment.save({
        name: name
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function addPosition(name) {
      var deferred = $q.defer();

      api.organization.addPosition.save({
        name: name
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function addEmployee(employee_data) {
      var deferred = $q.defer();

      api.organization.addEmployee.save({
        employee_data: employee_data
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getInactiveEmployees() {

      var deferred = $q.defer();

      if (cacheData.getInactiveEmployees) {
        deferred.resolve(cacheData.getInactiveEmployees);
      } else {

        api.organization.getInactiveEmployees.get({},
          // Success
          function (response) {
            dataLoaded = true;

            if (response.message) {
              UtilsService.showToast(response.message);
            }

            //Guardar data en cache
            cacheData.getInactiveEmployees = response.data;

            deferred.resolve(response.data);
          },
          // Error
          function (response) {
            UtilsService.showToast(response.data.message, true);
            deferred.reject(response.data);
          });

      }

      return deferred.promise;
    }

    function getOrganizationEmployees() {

      var deferred = $q.defer();

      if (cacheData.getOrganizationEmployees) {
        deferred.resolve(cacheData.getOrganizationEmployees);
      } else {

        api.organization.getOrganizationEmployees.get({},
          // Success
          function (response) {
            dataLoaded = true;

            if (response.message) {
              UtilsService.showToast(response.message);
            }

            //Guardar data en cache
            cacheData.getOrganizationEmployees = response.data;

            deferred.resolve(response.data);
          },
          // Error
          function (response) {
            UtilsService.showToast(response.data.message, true);
            deferred.reject(response.data);
          });

      }

      return deferred.promise;
    }

    function getOrganizationStructure(periodId, lists) {

      var deferred = $q.defer();

      if (cacheData.getOrganizationStructure) {
        deferred.resolve(cacheData.getOrganizationStructure);
      } else {

        api.organization.getOrganizationStructure.get({
          period_id: periodId
        },
          // Success
          function (response) {
            dataLoaded = true;

            if (response.message) {
              UtilsService.showToast(response.message);
            }

            //Guardar data en cache
            cacheData.getOrganizationStructure = response.data;

            deferred.resolve(response.data);
          },
          // Error
          function (response) {
            UtilsService.showToast(response.data.message, true);
            deferred.reject(response.data);
          });

      }

      return deferred.promise;
    }

    function getOrganizationChart() {

      var deferred = $q.defer();

      if (cacheData.getOrganizationChart) {
        deferred.resolve(cacheData.getOrganizationChart);
      } else {

        api.organization.getOrganizationChart.get({},
          // Success
          function (response) {
            dataLoaded = true;

            if (response.message) {
              UtilsService.showToast(response.message);
            }

            //Guardar data en cache
            cacheData.getOrganizationChart = response.data;

            deferred.resolve(response.data);
          },
          // Error
          function (response) {
            UtilsService.showToast(response.data.message, true);
            deferred.reject(response.data);
          });

      }

      return deferred.promise;
    }

    function removeEmployee(employee_id) {
      var deferred = $q.defer();

      api.organization.removeEmployee.save({
        employee_id: employee_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function updateEmployee(employee_id, employee_data) {
      var deferred = $q.defer();

      api.organization.updateEmployee.save({
        employee_id: employee_id,
        employee_data: employee_data
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function resetPasswordEmployee(employee_id) {
      var deferred = $q.defer();

      api.organization.resetPassword.save({
        id: employee_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function updateArea(id, name) {
      var deferred = $q.defer();

      api.organization.updateArea.save({
        id: id,
        name: name
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function updateDepartment(id, name) {
      var deferred = $q.defer();

      api.organization.updateDepartment.save({
        id: id,
        name: name
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function updatePosition(id, name) {
      var deferred = $q.defer();

      api.organization.updatePosition.save({
        id: id,
        name: name
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getPositionDetail(id, params) {
      var deferred = $q.defer();
      var data = {};
      if (params) {
        data = params;
        data.id = id;
      } else {
        data.id = id;
      }

      api.organization.getPositionDetail.get(data,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function updatePositionDetail(params) {
      var deferred = $q.defer();

      api.organization.getPositionDetail.update(params,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function publishPositionDetail(params) {
      var deferred = $q.defer();

      api.organization.publishPositionDetail.save(params,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }
  }
}());
(function () {
  'use strict';

  angular
    .module('app.cstm.cstm_organization')
    .controller('CstmOrganizationController', CstmOrganizationController);

  /** @ngInject */
  function CstmOrganizationController($location, UsersService, UtilsService, organizationService, $state, fuseTheming, $mdDialog, LicenseService,api) {
    //Track Google Analytics
    UtilsService.trackPage();

    var vm = this;

    vm.isDataLoaded = false;
    vm.sendingData = false;
    vm.currentEdit = null;
    vm.editData = '';
    vm.newItemName = '';

    vm.colors = {};
    vm.themes = fuseTheming.themes.active.theme;

    vm.treeOptions = {
      nodeChildren: "children",
      dirSelectable: true,
      injectClasses: {
        ul: "a1",
        li: "a2",
        liSelected: "a7",
        iExpanded: "a3",
        iCollapsed: "a4",
        iLeaf: "a5",
        label: "a6",
        labelSelected: "a8"
      }
    }

    vm.goImport = goImport;

    vm.tabSelectedIndex = 0;

    vm.tab = {
      'position': 0,
      'area': 2,
      'department': 1
    }

    vm.colors.primary = vm.themes.primary.color;
    vm.colors.accent = vm.themes.accent.color;
    vm.colors.warn = vm.themes.warn.color;

    vm.periodsParse = JSON.parse(localStorage.getItem("IKANO_RH_PERIODS"));
    vm.periods = vm.periodsParse.periods.filter(function(element){ return element.estado});
    if ($state.params.tab) {
      vm.tabSelectedIndex = vm.tab[$state.params.tab];
    }

    vm.showPositionDetail = showPositionDetail;

    vm.getPositionDetail = getPositionDetail;
    vm.getPositionDetailDraft = getPositionDetailDraft;

    vm.enablePositionDetails = LicenseService.getModuleEnable('position_details');

    //Data
    /*organizationService.getOrganizationChart().then(function (response) {
      vm.dataForTheTree = response.organization;
    }).catch(function (err) {
      // TODO
    });*/

    vm.dtOptions = UtilsService.getDataTableOptions();

    vm.getDataImportElegible = getDataImportElegible;
    vm.setFromPeriodId = setFromPeriodId;

    //Data
    organizationService.getOrganizationStructure().then(function (response) {

      //Asignar data
      vm.organizationAreas = response.areas;
      vm.organizationDepartments = response.departments;
      vm.organizationPositions = response.positions;
      getConfigImportElegible();
      vm.isDataLoaded = true;

    }).catch(function (err) {
      // TODO
    });

    //Methods
    vm.addItem = addItem;
    vm.updateItem = updateItem;
    vm.removeItem = removeItem;
    vm.tabChanged = tabChanged;

    function addItem(type) {

      vm.sendingData = true;

      if (type == 'position') {
        _addPosition(vm.newItemName);
      } else if (type == 'area') {
        _addArea(vm.newItemName);
      } else if (type == 'department') {
        _addDepartment(vm.newItemName);
      }

    }

    function updateItem(type, item_id, item) {

      vm.sendingData = true;

      if (type == 'position') {
        _updatePosition(item_id, vm.editData, item);
      } else if (type == 'area') {
        _updateArea(item_id, vm.editData, item);
      } else if (type == 'department') {
        _updateDepartment(item_id, vm.editData, item);
      }

    }

    function _addArea(name) {
      organizationService.addArea(name).then(function (response) {

        vm.newItemName = '';
        vm.addForm = false;

        //Actualizar el nombre actualizado
        vm.organizationAreas.push(response.item);

        vm.sendingData = false;
      }).catch(function (err) {
        vm.sendingData = false;
      });

    }

    function _updateArea(id, name, item) {
      organizationService.updateArea(id, name).then(function (response) {

        vm.currentEdit = null;
        vm.editData = '';

        //Actualizar el nombre actualizado
        item.name = name;

        vm.sendingData = false;
      }).catch(function (err) {
        vm.sendingData = false;
      });
    }

    function _addDepartment(name) {
      organizationService.addDepartment(name).then(function (response) {

        vm.newItemName = '';
        vm.addForm = false;

        //Actualizar el nombre actualizado
        vm.organizationDepartments.push(response.item);

        vm.sendingData = false;
      }).catch(function (err) {
        vm.sendingData = false;
      });

    }

    function _updateDepartment(id, name, item) {
      organizationService.updateDepartment(id, name).then(function (response) {

        vm.currentEdit = null;
        vm.editData = '';

        //Actualizar el nombre actualizado
        item.name = name;

        vm.sendingData = false;
      }).catch(function (err) {
        vm.sendingData = false;
      });
    }

    function _addPosition(name) {
      organizationService.addPosition(name).then(function (response) {

        vm.newItemName = '';
        vm.addForm = false;

        //Actualizar el nombre actualizado
        vm.organizationPositions.push(response.item);

        vm.sendingData = false;
      }).catch(function (err) {
        vm.sendingData = false;
      });

    }

    function _updatePosition(id, name, item) {
      organizationService.updatePosition(id, name).then(function (response) {

        vm.currentEdit = null;
        vm.editData = '';

        //Actualizar el nombre actualizado
        item.name = name;

        vm.sendingData = false;
      }).catch(function (err) {
        vm.sendingData = false;
      });

    }

    function removeItem() {
      //TODO
    }

    function tabChanged() {
      vm.addForm = false;
    }

    function goImport(key) {
      switch (key) {
        case 'position':
          $state.go('app.organization_upload', { key: 'structure_positions_import' });
          break;
        case 'area':
          $state.go('app.organization_upload', { key: 'structure_areas_import' });
          break;
        case 'department':
          $state.go('app.organization_upload', { key: 'structure_departments_import' });
          break;
      }

    }


    /**
     * POSITIONS
     */

    function getPositionDetail(position) {
      organizationService.getPositionDetail(position.id).then(function (response) {
        vm.positionSelected = position;
        vm.positionDetail = response;
        showPositionDetail({});
      });
    }

    function getPositionDetailDraft(position) {
      organizationService.getPositionDetail(position.id, { version_status: 'draft' }).then(function (response) {
        vm.positionSelected = position;
        vm.positionDetail = response;
        showPositionDetail({ edit: true });
      });
    }

    function showPositionDetail(config) {
      $mdDialog.show({
        controller: 'PositionDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/services/dialogs/position-detail/position-detail-dialog.html',
        clickOutsideToClose: false,
        locals: {
          Position: vm.positionSelected,
          PositionDetail: vm.positionDetail,
          Config: config
        }
      });
    }

    /**
     * Importar elegibles
     */

    function getConfigImportElegible() {
      LicenseService.getOrganizacionUploadConfig().then(function (licenseData) {
        vm.licenseData = licenseData["update_employees_relations"]
        //getDataImportElegible();
        
        
      }, function (err) {
      });
    }

    function getDataImportElegible(period_id){
      //
      api.evaluations.update_employees_relations.get({data_import_action:'index',periodo_id:period_id},function(response){
        var data = {
          template_name: response.template_name,
          template_headers: response.template_headers,
          periodo_id: period_id
        }
        setConfigImportElegible(vm.licenseData,data);
      });
    }

    function setConfigImportElegible(config,data) {
      vm.configImportData = config;
      vm.configImportData.Data = data;
      vm.configImportData.templateUrl = 'app/main/elements/ik-import-data/' + config.template + '/' + config.template + '.html';
      vm.configImportData.config = {
        key: "update_employees_relations",
        config: config
      };
    }

    function setFromPeriodId(period_id){
      vm.configImportData.Data.from_period_id = period_id;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.cstm.cstm_evaluation')
    .factory('evaluationService', evaluationService);

  /** @ngInject */
  function evaluationService($q, api, UtilsService) {
    var service = {
      activateNewProcess: activateNewProcess,
      assignCorporateGoals: assignCorporateGoals,
      changeMatStructureInfo: changeMatStructureInfo,
      changeProcessStage: changeProcessStage,
      createCompanyGoal: createCompanyGoal,
      deleteCompanyGoal: deleteCompanyGoal,
      deleteEvaluation: deleteEvaluation,
      enrollEmployee: enrollEmployee,
      finalizeEvaluationProcess: finalizeEvaluationProcess,
      getActiveProcessesInfo: getActiveProcessesInfo,
      getDataToEnrollEmployee: getDataToEnrollEmployee,
      getEmployeeProcessData: getEmployeeProcessData,
      getEmployeeProfile: getEmployeeProfile,
      getEmployeeWorkTeam: getEmployeeWorkTeam,
      getEvaluations: getEvaluations,
      getEvaluationData: getEvaluationData,
      getEvaluationDetails: getEvaluationDetails,
      getEvaluationGoals: getEvaluationGoals,
      getGoalsToAssign: getGoalsToAssign,
      getPendingActivities: getPendingActivities,
      getPeriods: getPeriods,
      getProcessSummary: getProcessSummary,
      getSkillsProfiles: getSkillsProfiles,
      setActiveProcessDeadline: setActiveProcessDeadline,
      setPeriod: setPeriod,
      updateCompanyGoal: updateCompanyGoal,
      sendMessages: sendMessages,
      addHrModule: addHrModule,
      remove_hr_module: remove_hr_module,
      activeMassiveProcess: activeMassiveProcess,
      getActiveNewMassiveProcess: getActiveNewMassiveProcess
    };

    return service;

    //////////
    function activateNewProcess(period_id, employee_process_id, process_id, process_deadline, process_lists_item_id) {
      var deferred = $q.defer();

      api.evaluations.activateNewProcess.save({
        period_id: period_id,
        employee_process_id: employee_process_id,
        process_id: process_id,
        process_deadline: process_deadline,
        process_lists_item_id: process_lists_item_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function assignCorporateGoals(period_id, data,companyId) {

      var deferred = $q.defer();

      var dataPost = {
        period_id: period_id,
        goals_data: data,
        
      }

      if(companyId){
        dataPost.empresa_id = companyId;
      }

      api.evaluations.assignCorporateGoals.save(dataPost,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function changeMatStructureInfo(employee_process_id, data) {
      var deferred = $q.defer();

      api.evaluations.changeMatStructureInfo.save({
        employee_process_id: employee_process_id,
        mat_structure_info: data
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function changeProcessStage(employee_process_id, newStage, processDeadline) {
      var deferred = $q.defer();

      api.evaluations.changeProcessStage.save({
        employee_process_id: employee_process_id,
        evaluation_process_stage_id: newStage,
        process_deadline: processDeadline
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    //Crear un objetivo de compañía
    function createCompanyGoal(periodId, goalData) {
      var deferred = $q.defer();

      api.evaluations.createCompanyGoal.save({
        period_id: periodId,
        goal_data: goalData
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function deleteCompanyGoal(goal_id) {
      var deferred = $q.defer();

      api.evaluations.deleteCompanyGoal.save({
        goal_id: goal_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function deleteEvaluation(employee_process_id) {
      var deferred = $q.defer();

      api.evaluations.deleteEvaluation.save({
        employee_process_id: employee_process_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function enrollEmployee(enrollData, periodId, hrModules,operativa) {
      var deferred = $q.defer();

      var dataPost = {
        period_id: periodId,
        enroll_data: enrollData,
        hr_modules: hrModules
      }

      if(operativa){
        dataPost.enroll_data.type_evaluation = "operativa";
      }


      api.evaluations.enrollEmployee.save(dataPost,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getActiveNewMassiveProcess(data) {
      var deferred = $q.defer();

      api.evaluations.activeNewMassiveProcess.get(data,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function activeMassiveProcess(data) {
      var deferred = $q.defer();

      api.evaluations.activeMassiveProcess.save(data,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function finalizeEvaluationProcess(processes_id) {
      var deferred = $q.defer();

      api.evaluations.finalizeEvaluationProcess.save({
        process_id: processes_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getActiveProcessesInfo(periodId) {
      var deferred = $q.defer();

      api.evaluations.getActiveProcessesInfo.get({
        period_id: periodId
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getDataToEnrollEmployee(period_id) {
      var deferred = $q.defer();

      api.evaluations.getDataToEnrollEmployee.get({
        period_id: period_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getEmployeeProcessData(employee_process_id, process_stage_id) {
      var deferred = $q.defer();

      api.evaluations.getEmployeeProcessData.get({
        employee_process_id: employee_process_id,
        process_stage_id: process_stage_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getEmployeeProfile(employee_id) {
      var deferred = $q.defer();

      api.evaluations.getEmployeeProfile.get({
        employee_id: employee_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getEmployeeWorkTeam(employee_id) {
      var deferred = $q.defer();

      api.evaluations.getEmployeeWorkTeam.get({
        employee_id: employee_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getEvaluations(period_id,params) {

      var deferred = $q.defer();  

      params = params ? params : {};
      params.period_id = period_id;
      api.evaluations.getEvaluations.get(params,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getEvaluationData(employee_process_id) {
      var deferred = $q.defer();

      api.evaluations.getEvaluationData.get({
        employee_process_id: employee_process_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getEvaluationDetails(employee_process_id) {

      var deferred = $q.defer();

      api.evaluations.getEvaluationDetails.get({
        employee_process_id: employee_process_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getEvaluationGoals(period_id) {

      var deferred = $q.defer();

      api.evaluations.getEvaluationGoals.get({
        period_id: period_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getGoalsToAssign(data) {
      var deferred = $q.defer();

      api.evaluations.getGoalsToAssign.get(data,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getPendingActivities() {
      var deferred = $q.defer();

      api.evaluations.getPendingActivities.get({},
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    //Retorna el periodo con el que se esta trabajando actualmente
    function _getWorkingPeriod(periods, current) {
      var workingPeriodId = window.localStorage.getItem('IKANO_RH_WORK_PERIOD');
      var workingPeriod = {}

      angular.forEach(periods, function (period) {

        //Si se estaba trabajando con un periodo actualmente
        if (workingPeriodId && !current) {
          if (period.id == workingPeriodId) {
            workingPeriod = period;
          }

        } else {

          //No se estaba trabajando con un periodo actualmente, entonces se retorna el periodo marcado como actual en la DB
          if (period.actual) {
            window.localStorage.setItem('IKANO_RH_WORK_PERIOD', period.id);
            workingPeriod = period;
          }
        }
      });

      return workingPeriod;
    }

    function getPeriods(callApi) {

      var deferred = $q.defer();

      var localPeriods = JSON.parse(window.localStorage.getItem('IKANO_RH_PERIODS'));

      if (callApi || !localPeriods) {

        api.evaluations.getPeriods.get({},
          // Success
          function (response) {

            if (response.message) {
              UtilsService.showToast(response.message);
            }

            window.localStorage.setItem('IKANO_RH_PERIODS', JSON.stringify(response.data));

            response.data.workingPeriod = _getWorkingPeriod(response.data.periods, true);

            deferred.resolve(response.data);
          },
          // Error
          function (response) {
            UtilsService.showToast(response.data.message, true);
            deferred.reject(response.data);
          });
      } else {
        localPeriods.workingPeriod = _getWorkingPeriod(localPeriods.periods);
        deferred.resolve(localPeriods);
      }

      return deferred.promise;
    }

    function getProcessSummary(employee_process_id, process_stage_id) {
      var deferred = $q.defer();

      api.evaluations.getProcessSummary.get({
        employee_process_id: employee_process_id,
        process_stage_id: process_stage_id
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getSkillsProfiles(periodId) {
      var deferred = $q.defer();

      api.skills.getSkillsProfiles.get({
        period_id: periodId
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function setActiveProcessDeadline(periodId, companyId, activeProcessId, deadLine) {
      var deferred = $q.defer();

      api.evaluations.setActiveProcessDeadline.save({
        period_id: periodId,
        active_process_id: activeProcessId,
        deadline: deadLine,
        company_id: companyId
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function setPeriod(period) {
      window.localStorage.setItem('IKANO_RH_WORK_PERIOD', period.id);
    }

    function updateCompanyGoal(goal_id, goal_data) {

      var deferred = $q.defer();

      api.evaluations.updateCompanyGoal.save({
        goal_id: goal_id,
        goal_data: goal_data
      },
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function sendMessages(data) {
      var deferred = $q.defer();

      api.misc.sendMessages.save(data,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function addHrModule(data) {

      var deferred = $q.defer();

      api.evaluations.add_hr_module.save(data,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function remove_hr_module(data) {

      var deferred = $q.defer();

      api.evaluations.remove_hr_module.delete(data,
        // Success
        function (response) {

          if (response.message) {
            UtilsService.showToast(response.message);
          }

          deferred.resolve(response.data);
        },
        // Error
        function (response) {
          UtilsService.showToast(response.data.message, true);
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    
    

  }
}());
(function () {
  'use strict';

  angular
    .module('app.cstm.cstm_evaluation')
    .controller('CstmEvaluationController', CstmEvaluationController);

  /** @ngInject */
  function CstmEvaluationController($mdDialog, $document, UsersService,$mdToast, UtilsService, organizationService, evaluationService, $state, $scope, fuseTheming, OrganizationUploadService, api, $debounce, HrEDOService) {
    //Track Google Analytics
    UtilsService.trackPage();

    var vm = this;

    vm.tabSelectedIndex = 0;

    vm.tabs = {
      evaluations: 0,
      company_goal_list: 1,
      goal_assigments: 2,
      skills_profiles: 3,
      processes: 4
    }

    vm.themes = fuseTheming.themes.active.theme;
    vm.evaluationSelected = {};
    vm.evaluationSelecteds = [];

    vm.isEdo = false;
    if ($state.current.name == 'app.cstm_evaluation_edo') {
      vm.isEdo = true;
      initEdo();
    }

    // UI/UX Controls 
    vm.sendingData = {}; //Contiene la información de los objetivos sobre los que se esta ejecutando alguna acción

    // Cargar información inicial
    init();

    //Opciones del DataTable
    vm.dtOptions = UtilsService.getDataTableOptions();
    vm.dtOptionsEmployee = UtilsService.getDataTableOptions();
    vm.dtOptionsEmployee.paging = false;
    vm.dtOptionsEmployee.searching = false;
    //Methods
    vm.assignGoals = assignGoals;
    vm.deleteGoal = deleteGoal;
    vm.hasSkill = hasSkill;
    vm.loadInfo = loadInfo;
    vm.openEnrollEmployeeDialog = openEnrollEmployeeDialog;
    vm.openGoalDialog = openGoalDialog;
    vm.saveAssignments = saveAssignments;
    vm.setActiveProcessDeadline = setActiveProcessDeadline;
    vm.setPeriod = setPeriod;
    vm.goImport = goImport;
    vm.addEvaluationSelecteds = addEvaluationSelecteds;
    vm.openMatriculaMass = openMatriculaMass;
    vm.selectHeaderImage = selectHeaderImage;
    vm.selectFileChoices = selectFileChoices;
    vm.searchEmployees = {};
    vm.filterEmployees = filterEmployees;
    /**
     * cuestionario
     */
    vm.configQuestionarie = { isAdmin: true };
    vm.alphabetMin = 'abcdefghijklmnñopqrstuvwxyz';
    vm.alphabet = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ';
    vm.quesionsConfig = {};
    vm.questionsData = {};
    vm.edo_answer_choices_delete = {};
    vm.questionsData.values = [];
    vm.questionsData.edo_answer_choices = [];
    vm.questionsData.values.push({});
    vm.questionsData.edo_answer_choices.push({});

    vm.removeImgAnunciado = removeImgAnunciado;
    vm.saveFormQuestion = saveFormQuestion;
    vm.resetFormQuestion = resetFormQuestion;
    vm.resetAnswerChoices = resetAnswerChoices;
    vm.addEdoAnswerChoices = addEdoAnswerChoices;
    vm.addValues = addValues;
    vm.deleteAnswerChoices = deleteAnswerChoices;
    vm.deleteValues = deleteValues;
    vm.changeSelectedAnswer = changeSelectedAnswer;
    vm.removeImgChoices = removeImgChoices;
    vm.showImageDialog = showImageDialog;
    vm.selectedQuestion = selectedQuestion;
    vm.toDialogTopics = toDialogTopics;
    vm.toDialogDeleteTopics = toDialogDeleteTopics;
    vm.toDialogDeleteQuestion = toDialogDeleteQuestion;
    vm.selectedCorrectChoice = selectedCorrectChoice;
    vm.deleteImgChoice = deleteImgChoice;

    vm.questionnaireData = {};
    vm.question_questionnaires = [];
    vm.resetQuestionnaire = resetQuestionnaire;
    vm.selectedQuestionnaire = selectedQuestionnaire;
    vm.saveFormQuestionnaire = saveFormQuestionnaire;
    vm.addQuestionQuestionnaire = addQuestionQuestionnaire;
    vm.removeQuestionInQuestionnaire = removeQuestionInQuestionnaire;
    vm.toDialogDeleteQuestionnaire = toDialogDeleteQuestionnaire;

    /**
     * Asignar objectivos
     */
    vm.loadingAssingGoals = true;
    vm.goalAssingSelected = {};
    vm.employeeAssingSelected = {};
    vm.searchGoalAssigments = {};
    vm.getGoalsAssigments = _getGoalsAssigments;
    vm.fnSelectedAllGoal = function (selectedAll) {
      for (var i in vm.corporateGoals) {
        if (!vm.goalAssingSelected[vm.corporateGoals[i].id]) {
          vm.goalAssingSelected[vm.corporateGoals[i].id] = {};
        }
        vm.goalAssingSelected[vm.corporateGoals[i].id].selected = selectedAll;
      }
    }

    vm.fnSelectedAllEmployee = function (selectedAll) {
      for (var i in vm.activeProcessesGoalsMisc) {
        if(!vm.employeeAssingSelected[vm.activeProcessesGoalsMisc[i].id]){
          vm.employeeAssingSelected[vm.activeProcessesGoalsMisc[i].id] = {};
        }
        vm.employeeAssingSelected[vm.activeProcessesGoalsMisc[i].id].selected = selectedAll;
        vm.employeeAssingSelected[vm.activeProcessesGoalsMisc[i].id].group = vm.activeProcessesGoalsMisc[i].grupo;

      }
    }

    vm.changeEmployeeAssingSelected = changeEmployeeAssingSelected;

    function init() {
      //Tab en el que se encuentra actualmente el usuario
      vm.currentTab = 'evaluations';

      //Inicializar lista de evaluaciones del periodo
      vm.evaluations = null;
      //Inicializar lista de objetivos de la compañía del periodo
      vm.goals = null;
      //Listado de perfiles de competencias de los empleados
      vm.skillsProfiles = null;
      //Listado de procesos activos en el periodo
      vm.activeProcesses = null;

      vm.today = new Date;
      vm.today = vm.today.getFullYear() + '-' + ('0' + (vm.today.getMonth() + 1)).slice(-2) + '-' + ('0' + vm.today.getDate()).slice(-2);

      //Obtener la lista de periodos disponibles
      evaluationService.getPeriods().then(function (response) {
        //Lista de periodos disponibles
        vm.periods = response.periods;
        //Periodo sobre el cual se esta trabajando
        vm.workingPeriod = response.workingPeriod;
        //Cargar evaluaciones del periodo de trabajo
        if ($state.params.tab) {
          vm.tabSelectedIndex = vm.tabs[$state.params.tab];
          //loadInfo($state.params.tab);
        } else {
          vm.tabSelectedIndex = 0;
          //_getEva
        }


        organizationService.getOrganizationStructure(vm.workingPeriod.id).then(function (response) {
          //Asignar data
          vm.organizationAreas = response.areas;
          vm.organizationDepartments = response.departments;
          vm.organizationPositions = response.positions;
          vm.organizationCompanies = response.companies;
          vm.organizationPositionsLevels = response.positionLevels;
          vm.organizationChief = response.chiefs;

        }).catch(function (err) {
          // TODO
        });

      }).catch(function (err) {
      });

      vm.percentages = UtilsService.getArrayNumbers(0, 100);
    }
    //setConfigImportData();

    function initEdo() {
      api.evaluations.getIndexEdo.get({}, function (success) {
        HrEDOService.setConfig(vm.configQuestionarie);
        vm.topics = success.edo_topics;
        vm.edo_questionnaires = success.edo_questionnaires;
        vm.edo_questions = success.edo_questions;
        vm.type_questions = success.edo_question_types;
      }, function (error) {
        console.log(error);
      });
    }

    function assignGoals(goalId) {

      var pond = vm.goalPond[goalId];

      angular.forEach(vm.selectedEmployees, function (value, employee_process_id) {

        if (value) {

          if (typeof vm.employeesGoals[employee_process_id] === "undefined") {
            vm.employeesGoals[employee_process_id] = {};
          }
          if (typeof vm.goalAssignments[employee_process_id] === "undefined") {
            vm.goalAssignments[employee_process_id] = {};
          }

          if (typeof vm.employeesGoals[employee_process_id][goalId] === "undefined") {
            vm.employeesGoals[employee_process_id][goalId] = {};
          }
          if (typeof vm.goalAssignments[employee_process_id][goalId] === "undefined") {
            vm.goalAssignments[employee_process_id][goalId] = {};
          }

          vm.employeesGoals[employee_process_id][goalId]['porcentaje'] = parseInt(pond);
          vm.goalAssignments[employee_process_id][goalId]['porcentaje'] = parseInt(pond);
        }

      });


    }

    function deleteGoal(ev, goal) {

      var confirm = $mdDialog.confirm()
        .title('Confirma que desea eliminar este objetivo?')
        .htmlContent('')
        .ariaLabel('delet')
        .targetEvent(ev)
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm).then(function () {

        vm.sendingData[goal.id] = true;

        evaluationService.deleteCompanyGoal(goal.id).then(function (response) {

          vm.sendingData[goal.id] = false;
          vm.goals.splice(vm.goals.indexOf(goal), 1);

        }).catch(function (err) {
          vm.sendingData[goal.id] = false;
        });

      });
    }

    //Verifica si la persona tiene la competencia SkillId dentro de su perfil de competencias
    function hasSkill(profile, skillId) {
      var ret = false;

      angular.forEach(profile.competencias_perfils_cargos, function (profileSkill) {
        if (profileSkill.competencia_id == skillId) {
          ret = true;
        }
      });
      return ret;
    }

    function loadInfo(tabId) {

      //Actualizar el tab en el que se encuentra el usuario
      vm.currentTab = tabId;

      if (tabId == 'evaluations') {
        _getEvaluations(vm.workingPeriod.id);
      } else if (tabId == 'company_goal_list') {
        _getCompanyGoals(vm.workingPeriod.id);
      } else if (tabId == 'skills_profiles') {
        _getSkillsProfiles(vm.workingPeriod.id);
      } else if (tabId == 'goal_assigments') {
        //_getGoalsAssigments(vm.workingPeriod.id);
      } else if (tabId == 'processes') {
        _getActiveProcessesInfo(vm.workingPeriod.id);
      }


    }

    function _getActiveProcessesInfo(period_id) {
      //Si ya se cargó la información, no cargarla de nuevo
      if (vm.activeProcesses !== null) return;

      evaluationService.getActiveProcessesInfo(period_id).then(function (response) {

        vm.activeProcesses = response.activeProcesses;
      }).catch(function (err) {
      });
    }

    function _getEvaluations(period_id) {

      var params = {};
      if (vm.isEdo) {
        params.type_evaluation = 'operativa';
      }
      //Si ya se cargó la información, no cargarla de nuevo
      if (vm.evaluations !== null) return;

      evaluationService.getEvaluations(period_id, params).then(function (response) {
        vm.evaluations = response.activeProcesses;
        vm.reportEvaluationProcessStatus = response.reportEvaluationProcessStatus;
        vm.currentCompanyIdReport = Object.keys(vm.reportEvaluationProcessStatus.companies)[0];
        vm.available_process = response.available_process;
        //vm.currentCompanyIdReport = 1;
      }).catch(function (err) {
      });
    }

    function _getCompanyGoals(period_id) {

      //Si ya se cargó la información, no cargarla de nuevo
      if (vm.goals !== null) return;

      evaluationService.getEvaluationGoals(period_id).then(function (response) {
        vm.additional_data = response.additional_data;
        vm.goals = response.goals;
        vm.areas = response.areas;
        vm.companyDepartments = response.companyDepartments;
        vm.companies = response.companies;
        vm.companyGoalsCount = response.companyGoalsCount;
        vm.companyTypes = response.types;
        vm.positions_levels = response.positions_levels;
      }).catch(function (err) {
      });
    }

    function _getGoalsAssigments(company_id) {
      var data = { period_id: vm.workingPeriod.id, empresa_id: company_id };
      vm.companyIdSelectedAssigmentsGoals = company_id;
      vm.showMessageLoad = true;
      vm.loadingAssingGoals = true;
      evaluationService.getGoalsToAssign(data).then(function (response) {

        vm.goalAssingSelected = {};
        vm.employeeAssingSelected = {};
        vm.corporateGoals = response.goals;
        vm.employeesGoals = response.employeesGoals;
        vm.activeProcessesGoals = response.activeProcesses;
        vm.activeProcessesGoalsMisc = response.activeProcesses;
        vm.employeesGoalsTotal = response.employeesGoalsTotal;
        vm.position_levels = response.position_levels;
        vm.goals_configuration = response.goals_configuration;
        vm.employees_goals_ids = response.employees_goals_ids;
        vm.showMessageLoad = false;
        vm.loadingAssingGoals = false;
        
      }).catch(function (err) {
      });
    }

    function filterEmployees(){
      var dataFilter = angular.copy(vm.activeProcessesGoals);
      if(vm.searchEmployees.positionLevel){
        dataFilter = _getDataArray(dataFilter,vm.searchEmployees.positionLevel,'nivel');
      }

      if(vm.searchEmployees.department){
        dataFilter = _getDataArray(dataFilter,vm.searchEmployees.department,'company_department_id');
      }

      if(vm.searchEmployees.area){
        dataFilter = _getDataArray(dataFilter,vm.searchEmployees.area,'area_id');
      }

      if(vm.searchEmployees.employee){
        dataFilter = _getDataArrayEmployeeName(dataFilter,vm.searchEmployees.employee);
      }

      vm.activeProcessesGoalsMisc = dataFilter;
    }

    function _getDataArray(array,data,key){
      return array.filter(function(element){
        return element[key] == data;
      });
    }

    function _getDataArrayEmployeeName(array,data){
      var textoSearch = data.toLowerCase();
      return array.filter(function(element){
        var name = element.empleado.name.toLowerCase();
        return name.search(textoSearch) !== -1;
      });
    }

    function _serializeSelecteds() {
      vm.goalKeys = Object.keys(vm.goalAssingSelected);
      vm.employeeKeys = Object.keys(vm.employeeAssingSelected);
      vm.goalsSelectedTotal = 0;
      vm.selectedGoalsKeys = [];
      for (var i in vm.goalAssingSelected) {
        if (vm.goalAssingSelected[i].selected) {
          vm.goalsSelectedTotal++;
          vm.selectedGoalsKeys.push(parseInt(i));
        }
      }

      var totalGoalAssingSelected = _getTotalPorcentajeGoalSelected();

      if(vm.goalKeys.length && !vm.employeeKeys.length){
        for(var i in vm.goalAssingSelected){
          if(!vm.goalAssingSelected[i].selected){
            delete(vm.goalAssingSelected[i]);
          }
        }
      }
      
      if (vm.goalKeys.length && vm.employeeKeys.length) {
        for (var e in vm.employeeAssingSelected) {
          var employee = vm.employeeAssingSelected[e];
          var total_empoye = totalGoalAssingSelected + vm.employeesGoalsTotal[e].total_weight > 100;
          var maxGoalGroup = vm.goals_configuration[employee.group] ? vm.goals_configuration[employee.group].maximo : null;
          //var countGoalUsing = vm.employeesGoalsTotal[e].fixed.quantity;
          var goalsIdsEmploye = vm.employees_goals_ids[e] ? vm.employees_goals_ids[e] : [];

          for(var i in vm.selectedGoalsKeys){
            if(goalsIdsEmploye.indexOf(vm.selectedGoalsKeys[i]) == -1){
              goalsIdsEmploye.push(vm.selectedGoalsKeys[i]);
            }
          }

          if (!maxGoalGroup) {
            employee.selected = false;
            continue;
          }

          if (total_empoye) {
            employee.selected = false;
          }

          if (maxGoalGroup < goalsIdsEmploye.length) {
            employee.selected = false;
          }

          for (var g in vm.goalAssingSelected) {
            
            if (!employee.selected) {
              if (vm.employeesGoals[e] && vm.employeesGoals[e][g]) {
                delete (vm.employeesGoals[e][g]);
              }
              continue;
            }
            if (vm.goalAssingSelected[g].selected && !total_empoye) {
              if (!vm.employeesGoals[e]) {
                vm.employeesGoals[e] = {};
              }
              vm.employeesGoals[e][g] = {
                id: null,
                objetivo_id: g,
                matricula_id: e,
                porcentaje: vm.goalAssingSelected[g].porcentaje
              }
            } else {
              if(vm.employeesGoals[e] && vm.employeesGoals[e][g]){
                delete (vm.employeesGoals[e][g]);
              }
              
            }
          }
          if(!employee.selected){
            delete(vm.employeeAssingSelected[e]);
          }
        }
      }
    }

    function _getTotalPorcentajeGoalSelected() {
      var total = 0;
      for (var i in vm.goalAssingSelected) {
        if (vm.goalAssingSelected[i].selected) {
          total += vm.goalAssingSelected[i].porcentaje;
        }
      }
      return total;
    }

    function serializeAssignmentsGoals() {
      var data = [];
      for (var e in vm.employeeAssingSelected) {
        var goalsSelected = {};
        for (var g in vm.goalAssingSelected) {
          if (vm.employeesGoals[e] && vm.employeesGoals[e][g]) {
            goalsSelected[g] = {};
            goalsSelected[g].porcentaje = vm.employeesGoals[e][g].porcentaje;
          }
        }
        data.push({
          matricula_id: parseInt(e),
          goals: goalsSelected
        });
      }
      return data;
    }

    function changeEmployeeAssingSelected(employee) {
      if (!vm.employeeAssingSelected[employee.id].group) {
        vm.employeeAssingSelected[employee.id].group = employee.grupo;
      }
    }

    function _getSkillsProfiles(period_id) {

      //Si ya se cargó la información, no cargarla de nuevo
      if (vm.skillsProfiles !== null) return;

      evaluationService.getSkillsProfiles(period_id).then(function (response) {
        vm.skillsProfiles = response.employeesProfiles;
        vm.skills = response.skills;
      }).catch(function (err) {
      });
    }

    function openEnrollEmployeeDialog(ev) {
      $mdDialog.show({
        controller: 'EnrollEmployeeDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/custom_modules/evaluation/dialogs/enroll-employee/enroll-employee-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          Evaluations: vm.evaluations,
          WorkingPeriod: vm.workingPeriod,
          Operativa: vm.isEdo
        }
      });
    }

    function openMatriculaMass(ev) {
      $mdDialog.show({
        controller: 'MatriculaMassDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/custom_modules/evaluation/dialogs/matricula-mass/matricula-mass-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          Available: vm.available_process,
          EvaluationSelecteds: vm.evaluationSelecteds,
          PeriodoId: vm.workingPeriod.id,
          isEdo: vm.isEdo,
          Lists: {
            organizationCompanies: vm.organizationCompanies,
            organizationDepartments: vm.organizationDepartments,
            organizationAreas: vm.organizationAreas,
            organizationPositions: vm.organizationPositions,
            organizationPositionsLevels: vm.organizationPositionsLevels,
            organizationChief: vm.organizationChief
          }
        }
      });
    }

    function openGoalDialog(ev, goalData) {
      $mdDialog.show({
        controller: 'EvaluationGolDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/custom_modules/evaluation/dialogs/goal/goal-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          WorkingPeriod: vm.workingPeriod,
          Goals: vm.goals,
          Goal: goalData,
          Areas: vm.areas,
          CompanyDepartments: vm.companyDepartments,
          Companies: vm.companies,
          AdditionalData: vm.additional_data,
          Types: vm.companyTypes,
          Positions: vm.organizationPositions
        }
      });
    }

    function goImport() {
      OrganizationUploadService.setData({ company_goals_import: { periodo_id: vm.workingPeriod.id } });
      $state.go('app.organization_upload', { key: 'company_goals_import' });
    }

    function saveAssignments() {
      var goals_data = serializeAssignmentsGoals();

      evaluationService.assignCorporateGoals(vm.workingPeriod.id, goals_data, vm.companyIdSelectedAssigmentsGoals).then(function (response) {

        //Inicializar de nuevo la variable que tiene las asignaciones
        vm.goalAssignments = {};
        vm.goal_selected = null;

        vm.employeesGoalsTotal = response.employeesGoalsTotal;
        vm.goalAssingSelected = {};
        vm.employeeAssingSelected = {};

        UtilsService.showToast(response.message, true);
        
        setTimeout(function(){
          for(var e in document.getElementsByTagName('md-toast')){
            document.getElementsByTagName('md-toast')[e].style.display = 'none';
          }
        },6000);

      }).catch(function (err) {
        // TODO
      });
    }

    function setActiveProcessDeadline(ev, activeProcessId) {
      evaluationService.setActiveProcessDeadline(vm.workingPeriod.id, vm.currentCompanyIdReport, activeProcessId, vm.process_deadline).then(function (response) {

        angular.forEach(vm.evaluations, function (ev) {
          if (ev.evaluation_active_process_id == activeProcessId && (vm.currentCompanyIdReport == '*' || vm.currentCompanyIdReport == ev.empresa_id)) {
            ev.process_deadline = vm.process_deadline;
          }
        });

      }).catch(function (err) {
        // TODO
      });
    }

    function setPeriod(period) {
      vm.workingPeriod = period;
      evaluationService.setPeriod(period);

      vm.evaluations = null;
      vm.goals = null;
      vm.skillsProfiles = null;
      vm.activeProcesses = null;

      if (vm.currentTab == 'evaluations') {
        _getEvaluations(vm.workingPeriod.id);
      } else if (vm.currentTab == 'company_goal_list') {
        _getCompanyGoals(vm.workingPeriod.id);
      } else if (vm.currentTab == 'skills_profiles') {
        _getSkillsProfiles(vm.workingPeriod.id);
      } else if (vm.currentTab == 'goal_assigments') {
        //_getGoalsAssigments(vm.workingPeriod.id);
      } else if (vm.currentTab == 'processes') {
        _getActiveProcessesInfo(vm.workingPeriod.id);
      }

    }

    function addEvaluationSelecteds(employee_process_id) {
      var index = vm.evaluationSelecteds.indexOf(employee_process_id);
      if (index !== -1) {
        vm.evaluationSelecteds.splice(index, 1);
      } else {
        vm.evaluationSelecteds.push(employee_process_id);
      }
    }


    $scope.$watch('vm.goalAssingSelected', function (value) {
      $debounce(_serializeSelecteds, 500);
    }, true);

    $scope.$watch('vm.employeeAssingSelected', function (value) {
      $debounce(_serializeSelecteds, 500);
    }, true);

    /**
     * CUESTIONARIO
     */

    $scope.$on('handleFileSelect', function (event, data) {
      try {
        var file = data.currentTarget.files[0];
        if ((file.size / 1024) > 500) {
          UtilsService.showToast('La imagen adjuntada supera el peso de 500kb', true);
          return;
        }
        var reader = new FileReader();
        reader.onload = function (evt) {
          $scope.$apply(function ($scope) {
            if (vm.headerImg) {
              vm.questionsData.graphic_file = {};
              vm.questionsData.graphic_file.extension = file.type.split('/')[1];
              vm.questionsData.graphic_file.bs64_data = evt.target.result.split(',')[1];
              vm.questionsData.img = evt.target.result;
            } else {
              var graphic_file = {};
              graphic_file.extension = file.type.split('/')[1];
              graphic_file.bs64_data = evt.target.result.split(',')[1];

              //vm.questionsData.edo_answer_choices[vm.indexInputFile] = {};
              vm.questionsData.edo_answer_choices[vm.indexInputFile].graphic_file = graphic_file;
              vm.questionsData.edo_answer_choices[vm.indexInputFile].img = evt.target.result;
              //vm.questionsData.edo_answer_choices[vm.indexInputFile].dataImg = file.name;
            }

          });
        };
        reader.readAsDataURL(file);
      } catch (e) {
        console.error(e);
      }

    });

    function removeImgAnunciado() {
      vm.questionsData.img = null;
      delete (vm.questionsData.graphic_file);
    }

    function removeImgChoices(choice) {
      choice.img = null;
      choice.dataImg = null;
      if (choice.graphic_file) {
        delete (choice.graphic_file);
      }
    }

    function selectHeaderImage(input) {
      vm.headerImg = true;
      angular.element(document.querySelector('#' + input)).click();
    }

    function selectFileChoices(input, index) {
      vm.headerImg = false;
      vm.indexInputFile = index;
      angular.element(document.querySelector('#' + input)).click();
    }

    function addEdoAnswerChoices() {
      vm.questionsData.edo_answer_choices.push({});
    }

    function addValues() {
      vm.questionsData.values.push({});
    }

    function deleteAnswerChoices(index) {
      if (vm.questionsData.edo_answer_choices[index].id) {
        vm.edo_answer_choices_delete[vm.questionsData.edo_answer_choices[index].id] = true;
      }
      vm.questionsData.edo_answer_choices.splice(index, 1);
    }

    function selectedCorrectChoice(index) {
      for (var i in vm.questionsData.edo_answer_choices) {
        if (index != i) {
          vm.questionsData.edo_answer_choices[i].isCorrect = false;
        }
      }
    }

    function deleteValues(index) {
      vm.questionsData.values.splice(index, 1);
    }

    function changeSelectedAnswer(index, indexParent) {
      for (var i in vm.questionsData.edo_answer_choices) {
        var choice = vm.questionsData.edo_answer_choices[i];
        if (i != indexParent && choice.char_correct_answer == index) {
          vm.questionsData.edo_answer_choices[i].char_correct_answer = null;
        }
      }
    }

    function selectedQuestion(questions) {
      vm.showCreateQuestions = true;
      vm.questionsData.id = questions.id;
      vm.questionsData.edo_topic_id = questions.edo_topic_id;
      vm.questionsData.edo_question_type_id = questions.edo_question_type.id;
      vm.questionsData.question_text = questions.question_text;
      serializeForm(questions);
    }

    function toDialogTopics(topic) {
      $mdDialog.show({
        controller: 'TopicsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/custom_modules/evaluation/dialogs/topics/topics-dialog.html',
        clickOutsideToClose: false,
        locals: {
          Topic: topic ? angular.copy(topic) : {}
        }
      }).then(function (response) {
        if (topic) {
          for (var i in vm.topics) {
            if (vm.topics[i].id == topic.id) {
              vm.topics[i] = response;
            }
          }
        } else {
          vm.topics.push(response);
        }

      });
    }

    function toDialogDeleteTopics(topic) {
      var confirm = $mdDialog.confirm()
        .title('¿Confirma que desea inactivar el tema?')
        .ariaLabel('delet')
        .ok('Ok')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        topic.inactive = true;
        api.evaluations.updateTopics.delete({ id: topic.id }, function (success) {
          for (var i in vm.topics) {
            if (vm.topics[i].id == topic.id) {
              vm.topics[i].is_active = false;
              //vm.topics.splice(i, 1);
            }
          }

        }, function (error) {
          topic.inactive = false;
          console.error(error);
        })

      });
    }

    function toDialogDeleteQuestion(question) {
      var confirm = $mdDialog.confirm()
        .title('¿Confirma que desea inactivar la pregunta?')
        .ariaLabel('delet')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm).then(function () {
        question.inactive = true;
        api.evaluations.updateQuestion.delete({ id: question.id }, function (success) {
          for (var i in vm.edo_questions) {
            if (vm.edo_questions[i].id == question.id) {
              vm.edo_questions[i].is_active = false;
              //vm.edo_questions.splice(i, 1);
            }
          }
          UtilsService.showToast(success.message);
        }, function (error) {
          question.inactive = false;
          //UtilsService.showToast(success.message);
          console.error(error);
        })

      });
    }

    function showImageDialog(url, name) {
      if (!url) {
        return;
      }
      $mdDialog.show({
        controller: 'ShowImageDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/custom_modules/evaluation/dialogs/show-image/show-image.html',
        clickOutsideToClose: false,
        locals: {
          Url: url,
          Name: name
        }
      });
    }

    function resetFormQuestion() {
      vm.questionsData = {};
      resetAnswerChoices();
    }

    function saveFormQuestion() {
      vm.loadingSaveQuestion = true;
      var data = serializePost(angular.copy(vm.questionsData));
      if (vm.questionsData.id) {
        data.id = vm.questionsData.id;
        delete (data.edo_question_type_id);
        updateQuestion(data);
      } else {
        createQuestion(data);
      }
    }

    function createQuestion(data) {
      api.evaluations.edoQuestions.save(data, function (success) {
        UtilsService.showToast(success.message);
        vm.edo_questions.push(success.data.edo_questions);
        vm.loadingSaveQuestion = false;
        vm.showCreateQuestions = false;
        vm.resetFormQuestion();
      }, function (error) {
        vm.loadingSaveQuestion = false;
        console.log(error);
        //UtilsService.showToast(error.data.message, true);
        for (var i in error.data.erros.base) {
          UtilsService.showToast(error.data.erros.base[i], true);
        }
      });
    }

    function updateQuestion(data) {
      api.evaluations.updateQuestion.update(data, function (success) {
        UtilsService.showToast(success.message);
        for (var i in vm.edo_questions) {
          if (vm.edo_questions[i].id == success.data.edo_questions.id) {
            vm.edo_questions[i] = success.data.edo_questions;
          }
        }
        vm.loadingSaveQuestion = false;
        vm.showCreateQuestions = false;
        vm.resetFormQuestion();
      }, function (error) {
        vm.loadingSaveQuestion = false;
        console.log(error);
        //UtilsService.showToast(error.data.message, true);
        for (var i in error.data.erros.base) {
          UtilsService.showToast(error.data.erros.base[i], true);
        }
      });
    }

    function serializePost(data) {
      var dataJsonReturn = {
        question_text: data.question_text,
        edo_topic_id: data.edo_topic_id,
        edo_question_type_id: data.edo_question_type_id
      }
      if (vm.questionsData.graphic_file) {
        dataJsonReturn.graphic_file = vm.questionsData.graphic_file
      }
      var jsonInsert = {};
      switch (data.edo_question_type_id) {
        case 1:
          dataJsonReturn.edo_answer_choices = [];
          if (Object.keys(vm.edo_answer_choices_delete).length) {
            for (var i in vm.edo_answer_choices_delete) {
              jsonInsert = {};
              jsonInsert.id = i;
              jsonInsert._destroy = true;
              dataJsonReturn.edo_answer_choices.push(jsonInsert);
            }
          }
          for (var i in data.edo_answer_choices) {

            jsonInsert = {};
            if (data.edo_answer_choices[i].id) {
              jsonInsert.id = data.edo_answer_choices[i].id;
            }

            jsonInsert.row_order = i;
            jsonInsert.is_correct_answer = data.edo_answer_choices[i].isCorrect;

            if (vm.quesionsConfig.onlyImg) {
              if (data.edo_answer_choices[i].img && data.edo_answer_choices[i].graphic_file) {
                jsonInsert.graphic_file = data.edo_answer_choices[i].graphic_file;
              }

              jsonInsert.label = null;
            } else {
              jsonInsert.graphic_path = null;
              jsonInsert.graphic_file = null;
              jsonInsert.label = data.edo_answer_choices[i].label;
            }
            dataJsonReturn.edo_answer_choices.push(jsonInsert);
          }
          break;
        case 2:
          dataJsonReturn.edo_answer_choices = [];

          dataJsonReturn.options = {
            values: {},
            visible: vm.questionsData.graphic_file ? false : true
          };

          for (var i in data.edo_answer_choices) {
            jsonInsert = {};
            var alphabetMin = vm.alphabetMin[i];

            if (data.edo_answer_choices[i].id) {
              jsonInsert.id = data.edo_answer_choices[i].id;
            }

            jsonInsert.row_order = i;
            jsonInsert.char_correct_answer = alphabetMin;

            if (!data.edo_answer_choices[i].img) {
              jsonInsert.graphic_path = null;
              jsonInsert.graphic_file = null;
            }

            if (data.edo_answer_choices[i].graphic_file) {
              jsonInsert.graphic_file = data.edo_answer_choices[i].graphic_file;
            }

            if (data.edo_answer_choices[i].label) {
              jsonInsert.label = data.edo_answer_choices[i].label;
            }

            dataJsonReturn.options.values[alphabetMin] = {
              label: data.edo_answer_choices[i].response
            };

            dataJsonReturn.edo_answer_choices.push(jsonInsert);
          }

          /*var values = {};
          for (var v in data.values) {
            values = {};
 
            var value = data.values[v];
            var alphabetMin = vm.alphabetMin[v];
 
            
 
          }*/
          break;
        case 3:
          dataJsonReturn.edo_answer_choices = [];
          if (Object.keys(vm.edo_answer_choices_delete).length) {
            for (var i in vm.edo_answer_choices_delete) {
              jsonInsert = {};
              jsonInsert.id = i;
              jsonInsert._destroy = true;
              dataJsonReturn.edo_answer_choices.push(jsonInsert);
            }
          }
          for (var i in data.edo_answer_choices) {
            jsonInsert = {};

            if (data.edo_answer_choices[i].id) {
              jsonInsert.id = data.edo_answer_choices[i].id;
            }

            jsonInsert.row_order = i;
            jsonInsert.is_correct_answer = data.edo_answer_choices[i].is_correct_answer;
            if (vm.quesionsConfig.onlyImg) {
              if (data.edo_answer_choices[i].img && data.edo_answer_choices[i].graphic_file) {
                jsonInsert.graphic_file = data.edo_answer_choices[i].graphic_file;
              }
              jsonInsert.label = null;
            } else {
              jsonInsert.graphic_path = null;
              jsonInsert.graphic_file = null;
              jsonInsert.label = data.edo_answer_choices[i].label;
            }
            dataJsonReturn.edo_answer_choices.push(jsonInsert);
          }
          break;
        case 4:
          dataJsonReturn.numerical_answer = data.numerical_answer;
          break;
      }
      return dataJsonReturn;
    }

    function serializeForm(data) {
      if (data.graphic_path) {
        vm.questionsData.img = api.baseUrl + data.graphic_path;
      }
      vm.questionsData.edo_answer_choices = [];
      switch (data.edo_question_type.id) {
        case 1:
          for (var i in data.edo_answer_choices) {
            var choices = data.edo_answer_choices[i];

            var jsonInsert = {};
            jsonInsert.id = choices.id;
            if (choices.graphic_path) {
              vm.quesionsConfig.onlyImg = true;
              jsonInsert.img = api.baseUrl + choices.graphic_path;
            } else {
              jsonInsert.label = choices.label;
            }

            if (choices.is_correct_answer) {
              jsonInsert.isCorrect = true;
            }

            vm.questionsData.edo_answer_choices.push(jsonInsert);
          }
          break;
        case 2:
          /*for (var v in data.options.values) {
            vm.questionsData.values.push({ label: data.options.values[v].label });
          }*/
          for (var i in data.edo_answer_choices) {
            var choices = data.edo_answer_choices[i];

            var jsonInsert = {};

            var alphabetMin = vm.alphabetMin[i];

            jsonInsert.id = choices.id;
            if (choices.graphic_path) {
              vm.quesionsConfig.onlyImg = true;
              jsonInsert.img = api.baseUrl + choices.graphic_path;
            }

            jsonInsert.label = choices.label;

            jsonInsert.char_correct_answer = choices.char_correct_answer;

            jsonInsert.response = data.options.values[alphabetMin].label;

            vm.questionsData.edo_answer_choices.push(jsonInsert);
          }
          break;
        case 3:
          for (var i in data.edo_answer_choices) {

            var choices = data.edo_answer_choices[i];

            var jsonInsert = {};

            jsonInsert.id = choices.id;
            if (choices.graphic_path) {
              vm.quesionsConfig.onlyImg = true;
              jsonInsert.img = api.baseUrl + choices.graphic_path;
            } else {
              jsonInsert.label = choices.label;
            }
            jsonInsert.is_correct_answer = choices.is_correct_answer;

            vm.questionsData.edo_answer_choices.push(jsonInsert);
          }
          break;
        case 4:
          vm.questionsData.numerical_answer = data.numerical_answer;
          break;
      }
    }

    function validateChoices() {
      var countCorrect = 0;
      for (var i in vm.questionsData.edo_answer_choices) {
        var choice = vm.questionsData.edo_answer_choices[i];
        if (vm.quesionsConfig.onlyImg && (!choice.graphic_file && !choice.img)) {
          vm.quesionsConfig.formValid = false;
          return;
        } else if (!vm.quesionsConfig.onlyImg && !choice.label) {
          vm.quesionsConfig.formValid = false;
          return;
        }

        if (choice.isCorrect) {
          countCorrect = countCorrect + 1;
        }
      }

      if (!countCorrect) {
        vm.quesionsConfig.formValid = false;
        return;
      }

      vm.quesionsConfig.formValid = true;
    }

    function validateChoicesMultiple() {
      var boolCorrectAnswer = false;
      for (var i in vm.questionsData.edo_answer_choices) {
        var choice = vm.questionsData.edo_answer_choices[i];
        if (vm.quesionsConfig.onlyImg && !choice.graphic_file) {
          vm.quesionsConfig.formValid = false;
          return;
        } else if (!vm.quesionsConfig.onlyImg && !choice.label) {
          vm.quesionsConfig.formValid = false;
          return;
        }
        if (choice.is_correct_answer) {
          boolCorrectAnswer = true;
        }
      }
      vm.quesionsConfig.formValid = boolCorrectAnswer;
    }

    function validateAsociacion() {
      /*if (vm.questionsData.values.length != vm.questionsData.edo_answer_choices.length) {
        vm.quesionsConfig.formValid = false;
        return;
      }*/
      for (var i in vm.questionsData.edo_answer_choices) {
        var choice = vm.questionsData.edo_answer_choices[i];
        if (!choice.label && !choice.graphic_file) {
          vm.quesionsConfig.formValid = false;
          return;
        }
        if (!choice.response) {
          vm.quesionsConfig.formValid = false;
          return;
        }

      }
      /*for (var v in vm.questionsData.values) {
        var value = vm.questionsData.values[v];
        if (!value.label) {
          vm.quesionsConfig.formValid = false;
          return;
        }
      }*/
      vm.quesionsConfig.formValid = true;

    }

    function validationForm(data) {

      if (data && data.edo_question_type_id) {
        switch (data.edo_question_type_id) {
          case 1:
            validateChoices();
            break;
          case 2:
            validateAsociacion();
            break;
          case 3:
            validateChoicesMultiple();
            break;
          case 4:
            vm.quesionsConfig.formValid = true;
            break;
        }
      }
    }

    function resetAnswerChoices() {
      vm.edo_answer_choices_delete = {};
      vm.questionsData.values = [];
      vm.questionsData.edo_answer_choices = [];
      vm.questionsData.values.push({});
      vm.questionsData.edo_answer_choices.push({});
    }

    function deleteImgChoice(index) {
      delete (vm.questionsData.edo_answer_choices[index].graphic_file);
      delete (vm.questionsData.edo_answer_choices[index].img);
      delete (vm.questionsData.edo_answer_choices[index].dataImg);
    }


    /**
     * Cuestionario
     */

    function selectedQuestionnaire(questionnaire) {
      api.evaluations.updateQuestionnaire.get({ id: questionnaire.id }, function (success) {
        vm.showCreateQuestionnaire = true;
        vm.questionnaireData.id = questionnaire.id;
        vm.questionnaireData.label = questionnaire.label;
        vm.questionnaireData.summary = success.data.summary.by_topic ? success.data.summary.by_topic : [];

        vm.question_questionnaires = HrEDOService.serializeQuestions(success.data.edo_questionnaire.edo_questionnaire_statements);
      }, function (error) {
        console.error(error);
      });
    }

    function addQuestionQuestionnaire() {

      var questions = vm.edo_questions.map(function (element) {
        var isUsing = vm.question_questionnaires.filter(function (elm) { return element.id == elm.question_id && !elm.delete });
        element.show = true;
        if (isUsing.length) {
          element.show = false;
        }
        return element;
      });
      $mdDialog.show({
        controller: 'AddQuestionsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/custom_modules/evaluation/dialogs/add-questions/add-questions-dialog.html',
        clickOutsideToClose: false,
        locals: {
          Questions: questions,
          QuestionType: vm.type_questions,
          Topics: vm.topics,
          Using: vm.question_questionnaires
        }
      }).then(function (response) {
        addSummary(response);
        console.log(response);
        vm.question_questionnaires.push(HrEDOService.serializeQuestion(response));
      });
    }

    function addSummary(question) {
      var edoTopic = question.edo_topic.id;
      var summaryCopy = vm.questionnaireData.summary ? angular.copy(vm.questionnaireData.summary) : [];
      var search = false;
      for (var i in summaryCopy) {
        if (summaryCopy[i].id == edoTopic) {
          search = true;
          summaryCopy[i].questions = summaryCopy[i].questions + 1;
        }
      }

      if (!search) {
        question.edo_topic.questions = 1;
        summaryCopy.push(question.edo_topic);
      }

      vm.questionnaireData.summary = summaryCopy;
    }

    function resSummary(question) {
      var edoTopic = question.edo_topic_id;
      var summaryCopy = angular.copy(vm.questionnaireData.summary);

      for (var i in summaryCopy) {
        if (summaryCopy[i].id == edoTopic) {
          if (summaryCopy[i].questions == 1) {
            summaryCopy.splice(i, 1);
          } else {
            summaryCopy[i].questions = summaryCopy[i].questions - 1;
          }
        }
      }

      vm.questionnaireData.summary = summaryCopy;
    }

    function removeQuestionInQuestionnaire(index) {
      resSummary(vm.question_questionnaires[index]);
      if (vm.question_questionnaires[index].id) {
        vm.question_questionnaires[index].delete = 1;
      } else {
        vm.question_questionnaires.splice(index, 1);
      }

    }

    function saveFormQuestionnaire() {
      var data = seriaizeQuestionairePost();
      if (vm.questionnaireData.id) {
        updateQuestionnaire(data);
      } else {
        createQuestionnaire(data);
      }
    }

    function seriaizeQuestionairePost() {
      var dataReturn = {
        id: vm.questionnaireData.id ? vm.questionnaireData.id : null,
        label: vm.questionnaireData.label,
        edo_questionnaire_statements: []
      };

      for (var i in vm.question_questionnaires) {
        var question = vm.question_questionnaires[i];
        var jsonInsert = {};
        if (question.delete) {
          if (question.id) {
            jsonInsert.id = question.id;
            jsonInsert._destroy = true;
          }
        } else {
          if (question.id) {
            continue;
          }
          jsonInsert.edo_question_id = question.question_id;
          jsonInsert.question_number = parseInt(i);
        }
        dataReturn.edo_questionnaire_statements.push(jsonInsert);
      }
      return dataReturn;
    }

    function createQuestionnaire(data) {
      api.evaluations.edoQuestionnaire.save(data, function (success) {
        UtilsService.showToast(success.message);
        vm.questionnaireData.id = success.data.id;
        vm.edo_questionnaires.push({
          id: success.data.edo_questionnaire.id,
          label: success.data.edo_questionnaire.label,
          is_active: success.data.edo_questionnaire.is_active
        });
        vm.showCreateQuestionnaire = false;
        vm.question_questionnaires = [];
      }, function (error) {
        UtilsService.showToast(error.data.message, true);
        console.error(error);
      })
    }

    function updateQuestionnaire(data) {
      api.evaluations.updateQuestionnaire.update(data, function (success) {
        UtilsService.showToast(success.message);
        for (var i in vm.edo_questionnaires) {
          if (vm.edo_questionnaires[i].id == data.id) {
            vm.edo_questionnaires[i].label = success.data.edo_questionnaire.label;
          }
        }

        vm.showCreateQuestionnaire = false;
        vm.question_questionnaires = [];
      }, function (error) {
        UtilsService.showToast(error.data.message, true);
        console.error(error);
      })
    }

    function toDialogDeleteQuestionnaire(questionnaire) {
      var confirm = $mdDialog.confirm()
        .title('¿Confirma que desea inactivar el cuestionario?')
        .ariaLabel('delet')
        .ok('Confirmar')
        .cancel('Cancelar');

      $mdDialog.show(confirm).then(function () {
        questionnaire.inactive = true;
        api.evaluations.updateQuestionnaire.delete({ id: questionnaire.id }, function (success) {
          UtilsService.showToast(success.message);
          for (var i in vm.edo_questionnaires) {
            if (vm.edo_questionnaires[i].id == questionnaire.id) {
              vm.edo_questionnaires.splice(i, 1);
            }
          }
        }, function (error) {
          questionnaire.inactive = false;
          console.error(error);
        })

      });
    }

    function resetQuestionnaire() {
      vm.questionnaireData = {};
      vm.question_questionnaires = [];
    }

    $scope.$watch('vm.quesionsConfig', function () {
      validationForm(vm.questionsData);
    }, true);

    $scope.$watch('vm.questionsData', function (newValue) {
      $debounce(function(){
        validationForm(newValue);
      },500);
    }, true);

  }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .service('positionDetailService', positionDetailService)
        .directive('positionDetail', positionDetailDirective)
        .controller('positionDetailController', positionDetailController)
        .directive('detailAttributes', detailAttributesDirective)
        .controller('detailAttributesController', detailAttributesController)
        .directive('detailSections', detailSectionsDirective)
        .controller('detailSectionsController', detailSectionsController)
        .directive('attributes', attributesDirective);
    /*.directive('inputText', inputTextDirective)
    .controller('inputTextController', inputTextController)
    .directive('inputTextarea', inputTextareaDirective)
    .controller('inputTextareaController', inputTextareaController);*/

    function positionDetailService() {
        return {
            serializeSections: serializeSections,
            serializeAttributes: serializeAttributes,
            setConfig: setConfig,
            getConfig: getConfig
        }

        var config = {};

        function serializeSections(sections) {
            return sections.map(function (element) {
                element.haveSections = element.sections.length ? true : false;

                return element;
            });
        }
        function serializeAttributes(structure, data, isArray) {

            if (isArray) {
                return serializeAttributesTable(structure, data);
            } else {
                return serializeAttributesSingle(structure, data);
            }
        }


        function serializeAttributesSingle(structure, data) {
            return structure.map(function (element) {
                element.data = data[element.name];
                return element;
            });
        }

        function serializeAttributesTable(structure, data) {
            var table = {};

            table.header = structure;
            table.body = data;

            return table;
        }

        function setConfig(configParams) {
            config = configParams;
        }

        function getConfig() {
            return config;
        }
    }

    function positionDetailDirective() {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                structure: '=structure',
                config: '=config'
            },
            controller: 'positionDetailController as vm',
            transclude: true,
            templateUrl: 'app/core/directives/position-detail/templates/position-detail.html'
        };
    }

    function positionDetailController($scope, positionDetailService) {
        var vm = this;
        vm.sections = positionDetailService.serializeSections($scope.structure.sections);
        vm.data = $scope.data;
        vm.config = $scope.config;
        positionDetailService.setConfig(vm.config);
    }

    function detailAttributesDirective() {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                structure: '=structure',
                isArray: '=isArray',
            },
            controller: 'detailAttributesController as vm',
            transclude: true,
            templateUrl: 'app/core/directives/position-detail/templates/detail-attributes.html'
        };
    }

    function detailAttributesController($scope, positionDetailService) {
        var vm = this;
        vm.attributes = positionDetailService.serializeAttributes($scope.structure, $scope.data, $scope.isArray);
        vm.isArray = $scope.isArray;
        vm.config = positionDetailService.getConfig();
        
        
        vm.addRow = function () {
            vm.attributes.body.push({});
        }

        vm.deleteRow = function (index) {
            vm.attributes.body.splice(index, 1);
        }
    }

    function detailSectionsDirective() {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                sections: '=sections'
            },
            controller: 'detailSectionsController as vm',
            transclude: true,
            templateUrl: 'app/core/directives/position-detail/templates/detail-sections.html'
        };
    }

    function detailSectionsController($scope, positionDetailService) {
        var vm = this;
        vm.sections = positionDetailService.serializeSections($scope.sections);
        vm.data = $scope.data;
    }

    function attributesDirective() {
        return {
            restrict: 'E',
            scope: {
                data: '=value',
                structure: '=structure',
                extra: '=extra'
            },
            template: '<div ng-include="templateLoad" ></div>',
            controller: function ($scope, positionDetailService) {

                //var vm = this;
                $scope.config = positionDetailService.getConfig();
                $scope.label = $scope.structure.label;
                $scope.options = $scope.structure.df_attribute_type;
                $scope.valueText = angular.copy($scope.data);
                //$scope.value = 'hola';
                if($scope.extra && $scope.extra.nolabel){
                    $scope.label = '';
                }

                $scope.templateLoad = 'app/core/directives/position-detail/templates/attributes/'+$scope.options.name+'.html';
                
                $scope.$watch('valueText',function(newData){
                    $scope.data = newData;
                },true);
            }
        };
    }

    /*function inputTextDirective(){
        return {
            restrict: 'E',
            scope: {
                label: '=label',
                value: '=value',
                options: '=options'
            },
            controller: 'inputTextController as vm',
            transclude: true,
            templateUrl: 'app/core/directives/position-detail/templates/attributes/Text.html'
        };
    }

    function inputTextController($scope, positionDetailService){
        var vm = this;
        
        vm.config = positionDetailService.getConfig();
        vm.label = $scope.label;
        vm.value = $scope.value;
        vm.options = $scope.options;
        //console.log(vm);
    }

    function inputTextareaDirective(){
        return {
            restrict: 'E',
            scope: {
                label: '=label',
                value: '=value',
                options: '=options'
            },
            controller: 'inputTextareaController as vm',
            transclude: true,
            templateUrl: 'app/core/directives/position-detail/templates/attributes/TextArea.html'
        };
    }

    function inputTextareaController($scope,positionDetailService){
        var vm = this;

        vm.config = positionDetailService.getConfig();
        vm.label = $scope.label;
        vm.value = $scope.value;
        vm.options = $scope.options;
        console.log(vm.options);
    }*/

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('number', function () {
            return {
                require: 'ngModel',
                restrict: 'A',
                link: function (scope, element, attrs, ctrl) {
                    ctrl.$parsers.push(function (input) {
                        if (input == undefined) return ''
                        var inputNumber = input.toString().replace(/[^0-9]/g, '');
                        if (inputNumber != input) {
                            ctrl.$setViewValue(inputNumber);
                            ctrl.$render();
                        }
                        return inputNumber;
                    });
                }
            };
        });
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService,UsersService)
    {
        var vm = this;
        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }


        vm.navigation = UsersService.getMenu();

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/default.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = true;

            // Is group?
            vm.group = true;

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    /*if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }*/
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMessage', msMessageDirective);

    /** @ngInject */
    function msMessageDirective($document)
    {
        return {
            restrict   : 'E',
            scope   : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-message/ms-message.html',
            link       : function (scope, iElement, attr)
            {
              iElement.addClass("msg-box");
              iElement.addClass(attr.type);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('loadingBar', loadingBarDirective);

    /** @ngInject */
    function loadingBarDirective()
    {
        return {
            restrict: 'E',
            scope   : {},
            templateUrl: 'app/core/directives/ms-loading-bar/ms-loading-bar.html',
            link       : function (scope, iElement)
            {
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController($scope,$rootScope)
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;
        vm.lastStepValid = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        
        /*$scope.$watch('vm.selectedIndex',function(newValue,oldValue){
            $rootScope.$emit('changeSelectedIndex',{newValue:newValue,oldValue:oldValue});
        },true);*/

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }
            vm.lastStepValid = angular.copy(vm.selectedInde);
            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }
            vm.lastStepValid = angular.copy(vm.selectedInde);
            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            var selected = vm.selectedIndex + 1;
            return angular.isDefined(vm.forms[selected]) && vm.forms[selected].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            
            // Go back to the first step
            vm.lastStepValid = angular.copy(vm.selectedInde);
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ikSkillApprovalComments', ikSkillApprovalComments);

    /** @ngInject */
    function ikSkillApprovalComments()
    {
        return {
            restrict   : 'E',
            scope   : {
                data          : '=ngModel',
                allowComment  : '=allowComment'
            },            
            transclude : true,
            templateUrl: 'app/core/directives/ik-skill-approval-comments/ik-skill-approval-comments.html',
            link       : function (scope, iElement)
            {
              //Si el objetivo se encuentra en estado rechazado, enviar el ultimo comentario hecho como comentario actual de rechazo
              scope.data.rejected_comment = '';
              if(!scope.data.aprobado) {
                if(!angular.isUndefined(scope.data.comments) ) {
                  if(!angular.isUndefined(scope.data.comments[0]) ) {
                    scope.data.rejected_comment = scope.data.comments[0]['comment'];
                    scope.data.rejected_comment_id = scope.data.comments[0]['id'];
                  }
                }
              }
              
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikQuestionType', ikQuestionTypeDirective);

    /** @ngInject */
    function ikQuestionTypeDirective() {
        return {
            restrict: 'E',
            scope: {
                data: '=ngModel',
                type: '=type',
                config: '=config'
            },
            template: '<div ng-include="templatePath" onload="templateLoaded()"></div>',
            controller: function ($scope, HrEDOService,api) {

                $scope.baseUrl = api.baseUrl;
                $scope.templateNow = null;

                $scope.edoService = HrEDOService;

                $scope.alphabet = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ';

                $scope.isAdmin = $scope.config ? $scope.config.isAdmin : false;

                function templateLoaded() {
                    $scope.templatePath = "app/main/elements/ik-question-type/" + $scope.templateNow + ".html";
                }

                $scope.$watch('type', function (newValue) {
                    if (!$scope.templateNow) {
                        $scope.templateNow = newValue;
                        templateLoaded();
                    } else if ($scope.templateNow != newValue) {
                        $scope.templateNow = newValue;
                        templateLoaded();
                    }
                }, true);
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .controller('IkImportDataController', IkImportDataController)
        .service('IkImportDataService', IkImportDataService)
        .directive('ikImportData', ikImportData)
        .filter('filterName', filterName)

    function IkImportDataController($mdColors, $scope, fuseTheming, IkImportDataService, FileSaver, $http, UtilsService, $state, LicenseService) {
        var vm = this;

        vm.dtOptions = {};
        vm.selectedIndex = 1;
        vm.totalStepNumber = 2;
        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        vm.selectedTab = selectedTab;
        vm.colors = {};
        vm.tabStep = {};
        vm.tabSelected = {
            id: 1,
        };
        vm.themes = fuseTheming.themes.active.theme;

        vm.importNameFile = null;
        vm.importActionData = [];
        vm.importValidationData = {};
        vm.import_new_data = {};
        vm.import_updated_data = {};
        vm.import_deleted_data = {};

        vm.collapseTable = {};
        vm.selectedUpload = {};

        vm.uploadFileConfig = false;

        vm.processImage = processImage;
        vm.uploadFile = uploadFile;
        vm.donwloadFile = donwloadFile;
        vm.showCollapse = showCollapse;
        vm.isLastStep = isLastStep;
        vm.saveStep = saveStep;
        vm.totalStep = totalStep;
        vm.isFirstStep = isFirstStep;
        vm.currentStepInvalid = currentStepInvalid;
        vm.finalizeEvaluationProcess = finalizeEvaluationProcess;
        vm.setStep = setStep;

        vm.colorsLicense = LicenseService.getValue("color");

        vm.loadingFinalize = false;

        /**
         * FUNCIONES
         */

        function _init(data) {
            vm.config = data;
            IkImportDataService.setKey(vm.config.key);
            if (vm.config.config && vm.config.config.Data && vm.config.config.Data.template_name) {
                IkImportDataService.nameDonwloadFile(vm.config.config.Data.template_name);
            }

            initColors();
            initStep();
            getIndex();
        }

        /**
         * FUNCTION VIEW - CONTROLLER
         */

        function showCollapse(action) {
            vm.collapseTable[action] = !vm.collapseTable[action];
        }

        function saveStep(step, action) {
            switch (action) {
                case 'previous':
                    vm.selectedIndex--;
                    vm.tabStep[vm.selectedIndex].isValid = false;
                    vm.tabSelected.id = vm.selectedIndex;
                    break;
                case 'next':
                    vm.selectedIndex++;
                    vm.tabStep[vm.selectedIndex].isValid = true;
                    vm.tabSelected.id = vm.selectedIndex;
                    break;
            }
        }

        function setStep(step) {
            vm.tabStep[step].isValid = true;
            vm.selectedIndex = step;
            vm.tabSelected.id = vm.selectedIndex;
        }

        function isLastStep() {
            return vm.selectedIndex == totalStep();
        }

        function totalStep() {
            return vm.totalStepNumber;
        }

        function isFirstStep() {
            return vm.selectedIndex == 1;
        }

        function currentStepInvalid() {
            if (isLastStep()) {
                var validCheck = false;
                for (var i in vm.selectedUpload) {
                    if (vm.selectedUpload[i]) {
                        validCheck = true;
                    }
                }
                return validCheck;
            }
        }

        // Setea el nuevo tab seleccionado
        function selectedTab(tab) {
            if (!validateTab(tab)) {
                return;
            }
            vm.tabSelected.id = tab;
        }

        function validateTab(tab) {
            if (tab == 2) {
                if (vm.tabSelected.id == 2) {
                    return true;
                } else if (vm.tabSelected.valid) {
                    return true;
                }
            }
            return false;
        }

        function initColors() {
            vm.colors.primary = vm.themes.primary.color;
            vm.colors.accent = vm.themes.accent.color;
            vm.colors.warn = vm.themes.warn.color;
        }

        function initStep() {
            var total = totalStep()
            for (var i = 1; i <= total; i++) {
                vm.tabStep[i] = {};
            }
        }

        function getIndex() {
            if (!vm.config.config.Data) {
                IkImportDataService.getIndex().then(function (resolve) {
                    vm.tableStructure = resolve.template_headers;
                    serializeIndex();
                    IkImportDataService.nameDonwloadFile(resolve.template_name);
                }, function (reject) { });
            } else if (vm.config.config.Data && vm.config.config.Data.template_headers) {
                vm.tableStructure = vm.config.config.Data.template_headers;
                serializeIndex();
            } else if (vm.config.config.Data && !vm.config.config.Data.template_headers) {
                var data = {};
                for (var i in vm.config.config.dataSend) {
                    data[vm.config.config.dataSend[i]] = vm.config.config.Data[vm.config.config.dataSend[i]];
                }
                IkImportDataService.getIndex(data).then(function (resolve) {
                    vm.tableStructure = resolve.template_headers;
                    serializeIndex();
                    IkImportDataService.nameDonwloadFile(resolve.template_name);
                }, function (reject) { });
            }

        }

        function serializeIndex() {
            vm.keysTableStructure = Object.keys(vm.tableStructure);
        }

        function donwloadFile() {
            var data = {};
            if (vm.config.config.urlDonwloadFile) { //Si tiene la configuracion en el archivo upload-organization.json
                for (var i in vm.config.config.dataSend) {
                    data[vm.config.config.dataSend[i]] = vm.config.config.Data[vm.config.config.dataSend[i]];
                }
                IkImportDataService.getFile(vm.config.config.urlDonwloadFile, data);
            } else if (vm.config.config.Data) {

                for (var i in vm.config.config.dataSend) {
                    data[vm.config.config.dataSend[i]] = vm.config.config.Data[vm.config.config.dataSend[i]];
                }
                IkImportDataService.getFile(null, data);
            } else { //default
                IkImportDataService.getFile();
            }


        }

        function processImage(element) {

            vm.file = element.files[0];
            /*var reader = new FileReader();
            reader.onload = function (event) {
              $scope.$apply(function ($scope) {
                vm.file = element.files[0];
              });
            }*/
            $scope.$apply(function ($scope) {
                vm.uploadFileConfig = true;
            });
        }

        function uploadFile() {
            var url = null;
            var data = null;
            if (vm.config.config.dataSend) {
                data = {};
                for (var i in vm.config.config.dataSend) {
                    data[vm.config.config.dataSend[i]] = vm.config.config.Data[vm.config.config.dataSend[i]];
                }
            }
            if (vm.config.config.urlUploadFile) {
                url = vm.config.config.urlUploadFile;

            }
            IkImportDataService.uploadFile(vm.file, url, data).then(function (resolve) {
                setImportNameFile(resolve.data.uploaded_file_name);
                setImpotHeaderTable(resolve.data.column_header);
                setImportNewData(resolve.data.validations.import_new_data);
                setImportUpdateData(resolve.data.validations.import_updated_data);
                setImportDeleteData(resolve.data.validations.import_deleted_data);
                setImportValidationData(resolve.data.validations.validations_data);
                setImportActionData(resolve.data.validations.allowed_changes);
                validImportData();
            }, function (reject) { });
        }

        function setImportNameFile(data) {
            vm.importNameFile = data;
        }
        function setImpotHeaderTable(data) {
            vm.tableHeader = data;
        }
        function setImportNewData(data) {
            vm.import_new_data = setTableData(data);
        }
        function setImportUpdateData(data) {
            vm.import_updated_data = setTableData(data);
        }
        function setImportDeleteData(data) {
            vm.import_deleted_data = setTableData(data);
        }
        function setImportValidationData(data) {
            if (!data || angular.equals(data, {})) {
                data = null;
            }

            vm.importValidationData = setTableData(data);
        }
        function setImportActionData(data) {
            vm.importActionData = data;
        }

        function validImportData() {
            vm.showAction = false;
            vm.showImport = false;
            if (vm.importValidationData) {
                vm.showImport = true;
            } else {
                for (var i in vm.importActionData) {
                    if (vm[vm.importActionData[i]]) {
                        vm.showAction = true;
                        break;
                    }
                }
                if (!vm.showAction) {
                    saveStep(vm.selectedIndex, 'previous');
                    UtilsService.showToast("El archivo que intenta subir no tiene modificaciones ni errores.", true);
                }
            }
        }

        function finalizeEvaluationProcess() {
            var actionsImport = serializeAction();
            var data = {
                uploaded_file_name: vm.importNameFile,
                do_changes_actions: actionsImport
            };

            if (vm.config.config.dataSend) {
                for (var i in vm.config.config.dataSend) {
                    data[vm.config.config.dataSend[i]] = vm.config.config.Data[vm.config.config.dataSend[i]];
                }
            }

            vm.loadingFinalize = true;

            if (vm.config.config.urlFinalizeEvaluation && vm.config.config.customFinalizeEvaluation) {
                var url = vm.config.config.urlFinalizeEvaluation;
                var dataSend = {};
                dataSend.finalize = false;
                dataSend.data = data;
                for (var i in vm.config.config.dataSend) {
                    dataSend[vm.config.config.dataSend[i]] = vm.config.config.Data[vm.config.config.dataSend[i]];
                }

                IkImportDataService.finalizeEvaluation(url, dataSend).then(function (resolve) {
                    fnFinalizeEvaluation(resolve);
                }, function (reject) { });
            } else if (vm.config.config.urlFinalizeEvaluation && !vm.config.config.customFinalizeEvaluation) {

                var url = vm.config.config.urlFinalizeEvaluation;
                for (var i in vm.config.config.dataSend) {
                    data[vm.config.config.dataSend[i]] = vm.config.config.Data[vm.config.config.dataSend[i]];
                }
                data.data_import_action = 'do-changes';

                IkImportDataService.finalizeEvaluation(url, data).then(function (resolve) {
                    fnFinalizeEvaluation(resolve);
                }, function (reject) { });

            } else {

                IkImportDataService.doChanges(data).then(function (resolve) {
                    UtilsService.showToast(resolve.message, false);
                    fnFinalizeEvaluation();
                }, function (reject) { });
            }


        }

        function fnFinalizeEvaluation(data) {
            vm.loadingFinalize = false;
            var configCallback = vm.config.config.finishCallback;

            switch (configCallback.type) {
                case 'go':
                    $state.go(configCallback.url, configCallback.params)
                    break;
                case 'function':
                    $scope.setfunction(data);
                    break;
            }


        }

        function serializeAction() {
            var arrReturn = [];
            for (var i in vm.selectedUpload) {
                if (vm.selectedUpload[i]) {
                    arrReturn.push(i);
                }
            }
            return arrReturn;
        }

        function setTableData(data) {
            if (!data) {
                return null;
            }
            var objReturn = {
                tableContent: []
            };
            for (var i in data) {
                objReturn.tableContent.push(data[i]);
            }

            return objReturn;
        }

        $scope.$watch('configPath', function (value) {
            if (value) {
                _init(value);
            }
        });

    }

    function IkImportDataService($q, api, UtilsService, $http) {

        this.key = "";
        this.nameDonwload = null;

        this.setKey = function (data) {
            this.key = data;
        }

        this.getKey = function () {
            return this.key;
        }

        this.nameDonwloadFile = function (data) {
            this.nameDonwload = data;
        }

        this.getIndex = function (dataExtra, path) {
            var deferred = $q.defer();
            var dataPost = dataExtra ? dataExtra : {};

            path = path ? path : 'organization';

            dataPost.id = this.getKey();
            dataPost.data_import_action = 'index';

            api.organization.importData.get(dataPost,
                // Success
                function (response) {

                    deferred.resolve(response);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        this.getFile = function (urlComplet, dataSend) {
            var url = "";
            var data = {};
            if (!urlComplet) {
                url = 'organization/' + this.getKey();
                data = dataSend ? dataSend : {};
                data.data_import_action = 'download-template';
            } else {
                url = urlComplet;
                data = dataSend ? dataSend : null;
            }

            if (!data.data_import_action) {
                data.data_import_action = 'download-template';
            }

            api.general.getWindowHttp('GET', url, data, this.nameDonwload);

        }

        this.uploadFile = function (file, url, data) {

            var fd = new FormData();
            fd.append("file", file);
            fd.append("data_import_action", 'upload-template');
            if (data) {
                for (var i in data) {
                    fd.append(i, data[i]);
                }
            }
            if (url) {
                return api.general.importFile(fd, url);
            } else {
                return api.organization.importFile(this.getKey(), fd);
            }

        }

        this.doChanges = function (data) {
            var deferred = $q.defer();

            data.data_import_action = 'do-changes';
            data.id = this.getKey();
            api.organization.importData.save(data,
                // Success
                function (response) {
                    deferred.resolve(response);
                },
                // Error
                function (response) {
                    UtilsService.showToast(response.data.message, true);
                    deferred.reject(response.data);
                });

            return deferred.promise;
        }

        this.finalizeEvaluation = function (url, data) {

            return api.general.genericRequest(url, 'POST', data);
        }
    }

    function filterName() {
        return function (value) {
            switch (value) {
                case 'import_deleted_data':
                    return 'Eliminar';

                case 'import_updated_data':
                    return 'Actualizar';

                case 'import_new_data':
                    return 'Nuevo';

            }
        }
    }

    function ikImportData() {
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                configPath: '=config',
                setfunction: '&'
            },
            controller: 'IkImportDataController as ikImportData',
            template: '<div ng-include="templatePath"></div>',
            compile: function (tElement) {
                /*tElement.addClass('ms-form-wizard');

                return function postLink() {

                };*/
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ikHrGoalCard', ikHrGoalCardDirective);

    /** @ngInject */
    function ikHrGoalCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                data        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="full-width" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('ikEmployeeTeamCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikHrEvaluationSummaryAction', ikHrEvaluationSummaryActionDirective);

    /** @ngInject */
    function ikHrEvaluationSummaryActionDirective($injector) {
        return {
            restrict: 'E',
            scope: {
                summaryTemplate: '=summaryTemplate',
                module: '=module',
                action: '=action',
                data: '=data',
                summary: '=summaryData',
                vm: '=viewModel',
                license: '=license'
            },
            template: '<div class="full-width" ng-include="summaryTemplatePath" onload="templateLoadedx()"></div>',
            compile: function (tElement, attr) {

                return function postLink(scope, iElement) {
                    var module_name = scope.module.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
                    var action_name = scope.action.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

                    scope.summaryTemplatePath = 'app/main/elements/ik-hr-evaluation-action/' + module_name + '/' + action_name + '/summary/' + scope.summaryTemplate + '/' + scope.summaryTemplate + '.html';

                    if (scope.license.templates && scope.license.templates[scope.module]) {
                        scope.summaryTemplatePath = 'app/main/elements/ik-hr-evaluation-action/' + module_name + '/' + action_name + '/summary/' + scope.license.templates[scope.module] + '/' + scope.summaryTemplate + '.html';
                    }

                    // Methods
                    scope.templateLoadedx = templateLoadedx;

                    scope.isSummary = true;
                    //////////
                    function templateLoadedx() {
                        scope.$emit('ikHrEvaluationSummaryAction::templateLoadedx', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikHrEvaluationAction', ikHrEvaluationActionDirective);

    /** @ngInject */
    function ikHrEvaluationActionDirective($injector) {
        return {
            restrict: 'E',
            scope: {
                template: '=template',
                module: '=module',
                action: '=action',
                data: '=data',
                vm: '=viewModel',
                license: '=license'
            },
            template: '<div class="full-width" ng-include="templatePath" onload="templateLoaded()"></div>',
            compile: function (tElement, attr) {

                return function postLink(scope, iElement) {



                    var module_name = scope.module.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
                    var action_name = scope.action.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();


                    scope.template = scope.template ? scope.template : 'default';


                    scope.templatePath = 'app/main/elements/ik-hr-evaluation-action/' + module_name + '/' + action_name + '/' + scope.template + '/' + scope.template + '.html';

                    if (scope.data.fullTemplatePath) {
                        scope.templatePath = scope.data.fullTemplatePath;
                    }





                    // Methods
                    scope.templateLoaded = templateLoaded;

                    scope.isSummary = false;

                    var ModuleServiceName = scope.module + 'Service';
                    if ($injector.has(ModuleServiceName)) {
                        var Service = $injector.get(ModuleServiceName);

                        //Ejecutar la funcion INIT para cada módulo en caso que exista          
                        var initFunction = "init_" + scope.action;
                        if (eval('(typeof Service.' + initFunction + ' == "function")')) {
                            eval('Service.' + initFunction + '(scope.data);');
                        }
                    }
                    //////////

                    function templateLoaded() {
                        scope.$emit('ikHrEvaluationAction::templateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikGoalCommentsModal', ikGoalCommentsModal);

    /** @ngInject */
    function ikGoalCommentsModal() {
        return {
            restrict: 'E',
            scope: {
                data: '=ngModel',
                allowComment: '=allowComment',
                config: '=config',
                fnSave: '&'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ik-goal-comments-modal/ik-goal-comments-modal.html',
            link: function (scope, iElement) {

                

                //Si el objetivo se encuentra en estado rechazado, enviar el ultimo comentario hecho como comentario actual de rechazo
                scope.data.rejected_comment = '';
                /*if (!scope.data.aprobado) {
                    if (!angular.isUndefined(scope.data.comments)) {
                        if (!angular.isUndefined(scope.data.comments[0])) {
                            scope.data.rejected_comment = scope.data.comments[0]['comment'];
                            scope.data.rejected_comment_id = scope.data.comments[0]['id'];
                        }
                    }
                }*/

            },
            controller: function ($scope, $mdDialog, $document,UsersService) {

                $scope.userInfo = UsersService.getUserInfo();

                $scope.showModal = function () {
                    $mdDialog.show({
                        controller: 'goalCommentsDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/core/directives/ik-goal-comments-modal/dialog/dialog.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: false,
                        locals: {
                            data: $scope.data
                        }
                    }).then(function (result) {
                        $scope.data.rejected_comment = result.rejected_comment;
                        $scope.data.aprobado = false;
                        $scope.fnSave({ goal: $scope.data })
                    });
                }

                $scope.deleteComment = function () {
                    $scope.data.rejected_comment = '';
                    $scope.data.aprobado = true;
                    $scope.fnSave({ goal: $scope.data })
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ikGoalApprovalComments', ikGoalApprovalCommentsDirective);

    /** @ngInject */
    function ikGoalApprovalCommentsDirective()
    {
        return {
            restrict   : 'E',
            scope   : {
                data          : '=ngModel',
                allowComment  : '=allowComment',
                config        : '=config',
                fnSave        : '&'  
            },            
            transclude : true,
            templateUrl: 'app/core/directives/ik-goal-approval-comments/ik-goal-approval-comments.html',
            link       : function (scope, iElement)
            {
                
              //Si el objetivo se encuentra en estado rechazado, enviar el ultimo comentario hecho como comentario actual de rechazo
              scope.data.rejected_comment = '';
              if(!scope.data.aprobado) {
                if(!angular.isUndefined(scope.data.comments) ) {
                  if(!angular.isUndefined(scope.data.comments[0]) ) {
                    scope.data.rejected_comment = scope.data.comments[0]['comment'];
                    scope.data.rejected_comment_id = scope.data.comments[0]['id'];
                  }
                }
              }
              
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikEvaluationSummary', ikEvaluationSummaryDirective);

    /** @ngInject */
    function ikEvaluationSummaryDirective() {
        return {
            restrict: 'E',
            scope: {
                data: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ik-evaluation-summary/ik-evaluation-summary.html',
            controller: function ($scope) {

                $scope.$watch('data', function (newValue, oldValue) {
                    if (newValue) {
                        generateTableError();
                    }
                });

                function serilaizeSummary() {
                    //console.log($scope.data);
                    //var summary = angular.copy($scope.data);
                    /*if (summary.errors instanceof Array) {
                        return;
                    } else {
                        var error = [];
                        for (var i in summary.errors) {
                            for(var j in summary.errors[i]){
                                error.push(summary.errors[i][j]);
                            }
                        }
                        $scope.data.errors = error;
                    }*/
                    generateTableError();
                }

                function generateTableError() {
                    var data = $scope.data.errors;
                    var tableError = [];
                    
                    for(var i in data){
                        var text = data[i].split(':',2);
                        tableError.push({
                            id:i,
                            text: text.length > 1 ? text[0] : ' -- ',
                            value: text.length > 1 ? text[1].replace("'","") : text[0].replace("'","")
                        });
                    }
                    $scope.tableError = tableError;
                }   
            },
            link: function (scope, iElement) {

            }
        };
    }

    
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ikEvaluationResultList', ikEvaluationResultListDirective);

    /** @ngInject */
    function ikEvaluationResultListDirective(LicenseService)
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                data        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="full-width" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {

                        scope.decimals_evaluation_result = parseInt(LicenseService.getValue('decimals_evaluation_result'));
                        scope.$emit('ikEmployeeTeamCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ikEvaluationResultCard', ikEvaluationResultCardDirective);

    /** @ngInject */
    function ikEvaluationResultCardDirective(LicenseService)
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                data        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="full-width" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {

                        scope.decimals_evaluation_result = parseInt(LicenseService.getValue('decimals_evaluation_result'));
                        scope.$emit('ikEmployeeTeamCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikEvaluationData', ikEvaluationDataDirective);

    /** @ngInject */
    function ikEvaluationDataDirective() {
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                data: '=ngModel',
                vm: '=viewModel'
            },
            template: '<div ng-include="templatePath" onload="templateLoaded()"></div>',
            compile: function (tElement) {
                return function postLink(scope, iElement) {
                    // Methods
                    scope.templateLoaded = templateLoaded;

                    //////////
                    /**
                     * Emit cardTemplateLoaded event
                     */

                    scope.evFinalCurrentAuto = 0.0;
                    scope.evFinalCurrent = 0.0;
                    for (var i in scope.data.evaluation_hr_modules) {
                        var evaluation = scope.data.evaluation_hr_modules[i];
                        if (!evaluation.hr_module.has_evaluation) {
                            continue;
                        }

                        var evFinalCurrentAuto = (evaluation.weight * parseFloat(evaluation.auto_evaluation)) / 100;
                        var evFinalCurrent = (evaluation.weight * parseFloat(evaluation.chief_evaluation)) / 100;

                        scope.evFinalCurrentAuto = scope.evFinalCurrentAuto + evFinalCurrentAuto;
                        scope.evFinalCurrent = scope.evFinalCurrent + evFinalCurrent;
                    } 


                    function templateLoaded() {
                        for (var i in scope.data.evaluation_data) {
                            scope.data.evaluation_data[i].template = 'app/main/elements/ik-evaluation-data-module/' + i + '/default/default.html';
                        }

                        scope.$emit('ikEvaluationData::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikEmployeeTeamCard', ikEmployeeTeamCardDirective);

    /** @ngInject */
    function ikEmployeeTeamCardDirective() {
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                data: '=ngModel',
                vm: '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            controller: function ($scope, fuseTheming) {
                var themes = fuseTheming.themes.active.theme;
                $scope.colors = {
                    primary: themes.primary.color,
                    accent: themes.accent.color,
                    warn: themes.warn.color
                };
            },
            compile: function (tElement, attr) {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;
                    //////////
                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded() {
                        scope.$emit('ikEmployeeTeamCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ikEmployeeInfo', ikEmployeeInfo);

    /** @ngInject */
    function ikEmployeeInfo() {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                comment: '=comment',
                padding: '=padding',
                key: '@key'
            },
            templateUrl: 'app/core/directives/ik-employee-info/ik-employee-info.html',
            controller: function ($scope, fuseTheming) {
                $scope.evaluator = $scope.key ? $scope.data[$scope.key] : $scope.data.evaluator;
                var themes = fuseTheming.themes.active.theme;
                $scope.colors = {
                    primary: themes.primary.color,
                    accent: themes.accent.color,
                    warn: themes.warn.color
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('PageService', PageService);

    /** @ngInject */
    function PageService($q, api)
    {
    	
    	var menu_loaded = false;
    	
        var service = {
        	admin_deletePage: admin_deletePage,
        	admin_newPage: admin_newPage,
        	admin_savePage: admin_savePage,
        	getMainLayout: getMainLayout,
        	getModules: getModules,
        	getPageLayout: getPageLayout,
        	getTemplates: getTemplates
        };
        return service;

        //////////
        
        function admin_deletePage(page_id) {
			var deferred = $q.defer();

			api.admin.page.delete.save({
				item_id: page_id
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;           	
        }
                
        function admin_newPage(page, page_order) {
			var deferred = $q.defer();

			api.admin.page.new.save({
				item_data: page.Page,
				item_order: page_order
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;           	
        }
                
        function admin_savePage(page, page_order) {
			var deferred = $q.defer();

			api.admin.page.edit.save({
				item_id: page.Page.id,
				item_data: page.Page,
				item_order: page_order
			},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;           	
        }
        
        function getMainLayout() {
			var deferred = $q.defer();

			api.content.main_layout.get({},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;        	
        }
                
        function getPageLayout(page_url, item_id) {
			var deferred = $q.defer();
			
			api.content.page_layout.get({page_url: page_url, item_id: item_id},
			// Success
			function(response) {
				deferred.resolve(response);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;
        }
        
        function getModules() {
			var pageModules = {};
			pageModules['Text'] = "app/main/page/text/text.html";
			pageModules['Directorio'] = "app/main/modules/directorio/directorio.html";
			pageModules['BalanceHidrico'] = "app/main/custom_modules/balance_hidrico/balance_hidrico.html";
			pageModules['PrecioAzucar'] = "app/main/custom_modules/precio_azucar/precio_azucar.html";
			pageModules['InformacionFinanciera'] = "app/main/custom_modules/informacion_financiera/informacion_financiera.html";
			pageModules['Riego'] = "app/main/custom_modules/hacienda_files/riego.html";
			pageModules['CalidadLabores'] = "app/main/custom_modules/hacienda_files/calidad_labores.html";
			pageModules['Laboratorio'] = "app/main/custom_modules/hacienda_files/laboratorio.html";
			pageModules['Event.widget'] = "app/main/modules/events/event_widget/event_widget.html";
			pageModules['Event'] = "app/main/modules/events/event.html";
			pageModules['Bulletin.widget'] = "app/main/modules/bulletin/bulletin_widget/bulletin_widget.html";
			pageModules['Bulletin'] = "app/main/modules/bulletin/bulletin.html";
			pageModules['AsistenteTecnico'] = "app/main/custom_modules/asistente_tecnico/asistente_tecnico.html";
			pageModules['New.slider'] = "app/main/modules/news/slider/news-slider.html";
			pageModules['News.notice'] = "app/main/modules/news/notice/notice.html";
			pageModules['Intro'] = "app/main/custom_modules/intro/intro.html";
			pageModules['Header'] = "app/main/modules/header/header.html";      
			pageModules['Recomendacion'] = "app/main/custom_modules/recomendaciones/recomendaciones.html";      
			
			return pageModules;  	
        }
        
        function getTemplates() {
        	var templates = [];
        	templates.push( {"template":"layout-2-col", "name":"Dos columnas"} );
        	templates.push( {"template":"layout-2-col-no-header", "name":"Dos columnas sin cabezote"} );
        	
        	return templates;
        }
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.page', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.page', {
            url  : '/page/:page_url',
            views: {
                'content@app': {
                    templateUrl: 'app/main/page/page.html',
                    controller : 'PageController as vm'
                }
            }
        });

 		$stateProvider.state('app.page_item', {
            url  : '/page/:page_url/:item_id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/page/page.html',
                    controller : 'PageController as vm'
                }
            }
        });        
    }

})();
(function() {
	'use strict';

	angular.module('app.page').controller('PageController', PageController);

	/** @ngInject */
	function PageController($state, $injector, $mdSidenav, PageService, UtilsService) {

    	//Track Google Analytics
        UtilsService.trackPage();        

		var vm = this;
		
		
		vm.pageModules = {};
		vm.pageModules = PageService.getModules();
		
		vm.pageData = {};

		var page_url = $state.params.page_url;
		var item_id = $state.params.item_id;

		//dom : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

		//Global configuration
		vm.dtOptions = {
			dom : '<"top"f>rt',
			pagingType : 'simple',
			autoWidth : false,
			responsive : true,
			language: UtilsService.getLanguajeDataTable()
		};

		// Data
		
		PageService.getPageLayout(page_url, item_id).then(function(data) {

			vm.page_info = data;
			
			vm.page_layout = vm.page_info.content_layout;
			
			//Contiene el template que se debe usar en la página que se esta consultando
			vm.page_template = 'app/main/page_layouts/' + vm.page_info.page_layout.Page.template + '/' + vm.page_info.page_layout.Page.template + '.html';

			angular.forEach(vm.page_layout, function(value, key) {
				var ModuleServiceName = value.module + 'Service';
				
				// Validar si el servicio existe
				if( $injector.has(ModuleServiceName) ) {
					var Service = $injector.get(ModuleServiceName);

					//Ejecutar la funcion INIT para cada módulo en caso que exista					
					if( eval('(typeof Service.init == "function")') ) {
						eval('Service.init(vm, value.module, value.id, vm.page_info.page_content[value.content_id][value.module][value.id]["content"], vm.page_info.page_content[value.content_id][value.module][value.id]["params"]);');
					}
				}
			});

		}).catch(function(err) {
			// TODO
		});
		

		//Methods
		vm.moduleAction = moduleAction;
		vm.toggleSidenav = toggleSidenav;

		function moduleAction(module, action, module_id, params) {
			var ModuleService = module + 'Service';

			var Service = $injector.get(ModuleService);
			eval('Service.' + action + '(vm, module, module_id, params);');
		}
		
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }		

	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, $httpProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });


    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
      /*
        'manuelita' : {
            primary   : {
                name: 'green',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'light-green',
                hues: {
                    'default': '500',
                    'hue-1'  : '300',
                    'hue-2'  : '200',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'electrojaponesa' : {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'red',
                hues: {
                    'default': '500',
                    'hue-1'  : '300',
                    'hue-2'  : '200',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'grey'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },   */     
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function() {

    'use strict';

    angular
        .module('app.core')
        .filter('split', split);
        
	/** @ngInject */
	/* Retorna el nombre del mes */
	
	function split()
    {
        return function(str, chr){
        	
        	var ret = '';
        	
        	var arr = str.split(chr);
        	
        	angular.forEach(arr, function (val) {
        		ret = ret + "<li>" + val + "</li>";
        	});
        	
        	return "<ul>" + ret + "</ul>";
            
        };       
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('onlyCapitalize', onlyCapitalize);

    /** @ngInject */
    function onlyCapitalize()
    {
        return function (value,textDefault)
        {
            if(!value){
                return textDefault;
            }
            var valueArr = value.split(" ");
            var returnString = "";
            for(var i in valueArr){
                returnString +=  valueArr[i].charAt(0);
            }

            return returnString;
        };
    }

})();
(function() {

    'use strict';

    angular
        .module('app.core')
        .filter('monthName', monthName);
        
	/** @ngInject */
	/* Retorna el nombre del mes */
	function monthName() {
		
		return function (value) {
			var months = {};

			months[1] = 'Enero';
			months[2] = 'Febrero';
			months[3] = 'Marzo';
			months[4] = 'Abril';
			months[5] = 'Mayo';
			months[6] = 'Junio';
			months[7] = 'Julio';
			months[8] = 'Agosto';
			months[9] = 'Septiembre';
			months[10] = 'Octubre';
			months[11] = 'Noviembre';
			months[12] = 'Diciembre';
			
			return months[value];
		};

	}

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterQuestionType', filterQuestionType)
        .filter('filterQuestionsTopics', filterQuestionsTopics)
        .filter('filterQuestionText', filterQuestionText);

    /** @ngInject */
    function filterQuestionText() {
        return function (items, parameter, key1, key2) {
            if (!items || items.length === 0) {
                return items;
            }

            if (!parameter) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];


                if (item[key1].toLowerCase().indexOf(parameter.toLowerCase()) >= 0) {
                    filtered.push(item);
                }else if (key2 && item[key2]) {
                    if (item[key2].toLowerCase().indexOf(parameter.toLowerCase()) >= 0) {
                        filtered.push(item);
                    }
                }

            }

            return filtered;
        };
    }

    function filterQuestionType() {
        return function (items, parameter) {
            if (!items || items.length === 0) {
                return items;
            }

            if (!parameter) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];

                if (item.edo_question_type.id == parameter) {
                    filtered.push(item);
                }


            }

            return filtered;

        };
    }

    function filterQuestionsTopics() {
        return function (items, parameter) {
            if (!items || items.length === 0) {
                return items;
            }

            if (!parameter) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];

                if (item.edo_topic.id == parameter) {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPositionLevel', filterByPositionLevel);

    /** @ngInject */
    function filterByPositionLevel()
    {
        return function (items, positionLevel)
        {
            
            if ( items.length === 0 || !positionLevel )
            {
                return items;
            }

            var filtered = [];

            /*for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                match = false;
                
                if(item.nivel == positionLevel) {
                  match = true;
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }*/

            return items.filter(function(element){
                return element.nivel === positionLevel;
            });

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPosition', filterByPosition);

    /** @ngInject */
    function filterByPosition()
    {
        return function (items, Position)
        {

            if ( items.length === 0 || !Position )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                match = false;

                if(item.cargo_id == Position) {
                  match = true;
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByDocument', filterByDocument);

    /** @ngInject */
    function filterByDocument()
    {
        return function (items, textSearch,keyArray,arrayKeySearchs)
        {
            if ( items.length === 0 || !textSearch )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                match = false;

                if(item.company_department_id == textSearch) {
                  match = true;
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByDepartment', filterByDepartment);

    /** @ngInject */
    function filterByDepartment()
    {
        return function (items, Department)
        {
            if ( items.length === 0 || !Department )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                match = false;

                if(item.gerencia_id == Department) {
                  match = true;
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByCompany', filterByCompany);

    /** @ngInject */
    function filterByCompany()
    {
        return function (items, Company)
        {

            if ( items.length === 0 || !Company )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                match = false;

                if(item.empresa_id == Company) {
                  match = true;
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByChief', filterByChief);

    /** @ngInject */
    function filterByChief()
    {
        return function (items, Chief)
        {

            if ( items.length === 0 || !Chief )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                match = false;
                if(item.chief && item.chief.id == Chief) {
                  match = true;
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByArea', filterByArea);

    /** @ngInject */
    function filterByArea()
    {
        return function (items, Area)
        {

            if ( items.length === 0 || !Area )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                match = false;

                if(item.area_id == Area) {
                  match = true;
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();

(function() {

    'use strict';

    angular
        .module('app.core')
        .filter('fechagmt', fechagmt)
        .filter('horagmt', horagmt);
        
	/** @ngInject */
	/* Retorna el nombre del mes */
	
	function fechagmt()
    {
        return function(fecha_time, formato){
            if(formato) {
            	return fecha_time ? moment( fecha_time ).add(-5, "hours").format(formato) : '';	
            } else {
				return fecha_time ? moment( fecha_time ).add(-5, "hours").format('MMM D, YYYY') : '';            	
            }
            
        };       
    }
   
    /** @ngInject */
    function horagmt()
    {
        return function(hora_time){
            return moment( hora_time ).add(-5, "hours").format('h:mm a');
        };       
    }	
	

})();

(function() {

    'use strict';

    angular
        .module('app.core')
        .filter('fecha', fecha)
        .filter('hora', hora)
        .filter('formatMoment', formatMoment);
        
	/** @ngInject */
	/* Retorna el nombre del mes */
	
	function fecha()
    {
        return function(fecha_time, formato){
            if(formato) {
            	return fecha_time ? moment( fecha_time ).format(formato) : '';	
            } else {
				return fecha_time ? moment( fecha_time ).format('MMM D, YYYY') : '';            	
            }
            
        };       
    }
   
    /** @ngInject */
    function hora()
    {
        return function(hora_time){
            return moment( hora_time ).format('h:mm a');
        };       
    }
    
    function formatMoment() {
        return function (input, formatDate /*, param1, param2, ...param n */) {
            
            return moment(input).format(formatDate);
        };
    }
	

})();
(function() {

	'use strict';

	angular.module('app.core')
			.filter('dateToISO', dateToISO);

	/** @ngInject */
	/* Retorna la fecha en formato javascript date */
	function dateToISO() {

		return function(value) {
			if(value) {
				return new Date(value).toISOString();	
			} else {
				return "";
			}
			
		};

	}

})(); 
(function() {
	'use strict';

	angular.module('app.core').filter('dateRange', dateRange).filter('dateToISO', dateToISO).filter('toTrusted', toTrustedFilter).filter('htmlToPlaintext', htmlToPlainTextFilter).filter('nospace', nospaceFilter).filter('humanizeDoc', humanizeDocFilter);

	function parseDate(input) {
		var parts = input.substr(0, 10).split('-');

		// Note: months are 0-based
		return new Date(parts[0], parts[1]*1 - 1, parts[2]);
	}

	function dateRange() {
		return function(items, from, to) {
			if (!from || !to) {
				return items;
			}
			var df = parseDate(from);
			var dt = parseDate(to);
			
			var arrayToReturn = [];

			for (var i = 0; i < items.length; i++) {

				if ( typeof items[i]['Pesaje'][0] !== 'undefined') {
					var item_fecha = items[i]['Pesaje'][0]['fecha_pesaje'];

					var tf = parseDate(item_fecha);
					if (tf > df && tf < dt) {
						arrayToReturn.push(items[i]);
					}

				}

			}

			return arrayToReturn;
		};
	}

	/** @ngInject */
	function dateToISO() {
		return function(input) {
			return new Date(input).toISOString();
		};
	}

	/** @ngInject */
	function toTrustedFilter($sce) {
		return function(value) {
			return $sce.trustAsHtml(value);
		};
	}

	/** @ngInject */
	function htmlToPlainTextFilter() {
		return function(text) {
			return String(text).replace(/<[^>]+>/gm, '');
		};
	}

	/** @ngInject */
	function nospaceFilter() {
		return function(value) {
			return (!value) ? '' : value.replace(/ /g, '');
		};
	}

	/** @ngInject */
	function humanizeDocFilter() {
		return function(doc) {
			if (!doc) {
				return;
			}
			if (doc.type === 'directive') {
				return doc.name.replace(/([A-Z])/g, function($1) {
					return '-' + $1.toLowerCase();
				});
			}
			return doc.label || doc.name;
		};
	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('orgchart', orgchart);

    /** @ngInject */
    function orgchart()
    {
      return {
        restrict: 'E',
        link: function($scope, $elm) {

          // Instantiate and draw our chart, passing in some options.
          var chart = new google.visualization.OrgChart($elm[0]);
          chart.draw($scope.orgChartData);
        }
      }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('ngThumb', ['$window', ngThumb]);

    /** @ngInject */
    function ngThumb($window)
    {
		var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function(item) {
                return angular.isObject(item) && item instanceof $window.File;
            },
            isImage: function(file) {
                var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            template: '<canvas/>',
            link: function(scope, element, attributes) {
                if (!helper.support) return;

                var params = scope.$eval(attributes.ngThumb);

                if (!helper.isFile(params.file)) return;
                if (!helper.isImage(params.file)) return;

                var canvas = element.find('canvas');
                var reader = new FileReader();

                reader.onload = onLoadFile;
                reader.readAsDataURL(params.file);

                function onLoadFile(event) {
                    var img = new Image();
                    img.onload = onLoadImage;
                    img.src = event.target.result;
                }

                function onLoadImage() {
                    var width = params.width || this.width / this.height * params.height;
                    var height = params.height || this.height / this.width * params.width;
                    canvas.attr({ width: width, height: height });
                    canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function() {
	'use strict';

	angular.module('app.core').directive('download', downloadDirective);

	/** @ngInject */
	/* Valida si el archivo existe antes de descargarlo */
	function downloadDirective($timeout, $q, $interpolate, api, UsersService) {

		return function(scope, element, attrs) {
			var clickingCallback = function() {

				api.utils.fileExists.get({
					module : attrs.downloadModule,
					file_id : attrs.downloadFileid,
					file_name : attrs.downloadFilename,
					extras : attrs.downloadExtras
				},
				// Success
				function(response) {
					if(response.status == 1) {
						var authToken = UsersService.getCredentials();
						
						//TODO: No es la mejor manera enviar el Token en la URL. Buscar otra manera para descargar el archivo enviando el Token
						window.open(api.baseUrl + "utils/downloadFile/"+attrs.downloadModule+"/"+attrs.downloadFileid+"/"+attrs.downloadFilename+"/"+attrs.downloadExtras+"?X-Auth-Token="+authToken, "_self");	
					} else {
						if(response.status == -1) {
							alert('No tiene permisos para descargar este archivo');
						} else {
							alert('El archivo solicitado no se encuentra disponible');
						}
					}
					//Descargar archivo
				},
				// Error
				function(response) {
					//deferred.reject( response.error ); TODO
					console.error('error');
				});

			};
			element.bind('click', clickingCallback);
		};

	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('currentPasswordCheck', currentPasswordCheck);

    /** @ngInject */
    function currentPasswordCheck(api)
    {
		  return {
			require: 'ngModel',
		    link: function(scope, elem, attrs, ctrl) {

	            elem.on('blur', function (evt) {
	                scope.$apply(function () {
	                	
	                	api.users.currentPasswordCheck.save({'password': elem.val()},	         
	                       // Success
	                       function (response)
	                       {
	                           ctrl.$setValidity('currentPasswordCheck', response.status);
	                       },	         
	                       // Error
	                       function (response)
	                       {
								ctrl.$setValidity('currentPasswordCheck', false);
	                           	console.error(response);
	                       }
	                   );
	                });
	            });
		    }
		  }; 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('compare', compareDirective);

    /** @ngInject */
    function compareDirective()
    {
	    return {
	        require: "ngModel",
	        scope: {
	            otherModelValue: "=compare"
	        },
	        link: function(scope, element, attributes, ngModel) {
	             
	            ngModel.$validators.compare = function(modelValue) {
	                return modelValue == scope.otherModelValue;
	            };
	 
	            scope.$watch("otherModelValue", function() {
	                ngModel.$validate();
	            });
	        }
	    };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, UsersService, NotificationService, evaluationService,$mdDialog,$document) {
        var vm = this;

        //Contiene los indicadores de las notificaciones
        vm.tabIndicators = NotificationService.getNotificationIndicators();

        // Data

        $rootScope.global = {
            search: ''
        };

        if($rootScope.licenseData.user_manual_code){
            vm.user_manual_code = $rootScope.licenseData.user_manual_code ? $rootScope.licenseData.user_manual_code.administrador : null;
        }
        vm.userInfo = UsersService.getUserInfo();
        vm.bodyEl = angular.element('body');

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.searchResultClick = searchResultClick;
        vm.openChangePasswordDialog = openChangePasswordDialog;
        vm.goManualUser = goManualUser;
        vm.openDocumentsDialog = openDocumentsDialog;
        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Get the selected language directly from angular-translate module setting
            //vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            $translate.use('es');
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            UsersService.logout();
            $state.go('app.users_login');
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                }
                else {
                    $state.go(item.state);
                }
            }
        }

        function openChangePasswordDialog(ev) {
            $mdDialog.show({
                controller: 'ChangePasswordController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/users/dialogs/change-password/change-password.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev,
                }
            });
        }

        function goManualUser(){
            var url = "http://usermanual.ikanosmart.com/manual/"+vm.user_manual_code;
            var a = document.createElement('a');
            a.style = "display: none";
            a.href = url;
            a.target = '_blank';
            a.click();
        }

        function openDocumentsDialog(ev){
            $mdDialog.show({
                controller: 'DocumentsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/misc/dialog/documents/documents-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController($state, NotificationService, $mdSidenav)
    {
        var vm = this;

        // Data
   
   /*
		NotificationService.getUserNotifications(1).then(function(data) {
			vm.notifications = data;
			
			//Contar el número de notificaciones no leidas por el usuario
			var numNotificationsUnread = 0;
			angular.forEach(vm.notifications, function(e) {
				if(e.ModuleNotification.status == 0) {
					numNotificationsUnread = numNotificationsUnread*1 + 1;
				}
			});
			NotificationService.setIndicator('notifications', numNotificationsUnread);
			
		}).catch(function(err) {
			// TODO
		});
		*/
		
		//Methods	
		vm.gotoNotification = gotoNotification;
		vm.toggleSidenav = toggleSidenav;
		
		function gotoNotification(notification) {
			
			var notification_id = notification.ModuleNotification.id;
			
			//Marcar notificaciones como leida
			NotificationService.markAsRead(notification_id).then(function(data) {
				
				if(data) {
					//Marcar notificaciones como leida localmente
					notification.ModuleNotification.status = 1;
					
					//Actualizar el valor del indicador
					NotificationService.setIndicator('notifications', -1);					
				}
				
							
			}).catch(function(err) {
				// TODO
			});

			//Ir a la página a la que hace referencia la notificación			
			if(notification.ModuleNotification.link) {
				var link = JSON.parse(notification.ModuleNotification.link);
				toggleSidenav('quick-panel');
				$state.go(link.state, link.params);
			}

		}   

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }		    

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('NotificationService', NotificationService);

    /** @ngInject */
    function NotificationService($q, api)
    {
		var notifications;
		var indicators = {};
		
        var service = {
            getNotificationIndicators: getNotificationIndicators,
            getUserNotifications: getUserNotifications,
            markAsRead: markAsRead,
            setIndicator: setIndicator
        };

        return service;

        //////////
        function getNotificationIndicators()
        {
        	return indicators;
        }
        
        function getUserNotifications(page) {
          
			var deferred = $q.defer();

			api.notifications.getUserNotifications.get({page: page},
			// Success
			function(response) {
				if(response.notifications) {
					notifications = response.notifications;	
				} else {
					notifications = [];
				}
				
				deferred.resolve(notifications);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;        	
        }
        
        function markAsRead(notification_id) {
			var deferred = $q.defer();

			api.notifications.markAsRead.save({notification_id: notification_id},
			// Success
			function(response) {
				deferred.resolve(response.response_data);
			},
			// Error
			function(response) {
				//deferred.reject( response.error ); TODO
				console.error(response);
			});

			return deferred.promise;          	
        }
        
        function setIndicator(indicator_id, value)
        {
        	if(value == -1)
        	{
        		// Resta 1 al valor actual
				indicators[indicator_id] = indicators[indicator_id] - 1;        		
        	} else {
				indicators[indicator_id] = value;	        		
        	}        	
        }
  
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $rootScope,UsersService)
    {
        var vm = this;
        vm.license = {};

        setTimeout(function(){
            vm.license = $rootScope.licenseData.license; 
        },1000);

        

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
	'use strict';

	angular.module('app.core').factory('UtilsService', UtilsService);
	angular.module('app.core').factory('debounce', debounce);

	/** @ngInject */
	function UtilsService($q, api, $http, $location, $mdToast) {
		var service = {
			arrToObjectKey: arrToObjectKey,
			deleteFile: deleteFile,
			generateExcel: generateExcel,
			getArrayNumbers: getArrayNumbers,
			getLanguajeDataTable: getLanguajeDataTable,
			getDataTableOptions: getDataTableOptions,
			sendExcel: sendExcel,
			showToast: showToast,
			trackPage: trackPage,
			getChartHistory: getChartHistory
		};

		return service;

		//////////

		function arrToObjectKey(arr, key) {
			//Modificar el array de goal_types para poner el tipo de objetivo como llave del array
			var new_object = {};
			angular.forEach(arr, function (e) {
				new_object[e[key]] = e;
			});

			return new_object;
		}

		function deleteFile(module, file_id, extras) {

			var deferred = $q.defer();

			api.utils.deleteFile.save({
				module: module,
				extras: extras,
				file_id: file_id
			},
				// Success
				function (response) {
					deferred.resolve(response.status);
				},
				// Error
				function (response) {
					//deferred.reject( response.error ); TODO
					console.error(response);
				});

			return deferred.promise;
		}

		function generateExcel(filename, excel_data) {
			var deferred = $q.defer();

			//Convertir a una cadena de texto
			var j = JSON.stringify(excel_data);

			//Crear un formulario				
			var formData = new FormData();
			//Adjuntar la cadena de texto como documento
			formData.append("_attachments", new Blob([j], { type: 'text/plain' }));

			var xhr = new XMLHttpRequest();
			var url = api.utils.generateExcelFile + filename + '.json';
			xhr.open('POST', url, true);
			//xhr.setRequestHeader('X-Auth-Token', UsersService.getCredentials());

			xhr.onreadystatechange = function () {
				if (xhr.readyState == XMLHttpRequest.DONE) {
					var response = JSON.parse(this.responseText);
					deferred.resolve(response.file_url);
				}
			};

			//Enviar la respuesta
			xhr.send(formData);

			return deferred.promise;
		}

		function getArrayNumbers(from, to) {
			var items = [];
			for (var i = from; i < to * 1 + 1; i++) {
				items.push(i);
			}

			return items;
		}

		function getLanguajeDataTable() {
			return {
				"sEmptyTable": "No se encontraron resultados",
				"sInfo": "Mostrando _START_ de _END_ hasta _TOTAL_ entradas",
				"sInfoEmpty": "Mostrando 0 de 0 de 0 entradas",
				"sInfoFiltered": "(filtered from _MAX_ total entries)",
				"sInfoPostFix": "",
				"sInfoThousands": ",",
				"sLengthMenu": "Mostrar _MENU_ entradas",
				"sLoadingRecords": "Cargando...",
				"sProcessing": "Procesando...",
				"sSearch": "Buscar:",
				"sZeroRecords": "No se encontraron resultados con esa búsqueda",
				"oPaginate": {
					"sFirst": "Primera",
					"sLast": "Última",
					"sNext": "Siguiente",
					"sPrevious": "Anterior"
				},
				"oAria": {
					"sSortAscending": ": activate to sort column ascending",
					"sSortDescending": ": activate to sort column descending"
				}
			};
		}

		function getDataTableOptions(optionsType) {

			if (optionsType == 'no-paginate') {
				var options = {
					dom: '<"top"f>rt',
					paging: false,
					autoWidth: false,
					responsive: true,
					language: getLanguajeDataTable(),
					order: []
				};

			} else {

				var options = {
					dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
					pagingType: 'simple',
					autoWidth: false,
					language: getLanguajeDataTable(),
					responsive: true
				};
			}


			return options;

		}

		function sendExcel(to, template, filename, excel_data) {
			var deferred = $q.defer();

			//Convertir a una cadena de texto
			var j = JSON.stringify(excel_data);

			//Crear un formulario				
			var formData = new FormData();
			//Adjuntar la cadena de texto como documento
			formData.append("_attachments", new Blob([j], { type: 'text/plain' }));

			var xhr = new XMLHttpRequest();
			var url = api.utils.sendEmailFile + to + '/' + template + '/' + filename + '.json';
			xhr.open('POST', url, true);
			//xhr.setRequestHeader('X-Auth-Token', UsersService.getCredentials());

			xhr.onreadystatechange = function () {
				if (xhr.readyState == XMLHttpRequest.DONE) {
					var response = JSON.parse(this.responseText);
					deferred.resolve(response.file_url);
				}
			};

			//Enviar la respuesta
			xhr.send(formData);


			/*
							api.utils.sendEmailFile.save({
								to : to,
								template : template,
								filename : filename,
								excel_data : excel_data
							},
							// Success
							function(response) {
								deferred.resolve(response.file_url);
							},
							// Error
							function(response) {
								//deferred.reject( response.error ); TODO
								console.error(response);
							});
			*/
			return deferred.promise;
		}

		function showToast(msg, isError) {

			var toastClass = isError ? "toast-error" : "";

			$mdToast.show({
				template: '<md-toast class="' + toastClass + '">' + msg + '</md-toast>',
				hideDelay: 5000,
				position: 'top right'
			});
		}

		function trackPage() {
			return;
			//Analytics.trackPage($location.path());
		}

		function getChartHistory(data) {
			var objReturn = {};

			objReturn.graph1 = getGraph1(data);
			objReturn.graph2 = getGraph2(data);
			objReturn.graph3 = getGraph3(data);
			return objReturn;
		}

		/**
		 * Generador de Graficos de historia de evaluacion
		 */
		function getColorsGrafic() {
			var data = JSON.parse(window.localStorage.getItem('IKANO_RH_LICENSE_DATA'));
			var arrReturn = []

			if (data.color.grafic) {
				var arrColors = JSON.parse(data.color.grafic);
				for (var i in arrColors) {
					arrReturn.push(arrColors[i].replace('"', ''));
				}
			}
			return arrReturn;
		}

		function getGraph1(data) {
			var categories = [];
			var series = [];
			var dataSeries = [];
			var color = getColorsGrafic();
			for (var i in data.evaluation_hr_modules) {
				var evaluation = data.evaluation_hr_modules[i];
				if (evaluation.hr_module.has_evaluation) {

					dataSeries.push(parseFloat(evaluation.final_evaluation));
					categories.push(evaluation.hr_module.name);

				}
			}
			categories.push('Resultado evaluación');
			dataSeries.push(parseFloat(data.ev_final));
			series.push({ name: 'Valor', data: dataSeries });
			return {
				colors: color,
				chart: {
					type: 'bar',
					height: '400',
					width: '400'
				},
				title: {
					text: 'Evaluación de desempeño'
				},
				xAxis: {
					categories: categories
				},
				yAxis: {
					min: 0,
					title: {
						text: ""
					}
				},
				legend: {
					reversed: true
				},
				plotOptions: {
					series: {
						stacking: 'normal'
					}
				},
				/*series: [{
					name: 'John',
					data: [5, 3, 4, 7, 2]
				}, {
					name: 'Jane',
					data: [2, 2, 3, 2, 1]
				}, {
					name: 'Joe',
					data: [3, 4, 4, 2, 5]
				}]*/
				series: series
			};
		}

		function getGraph2(data) {
			var categories = [];
			var series = [];
			var dataSeries = [];
			var color = getColorsGrafic();
			for (var i in data.evaluation_history) {
				var evaluation = data.evaluation_history[i];
				dataSeries.push(parseFloat(evaluation.ev_final));
				categories.push(evaluation.periodo.name);
			}


			series.push({ name: 'Valor', data: dataSeries });
			return {
				colors: color,
				chart: {
					type: 'line',
					height: '400',
					width: '400'
				},
				title: {
					text: 'Evaluación de desempeño'
				},
				xAxis: {
					categories: categories
				},
				yAxis: {
					min: 0,
					max: 100,
					title: {
						text: ''
					}
				},
				plotOptions: {
					line: {
						dataLabels: {
							enabled: true
						},
						enableMouseTracking: false
					}
				},
				series: series
			};
		}

		function getGraph3(data) {
			var categories = [];
			var series = [];
			var auxModules = {};
			var color = getColorsGrafic();
			for (var i in data.evaluation_history) {
				var history = data.evaluation_history[i];
				categories.push(history.periodo.name);
				for (var h in history.evaluation_hr_modules) {
					var history_modules = history.evaluation_hr_modules[h];
					if (history_modules.hr_module.has_evaluation) {
						if (auxModules[history_modules.hr_module.name]) {
							var index = auxModules[history_modules.hr_module.name];
							series[index - 1].data.push(parseFloat(history_modules.final_evaluation));
						} else {
							var dataInsert = { name: history_modules.hr_module.name, data: [] };
							dataInsert.data.push(parseFloat(history_modules.final_evaluation));
							series.push(dataInsert);
							auxModules[history_modules.hr_module.name] = series.length;
						}
					}
				}
			}

			return {
				colors: color,
				chart: {
					type: 'column',
					height: '400',
					width: '400'
				},
				title: {
					text: ''
				},
				subtitle: {
					text: ''
				},
				xAxis: {
					categories: categories,
					crosshair: true
				},
				yAxis: {
					min: 0,
					title: {
						text: ''
					}
				},
				tooltip: {
					headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
					pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
						'<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
					footerFormat: '</table>',
					shared: true,
					useHTML: true
				},
				plotOptions: {
					column: {
						pointPadding: 0.2,
						borderWidth: 0
					}
				},
				series: series
			};
		}

	}

	function debounce($timeout, $q) {
		// The service is actually this function, which we call with the func
		// that should be debounced and how long to wait in between calls
		return function debounce(func, wait, immediate) {
			var timeout;
			// Create a deferred object that will be resolved when we need to
			// actually call the func
			var deferred = $q.defer();
			return function () {
				var context = this, args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) {
						deferred.resolve(func.apply(context, args));
						deferred = $q.defer();
					}
				};
				var callNow = immediate && !timeout;
				if (timeout) {
					$timeout.cancel(timeout);
				}
				timeout = $timeout(later, wait);
				if (callNow) {
					deferred.resolve(func.apply(context, args));
					deferred = $q.defer();
				}
				return deferred.promise;
			};
		};
	}


}()); 
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, msNavigationService, AppConfigService, PageService, UsersService)
    {
        // Data
        //////////    
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

		PageService.menu_loaded = false;
		// Data
		if(!PageService.menu_loaded && UsersService.isLogged()) {


      var weightOrder = 1;

      msNavigationService.saveItem('menu_divider_1', {
        title : "Evaluación de desempeño",
        group : true,
        weight : weightOrder
      });
      weightOrder = weightOrder + 1;

      msNavigationService.saveItem('page_1', {
        title : 'Evaluaciones',
        icon  : 'icon-clipboard-check',
        state : 'app.cstm_evaluation',
        weight : weightOrder
      });

      weightOrder = weightOrder + 1;

      msNavigationService.saveItem('page_2', {
        title : 'Evaluación operativa',
        icon  : 'icon-clipboard-check',
        state : 'app.cstm_evaluation_rio',
        weight : weightOrder
      });
      weightOrder = weightOrder + 1;

      msNavigationService.saveItem('menu_divider_2', {
        title : "Estructura organizacional",
        group : true,
        weight : weightOrder
      });
      weightOrder = weightOrder + 1;

      msNavigationService.saveItem('page_3', {
        title : 'Colaboradores',
        icon  : 'icon-account',
        state : 'app.organization_employees',
        weight : weightOrder
      });
      weightOrder = weightOrder + 1;

      msNavigationService.saveItem('page_4', {
        title : 'Estructura',
        icon  : 'icon-sitemap',
        state : 'app.cstm_organization',
        weight : weightOrder
      });
      weightOrder = weightOrder + 1;


      msNavigationService.saveItem('menu_divider_3', {
        title : "Reportes",
        group : true,
        weight : weightOrder
      });
      weightOrder = weightOrder + 1;

      msNavigationService.saveItem('page_5', {
        title : 'Evaluación de desempeño',
        icon  : 'icon-account',
        state : 'app.reports',
        weight : weightOrder
      });
      weightOrder = weightOrder + 1;
      

			//Crear el menu principal de la aplicación
      /*
			PageService.getMainLayout().then(function(data) {				
				var menu = data.main_menu;
				//AppConfigService.saveMenu(menu);
				
				//Limpiar el menú de navegación
				msNavigationService.clearNavigation();
				
				var weightOrder = 1;

        msNavigationService.saveItem('page_1', {
          title : 'Evaluaciones',
          icon  : '',
          state : 'app.cstm_evaluation',
          weight : weightOrder
        });
        weightOrder = weightOrder + 1;

				// Crear el menú de las secciones de contenido
				angular.forEach(data.main_menu, function(item) {
					
					if(item.Page.module == "menu_divider") {
						
						// Navigation
						msNavigationService.saveItem('menu_divider' + item.Page.id, {
							title : item.Page.menu_name,
							group : true,
							weight : weightOrder
						});
										
					} else {
						
						if(item.notifications_count) {
							msNavigationService.saveItem('page_' + item.Page.id, {
								title : item.Page.menu_name,
								icon  : item.Page.menu_icon,
								state : 'app.' + item.Page.module,
								weight : weightOrder,
					            badge : {
					                content: item.notifications_count,
					                color  : item.notifications_color
					            },								
								stateParams : {
									'page_url' : item.Page.friendly_url
								}
							});
							
						} else {
							msNavigationService.saveItem('page_' + item.Page.id, {
								title : item.Page.menu_name,
								icon  : item.Page.menu_icon,
								state : 'app.' + item.Page.module,
								weight : weightOrder,
								stateParams : {
									'page_url' : item.Page.friendly_url
								}
							});
							
						}
						
					}
					weightOrder = weightOrder + 1;
					
				});	
				
				PageService.menu_loaded = true;
	
			}).catch(function(err) {
				// TODO
			});	
      */			
		}
    }
})();
(function () {
  'use strict';

  angular
    .module('app.users')
    .factory('LicenseService', LicenseService)
    .factory('$debounce', debounce);

  /** @ngInject */
  function LicenseService($q, $http, $location) {
    var licenseInfo; 
    var state;

    var service = {
      getLicense: getLicense,
      getValue: getValue,
      getOrganizacionUploadConfig: getOrganizacionUploadConfig,
      setLicense: setLicense,
      getLicenseJson: getLicenseJson,
      setLocalstorage: setLocalstorage,
      getLocalstorage: getLocalstorage,
      getModuleEnable: getModuleEnable,
      setLastState: setLastState,
      getLastState: getLastState
    };

    return service;

    //////////
    function getLicense() {

      var deferred = $q.defer();

      $http.get("app/data/licenses.json").success(function (LicensesData) {

        var currentDomain = $location.host();

        licenseInfo = LicensesData[currentDomain];

        if (!licenseInfo) {
          deferred.reject('Licencia no encontrada');
        } else {
          deferred.resolve(licenseInfo);
        }
      }).error(function (data) {
        deferred.reject('There was an error');
      });

      return deferred.promise;
    }

    function getOrganizacionUploadConfig() {
      var deferred = $q.defer();

      $http.get("app/data/upload-organization.json").success(function (LicensesData) {

        deferred.resolve(LicensesData);
      }).error(function (data) {
        deferred.reject('There was an error');
      });

      return deferred.promise;
    }

    function getValue(varName) {
      return licenseInfo[varName];
    }

    function getLicenseJson() {
      return licenseInfo;
    }

    function setLicense(info) {
      licenseInfo = info;
    }

    function setLocalstorage(info) {
      localStorage.setItem('IKANO_RH_LICENSE_DATA', JSON.stringify(info));
    }

    function getLocalstorage() {
      var data = localStorage.getItem('IKANO_RH_LICENSE_DATA');

      if (data) {
        var JsonData = JSON.parse(data);
        setLicense(JsonData);
        return JsonData;
      } else {
        return null;
      }

    }

    /**
		 * Get module enable
		 */

    function getModuleEnable(module) {
      var license = this.getLicenseJson();
      var response = false;

      if (license.modules_enabled && license.modules_enabled[module]) {
        response = license.modules_enabled[module];
      }

      return response;
    }

    function setLastState(stateParams){
      state = stateParams;
    }

    function getLastState(){
      return state;
    }

  }

  function debounce($rootScope, $browser, $q, $exceptionHandler) {
		var deferreds = {},
			methods = {},
			uuid = 0;

		function fnDebounce(fn, delay, invokeApply) {
			var deferred = $q.defer(),
				promise = deferred.promise,
				skipApply = (angular.isDefined(invokeApply) && !invokeApply),
				timeoutId, cleanup,
				methodId, bouncing = false;

			// check we dont have this method already registered
			angular.forEach(methods, function (value, key) {
				if (angular.equals(methods[key].fn, fn)) {
					bouncing = true;
					methodId = key;
				}
			});

			// not bouncing, then register new instance
			if (!bouncing) {
				methodId = uuid++;
				methods[methodId] = { fn: fn };
			} else {
				// clear the old timeout
				deferreds[methods[methodId].timeoutId].reject('bounced');
				$browser.defer.cancel(methods[methodId].timeoutId);
			}
			var debounced = function () {
				// actually executing? clean method bank
				delete methods[methodId];

				try {
					deferred.resolve(fn());
				} catch (e) {
					deferred.reject(e);
					$exceptionHandler(e);
				}

				if (!skipApply) $rootScope.$apply();
			};
			timeoutId = $browser.defer(debounced, delay);
			// track id with method
			methods[methodId].timeoutId = timeoutId;
			cleanup = function (reason) {
				delete deferreds[promise.$$timeoutId];
			};
			promise.$$timeoutId = timeoutId;
			deferreds[timeoutId] = deferred;
			promise.then(cleanup, cleanup);
			return promise;
		}
		// similar to angular's $timeout cancel
		fnDebounce.cancel = function (promise) {
			if (promise && promise.$$timeoutId in deferreds) {
				deferreds[promise.$$timeoutId].reject('canceled');
				return $browser.defer.cancel(promise.$$timeoutId);
			}
			return false;
		};

		return fnDebounce;
  }
  
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('AppConfigService', AppConfigService);

    /** @ngInject */
    function AppConfigService($q, api)
    {
    	var MENU_KEY = 'app_vs:menu';
    	
        var service = {
        	getMenu: getMenu,
        	saveMenu: saveMenu
        };
        return service;

        //////////
        
        function getMenu() {
			return JSON.parse(window.localStorage.getItem(MENU_KEY));
        }
                
        function saveMenu(arrMenu) {
			window.localStorage.setItem(MENU_KEY, JSON.stringify(arrMenu));
        }
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $provide)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });


        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);        

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, UsersService, LicenseService, api) {
        /*LicenseService.getLicense().then(function (response) {
            api.setBaseUrl(response.api_baseUrl);
            LicenseService.setLicense(response);
            UsersService.setLicenseToken(response.secret);
        });*/

        var licenseData = LicenseService.getLocalstorage();
        if (licenseData) {
            api.setBaseUrl(licenseData.api_baseUrl);
        }


        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, params) {
            var user = UsersService.getUserInfo();
            $rootScope.loadingProgress = true;
            if (params.requiresAuthentication) {
                if (!UsersService.checkAuth(params)) {
                    event.preventDefault();
                    $state.go('app.users_login');
                }
            }

            var urlAdmin = ['app.cstm_evaluation', 'app.cstm_evaluation_filter', 'app.cstm_evaluation_details', 'app.organization_employees', 'app.cstm_organization_filter', 'app.cstm_organization', 'app.reports'];

            if (urlAdmin.indexOf(params.name) != -1) {
                if(user.group.id == 3){
                    event.preventDefault();
                    $state.go('app.employee_profile');
                }
            }


        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            LicenseService.setLastState(fromState);
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider,$injector, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        //$urlRouterProvider.otherwise('/page/home');
        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);


        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        // Directive for generic chart, pass in chart options
        .directive('hcChart', function () {
            return {
                restrict: 'E',
                template: '<div></div>',
                scope: {
                    options: '='
                },
                link: function (scope, element) {
                    Highcharts.chart(element[0], scope.options);
                }
            };
        })
        // Directive for pie charts, pass in title and data only    
        .directive('hcPieChart', function () {
            return {
                restrict: 'E',
                template: '<div></div>',
                scope: {
                    title: '@',
                    data: '='
                },
                link: function (scope, element) {
                    Highcharts.chart(element[0], {
                        chart: {
                            type: 'pie'
                        },
                        title: {
                            text: scope.title
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                                }
                            }
                        },
                        series: [{
                            data: scope.data
                        }]
                    });
                }
            };
        });
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $location, $rootScope, $window, $cookies, $http, LicenseService) {
        var vm = this;

        //Definir la informacion de la licencia
        //Tema       
        /*LicenseService.getLicense().then(function(licenseData) {
          vm.license = licenseData.license;

          var themeName = vm.license;

          var customTheme = $cookies.getObject('customTheme');

          if(!customTheme || !angular.equals(customTheme, licenseData.theme)) {
            $cookies.putObject('customTheme', licenseData.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();            
          }
          $rootScope.licenseData = licenseData;
        }, function(err) {
        });*/
        function init() {
            var licenseData = LicenseService.getLicenseJson();
            if (licenseData) {
                vm.license = licenseData.license;

                var customTheme = $cookies.getObject('customTheme');

                if (!customTheme || !angular.equals(customTheme, licenseData.theme)) {
                    $cookies.putObject('customTheme', licenseData.theme);
                    $cookies.put('selectedTheme', 'custom');
                    $window.location.reload();
                }
                $rootScope.licenseData = licenseData;
            } else {
                setTimeout(init, 1000);
            }
        }


        // Data
        vm.themes = fuseTheming.themes;
        //////////        
        init();
    }
})();  
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.config(config);

	/** @ngInject */
	function config($translateProvider, $httpProvider,$mdIconProvider) {
		// Put your common app configurations here
		$httpProvider.interceptors.push(validateToken);
		//$httpProvider.xsrfWhitelistedOrigins.push('http://rio.ikanorh.loc:3001');


		// angular-translate configuration
		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: '{part}/i18n/{lang}.json'
		});
		//$translateProvider.preferredLanguage('en');
		$translateProvider.preferredLanguage('es');
		$translateProvider.useSanitizeValueStrategy('sanitize');
		/*$mdIconProvider
      	.iconSet('arrow_drop_down', 'assets/icons/arrow_drop_down.svg', 24)
      	.defaultIconSet('assets/icons/arrow_drop_down.svg', 24);*/
	}

	function validateToken($location, $injector, $q, $rootScope) {

		return {
			request: function (config) {
				var jwt = localStorage.getItem('IKANO_RH_JWT');
				var license = localStorage.getItem('IKANO_RH_LICENSE');
				if (jwt != null && jwt != '') {
					config.headers['X-Auth-Token'] = jwt;
				}

				if (license != null && license != ''){
					config.headers['X-License-Key'] = license;
				}

				//Afecta solamente los que van al api
				if (config.url.indexOf('html') == -1 && config.url.indexOf('http') == -1 && config.url.indexOf('https') == -1 && config.url.indexOf('json') == -1) {
					var urlBase = $injector.get('api').baseUrl;
					config.url = urlBase + config.url;
				}

				return config || $q.when(config);
			},

			requestError: function (config) {
				return config;
			},

			response: function (response) {
				return response || $q.when(response);
			},

			responseError: function (response) {
				//token error
				if (response.status == 401) {
					$injector.get('$state').transitionTo('app.users_login');
				}

				return $q.reject(response);
			}
		};
	}

})();
(function () {
        'use strict';

        angular
                .module('fuse')
                .factory('api', apiService);

        /** @ngInject */
        function apiService($resource, $rootScope, LicenseService, $http,$q) {

                var api = {};

                api.baseUrl = "";

                //LicenseService.getLicense().then(function(licenseData) {

                //$rootScope.licenseData = licenseData;

                api.baseUrl = "";
                //api.baseUrl = "http://pruebas-electrojaponesaapi.ikanosmart.com/"
                //api.baseUrl = "http://pruebas-ikanorhapi.ikanosmart.com/";
                //api.baseUrl = "http://desarrollo-ikanorhapi.ikanosmart.com/";
                //api.baseUrl = "http://ikanorhapi.ikanosmart.com/";
                //api.baseUrl = "http://demorhapi.ikanosmart.com/";
                //api.baseUrl = "https://ikanorhapi.ikanosmart.com/";
                //api.baseUrl = "http://pruebas-pallomarods-api.ikanosmart.com/";

                //api.baseUrl = licenseData.api_baseUrl;

                api.content = {
                        main_layout: $resource(api.baseUrl + 'page/getMainLayout.json'),
                        page_layout: $resource(api.baseUrl + 'page/getPageLayout/:page_url/:item_id.json', { page_url: '@page_url', item_id: '@item_id' })
                };


                api.users = {
                        currentPasswordCheck: $resource(api.baseUrl + 'module_users/currentPasswordCheck.json', { password: '@password' }),
                        changePassword: $resource(api.baseUrl + 'users/password/change'),
                        login: $resource(api.baseUrl + 'users/login'),
                        firebaseLogin: $resource(api.baseUrl + 'module_users/firebaseLogin.json'),
                        resetPassword: $resource(api.baseUrl + 'users/password/recovery'),
                        sendResetLink: $resource(api.baseUrl + 'users/password/forgot'),
                        uploadProfilePicture: $resource(api.baseUrl + 'module_users/uploadProfilePicture.json')
                };

                api.utils = {
                        deleteFile: $resource(api.baseUrl + 'utils/deleteFile/:module/:extras.json', { module: '@module', file_id: '@file_id', extras: '@extras' }),
                        downloadFile: $resource(api.baseUrl + 'utils/downloadFile/:module/:file_id/:file_name/:extras', { module: '@module', file_id: '@file_id', file_name: '@file_name', extras: '@extras' }),
                        fileExists: $resource(api.baseUrl + 'utils/fileExists/:module/:file_id/:file_name/:extras.json', { module: '@module', file_id: '@file_id', file_name: '@file_name', extras: '@extras' }),
                        generateExcelFile: api.baseUrl + 'utils/generateExcelFile/',
                        sendEmail: $resource(api.baseUrl + 'utils/sendEmail/:module/:extras.json', { module: '@module', message: '@message', extras: '@extras' }),
                        sendEmailFile: api.baseUrl + 'utils/sendEmailFile/',
                        uploadFile: api.baseUrl + 'utils/uploadFile/',
                };
                api.notifications = {
                        getUserNotifications: $resource(api.baseUrl + 'module_notifications/getUserNotifications/:page.json', { page: '@page' }),
                        markAsRead: $resource(api.baseUrl + 'module_notifications/markNotificationAsRead.json', { notification_id: '@notification_id' })
                };


                /** Administrador **/
                api.admin = {};

                api.admin.page = {
                        edit: $resource(api.baseUrl + 'page/adm_edit/:item_id.json', { item_id: '@item_id', item_data: '@item_data', 'item_order': '@item_order' }),
                        delete: $resource(api.baseUrl + 'page/adm_delete.json', { item_id: '@item_id' }),
                        getList: $resource(api.baseUrl + 'page/adm_list.json'),
                        new: $resource(api.baseUrl + 'page/adm_new.json', { item_data: '@item_data', 'item_order': '@item_order' }),
                };

                api.admin.user = {
                        editUser: $resource(api.baseUrl + 'module_users/adm_editUser.json', { user_id: '@user_id', user_data: '@user_data' }),
                        deleteUser: $resource(api.baseUrl + 'module_users/adm_deleteUser.json', { user_id: '@user_id' }),
                        getUsers: $resource(api.baseUrl + 'module_users/adm_getUsers.json'),
                        getUserProfiles: $resource(api.baseUrl + 'module_users/adm_getUserProfiles.json'),
                        newUser: $resource(api.baseUrl + 'module_users/adm_newUser.json', { user_data: '@user_data' })
                };

                /** Custom **/
                api.evaluations = {
                        activateNewProcess: $resource(api.baseUrl + 'evaluation/admin/activateNewProcess/:period_id', { period_id: '@period_id' }),
                        assignCorporateGoals: $resource(api.baseUrl + 'evaluation/admin/assignCorporateGoals/:period_id', { period_id: '@period_id' }),
                        changeMatStructureInfo: $resource(api.baseUrl + 'evaluation/admin/changeMatStructureInfo/:employee_process_id', { employee_process_id: '@employee_process_id' }),
                        changeProcessStage: $resource(api.baseUrl + 'evaluation/admin/changeStage/:employee_process_id', { employee_process_id: '@employee_process_id' }),
                        createCompanyGoal: $resource(api.baseUrl + 'evaluation/admin/createCompanyGoal'),
                        deleteCompanyGoal: $resource(api.baseUrl + 'evaluation/admin/deleteCompanyGoal'),
                        deleteEvaluation: $resource(api.baseUrl + 'evaluation/admin/deleteEvaluation'),
                        enrollEmployee: $resource(api.baseUrl + 'evaluation/admin/enrollEmployee/:period_id', { period_id: '@period_id' }),
                        activeMassiveProcess: $resource(api.baseUrl + 'evaluation/admin/activateNewMassiveProcess/:period_id', { period_id: '@period_id' }),
                        activeNewMassiveProcess: $resource(api.baseUrl + 'evaluation/admin/activeNewMassiveProcess'),
                        finalizeEvaluationProcess: $resource(api.baseUrl + 'evaluation/finalize_process'),
                        getActiveProcessesInfo: $resource(api.baseUrl + 'evaluation/admin/getActiveProcessesInfo/:period_id', { period_id: '@period_id' }),
                        getDataToEnrollEmployee: $resource(api.baseUrl + 'evaluation/admin/getDataToEnrollEmployee/:period_id', { period_id: '@period_id' }),
                        getEvaluations: $resource(api.baseUrl + 'evaluation/admin/employee_processes/:period_id', { period_id: '@period_id' }),
                        getEmployeeWorkTeam: $resource(api.baseUrl + 'evaluation/employee/:employee_id/work_team', { employee_id: '@employee_id' }),
                        getEmployeeProfile: $resource(api.baseUrl + 'evaluation/employee/:employee_id/profile', { employee_id: '@employee_id' }),
                        getEmployeeProcessData: $resource(api.baseUrl + 'evaluation/:employee_process_id/active_process_data', { employee_process_id: '@employee_process_id' }),
                        getGoalsToAssign: $resource(api.baseUrl + 'evaluation/admin/getGoalsToAssign/:period_id', { period_id: '@period_id' }),
                        getPendingActivities: $resource(api.baseUrl + 'evaluation/employee/pending_activities'),
                        /*getEvaluationData: $resource(api.baseUrl + 'evaluation/admin/getEvaluationData/:employee_process_id', {employee_process_id: '@employee_process_id'}),*/
                        getEvaluationData: $resource(api.baseUrl + 'evaluation/:employee_process_id/employee/:periodo_id', { employee_process_id: '@employee_process_id' }),
                        getEvaluationDetails: $resource(api.baseUrl + 'evaluation/admin/evaluationDetails/:employee_process_id', { employee_process_id: '@employee_process_id' }),
                        getEvaluationGoals: $resource(api.baseUrl + 'evaluation/admin/evaluationGoals', { period_id: '@period_id' }),
                        getPeriods: $resource(api.baseUrl + 'evaluation/admin/getPeriods'),
                        getProcessSummary: $resource(api.baseUrl + 'evaluation/:employee_process_id/process_summary', { employee_process_id: '@employee_process_id' }),
                        saveProcessData: $resource(api.baseUrl + 'evaluation/save_process_data'),
                        setActiveProcessDeadline: $resource(api.baseUrl + 'evaluation/admin/setActiveProcessDeadline/:period_id', { period_id: '@period_id' }),
                        updateCompanyGoal: $resource(api.baseUrl + 'evaluation/admin/updateCompanyGoal/:goal_id', { goal_id: '@goal_id' }),
                        add_hr_module: $resource(api.baseUrl + 'evaluation/admin/add_hr_module'),
                        remove_hr_module: $resource(api.baseUrl + 'evaluation/admin/remove_hr_module'),
                        getIndexEdo: $resource(api.baseUrl + 'evaluation/edo'),
                        edoTopics: $resource(api.baseUrl + 'evaluation/edo/topics'),
                        updateTopics: $resource(api.baseUrl + 'evaluation/edo/topics/:id', { id: '@id' },{'update': { method:'PUT' }}),
                        edoQuestions: $resource(api.baseUrl + 'evaluation/edo/questions'),
                        updateQuestion: $resource(api.baseUrl + 'evaluation/edo/questions/:id',{ id: '@id' },{'update': { method:'PUT' }}),
                        edoQuestionnaire: $resource(api.baseUrl + 'evaluation/edo/questionnaires'),
                        updateQuestionnaire: $resource(api.baseUrl + '/evaluation/edo/questionnaires/:id',{ id: '@id' },{'update': { method:'PUT' }}),
                        summary_results: $resource(api.baseUrl + 'evaluation/summary_results'),
                        add_skill_evaluator: $resource(api.baseUrl + 'evaluation/admin/add_skill_evaluator'),
                        remove_skill_evaluator: $resource(api.baseUrl + 'evaluation/admin/remove_skill_evaluator'),
                        update_employees_relations: $resource(api.baseUrl + 'evaluation/admin/update_employees_relations'),
                        start_edo_evaluation: $resource(api.baseUrl + 'evaluation/hr_function/HrEDO/start_evaluation')
                };

                api.skills = {
                        getSkillsProfiles: $resource(api.baseUrl + 'skills/admin/profiles/:period_id', { period_id: '@period_id' }),
                }

                api.organization = {
                        activateEmployee: $resource(api.baseUrl + 'organization/admin/activateEmployee'),
                        addArea: $resource(api.baseUrl + 'organization/addArea'),
                        addDepartment: $resource(api.baseUrl + 'organization/addDepartment'),
                        addPosition: $resource(api.baseUrl + 'organization/addPosition'),
                        addEmployee: $resource(api.baseUrl + 'organization/addEmployee'),
                        getOrganizationStructure: $resource(api.baseUrl + 'organization/organizational_structure', { period_id: '@period_id' }),
                        getOrganizationEmployees: $resource(api.baseUrl + 'organization/structure_employees'),
                        getInactiveEmployees: $resource(api.baseUrl + 'organization/admin/getInactiveEmployees'),
                        getOrganizationChart: $resource(api.baseUrl + 'organization/admin/getOrganizationChart'),
                        removeEmployee: $resource(api.baseUrl + 'organization/removeEmployee/:employee_id', { employee_id: '@employee_id' }),
                        updateArea: $resource(api.baseUrl + 'organization/updateArea/:id', { id: '@id' }),
                        updateDepartment: $resource(api.baseUrl + 'organization/updateDepartment/:id', { id: '@id' }),
                        updateEmployee: $resource(api.baseUrl + 'organization/updateEmployee/:employee_id', { employee_id: '@employee_id' }),
                        resetPassword: $resource(api.baseUrl + 'organization/updateEmployee/reset_password'),
                        updatePosition: $resource(api.baseUrl + 'organization/updatePosition/:id', { id: '@id' }),
                        importData: $resource(api.baseUrl + 'organization/:id', { id: '@id' }),
                        getPositionDetail: $resource(api.baseUrl + '/organization/position/:id/details', { id: '@id' }, { update: { method: 'PUT' } }),
                        publishPositionDetail: $resource(api.baseUrl + '/organization/position/:id/publish_details', { id: '@id' }, { update: { method: 'PUT' } }),
                        importFile: function (id, data) {
                                return $http({
                                        method: 'POST',
                                        url: api.baseUrl + 'organization/' + id,
                                        data: data,
                                        transformRequest: angular.identity,
                                        headers: { 'Content-Type': undefined }
                                })
                        }
                };

                api.reports = {
                        getReport: $resource(api.baseUrl + 'report/getReport', { report_name_id: '@report_name_id', type_report: '@type_report' }),
                        getReportList: $resource(api.baseUrl + 'report/getReportsList')

                }

                api.misc = {
                        sendMessages: $resource(api.baseUrl + 'misc/messages/complete'),
                        documents: $resource(api.baseUrl + 'misc/documents/:id', { id: '@id' }),
                        get_lists: $resource(api.baseUrl + 'misc/lists/get_lists')
                }

                api.general = {
                        getWindowHttp: function (method, endpoint, params, nameFile) {
                                var deferred = $q.defer();
                                var data = {};
                                if (typeof params == "undefined") {
                                        params = {};
                                } else if (method.toUpperCase() == "POST") {
                                        data = params;
                                        params = {};
                                }
                                $http({
                                        method: method,
                                        url: api.baseUrl + endpoint,
                                        responseType: 'arraybuffer',
                                        data: data,
                                        headers: {
                                                'Cache-Control': 'no-cache',
                                                'Pragma': 'no-cache'
                                        },
                                        params: params
                                }).success(function (data, status, headers) {
                                        

                                        var contentDisposition = headers('Content-Disposition');
                                        var matches = /filename=([^;]+)/ig.exec(contentDisposition);
                                        var filenameContentDisposition = (matches[1] || 'untitled').trim().replace(/\s/g, '').replace(/"/g,'');

                                        // Opera 8.0+
                                        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

                                        // Firefox 1.0+
                                        var isFirefox = typeof InstallTrigger !== 'undefined';

                                        // Safari 3.0+ "[object HTMLElementConstructor]" 
                                        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

                                        // Internet Explorer 6-11
                                        var isIE = /*@cc_on!@*/false || !!document.documentMode;

                                        // Edge 20+
                                        var isEdge = !isIE && !!window.StyleMedia;

                                        // Chrome 1 - 71
                                        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

                                        // Blink engine detection
                                        var isBlink = (isChrome || isOpera) && !!window.CSS;



                                        if (isFirefox) { //FIREFOX
                                                var a = document.createElement('a');
                                                var filename = nameFile ? nameFile : filenameContentDisposition;
                                                var blob = new Blob([data], { type: headers('Content-Type') });
                                                var url = window.URL.createObjectURL(blob);
                                                a.style = "display: none";
                                                a.href = url;
                                                a.download = filename;
                                                document.body.appendChild(a);
                                                a.click();
                                                setTimeout(function () {
                                                        document.body.removeChild(a);
                                                        window.URL.revokeObjectURL(url);
                                                }, 100);
                                        } else { //OTROS NAVEGADORES
                                                var blob = new Blob([data], {
                                                        type: headers('Content-Type')
                                                });
                                                var objectUrl = URL.createObjectURL(blob);
                                                var anchor = angular.element('<a/>');
                                                var filename = nameFile ? nameFile : filenameContentDisposition;
                                                anchor.attr({
                                                        href: objectUrl,
                                                        target: '_blank',
                                                        download: filename
                                                })[0].click();
                                        }
                                        deferred.resolve();
                                }).error(function (data, status, headers) {
                                        var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
                                        var obj = {};
                                        try {
                                                obj = {
                                                        data: JSON.parse(decodedString),
                                                        status: status
                                                };
                                        }
                                        catch (err) {
                                                obj = { data: decodedString };
                                        }
                                        deferred.reject();
                                });
                                return deferred.promise;
                        },
                        importFile: function (data, url) {
                                return $http({
                                        method: 'POST',
                                        url: api.baseUrl + url,
                                        data: data,
                                        transformRequest: angular.identity,
                                        headers: { 'Content-Type': undefined }
                                })
                        },
                        genericRequest: function (url, method, data) {
                                return $http({
                                        method: method,
                                        url: api.baseUrl + url,
                                        data: data
                                })
                        }
                }
                /** Custom Administrador **/


                //}, function(err) {
                //});

                api.setBaseUrl = function (baseUrl) {
                        api.baseUrl = baseUrl;
                }

                return api;



        }

})();

(function() {
  'use strict';

  angular.module('app.employee', [
        'app.employee.profile'])
  .config(config);
  
  function config() {

  }


})(); 

(function ()
{
    'use strict';

    angular
        .module('app.cstm', [
          'app.cstm.cstm_evaluation',
          'app.cstm.cstm_organization'
          ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span>\nNOTIFICACIONES</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/notifications/notifications.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/employee_main.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/template/not-found.html","<div class=\"pl-15 blue-grey-500-fg h6\">No se encontraron actividades</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/page/page.html","<span ng-include=\"vm.page_template\"></span>");
$templateCache.put("app/main/utils/loading-data.html","<div class=\"m-20 secondary-text\">Cargando información, por favor espere un momento...<md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear></div>");
$templateCache.put("app/core/directives/ik-employee-info/ik-employee-info.html","<div class=\"ik-employee-info mb-5\" layout=\"row\" layout-align=\"start start\" ng-if=\"evaluator\"><div \nclass=\"avatar-wrapper\"><img ng-src=\"{{evaluator.foto}}\" class=\"avatar medium\"></div><div layout=\"column\" \nclass=\"w-100-p\"><div layout=\"row\" class=\"bb p-10\"><div class=\"nombre\">{{evaluator.name}}</div></div><div \nclass=\"text-s text-primary comment-read mt-10\" ng-bind-html=\"comment\"></div></div></div>");
$templateCache.put("app/core/directives/ik-evaluation-summary/ik-evaluation-summary.html","<div class=\"summary-detail\"><div class=\"table-header white-500-bg\"><table class=\"tbl-lbl-data\"><thead><tr><td \nclass=\"background titleTable text-center w-30-p\">Acciones pendientes</td><td class=\"background titleTable text-center\">\nDetalle</td></tr></thead><tbody><tr ng-repeat=\"error in tableError\"><td class=\"w-30-p text-m text-primary\">\n{{error.text}}</td><td class=\"text-primary\">{{error.value}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/core/directives/ik-goal-approval-comments/ik-goal-approval-comments.html","<div class=\"pv-10 ph-15\"><div layout=\"row\" layout-align=\"start start\" flex><md-switch class=\"twp md-secondary\" \nng-change=\"$(\'#txt_goal_comment_{{ data.id }}\').focus()\" ng-model=\"data.aprobado\" aria-label=\"comentarios\" \nng-true-value=\"false\" ng-false-value=\"true\" ng-if=\"allowComment\"><span ng-if=\"data.aprobado == true\">\nSolicitar ajustes a este objetivo</span> <span ng-if=\"data.aprobado == false\">Ajustes solicitados</span></md-switch>\n</div><div flex=\"100\" class=\"mt-20\" ng-if=\"allowComment\"><md-input-container class=\"md-block kj\" \nng-if=\"data.aprobado == false\"><label class=\"twp\">Ajustes a solicitar...</label><textarea \nclass=\"twp comentarios_text_rec\" id=\"txt_goal_comment_{{ data.id }}\" ng-focus=\"true\" ng-model=\"data.rejected_comment\" \nmd-maxlength=\"500\" maxlength=\"500\" max-rows=\"15\" required>                    \n      </textarea></md-input-container>\n</div><div layout=\"row\" layout-align=\"end end\" ng-if=\"config.sendComment && !data.aprobado\"><md-button type=\"submit\" \nng-click=\"fnSave({$event:$event,goal:data})\" class=\"send-button md-accent md-raised\">Enviar</md-button></div><div \nlayout=\"column\" flex=\"100\" ng-if=\"data.comments.length > 0\"><a href=\"#\" \nng-if=\"data.aprobado != false && data.show_goal_approval_comments != true\" class=\"md-accent-fg\" \nng-click=\"data.show_goal_approval_comments = true\">Ver ajustes solicitados anteriormente para este objetivo</a><div \nlayout=\"column\" flex=\"100\" ng-if=\"data.aprobado == false || data.show_goal_approval_comments == true\"><div \nclass=\"mb-15\"><span ng-if=\"!objetivo.objetivo\">Historial de ajustes solicitados</span></div><div layout=\"column\" \nflex=\"100\"><div layout=\"row\" ng-repeat=\"comment in data.comments\" flex=\"100\" class=\"bb pv-5\" \nng-if=\"comentario.estado != 2\"><div class=\"twp\"><div><strong>{{ comment.empleado.name }}</strong><div \nclass=\"secondary-text font-size-14\">{{comment.created_at | fecha}}</div></div><p class=\"text_nl2br\">\n{{ comment.comment }}</p></div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ik-goal-comments-modal/ik-goal-comments-modal.html","<div class=\"pv-10 ph-15\"><div layout=\"row\" layout-align=\"start start\" ng-if=\"data.lastComment && data.lastComment.id\" \nclass=\"mb-10\"><div class=\"badge-status incomplete\"><span>Se solicitaron ajustes</span></div></div><div layout=\"row\" \nlayout-align=\"start start\" flex ng-if=\"allowComment\" class=\"mb-15\"><span class=\"text-m md-accent-fg cursor-pointer\" \nng-click=\"showModal()\"><u ng-if=\"!data.lastComment || !data.lastComment.id\">Solicitar ajustes a este objetivo</u> <u \nng-if=\"data.lastComment && data.lastComment.id\">Modificar ajuste solicitado</u></span></div><div layout=\"column\" \nflex=\"100\" ng-if=\"data.comments.length > 0\"><div layout=\"column\" flex=\"100\"><div class=\"mb-15\"><span \nng-if=\"!objetivo.objetivo\">Historial de ajustes solicitados</span></div><div layout=\"column\" flex=\"100\"><div \nlayout=\"row\" layout-align=\"space-between start\" ng-repeat=\"comment in data.comments\" flex=\"100\" class=\"pv-5\" \nng-class=\"{\'bb\':!$last}\" ng-if=\"comentario.estado != 2\"><div class=\"twp\"><div><strong>{{ comment.empleado.name }}\n</strong><div class=\"secondary-text font-size-14\">{{comment.created_at | fecha}}</div></div><p class=\"text_nl2br\">\n{{ comment.comment }}</p></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"data.lastComment && data.lastComment.id == comment.id && allowComment\"><md-icon \nmd-font-icon=\"icon-trash s21 cursor-pointer\" ng-click=\"deleteComment();\"></md-icon></div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ik-skill-approval-comments/ik-skill-approval-comments.html","<div class=\"pv-10 ph-15\"><div layout=\"row\" layout-align=\"start start\" flex><md-switch class=\"twp md-secondary\" \nng-change=\"$(\'#txt_goal_comment_{{ data.id }}\').focus()\" ng-model=\"data.aprobado\" aria-label=\"comentarios\" \nng-true-value=\"false\" ng-false-value=\"true\" ng-if=\"allowComment\"><span ng-if=\"data.aprobado == true\">\nSolicitar ajustes a la evaluación de competencias</span> <span ng-if=\"data.aprobado == false\">Ajustes solicitados\n</span></md-switch></div><div flex=\"100\" class=\"mt-20\" ng-if=\"allowComment\"><md-input-container class=\"md-block kj\" \nng-if=\"data.aprobado == false\"><label class=\"twp\">Ajustes a solicitar...</label><textarea \nclass=\"twp comentarios_text_rec\" id=\"txt_goal_comment_{{ data.id }}\" ng-focus=\"true\" ng-model=\"data.rejected_comment\" \nmd-maxlength=\"500\" maxlength=\"500\" max-rows=\"15\" required>                    \n            </textarea>\n</md-input-container></div><div layout=\"column\" flex=\"100\" ng-if=\"data.evaluation_hr_module.comments.length > 0\"><a \nhref=\"#\" ng-if=\"data.aprobado != false && data.show_skill_approval_comments.comments != true\" class=\"md-accent-fg\" \nng-click=\"data.show_skill_approval_comments = true\">Ver ajustes solicitados anteriormente para estas competencias</a>\n<div layout=\"column\" flex=\"100\" ng-if=\"data.aprobado == false || data.show_skill_approval_comments == true\"><div \nclass=\"mb-15\"><span ng-if=\"!objetivo.objetivo\">Historial de ajustes solicitados</span></div><div layout=\"column\" \nflex=\"100\"><div layout=\"row\" ng-repeat=\"comment in ::data.evaluation_hr_module.comments\" flex=\"100\" class=\"bb pv-5\" \nng-if=\"comentario.estado != 2\"><div class=\"twp\"><div><strong>{{ comment.empleado.name }}</strong><div \nclass=\"secondary-text font-size-14\">{{comment.created_at | fecha}}</div></div><p class=\"text_nl2br\">\n{{ comment.comment }}</p></div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-loading-bar/ms-loading-bar.html","<div class=\"m-20 secondary-text\">Cargando información, por favor espere un momento...<md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-message/ms-message.html","<div id=\"ms-alert-message\" ng-transclude flex></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation.html","<div id=\"cstm-evaluation\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg ph-20 pt-10\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-check\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Evaluación de desempeño {{vm.evaluationPeriod.name}}</span></div><div layout=\"row\"><div \nclass=\"selected-project\"><span class=\"hacienda-label\">Periodo </span>{{vm.workingPeriod.name}}</div><md-menu \nid=\"projects-menu\" md-offset=\"0 48\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"period in vm.periods\">\n<md-button ng-click=\"vm.setPeriod(period)\" aria-label=\"{{period.name}}\"><span \nng-class=\"{\'secondary-text\': vm.workingPeriod.id == period.id}\">\n{{period.name}} - {{period.estado == true ? \'Abierto\' : \'Cerrado\'}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"vm.tabSelectedIndex\"><md-tab \nlabel=\"Evaluaciones\" md-on-select=\"vm.loadInfo(\'evaluations\')\"><div \nng-include=\"\'app/main/custom_modules/evaluation/partials/_evaluation-list.html\'\"></div></md-tab><md-tab \nlabel=\"Guía de objetivos\" md-on-select=\"vm.loadInfo(\'company_goal_list\')\"><div \nng-include=\"\'app/main/custom_modules/evaluation/partials/_evaluation-goals.html\'\"></div></md-tab><md-tab \nlabel=\"Asignar objetivos\" md-on-select=\"vm.loadInfo(\'goal_assigments\')\"><div \nng-include=\"\'app/main/custom_modules/evaluation/partials/_evaluation-assign-goals.html\'\"></div></md-tab><md-tab \nlabel=\"Perfiles de competencias\" md-on-select=\"vm.loadInfo(\'skills_profiles\')\"><div \nng-include=\"\'app/main/custom_modules/evaluation/partials/_skills-profiles-list.html\'\"></div></md-tab><md-tab \nlabel=\"Procesos\" md-on-select=\"vm.loadInfo(\'processes\')\"><div \nng-include=\"\'app/main/custom_modules/evaluation/partials/_processes-list.html\'\"></div></md-tab></md-tabs></div></div>\n</div>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation_rio.html","<div id=\"cstm-evaluation\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg ph-20 pt-10\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-check\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Evaluación de desempeño {{vm.evaluationPeriod.name}}</span></div><div layout=\"row\"><div \nclass=\"selected-project\"><span class=\"hacienda-label\">Periodo </span>{{vm.workingPeriod.name}}</div><md-menu \nid=\"projects-menu\" md-offset=\"0 48\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"period in vm.periods\">\n<md-button ng-click=\"vm.setPeriod(period)\" aria-label=\"{{period.name}}\"><span \nng-class=\"{\'secondary-text\': vm.workingPeriod.id == period.id}\">\n{{period.name}} - {{period.estado == true ? \'Abierto\' : \'Cerrado\'}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"vm.tabSelectedIndex\"><md-tab \nlabel=\"Evaluaciones\" md-on-select=\"vm.loadInfo(\'evaluations\')\"><div \nng-include=\"\'app/main/custom_modules/evaluation/partials/_evaluation-list.html\'\"></div></md-tab><md-tab \nlabel=\"Cuestionarios\"><div ng-include=\"\'app/main/custom_modules/evaluation/partials/_questionnaires-list.html\'\"></div>\n</md-tab><md-tab label=\"Preguntas\"><div \nng-include=\"\'app/main/custom_modules/evaluation/partials/_questions-list.html\'\"></div></md-tab><md-tab label=\"Temas\">\n<div ng-include=\"\'app/main/custom_modules/evaluation/partials/_topics-list.html\'\"></div></md-tab></md-tabs></div></div>\n</div>");
$templateCache.put("app/main/custom_modules/organization/organization.html","<div id=\"organization\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg ph-20 pt-10\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Estructura organizacional</span></div></div><div class=\"content\"><div \nng-if=\"!vm.isDataLoaded\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><md-tabs md-dynamic-height \nng-if=\"vm.isDataLoaded\" md-selected=\"vm.tabSelectedIndex\"><md-tab label=\"Cargos\" md-on-select=\"vm.tabChanged()\"><div \nng-include=\"\'app/main/custom_modules/organization/partials/_positions-list.html\'\"></div></md-tab><md-tab \nlabel=\"Gerencias\" md-on-select=\"vm.tabChanged()\"><div \nng-include=\"\'app/main/custom_modules/organization/partials/_departments-list.html\'\"></div></md-tab><md-tab \nlabel=\"Áreas\" md-on-select=\"vm.tabChanged()\"><div \nng-include=\"\'app/main/custom_modules/organization/partials/_areas-list.html\'\"></div></md-tab></md-tabs></div></div>\n</div>");
$templateCache.put("app/main/elements/ik-question-type/asociacion.html","<div class=\"container-respuesta-asociacion\"><div ng-if=\"!data.options.visible\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" ng-class=\"{\'full-width\':!data.graphic_path}\"><span \nclass=\"text-title text-color\" ng-if=\"config.isAdmin\">{{data.question_text}}</span><div class=\"mt-15 full-width\"><div \nlayout=\"column\"><div ng-repeat=\"option in data.answer_choices | orderBy:row_order track by $index \" layout=\"row\" \nlayout-align=\"start center\" class=\"mb-10\" layout-wrap><div layout=\"column\" flex=\"80\"><span \nclass=\"text-xl text-secondary\">{{option.label}}</span><div layout=\"row\" layout-align=\"center center\"><img \nng-src=\"{{baseUrl+option.graphic_path}}\" ng-if=\"option.graphic_path\" class=\"img-text\"></div></div><md-select \nng-model=\"data.answer_detail[option.id]\" flex=\"20\" ng-change=\"edoService.changeSelectAsociacion(data,option)\" required>\n<md-option ng-repeat=\"value in data.listAnswer\" ng-value=\"value.id\">{{value.id}}</md-option></md-select></div></div>\n</div></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"data.graphic_path\"><img \nng-src=\"{{baseUrl+data.graphic_path}}\"></div></div><div ng-if=\"data.options.visible\" layout=\"column\"><span \nclass=\"text-title text-color\" ng-if=\"config.isAdmin\">{{data.question_text}}</span><div layout=\"row\" \nlayout-align=\"space-around\" layout-wrap class=\"mt-15\" ng-class=\"{\'bb\':!$last}\" \nng-repeat=\"option in data.answer_choices | orderBy:row_order\"><div layout=\"column\" flex=\"60\"><div layout=\"column\" \nclass=\"p-20\" layout-wrap><span class=\"text-xl text-secondary\">{{option.label}}</span><div layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{baseUrl+option.graphic_path}}\" ng-if=\"option.graphic_path\" \nclass=\"img-text\"></div></div></div><div layout=\"column\" flex=\"40\" data-drop=\"true\" ng-model=\"data.listAnswer\" \njqyoui-droppable=\"{index: {{$index}}}\"><div class=\"option-container\"><div data-drag=\"{{data.listAnswer[$index].drag}}\" \ndata-jqyoui-options=\"{revert: \'invalid\'}\" ng-model=\"data.listAnswer\" \njqyoui-draggable=\"{index: {{$index}},placeholder:true}\" layout=\"row\" layout-align=\"start\" layout-wrap><div \nlayout=\"column\" layout-align=\"center center\" class=\"buttom-drag\" flex=\"20\"><img src=\"assets/icons/swipe.png\"> <span \nclass=\"text-m text-primary\">Cambiar de posición</span></div><div layout=\"row\" layout-align=\"start start\" \nclass=\"text-drag\" flex=\"80\"><span class=\"text-l text-secondary\">{{data.listAnswer[$index].label}}</span></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-question-type/respuesta_abierta_numerica.html","<div class=\"container-respuesta-abierta\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nng-class=\"{\'full-width\':!data.graphic_path}\"><span class=\"text-title text-color\" ng-if=\"config.isAdmin\">\n{{data.question_text}}</span><div class=\"mt-15 full-width\"><md-input-container class=\"md-block\"><input id=\"search\" \ntype=\"number\" ng-model=\"data.answer_detail.answer\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"data.graphic_path\"><img class=\"img-text\" ng-src=\"{{baseUrl+data.graphic_path}}\">\n</div></div></div>");
$templateCache.put("app/main/elements/ik-question-type/respuesta_multiple.html","<div class=\"container-respuesta-multiple\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nng-class=\"{\'full-width\':!data.graphic_path}\"><span class=\"text-title text-color\" ng-if=\"config.isAdmin\">\n{{data.question_text}}</span><div class=\"mt-15 full-width\"><div layout=\"row\" ng-if=\"data.answer_include_img.length\" \nlayout-wrap><div ng-repeat=\"option in data.answer_choices | orderBy:row_order track by $index \" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\" \nlayout=\"row\" layout-align=\"center start\" class=\"mb-10\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"data.answer_detail[option.id]\"><div layout=\"row\" layout-align=\"start start\"><img ng-if=\"option.graphic_path\" \nclass=\"img-radio-button\" ng-src=\"{{baseUrl+option.graphic_path}}\"></div></md-checkbox></div></div><div layout=\"column\" \nng-if=\"!data.answer_include_img.length\"><div \nng-repeat=\"option in data.answer_choices | orderBy:row_order track by $index \" layout=\"row\" class=\"mb-10\"><md-checkbox \naria-label=\"checkbox\" ng-model=\"data.answer_detail[option.id]\"><div layout=\"row\" layout-align=\"start start\"><span \nclass=\"text-l text-secondary\">{{option.label}}</span></div></md-checkbox></div></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"data.graphic_path\"><img class=\"img-text\" ng-src=\"{{baseUrl+data.graphic_path}}\">\n</div></div></div>");
$templateCache.put("app/main/elements/ik-question-type/respuesta_unica.html","<div class=\"container-respuesta-unica\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nng-class=\"{\'full-width\':!data.graphic_path}\"><span class=\"text-title text-color\" ng-if=\"config.isAdmin\">\n{{data.question_text}}</span><div class=\"mt-15 full-width\"><div layout=\"row\" ng-if=\"data.answer_include_img.length\" \nlayout-wrap><div ng-repeat=\"option in data.answer_choices | orderBy:row_order track by $index \" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\" \nlayout=\"row\" layout-align=\"center start\" class=\"mb-10\"><label class=\"container-radio-button\"><input type=\"radio\" \nng-model=\"data.answer_detail.edo_answer_choice_id\" ng-value=\"option.id\" required> <span class=\"checkmark-radio-button\">\n</span></label><div layout=\"row\" layout-align=\"start start\"><img ng-if=\"option.graphic_path\" class=\"img-radio-button\" \nng-src=\"{{baseUrl+option.graphic_path}}\"></div></div></div><div layout=\"column\" \nng-if=\"!data.answer_include_img.length\"><div \nng-repeat=\"option in data.answer_choices | orderBy:row_order track by $index \" layout=\"row\" class=\"mb-10\"><label \nclass=\"container-radio-button\"><input type=\"radio\" ng-model=\"data.answer_detail.edo_answer_choice_id\" \nng-value=\"option.id\" required> <span class=\"checkmark-radio-button\"></span></label><div layout=\"row\" \nlayout-align=\"start start\"><span class=\"text-l text-secondary\">{{option.label}}</span></div></div></div></div></div>\n<div layout=\"row\" layout-align=\"center center\" ng-if=\"data.graphic_path\"><img class=\"img-text\" \nng-src=\"{{baseUrl+data.graphic_path}}\"></div></div></div>");
$templateCache.put("app/main/modules/header/header.html","<div id=\"header-image\" class=\"md-accent-bg\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"background: url({{vm.page_info.page_content[page_content.module][page_content.id][\'content\'][\'picture\']}}); background-repeat: no-repeat;background-size:cover\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{vm.page_info.page_content[page_content.module][page_content.id][\'content\'][\'pageTitle\']}}</span></div><div \nclass=\"title\">{{vm.page_info.page_content[page_content.module][page_content.id][\'content\'][\'pageTitle\']}}</div></div>");
$templateCache.put("app/main/modules/hr-evaluation/hr-evaluation.html","<div id=\"hr-evaluation\" class=\"page-layout page-layout-simple\" layout=\"row\" ng-show=\"!vm.loadingInit\"><div \nclass=\"center\" flex ms-scroll><div class=\"header md-accent-bg p-15\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"avatar-wrapper mr-5\"><img \nng-src=\"{{vm.employeeProfile.empleado.foto}}\" class=\"avatar\"></div><div layout=\"column\"><div \nclass=\"title font-weight-200\">{{vm.employeeProfile.empleado.name}}</div><div class=\"font-weight-200\">\n{{vm.employeeProfile.cargo.name}}</div><div class=\"font-weight-200\">{{vm.employeeProfile.empresa.name}}</div></div>\n</div><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start center\" class=\"p-5\" \nng-repeat=\"moduleSummary in vm.moduleSummaryResults\"><span class=\"text-xl white-fg font-weight-600\">\n{{moduleSummary.data}}%</span> <span class=\"text-l white-fg font-weight-300\">{{moduleSummary.label}}</span></div><div \nlayout=\"column\" layout-align=\"start center\" class=\"p-5\"><span class=\"text-xl white-fg font-weight-600\">\n{{vm.moduleSummaryResultsFinal}}%</span> <span class=\"text-l white-fg font-weight-300\">Resultado final</span></div>\n</div></div><div class=\"content\" flex><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" md-align-tabs=\"top\"><md-tab \nng-repeat=\"(module, stage) in ::vm.evaluationProcessActions track by $index\" ng-click=\"vm.goStepTab(msWizard)\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">{{stage.label}}</span></span>\n</md-tab-label><md-tab-body><md-content><form name=\"evaluationStepForm[{{module}}]\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><ik-hr-evaluation-action template=\"vm.templates[module][stage.action]\" module=\"module\" \naction=\"stage.action\" view-model=\"vm\" data=\"vm.evaluationProcessData[module]\" license=\"vm.licenseConfig\">\n</ik-hr-evaluation-action><div layout=\"row\" layout-align=\"start center\" class=\"mb-15\" \nng-if=\"vm.evaluationProcessData[module].goals_weight\"><div class=\"pl-20\"><span class=\"md-accent-fg text-l\">\nPorcentaje de ponderación: </span><span class=\"md-accent-fg text-l\"><strong>\n{{vm.evaluationProcessData[module].goals_weight}}%</strong></span></div></div></form></md-content></md-tab-body>\n</md-tab><md-tab ng-click=\"vm.goStepTab(msWizard)\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Resumen</span></span></md-tab-label><md-tab-body><md-content><div \nng-include=\"\'app/main/utils/loading-data.html\'\" ng-if=\"vm.loadingSummary\"></div><div class=\"msg-min-warning m-16 p-15\" \nng-if=\"!vm.allowFinalize && !vm.loadingSummary\"><span class=\"text-m\">\nLa evaluación presenta algunas inconsistencias y no se puede finalizar. Por favor realice las modificaciones necesarias de acuerdo a la información que se muestra a continuación.\n</span></div><form name=\"evaluationStepForm[\'summary\']\" class=\"md-inline-form\" ms-form-wizard-form novalidate>\n<ik-hr-evaluation-summary-action ng-repeat=\"(module, stage) in ::vm.evaluationProcessActions\" \nsummary-data=\"vm.summaryData.evaluation_process_summary[module]\" summary-template=\"vm.templates[module][stage.action]\" \nmodule=\"module\" action=\"stage.action\" view-model=\"vm\" data=\"vm.evaluationProcessData[module]\" ng-if=\"vm.summaryData\" \nclass=\"mb-20\" license=\"vm.licenseConfig\"></ik-hr-evaluation-summary-action></form></md-content></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\" ng-hide=\"vm.formSent\"><md-button \nclass=\"md-raised md-accent\" ng-click=\" vm.goStep( msWizard.selectedIndex, msWizard, \'previous\' ) \" \nng-disabled=\"msWizard.isFirstStep()\">Anterior</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\': msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.goStep( msWizard.selectedIndex, msWizard, \'next\')\" \nng-disabled=\"msWizard.currentStepInvalid()\" ng-hide=\"msWizard.isLastStep()\">Siguiente</md-button><md-button \nclass=\"md-raised md-primary boton_fin\" ng-click=\"vm.finalizeEvaluationProcess()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"!vm.allowFinalize\">Finalizar</md-button></div><md-button \nclass=\"md-fab md-accent md-icon-button boton_save\" id=\"fab-save-button\" ng-show=\"vm.show_save\" \nng-click=\"vm.saveDesempeno(msWizard.selectedIndex, msWizard, 0)\" ng-disabled=\"!vm.change\" aria-label=\"Save\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button></ms-form-wizard></div></div></div>");
$templateCache.put("app/main/modules/reports/reports.html","<div id=\"reports\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg ph-20 pt-10\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-check\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Reportes</span></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Evaluación de desempeño\" md-on-select=\"vm.loadInfo(\'evaluations\')\"><md-list><md-list-item \nclass=\"contact md-2-line\" ng-repeat=\"report in vm.reports\"><div class=\"md-list-item-text\"><h4><a href=\"#\" \nui-sref=\"app.report({report_id: report.id})\">{{report.name}}</a></h4><p class=\"secondary-text\">{{report.description}}\n</p></div><md-divider></md-divider></md-list-item></md-list></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/page/admin/page_admin.html","<div id=\"page_admin\" class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-currency-usd\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Páginas</span></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr class=\"md-accent-bg\"><th><div class=\"table-header\"><span class=\"column-title\">Página</span></div></th><th>\n<div class=\"table-header\"><span class=\"column-title\">Última modificación</span></div></th><th></th></tr></thead><tbody>\n<tr ng-repeat=\"page in vm.Pages\"><td><a href=\"#\" ui-sref=\"app.admin_page_content({page_url: page.Page.friendly_url})\">\n{{ page.Page.menu_name }}</a></td><td>{{ page.Page.created }}</td><td><md-button class=\"md-icon-button md-accent\" \naria-label=\"Modificar\" ng-click=\"vm.openPageDialog($event, page)\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon>\n<md-tooltip><span>Modificar</span></md-tooltip></md-button></td></tr></tbody></table></div></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-button\" ng-click=\"vm.openPageDialog($event)\" aria-label=\"add page\" \ntranslate translate-attr-aria-label=\"Add Page\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/page/text/text.html","<div class=\"demo-content\" id=\"custom_text\"><p \nng-bind-html=\"vm.page_info.page_content[page_content.content_id][page_content.module][page_content.id][\'content\'][\'ModuleText\'][\'content\']\">\n</p></div>");
$templateCache.put("app/main/page_layouts/layout-2-col/layout-2-col.html","<div id=\"layout-2-col\" class=\"page-c1 page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header md-accent-bg\"><div class=\"breadcrumb\"><md-icon md-font-icon=\"icon-home\" \nclass=\"s16 grey-50-fg\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 grey-50-fg separator\"></md-icon>\n<span class=\"parent\">{{vm.page_info.page_layout.Page.name}}</span></div><div class=\"header-content\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"pt-64 font-size-48 font-weight-200\">{{vm.page_info.page_layout.Page.name}}\n</div><div class=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav-layout-2-col\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><md-content class=\"content\" flex \nms-scroll><div ng-repeat-start=\"page_content in vm.page_layout\" ng-if=\"vm.adminMode && page_content.container_id == 1\">\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Modificar\" ng-click=\"vm.gotoModuleAdmin(page_content)\"><md-icon\n md-font-icon=\"icon-pencil-box\"></md-icon><md-tooltip><span>Modificar</span></md-tooltip></md-button></div><div \nng-repeat-end ng-include=\"vm.pageModules[page_content.plantilla]\" ng-if=\"page_content.container_id == 1\"></div>\n</md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"sidenav-layout-2-col\" \nng-include=\"\'app/main/page_layouts/layout-2-col/sidenavs/layout-2-col-sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav></div>");
$templateCache.put("app/main/page_layouts/layout-2-col-no-header/layout-2-col-no-header.html","<div id=\"layout-2-col-no-header\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header-2 md-grey-50-bg\"><div ng-repeat=\"page_content in vm.page_layout\" \nng-include=\"vm.pageModules[page_content.plantilla]\" ng-if=\"page_content.container_id == 1\"></div></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"p-16\"><div ng-repeat=\"page_content in vm.page_layout\" \nng-include=\"vm.pageModules[page_content.plantilla]\" ng-if=\"page_content.container_id == 3\" class=\"p-24\"></div></div>\n</md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" \nng-include=\"\'app/main/page_layouts/layout-2-col-no-header/sidenavs/layout-2-col-no-header-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img \nsrc=\"assets/images/ikano_rh/{{vm.license}}/side-bar-logo.png\" ng-if=\"!vm.folded\"></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/notifications/notifications.html","<md-list><md-list-item class=\"md-2-line bb\" \nng-class=\"{\'md-grey-200-bg\' : notification.ModuleNotification.status == 0}\" \nng-repeat=\"notification in vm.notifications\" ng-click=\"vm.gotoNotification(notification)\"><div \nclass=\"md-list-item-text\"><p ng-bind-html=\"notification.ModuleNotification.name\"></p><div \nclass=\"secondary-text font-size-10\"><md-icon md-font-icon=\"icon-calendar-clock\" class=\"s16 md-accent-fg mr-8\">\n</md-icon>{{notification.ModuleNotification.created | dateToISO | date : format : \"mediumDate\"}}</div></div>\n</md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/employee/default.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"logo pl-20 pr-20\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.license\"><img \nng-src=\"assets/images/ikano_rh/{{vm.license}}/side-bar-logo.png\"></div><div class=\"toolbar-separator\"></div><div \nclass=\"ml-5\" ng-click=\"vm.goIndexEmployee()\"><md-button md-no-ink class=\"md-primary\">Mi perfil</md-button></div><div \nclass=\"ml-5\" ng-click=\"vm.goShowHv()\" ng-if=\"vm.license == \'pallomaro\'\"><md-button md-no-ink class=\"md-primary\">\nInformación hoja de vida</md-button></div><div class=\"ml-5\" ng-click=\"vm.openDocumentsDialog()\"><md-button md-no-ink \nclass=\"md-primary\">Biblioteca</md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"{{vm.userInfo.avatar}}\" \nng-if=\"vm.userInfo.avatar\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.userInfo.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.openChangePasswordDialog($event)\">Cambiar contraseña</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ng-if=\"vm.user_manual_code\"><md-icon md-font-icon=\"icon-help-circle\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.goManualUser()\">Manual de usuario</md-button></md-menu-item>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Salir</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"{{vm.userInfo.avatar}}\" \nng-if=\"vm.userInfo.avatar\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.userInfo.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Salir</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"ml-5\" ng-click=\"vm.openDocumentsDialog()\">\n<md-button md-no-ink class=\"md-primary\">Biblioteca</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" \nclass=\"md-accent\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{vm.userInfo.avatar}}\" ng-if=\"vm.userInfo.avatar\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.userInfo.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.openChangePasswordDialog($event)\">Cambiar contraseña</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ng-if=\"vm.user_manual_code && vm.userInfo.group.id == 1\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"icon\"></md-icon><md-button ng-click=\"vm.goManualUser()\">Manual de usuario\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.logout()\">Salir</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>\n</div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ik-goal-comments-modal/dialog/dialog.html","<md-dialog id=\"ik-goal-comments-modal-dialog\" aria-label=\"Objetivo\"><form name=\"dataForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">Solicitar ajustes </span><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"p-20\">\n<md-input-container class=\"md-block\"><label>Comentario</label><textarea name=\"comments\" ng-model=\"vm.rejected_comment\" \nrequired md-maxlength=\"500\" maxlength=\"500\"></textarea><div ng-messages=\"dataForm.comments.$error\" \nng-show=\"dataForm.comments.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Dato requerido</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\">\n<div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.saveComment()\" ng-disabled=\"dataForm.$invalid\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/templates/default.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed}\" \nng-include=\"\'default-navigation.html\'\"></li></ul><script type=\"text/ng-template\" id=\"default-navigation.html\">\n<div ms-navigation-item class=\"group\" layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"node.label\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.label}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n    </div>\n\n    <div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\" ng-repeat=\"children in node.end_points\">\n        <a class=\"ms-navigation-button\" ui-sref=\"{{children.state}}\" ui-sref-active=\"active md-accent-bg\" \n            ng-if=\"children.state && children.label\">\n             <i class=\"icon s16 {{children.icon}}\" ng-if=\"children.icon\"></i>\n             <span class=\"title\" translate=\"{{children.label}}\" flex>{{children.label}}</span>\n             <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n             <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n         </a>\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'default-navigation.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button esta\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/position-detail/templates/detail-attributes.html","<div layout=\"row\" layout-wrap><div layout=\"column\" ng-if=\"vm.isArray\" class=\"full-width\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"mb-15\" ng-if=\"vm.config.edit\"><md-icon \nmd-font-icon=\"icon-plus s16 md-primary-fg no-margin\" class=\"white-fg\"></md-icon><span class=\"text-m md-primary-fg\" \nng-click=\"vm.addRow()\">Agregar</span></div><div class=\"table-header full-width md-whiteframe-5dp\"><table \nclass=\"tbl-lbl-data\"><thead><tr><td class=\"titleTable background text-center no-border\" \nng-repeat=\"title in vm.attributes.header track by $index\"><span class=\"text-s\">{{title.label}}</span></td><td \nclass=\"titleTable background text-center no-border\" ng-if=\"vm.config.edit\"><span class=\"text-s\"></span></td></tr>\n</thead><tbody><tr ng-repeat=\"body in vm.attributes.body\" class=\"border-tr\"><td class=\"text-s\" \nng-class=\"{\'white-bg\':$even,\'font-weight-500\':$even}\" ng-repeat=\"attribute in vm.attributes.header track by $index\">\n<div layout=\"column\" ng-if=\"attribute.df_attribute_type.name == \'text\'\"><span class=\"text-s text-secondary\" \nng-if=\"!vm.config.edit\">{{body[attribute.name]}}</span><md-input-container md-no-float \nclass=\"no-errors no-padding no-margin full-width\" ng-if=\"vm.config.edit\"><input type=\"text\" \nng-model=\"body[attribute.name]\" aria-label=\"prueba\"></md-input-container></div><div layout=\"column\" \nng-if=\"attribute.df_attribute_type.name == \'textarea\'\"><div layout=\"column\" layout-align=\"center\" \nclass=\"comments-container\"><div layout=\"row\"><div layout=\"column\" ng-if=\"vm.config.edit\" class=\"w-100-p\"><textarea \nclass=\"comments-input\" ng-model=\"body[attribute.name]\" ng-attr-rows=\"{{attribute.df_attribute_type.options.rows}}\">\n</textarea></div><div layout=\"column\" layout-align=\"center start\" ng-if=\"!vm.config.edit\"><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"body[attribute.name]\"></div></div></div></div></div></td><td \nng-if=\"vm.config.edit\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-trash s16 cursor-pointer md-warn-fg no-margin\" ng-click=\"deleteRow($index);\"></md-icon><span \nclass=\"text-m md-warn-fg cursor-pointer\" ng-click=\"vm.deleteRow($index)\">Eliminar</span></div></td></tr></tbody>\n</table></div></div><div flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"mt-10 mb-10 p-5\" layout=\"column\" \nng-repeat=\"attribute in vm.attributes\" ng-if=\"!vm.isArray\"><div layout=\"column\" \nng-if=\"attribute.df_attribute_type.name == \'text\'\"><span class=\"text-s font-weight-600 text-primary mb-10\">\n{{attribute.label}}</span> <span class=\"text-s text-secondary\" ng-if=\"!vm.config.edit\">{{data[attribute.name]}}</span>\n<md-input-container md-no-float class=\"no-errors no-padding no-margin full-width\" ng-if=\"vm.config.edit\"><input \ntype=\"text\" ng-model=\"data[attribute.name]\" aria-label=\"prueba\"></md-input-container></div><div layout=\"column\" \nng-if=\"attribute.df_attribute_type.name == \'textarea\'\"><span class=\"text-s font-weight-600 text-primary mb-10\">\n{{attribute.label}}</span><div layout=\"column\" layout-align=\"center\" class=\"comments-container\"><div layout=\"row\"><div \nlayout=\"column\" ng-if=\"vm.config.edit\" class=\"w-100-p\"><textarea class=\"comments-input\" \nng-model=\"data[attribute.name]\" ng-attr-rows=\"{{attribute.df_attribute_type.options.rows}}\"></textarea></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"!vm.config.edit\"><div class=\"text-s text-secondary comment-read\" \nng-bind-html=\"data[attribute.name]\"></div></div></div></div></div></div></div>");
$templateCache.put("app/core/directives/position-detail/templates/detail-sections.html","<div layout=\"column\" ng-repeat=\"section in vm.sections track by $index\" class=\"container-detail\" \nng-class=\"{\'separator\':!$last}\" ng-if=\"vm.data[section.name]\"><span \nclass=\"text-m text-primary font-weight-500 mb-10 mt-10\">{{section.label}}</span><div layout=\"column\" \nclass=\"content-section\"><detail-attributes ng-if=\"!section.haveSections\" data=\"vm.data[section.name]\" \nstructure=\"section.df_attributes\" is-array=\"section.is_array\"></detail-attributes><detail-sections \nng-if=\"section.haveSections\" data=\"vm.data[section.name]\" sections=\"section.sections\"></detail-sections></div></div>");
$templateCache.put("app/core/directives/position-detail/templates/position-detail.html","<div layout=\"column\" id=\"position-detail\"><div class=\"container-section\" layout=\"column\" \nng-repeat=\"section in vm.sections\"><div class=\"section-header\" layout=\"row\" layout-align=\"space-between center\" \nng-class=\"{\'active\':!section.hideInfo}\"><span class=\"text-l font-weight-500\" \nng-class=\"!section.hideInfo ? \'md-accent-fg\' : \'text-secondary\'\">{{section.label}}</span><div layout=\"row\" \nlayout-align=\"start center\" class=\"cursor-pointer\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"md-accent-fg\" \nng-click=\"section.hideInfo = false;\" ng-if=\"section.hideInfo\"></md-icon><md-icon md-font-icon=\"icon-chevron-up\" \nclass=\"md-accent-fg\" ng-click=\"section.hideInfo = true;\" ng-if=\"!section.hideInfo\"></md-icon><span \nclass=\"text-m md-accent-fg\" ng-click=\"section.hideInfo = false;\" ng-if=\"section.hideInfo\">Ver información</span> <span \nclass=\"text-m md-accent-fg\" ng-click=\"section.hideInfo = true;\" ng-if=\"!section.hideInfo\">Ocultar información</span>\n</div></div><div class=\"content-section\" layout=\"column\" ng-show=\"!section.hideInfo\"><detail-attributes \nng-if=\"!section.haveSections\" data=\"vm.data.data[section.name]\" structure=\"section.df_attributes\" \nis-array=\"section.is_array\"></detail-attributes><detail-sections ng-if=\"section.haveSections\" \ndata=\"vm.data.data[section.name]\" sections=\"section.sections\"></detail-sections></div></div></div>");
$templateCache.put("app/core/services/dialogs/position-detail/position-detail-dialog.html","<md-dialog id=\"positon-detail-dialog\" aria-label=\"Enroll Employee\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.position.name}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-dialog-content ng-if=\"!vm.isEmpty\">\n<position-detail ng-if=\"vm.positionDetail\" data=\"vm.positionDetail.position_details\" \nstructure=\"vm.positionDetail.dynamic_form\" config=\"vm.config\"></position-detail></md-dialog-content><md-dialog-actions \nclass=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" \naria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"p-5\" ng-if=\"!vm.config.edit && !vm.isEmpty\"><md-button ng-click=\"vm.downloadFile()\" \nng-disabled=\"vm.loadingDownload\" aria-label=\"Cancelar\" \nclass=\"md-accent md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Descargar</md-button></div>\n<div class=\"p-5\" ng-if=\"vm.config.edit\"><md-button ng-click=\"vm.saveForm()\" \nng-disabled=\"dialogForm.$invalid || vm.loadingSave\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div><div class=\"p-5\" ng-if=\"vm.config.edit\"><md-button ng-click=\"vm.publishPositionDetail()\" \nng-disabled=\"dialogForm.$invalid || vm.loadingSave\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-primary submit-button md-raised h6 h-30 line-height-30 text-capitalized no-margin\">Guardar y Publicar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation-details/evaluation-details.html","<div id=\"cstm-evaluation-details\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg p-15\" layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\">\n<md-icon md-font-icon=\"icon-home\" class=\"s16 grey-50-fg\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 grey-50-fg separator\"></md-icon><span class=\"parent\" \nng-if=\"vm.getLastState.name != \'app.cstm_evaluation_edo\'\"><a href=\"#\" ui-sref=\"app.cstm_evaluation\" class=\"grey-50-fg\">\nEvaluaciones</a></span> <span class=\"parent\" ng-if=\"vm.getLastState.name == \'app.cstm_evaluation_edo\'\"><a href=\"#\" \nui-sref=\"app.cstm_evaluation_edo\" class=\"grey-50-fg\">Evaluaciones Operativas</a></span></div><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\"><div class=\"title pb-32 font-weight-200\">\n{{vm.evaluationInfo.empleado.cedula}} - {{vm.evaluationInfo.empleado.name}}</div></div></div></div><div \nclass=\"content\"><div ng-if=\"!vm.isDataLoaded\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><md-tabs \nmd-dynamic-height><md-tab label=\"Detalles\"><div \nng-include=\"\'app/main/custom_modules/evaluation/evaluation-details/partials/_evaluation-info.html\'\"></div></md-tab>\n<md-tab label=\"Evaluación actual\"><div \nng-include=\"\'app/main/custom_modules/evaluation/evaluation-details/partials/_current-evaluation.html\'\"></div></md-tab>\n<md-tab label=\"Historial de evaluaciones\"><div \nng-include=\"\'app/main/custom_modules/evaluation/evaluation-details/partials/_evaluation-history.html\'\"></div></md-tab>\n<md-tab label=\"Auditoría\"><div \nng-include=\"\'app/main/custom_modules/evaluation/evaluation-details/partials/_evaluation-log.html\'\"></div></md-tab>\n</md-tabs></div></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_evaluation-assign-goals.html","<div id=\"assign-corporate-goals\" layout=\"column\"><span class=\"md-primary-fg text-xl font-weight-300 mb-15\">\nAsignar objetivos</span><div class=\"md-whiteframe-5dp white-bg p-20 mb-15\" layout=\"column\" layout-align=\"center\"><span \nclass=\"md-accent-fg text-l Bold\">Paso 1</span><md-input-container><label>Seleccionar empresa</label><md-select \nng-model=\"vm.searchGoalAssigments.company\" ng-change=\"vm.getGoalsAssigments(vm.searchGoalAssigments.company)\">\n<md-option ng-repeat=\"company in vm.organizationCompanies\" ng-value=\"company.id\">{{company.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.showMessageLoad\" ng-include=\"\'app/main/utils/loading-data.html\'\">\n</div><div class=\"md-whiteframe-5dp white-bg p-20 mb-15\" layout=\"column\" layout-align=\"center\" \nng-if=\"!vm.loadingAssingGoals\"><span class=\"md-accent-fg text-l Bold\">Paso 2</span> <span \nclass=\"text-m text-secondary\">Seleccionar objetivos</span><table datatable=\"\" dt-options=\"vm.dtOptions\" \nclass=\"row-border hover\"><thead><tr><th><div layout=\"row\" layout-align=\"center center\"><md-checkbox \nng-model=\"vm.selectedAllGoal\" ng-value=\"true\" ng-change=\"vm.fnSelectedAllGoal(vm.selectedAllGoal);\" class=\"m-0\">\n</md-checkbox></div></th><th class=\"text-secondary text-m font-weight-300\">#</th><th \nclass=\"w-40-p text-secondary text-m font-weight-300 text-center\">Nombre del objetivo</th><th \nclass=\"text-secondary text-m font-weight-300 text-center\">Asignar ponderado</th></tr></thead><tbody><tr \nng-repeat=\"goal in vm.corporateGoals\"><td><div layout=\"row\" layout-align=\"center center\"><md-checkbox \nng-model=\"vm.goalAssingSelected[goal.id].selected\" ng-value=\"true\" class=\"m-0\"></md-checkbox></div></td><td>\n{{$index + 1}}</td><td class=\"w-40-p\">{{goal.name}}</td><td><div layout=\"row\" layout-align=\"center center\" \nclass=\"container-input\"><md-input-container><input ng-model=\"vm.goalAssingSelected[goal.id].porcentaje\" type=\"number\">\n</md-input-container></div></td></tr></tbody></table></div><div class=\"md-whiteframe-5dp white-bg p-20 mb-15\" \nlayout=\"column\" layout-align=\"center\" ng-if=\"!vm.loadingAssingGoals\"><span class=\"md-accent-fg text-l Bold\">Paso 3\n</span> <span class=\"text-m text-secondary\">Seleccionar colaboradores</span><div class=\"md-inline-form\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex class=\"filter-employee\"><md-input-container flex=\"25\"><label>Gerencia</label>\n<md-select ng-model=\"vm.searchEmployees[\'department\']\" ng-change=\"vm.filterEmployees();\"><md-option value=\"\">\n----------------</md-option><md-option ng-repeat=\"department in vm.organizationDepartments\" ng-value=\"department.id\">\n{{department.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Área</label>\n<md-select ng-model=\"vm.searchEmployees[\'area\']\" ng-change=\"vm.filterEmployees();\"><md-option value=\"\">----------------\n</md-option><md-option ng-repeat=\"area in vm.organizationAreas\" ng-value=\"area.id\">{{area.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"25\"><label>Nivel</label><md-select \nng-model=\"vm.searchEmployees[\'positionLevel\']\" ng-change=\"vm.filterEmployees();\"><md-option value=\"\">----------------\n</md-option><md-option ng-repeat=\"positionLevel in vm.position_levels | orderBy: \'order\'\" ng-value=\"positionLevel.id\">\n{{positionLevel.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Colaborador\n</label><input type=\"text\" name=\"employee\" ng-model=\"vm.searchEmployees[\'employee\']\" ng-change=\"vm.filterEmployees();\">\n</md-input-container></div></div><table class=\"row-border hover dataTable\"><thead><tr><th class=\"white-bg\"><div \nlayout=\"row\" layout-align=\"center center\"><md-checkbox ng-model=\"vm.selectedAllEmployee\" ng-value=\"true\" \nng-change=\"vm.fnSelectedAllEmployee(vm.selectedAllEmployee);\" class=\"m-0\"></md-checkbox></div></th><th \nclass=\"text-secondary text-m font-weight-300 white-bg\">Colobador</th><th \nclass=\"text-secondary text-m font-weight-300 white-bg\" ng-repeat=\"goal in vm.corporateGoals track by $index\">\n{{$index + 1}}</th><th class=\"text-secondary text-m font-weight-300 text-center white-bg\">*Total</th></tr></thead>\n<tbody><tr ng-repeat=\"employee in vm.activeProcessesGoalsMisc\"><td class=\"text-center\"><md-checkbox \nng-model=\"vm.employeeAssingSelected[employee.id].selected\" ng-value=\"true\" aria-label=\"employee\" \nng-change=\"vm.changeEmployeeAssingSelected(employee)\"></md-checkbox></td><td><div>{{employee.empleado.name}}</div><div \nclass=\"secondary-text\">{{employee.cargo.name}}</div><div class=\"secondary-text\" layout=\"column\"><span><b>Nivel:</b>\n {{employee.position_level.name}}</span> <span><b>Máximo:</b>\n {{vm.goals_configuration[employee.grupo] ? vm.goals_configuration[employee.grupo].maximo : \' 0 \'}}</span></div></td>\n<td ng-repeat=\"goal in vm.corporateGoals track by $index\" class=\"text-center\" \nng-class=\"{\'light-green-100-bg\': vm.goalAssingSelected[goal.id].selected && vm.goalAssingSelected[goal.id].porcentaje, \'light-green-500-bg\': vm.goalAssignments[employee.id][goal.id]}\">\n{{vm.employeesGoals[employee.id][goal.id][\'porcentaje\']}}</td><td class=\"text-center\"><span \nng-class=\"{\'md-warn\' : vm.employeesGoalsTotal[employee.id] > 100, \'green-fg\' : vm.employeesGoalsTotal[employee.id] == 100}\">\n{{vm.employeesGoalsTotal[employee.id].total_weight}}</span></td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.corporateGoals\"><md-button type=\"submit\" ng-click=\"vm.saveAssignments()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"!vm.goalKeys.length || !vm.employeeKeys\">GUARDAR</md-button></div>\n</div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_evaluation-goals.html","<div ng-if=\"!vm.goals\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><div ng-if=\"vm.goals\"><div \nclass=\"submenu\" layout=\"row\" layout-align=\"end end\"><md-button class=\"md-raised md-accent btn-capitalize\" \nng-click=\"vm.goImport()\">Importar objetivos</md-button><md-button class=\"md-raised md-primary-bg btn-capitalize\" \nng-click=\"vm.openGoalDialog($event, {})\">Nuevo objetivo</md-button></div><div class=\"md-inline-form\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"25\"><label>Empresa</label><md-select \nng-model=\"vm.search[\'company\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"company in vm.organizationCompanies\" value=\"{{company.id}}\">{{company.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"25\"><label>Gerencia</label><md-select \nng-model=\"vm.search[\'department\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"department in vm.organizationDepartments\" value=\"{{department.id}}\">{{department.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"25\"><label>Área</label><md-select \nng-model=\"vm.search[\'area\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"area in vm.organizationAreas\" value=\"{{area.id}}\">{{area.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"25\"><label>Cargo</label><md-select ng-model=\"vm.search[\'position\']\"><md-option value=\"\">\n----------------</md-option><md-option ng-repeat=\"position in vm.organizationPositions\" value=\"{{position.id}}\">\n{{position.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Nivel</label>\n<md-select ng-model=\"vm.search[\'positionLevel\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"positionLevel in vm.positions_levels\" ng-value=\"positionLevel.id\">{{positionLevel.value}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"25\"><label>Objetivo</label><input type=\"text\" name=\"goal\" \nng-model=\"vm.search[\'goal\']\"></md-input-container></div></div><div class=\"white-bg md-whiteframe-4dp mb-32\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Objetivo</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Matriculados</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Empresa</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Gerencia</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Area</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Cargo</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo</span></div></th><th class=\"md-blue-grey-700-bg\"><div><span></span></div></th></tr></thead>\n<tbody><tr \nng-repeat=\"goal in vm.goals | filter: vm.search[\'goal\'] | filterByCompany:vm.search[\'company\'] | filterByDepartment:vm.search[\'department\'] | filterByArea:vm.search[\'area\']\">\n<td><div>{{goal.name}}</div><div><b>Meta:</b> {{goal.meta}}</div><div \nng-repeat=\"additional in vm.additional_data track by $index\"><b>{{additional.label}}</b>\n {{goal.additional_data[additional.value]}}</div></td><td class=\"text-center\">{{vm.companyGoalsCount[goal.id]}}</td>\n<td>{{goal.empresa.name}}</td><td>{{goal.company_department.name}}</td><td>{{goal.area.name}}</td><td>\n{{goal.cargo.name}}</td><td>{{goal.tipo}}</td><td><div layout=\"row\" ng-if=\"!vm.sendingData[goal.id]\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openGoalDialog($event, goal)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon md-font-icon=\"icon-border-color\" class=\"amber-fg\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-if=\"!vm.companyGoalsCount[goal.id]\" \nng-click=\"vm.deleteGoal($event, goal)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon md-font-icon=\"icon-trash\" class=\"red-800-fg\"></md-icon>\n</md-button></div><md-progress-circular ng-disabled=\"!vm.sendingData[goal.id]\" ng-if=\"vm.sendingData[goal.id]\" \nclass=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_evaluation-list.html","<div ng-if=\"!vm.evaluations\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><div ng-if=\"vm.evaluations\"><div \nclass=\"submenu\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent btn-capitalize\" \nng-click=\"vm.openMatriculaMass($event)\">Activar proceso masivamente</md-button><md-button \nclass=\"md-raised md-primary-bg btn-capitalize\" ng-click=\"vm.openEnrollEmployeeDialog($event)\">Matricular colaborador\n</md-button></div><div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex layout-wrap>\n<md-input-container flex=\"25\"><label>Empresa</label><md-select ng-model=\"vm.search[\'company\']\"><md-option value=\"\">\n----------------</md-option><md-option ng-repeat=\"company in vm.organizationCompanies\" value=\"{{company.id}}\">\n{{company.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Gerencia</label>\n<md-select ng-model=\"vm.search[\'department\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"department in vm.organizationDepartments\" value=\"{{department.id}}\">{{department.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"25\"><label>Área</label><md-select \nng-model=\"vm.search[\'area\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"area in vm.organizationAreas\" value=\"{{area.id}}\">{{area.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"25\"><label>Cargo</label><md-select ng-model=\"vm.search[\'position\']\"><md-option value=\"\">\n----------------</md-option><md-option ng-repeat=\"position in vm.organizationPositions\" value=\"{{position.id}}\">\n{{position.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Nivel</label>\n<md-select ng-model=\"vm.search[\'positionLevel\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"positionLevel in vm.organizationPositionsLevels\" ng-value=\"positionLevel.id\">{{positionLevel.name}}\n</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Jefe</label><md-select \nng-model=\"vm.search[\'chief\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"chief in vm.organizationChief\" ng-value=\"chief.id\">{{chief.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"25\"><label>Colaborador</label><input type=\"text\" name=\"employee\" \nng-model=\"vm.search[\'employee\']\"></md-input-container></div></div><div class=\"widget-group\" layout=\"column\" \nlayout-sm=\"row\" layout-gt-sm=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" flex=\"20\" \nng-repeat=\"evProcess in vm.reportEvaluationProcessStatus.data[vm.currentCompanyIdReport]\"><ms-widget-front \nclass=\"white-bg\" layout=\"column\"><div class=\"p-10 md-primary-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.currentCompanyIdReport\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(company_id, company) in vm.reportEvaluationProcessStatus.companies\" value=\"{{company_id}}\">\n{{company}}</md-option></md-select><div class=\"pt-5\">{{evProcess.name}} <b>({{evProcess.total}})</b></div></div><a \nhref=\"#\" class=\"white-fg\" ng-click=\"flipWidget()\">Ampliar plazo</a></div><div class=\"text-gray-800\"><div \nng-repeat=\"stage in vm.reportEvaluationProcessStatus.stagesInfo[evProcess.evaluation_processes_id]\"><div class=\"small\" \nlayout=\"row\" ng-if=\"!stage.is_last_stage\"><div class=\"ph-10 pv-5\" \nng-class=\"{\'green-900-fg\': stage.last_stage, \'bb\': !stage.last_stage}\" flex=\"80\">{{stage.name}}</div><div \nclass=\"pr-10 pv-5 text-right\" ng-class=\"{\'green-900-fg\': stage.last_stage, \'bb\': !stage.last_stage}\" flex=\"20\"><b>\n{{evProcess.stages[stage.id] ? evProcess.stages[stage.id] : 0}}</b> <span class=\"secondary-text\">\n({{evProcess.stages[stage.id] ? evProcess.stages[stage.id]/evProcess.total*100 : 0 | number:0}}%)</span></div></div>\n<div ng-if=\"stage.is_last_stage\" layout=\"column\" class=\"mb-15\"><div layout=\"row\"><div class=\"ph-10 pv-5 green-900-fg\" \nflex=\"80\">{{stage.name}}</div><div class=\"pr-10 pv-5 green-900-fg text-right\" flex=\"20\"><b>\n{{evProcess.stages[stage.id] ? evProcess.stages[stage.id] : 0}}</b> <span class=\"secondary-text\">\n({{evProcess.stages[stage.id] ? evProcess.stages[stage.id]/evProcess.total*100 : 0 | number:0}}%)</span></div></div>\n<md-progress-linear class=\"ph-10 md-accent\" md-mode=\"determinate\" \nvalue=\"{{evProcess.stages[stage.id]/evProcess.total*100}}\"></md-progress-linear></div></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 grey-200-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><form name=\"wForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pt-10\"><b>Fecha límite:</b></div><md-datepicker flex ng-model=\"vm.process_deadline\" \nmd-placeholder=\"Fecha límite\" required></md-datepicker><md-button class=\"md-icon-button md-accent\" \nng-click=\"vm.setActiveProcessDeadline($event, evProcess.id); flipWidget()\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip><span>Aceptar</span></md-tooltip></md-button></div></form></ms-widget-back></ms-widget></div>\n<table class=\"dataTable\"><thead><tr><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Colaborador</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Ubicación</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Jefe</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Aprobador</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Jefe Corporativo</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Grupo</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Proceso</span></div></th></tr></thead><tbody><tr \nng-repeat=\"evaluation in vm.evaluations | filter: vm.search[\'employee\'] | filterByPositionLevel:vm.search[\'positionLevel\'] | filterByCompany:vm.search[\'company\'] | filterByDepartment:vm.search[\'department\'] | filterByArea:vm.search[\'area\'] | filterByPosition:vm.search[\'position\'] | filterByChief:vm.search[\'chief\']\">\n<td layout=\"column\"><a href=\"#\" ui-sref=\"app.cstm_evaluation_details({employee_process_id: evaluation.id})\">\n{{evaluation.empleado.name}}</a> <span class=\"secondary-text\">{{evaluation.empleado.cedula}}</span></td><td><div>\n{{evaluation.empresa.name}}</div><div>{{evaluation.cargo.name}}</div><div>{{evaluation.company_department.name}}</div>\n<div>{{evaluation.area.name}}</div><div><b>Nivel:</b> {{evaluation.position_level.name}}</div></td><td>\n{{evaluation.chief.name}}</td><td>{{evaluation.approval_chief.name}}</td><td>{{evaluation.corp_chief.name}}</td><td>\n{{evaluation.evaluation_employees_group.name}}</td><td><div><b>\n{{evaluation.evaluation_active_process.evaluation_process.name}} {{evaluation.evaluation_active_process.name}}</b>\n</div><div>{{evaluation.evaluation_process_stage.name}}</div><div \nng-class=\"{\'red-fg\' : evaluation.process_deadline < vm.today && !evaluation.evaluation_process_stage.is_last_stage}\" \nng-if=\"evaluation.process_deadline\"><b>Plazo:</b> {{evaluation.process_deadline | fecha}}</div></td></tr></tbody>\n</table></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_processes-list.html","<div class=\"widget-group\" layout=\"column\" layout-sm=\"row\" layout-gt-sm=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" flex=\"25\" ng-repeat=\"processInfo in vm.activeProcesses\"><ms-widget-front class=\"white-bg\" \nlayout=\"column\"><div class=\"p-10 md-primary-bg\">{{processInfo.evaluation_process.name}} {{processInfo.name}}</div><div \nclass=\"text-gray-800\"><div ng-repeat=\"stage in processInfo.evaluation_process.evaluation_process_stages\"><div \nclass=\"small\" layout=\"row\"><div class=\"ph-10 pv-5\" \nng-class=\"{\'green-900-fg\': stage.last_stage, \'bb\': !stage.last_stage}\" flex=\"100\">{{stage.name}}</div></div></div>\n</div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_questionnaires-list.html","<div id=\"container-questionnaires\"><div layout=\"column\" ng-show=\"!vm.showCreateQuestionnaire\"><div layout=\"row\" \nlayout-align=\"end center\" layout-wrap class=\"mb-15\"><div layout=\"row\" flex=\"50\"><md-input-container \nclass=\"md-block full-width\"><label>Buscar</label><md-icon md-font-icon=\"icon-magnify\" class=\"name\"></md-icon><input \ntype=\"text\" name=\"employee\" ng-model=\"vm.questionnaireSearch\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"end\" flex=\"50\"><md-button ng-click=\"vm.showCreateQuestionnaire = true;vm.resetQuestionnaire();\" \nclass=\"send-button md-accent md-raised m-0\">Nuevo</md-button></div></div><div \nclass=\"md-whiteframe-12dp white-500-bg mb-15\" layout=\"column\"><div layout=\"row\" layout-wrap \nclass=\"table-questionaries\" \nng-repeat=\"questionnaire in vm.edo_questionnaires | filterQuestionText: vm.questionnaireSearch:\'label\' | orderBy: \'label\' track by $index\" \nng-if=\"questionnaire.is_active\"><div layout=\"row\" flex=\"80\"><span class=\"text-l text-primary font-weight-500\">\n{{questionnaire.label}}</span></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-border-color s18 md-accent-fg cursor-pointer no-margin\" \nng-click=\"vm.selectedQuestionnaire(questionnaire)\"></md-icon><span class=\"text-m md-accent-fg cursor-pointer\" \nng-click=\"vm.selectedQuestionnaire(questionnaire)\">Modificar</span></div><div layout=\"row\" layout-align=\"start center\">\n<span class=\"text-m md-primary-fg cursor-pointer\" ng-click=\"vm.toDialogDeleteQuestionnaire(questionnaire)\">Inactivar\n</span></div></div></div></div></div><div layout=\"column\" ng-show=\"vm.showCreateQuestionnaire\"><div layout=\"row\" \nclass=\"md-whiteframe-3dp white-500-bg pt-30 pl-30 pr-30 pb-10 b mb-15\"><div layout=\"row\" class=\"full-width\">\n<md-input-container class=\"full-width\"><label class=\"font-weight-500\">Nombre</label><input type=\"text\" name=\"employee\" \nng-model=\"vm.questionnaireData.label\" required maxlength=\"64\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"mb-15\"><md-button ng-click=\"vm.addQuestionQuestionnaire();\" \nclass=\"send-button md-accent md-raised m-0\"><span class=\"mr-5\">Agregar pregunta</span><md-icon \nmd-font-icon=\"icon-plus  \"></md-icon></md-button></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"mb-15 container-empty-summary\" ng-if=\"!vm.questionnaireData.summary.length\"><span class=\"text-l text-secondary\">\nEl cuestionario aún no tiene preguntas agregadas</span></div><div layout=\"column\" layout-align=\"start start\" \nclass=\"mb-15 container-summary-questionaire\" layout-align=\"start center\" ng-if=\"vm.questionnaireData.summary.length\">\n<span class=\"text-m text-primary font-weight-500 mb-10\" flex=\"30\">Resumen de pregunta</span><div layout=\"row\" \nlayout-wrap class=\"full-width\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-5\" \nng-repeat=\"summary in vm.questionnaireData.summary\" flex=\"25\"><span class=\"text-s primary mr-5\">{{summary.label}}\n</span><div class=\"badge-circle\">{{summary.questions}}</div></div></div></div><div \nclass=\"container-questions-questionnaire mb-15\" layout=\"column\" ng-if=\"vm.questionnaireData.summary.length\"><span \nclass=\"text-l text-primary\">Preguntas asociadas al cuestionario</span><div \nclass=\"container-questionnaire md-whiteframe-10dp\"><div class=\"conatiner-question bb\" \nng-class=\"question.show ? \'isShow\' : \'\'\" layout=\"column\" ng-repeat=\"question in vm.question_questionnaires\" \nng-if=\"!question.delete\"><div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"70\"><span \nclass=\"text-m text-primary\" ng-if=\"!question.show\">{{question.question_text}}</span><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-m text-secondary font-weight-600 ml-r\">Tema:</span> <span \nclass=\"text-m text-secondary\">{{question.edo_topic}}</span></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-m text-secondary\">{{question.edo_question}}</span></div></div><div layout=\"row\" layout-align=\"end start\" \nflex=\"30\"><div layout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m cursor-pointer\" \nng-if=\"!question.show\" ng-click=\"question.show = true;\">Ver respuesta</span> <span \nclass=\"md-accent-fg text-m cursor-pointer\" ng-if=\"question.show\" ng-click=\"question.show = false;\">Ocultar respuesta\n</span><md-icon md-font-icon=\"icon-chevron-up s18 cursor-pointer mr-5 md-accent-fg\" ng-click=\"question.show = false;\" \nng-if=\"question.show\"></md-icon><md-icon md-font-icon=\"icon-chevron-down s18 cursor-pointer mr-5 md-accent-fg\" \nng-click=\"question.show = true;\" ng-if=\"!question.show\"></md-icon></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-trash s18 cursor-pointer mr-5 md-accent-fg\" \nng-click=\"vm.removeQuestionInQuestionnaire($index);\"></md-icon><span class=\"md-accent-fg text-m cursor-pointer\" \nng-click=\"vm.removeQuestionInQuestionnaire($index);\">Retirar</span></div></div></div><div layout=\"row\" \nng-if=\"question.show\" class=\"mt-10\" id=\"edo-container\"><ik-question-type ng-model=\"question\" \ntype=\"question.edo_question_type\" config=\"vm.configQuestionarie\" class=\"full-width\"></ik-question-type></div></div>\n</div></div><div layout=\"row\" layout-align=\"center center\" class=\"mb-15\"><md-button \nng-click=\"vm.showCreateQuestionnaire = false;vm.resetQuestionnaire()\" class=\"send-button md-warn md-raised\">Cancelar\n</md-button><md-button ng-click=\"vm.saveFormQuestionnaire();\" ng-disabled=\"!vm.questionnaireData.label\" \nclass=\"send-button md-accent md-raised\">Guardar</md-button></div></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_questions-list.html","<div id=\"container-questionnaires\"><div layout=\"column\" ng-show=\"!vm.showCreateQuestions\"><div \nclass=\"md-inline-form mb-15\"><div layout=\"row\" flex layout-wrap><md-input-container flex=\"33\"><label>Buscar</label>\n<md-icon md-font-icon=\"icon-magnify\" class=\"name\"></md-icon><input type=\"text\" name=\"employee\" \nng-model=\"vm.questionsSearch\"></md-input-container><md-input-container flex=\"33\"><label>Tipo</label><md-select \nng-model=\"vm.type\"><md-option value=\"\">-- --</md-option><md-option ng-repeat=\"type in vm.type_questions\" \nng-value=\"type.id\">{{type.label}}</md-option></md-select></md-input-container><div layout=\"row\" \nlayout-align=\"end center\" flex=\"33\"><md-button ng-click=\"vm.showCreateQuestions = true;\" \nclass=\"send-button md-accent md-raised m-0\">Nuevo</md-button></div></div></div><div \nclass=\"md-whiteframe-12dp white-500-bg mb-15\" layout=\"column\"><div layout=\"row\" layout-wrap \nclass=\"table-questionaries\" \nng-repeat=\"questions in vm.edo_questions | filterQuestionType: vm.type | filterQuestionText: vm.questionsSearch:\'question_text\' | orderBy: \'question_text\'\" \nng-if=\"questions.is_active\"><div layout=\"column\" flex=\"80\"><span class=\"text-l text-primary\">\n{{questions.question_text}}</span><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-m text-secondary font-weight-600 ml-r\">Tema:</span> <span class=\"text-m text-secondary\">\n{{questions.edo_topic.label}}</span></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-m text-secondary\">{{questions.edo_question_type.label}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"20\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!questions.inactive\"><md-icon md-font-icon=\"icon-border-color s18 md-accent-fg cursor-pointer no-margin\" \nng-click=\"vm.selectedQuestion(questions)\"></md-icon><span class=\"text-m md-accent-fg cursor-pointer\" \nng-click=\"vm.selectedQuestion(questions)\">Modificar</span></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!questions.inactive\"><span class=\"text-m md-primary-fg cursor-pointer\" \nng-click=\"vm.toDialogDeleteQuestion(questions)\">Inactivar</span></div><div layout=\"row\" layout-align=\"space-around\" \nng-if=\"questions.inactive\"><span class=\"text-m md-primary-fg cursor-pointer\">Inactivando pregunta...</span></div></div>\n</div></div></div><div layout=\"column\" ng-show=\"vm.showCreateQuestions\"><form name=\"questionForm\" novalidate><div \nlayout=\"column\" class=\"md-whiteframe-12dp white-500-bg\"><div layout=\"column\" class=\"p-40\"><div layout=\"column\" \nclass=\"mb-15\"><span class=\"text-l text-primary\">Tema</span><md-input-container><label>Seleccione</label><md-select \nng-model=\"vm.questionsData.edo_topic_id\" required><md-option ng-repeat=\"topic in vm.topics\" ng-value=\"topic.id\">\n{{topic.label}}</md-option></md-select></md-input-container></div><div layout=\"column\" class=\"mb-15\" \nng-if=\"!vm.questionsData.id\"><span class=\"text-l text-primary mb-10\">Tipo</span><div layout=\"row\" layout-wrap><div \nng-repeat=\"type in vm.type_questions\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\" layout=\"row\" layout-align=\"start start\" class=\"mb-10\"><label \nclass=\"container-radio-button pl-25\"><input type=\"radio\" ng-model=\"vm.questionsData.edo_question_type_id\" \nng-value=\"type.id\" ng-change=\"vm.resetAnswerChoices()\" required> <span class=\"checkmark-radio-button\"></span></label>\n<div layout=\"row\" layout-align=\"start start\"><span class=\"text-m text-secondary\">{{type.label}}</span></div></div>\n</div></div><div layout=\"column\" class=\"mb-15\"><span class=\"text-l text-primary\">Enunciado</span><md-input-container>\n<input type=\"text\" name=\"employee\" ng-model=\"vm.questionsData.question_text\" required></md-input-container></div><div \nlayout=\"column\" layout-wrap class=\"mb-15\"><span class=\"text-l text-primary\">Imagen del enunciado</span><div \nlayout=\"row\" layout-align=\"start center\"><img src=\"{{vm.questionsData.img}}\" class=\"thumbnail mr-15\" \nng-if=\"vm.questionsData.img\"> <span class=\"text-m text-secondary\" ng-if=\"!vm.questionsData.img\">Seleccionar archivo\n</span> <input type=\"file\" id=\"headerimg\" on-file-change=\"handleFileSelect\" class=\"ng-hide\" accept=\"image/*\"><md-button\n id=\"uploadButton\" class=\"md-raised md-primary btn-personalize\" ng-click=\"vm.selectHeaderImage(\'headerimg\')\" \nng-if=\"!vm.questionsData.img\">Adjuntar</md-button><div layout=\"row\" layout-align=\"start center\" \nclass=\"name-img-container\" ng-if=\"vm.questionsData.img\"><span class=\"text-m text-secondary cursor-pointer\" \nng-click=\"vm.showImageDialog(vm.questionsData.img,\'Imagen del anunciado\')\">\n{{vm.questionsData.img ? \'Mostrar imagen del enunciado\' : \'Seleccionar archivo\'}}</span><md-icon \nmd-font-icon=\"icon-close s18 cursor-pointer\" ng-click=\"vm.removeImgAnunciado()\"></md-icon></div></div></div></div><div \nlayout=\"column\" class=\"container-questions\" ng-if=\"vm.questionsData.edo_question_type_id\"><span \nclass=\"text-l text-secondary pl-20 font-weight-500\">Configuración de respuesta</span><div \nng-if=\"vm.questionsData.edo_question_type_id == 1\" class=\"container-questions\"><div layout=\"column\" layout-wrap \nclass=\"mb-25\" layout-align=\"start start\"><span class=\"text-l text-primary mb-10\">¿La respuesta contiene texto o imagen?\n</span><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"pr-15\"><label \nclass=\"container-radio-button\"><input type=\"radio\" ng-model=\"vm.quesionsConfig.onlyImg\" ng-value=\"true\"> <span \nclass=\"checkmark-radio-button\"></span></label><div layout=\"row\" layout-align=\"start start\"><span \nclass=\"text-m text-secondary\">Imagen</span></div></div><div layout=\"row\"><label class=\"container-radio-button\"><input \ntype=\"radio\" ng-model=\"vm.quesionsConfig.onlyImg\" ng-value=\"false\"> <span class=\"checkmark-radio-button\"></span>\n</label><div layout=\"row\" layout-align=\"start start\"><span class=\"text-m text-secondary\">Texto</span></div></div></div>\n</div><div layout=\"column\" layout-wrap class=\"mb-15\" layout-align=\"start start\"><span \nclass=\"text-l text-primary mb-15\">Opciones de respuesta</span><div layout=\"column\" class=\"full-width\"><div \nlayout=\"row\" class=\"answer-choices-options\" ng-repeat=\"choice in vm.questionsData.edo_answer_choices track by $index\" \nng-if=\"!choice.delete\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nflex=\"vm.questionsData.edo_answer_choices.length > 1 ? 90 : 100\" class=\"answer-choices-options-label\" layout-wrap><div \nlayout=\"row\" flex=\"80\"><md-input-container ng-if=\"!vm.quesionsConfig.onlyImg\" class=\"full-width m-0\"><label>\nOpción {{vm.alphabet[$index]}}</label><input type=\"text\" name=\"employee\" ng-model=\"choice.label\"></md-input-container>\n<div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.quesionsConfig.onlyImg\"><img src=\"{{choice.img}}\" \nclass=\"thumbnail mr-15\" ng-if=\"choice.img\"> <span class=\"text-m text-secondary\" ng-if=\"!choice.img\">Seleccionar archivo\n</span> <input type=\"file\" id=\"{{\'file\'+$index}}\" on-file-change=\"handleFileSelect\" class=\"ng-hide\" accept=\"image/*\">\n<md-button id=\"uploadButton\" class=\"md-raised md-primary btn-personalize\" \nng-click=\"vm.selectFileChoices(\'file\'+$index,$index)\" ng-if=\"!choice.img\">Adjuntar</md-button><div layout=\"row\" \nlayout-align=\"start center\" class=\"name-img-container\" ng-if=\"choice.img\"><span \nclass=\"text-m text-secondary cursor-pointer\" ng-click=\"vm.showImageDialog(choice.img,\'Opción \'+vm.alphabet[$index])\">\n{{\'Ver imagen opción \'+vm.alphabet[$index]}}</span><md-icon md-font-icon=\"icon-close s18 cursor-pointer\" \nng-click=\"vm.deleteImgChoice($index)\"></md-icon></div></div></div><div layout=\"row\" class=\"pl-15\" flex=\"20\"><label \nclass=\"container-radio-button\"><input type=\"radio\" ng-model=\"choice.isCorrect\" ng-value=\"true\" \nng-change=\"vm.selectedCorrectChoice($index)\"> <span class=\"checkmark-radio-button\"></span></label><div layout=\"row\" \nlayout-align=\"start start\"><span class=\"text-m text-secondary\">Respuesta correcta</span></div></div></div><div \nlayout=\"row\" layout-align=\"start center\" flex=\"10\" class=\"answer-choices-options-option\" \nng-if=\"vm.questionsData.edo_answer_choices.length > 1\"><md-icon \nmd-font-icon=\"icon-trash s18 cursor-pointer mr-5 text-secondary m-0\" ng-click=\"vm.deleteAnswerChoices($index);\" \nng-if=\"vm.questionsData.edo_answer_choices.length > 1\"></md-icon><span class=\"text-secondary text-m cursor-pointer\" \nng-click=\"vm.deleteAnswerChoices($index);\" ng-if=\"vm.questionsData.edo_answer_choices.length > 1\">Retirar</span></div>\n</div><div layout=\"row\" layout-align=\"end center \"><md-button class=\"md-fab md-accent\" aria-label=\"Add Questions\" \nng-click=\"vm.addEdoAnswerChoices();\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div></div>\n<div ng-if=\"vm.questionsData.edo_question_type_id == 3\" class=\"container-questions\"><div layout=\"column\" layout-wrap \nclass=\"mb-25\" layout-align=\"start start\"><span class=\"text-l text-primary mb-10\">¿La respuesta contiene texto o imagen?\n</span><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"pr-15\"><label \nclass=\"container-radio-button\"><input type=\"radio\" ng-model=\"vm.quesionsConfig.onlyImg\" ng-value=\"true\"> <span \nclass=\"checkmark-radio-button\"></span></label><div layout=\"row\" layout-align=\"start start\"><span \nclass=\"text-m text-secondary\">Imagen</span></div></div><div layout=\"row\"><label class=\"container-radio-button\"><input \ntype=\"radio\" ng-model=\"vm.quesionsConfig.onlyImg\" ng-value=\"false\"> <span class=\"checkmark-radio-button\"></span>\n</label><div layout=\"row\" layout-align=\"start start\"><span class=\"text-m text-secondary\">Texto</span></div></div></div>\n</div><div layout=\"column\" layout-wrap class=\"mb-15\" layout-align=\"start start\"><span \nclass=\"text-l text-primary mb-15\">Opciones de respuesta</span><div layout=\"column\" class=\"full-width\"><div \nlayout=\"row\" class=\"answer-choices-options\" ng-repeat=\"choice in vm.questionsData.edo_answer_choices track by $index\" \nng-if=\"!choice.delete\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nflex=\"vm.questionsData.edo_answer_choices.length > 1 ? 90 : 100\" class=\"answer-choices-options-label\" layout-wrap><div \nlayout=\"row\" flex=\"80\"><md-input-container ng-if=\"!vm.quesionsConfig.onlyImg\" class=\"full-width m-0\"><label>\nOpción {{vm.alphabet[$index]}}</label><input type=\"text\" name=\"employee\" ng-model=\"choice.label\"></md-input-container>\n<div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.quesionsConfig.onlyImg\"><img src=\"{{choice.img}}\" \nclass=\"thumbnail mr-15\" ng-if=\"choice.img\"> <span class=\"text-m text-secondary\" ng-if=\"!choice.img\">Seleccionar archivo\n</span> <input type=\"file\" id=\"{{\'file\'+$index}}\" on-file-change=\"handleFileSelect\" class=\"ng-hide\" accept=\"image/*\">\n<md-button id=\"uploadButton\" class=\"md-raised md-primary btn-personalize\" \nng-click=\"vm.selectFileChoices(\'file\'+$index,$index)\" ng-if=\"!choice.img\">Adjuntar</md-button><div layout=\"row\" \nlayout-align=\"start center\" class=\"name-img-container\" ng-if=\"choice.img\"><span \nclass=\"text-m text-secondary cursor-pointer\" ng-click=\"vm.showImageDialog(choice.img,\'Opción \'+vm.alphabet[$index])\">\n{{\'Ver imagen opción \'+vm.alphabet[$index]}}</span><md-icon md-font-icon=\"icon-close s18 cursor-pointer\" \nng-click=\"vm.deleteImgChoice($index)\"></md-icon></div></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-15\" flex=\"20\"><md-checkbox ng-model=\"choice.is_correct_answer\" ng-value=\"true\" aria-label=\"employee\" \nclass=\"m-0\"><span class=\"text-m text-secondary\">Respuesta Correcta</span></md-checkbox></div></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\" class=\"answer-choices-options-option\" \nng-if=\"vm.questionsData.edo_answer_choices.length > 1\"><md-icon \nmd-font-icon=\"icon-trash s18 cursor-pointer mr-5 text-secondary m-0\" ng-click=\"vm.deleteAnswerChoices($index);\" \nng-if=\"vm.questionsData.edo_answer_choices.length > 1\"></md-icon><span class=\"text-secondary text-m cursor-pointer\" \nng-click=\"vm.deleteAnswerChoices($index);\" ng-if=\"vm.questionsData.edo_answer_choices.length > 1\">Retirar</span></div>\n</div><div layout=\"row\" layout-align=\"end center \"><md-button class=\"md-fab md-accent\" aria-label=\"Add Questions\" \nng-click=\"vm.addEdoAnswerChoices();\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div></div>\n<div ng-if=\"vm.questionsData.edo_question_type_id == 4\" class=\"container-questions\"><div layout=\"column\" \nlayout-align=\"center start\"><span class=\"text-l text-primary mb-15\">Opciones de respuesta*</span><div \nclass=\"input-number\"><md-input-container class=\"full-width m-0\"><input type=\"text\" name=\"employee\" \nng-model=\"vm.questionsData.numerical_answer\" number required></md-input-container></div></div></div><div \nng-if=\"vm.questionsData.edo_question_type_id == 2\" class=\"container-questions\"><div layout=\"column\" class=\"mb-15\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"answer-association\" \nng-repeat=\"choice in vm.questionsData.edo_answer_choices track by $index\"><div layout=\"row\" layout-wrap><div \nflex=\"vm.questionsData.edo_answer_choices.length > 1 ? 90 : 100\" class=\"answer-choices-options-label\">\n<md-input-container class=\"full-width m-0\"><label>Agregar titulo de la opción</label><input type=\"text\" \nname=\"employee\" ng-model=\"choice.label\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" \nflex=\"10\" class=\"answer-choices-options-option\" ng-if=\"vm.questionsData.edo_answer_choices.length > 1\"><md-icon \nmd-font-icon=\"icon-trash s18 cursor-pointer mr-5 text-secondary m-0\" ng-click=\"vm.deleteAnswerChoices($index);\" \nng-if=\"vm.questionsData.edo_answer_choices.length > 1\"></md-icon><span class=\"text-secondary text-m cursor-pointer\" \nng-click=\"vm.deleteAnswerChoices($index);\" ng-if=\"vm.questionsData.edo_answer_choices.length > 1\">Retirar</span></div>\n</div><div layout=\"row\" layout-align=\"start center\" class=\"answer-choices-options-img\"><img src=\"{{choice.img}}\" \nclass=\"thumbnail mr-15\" ng-if=\"choice.img\"> <span class=\"text-m text-secondary\" ng-if=\"!choice.img\">Seleccionar archivo\n</span> <input type=\"file\" id=\"{{\'file\'+$index}}\" on-file-change=\"handleFileSelect\" class=\"ng-hide\" accept=\"image/*\">\n<md-button id=\"uploadButton\" class=\"md-raised md-primary btn-personalize\" \nng-click=\"vm.selectFileChoices(\'file\'+$index,$index)\" ng-if=\"!choice.img\">Adjuntar</md-button><div layout=\"row\" \nlayout-align=\"start center\" class=\"name-img-container\" ng-if=\"choice.img\"><span \nclass=\"text-m text-secondary cursor-pointer\" ng-click=\"vm.showImageDialog(choice.img,\'Opción \'+vm.alphabet[$index])\">\n{{\'Ver imagen opción \'+vm.alphabet[$index]}}</span><md-icon md-font-icon=\"icon-close s18 cursor-pointer\" \nng-click=\"vm.deleteImgChoice($index)\"></md-icon></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"answer-choices-options-response\"><md-input-container class=\"full-width\"><label class=\"md-accent-fg\">\nRespuesta asociada</label><input type=\"text\" name=\"employee\" ng-model=\"choice.response\"></md-input-container></div>\n</div><div layout=\"row\" layout-align=\"end center \" class=\"full-width\"><md-button class=\"md-fab md-accent\" \naria-label=\"Add Questions\" ng-click=\"vm.addEdoAnswerChoices();\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div></div></div></div><div layout=\"row\" layout-align=\"center center\" class=\"mt-15 mb-15\">\n{{questionForm.$valid + \' - \'+vm.quesionsConfig.formValid + \' - \'+ vm.loadingSaveQuestion}}<md-button \nng-click=\"vm.showCreateQuestions = false;vm.resetFormQuestion();\" ng-disabled=\"vm.loadingSaveQuestion\" \nclass=\"send-button md-warn md-raised\">Cancelar</md-button><md-button ng-click=\"vm.saveFormQuestion();\" \nng-disabled=\"!questionForm.$valid || !vm.quesionsConfig.formValid || vm.loadingSaveQuestion\" \nclass=\"send-button md-accent md-raised\">{{vm.loadingSaveQuestion ? \'Guardando...\' : \'Guardar\'}}</md-button></div>\n</form></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_skills-profiles-list.html","<div ng-if=\"!vm.skillsProfiles\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><div ng-if=\"vm.skillsProfiles\">\n<table class=\"skills-table\"><tr><th><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"search\" placeholder=\"Buscar\" type=\"text\" ng-model=\"vm.searchProfile\"></md-input-container></div></th><th \nng-repeat=\"skill in vm.skills\">{{skill.name}}</th></tr><tr \nng-repeat=\"profile in vm.skillsProfiles | filter: vm.searchProfile \"><td><div>{{profile.empleado.name}}</div><div \nclass=\"ml-5\"><div class=\"secondary-text\">{{profile.matricula.cargo.name}}</div><div class=\"secondary-text\">\n{{profile.matricula.empresa.name}}</div><div class=\"secondary-text\">Nivel: {{profile.matricula.nivel}}</div></div></td>\n<td ng-repeat=\"skill in vm.skills\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s20 md-accent\" \nng-if=\"vm.hasSkill(profile, skill.id)\"></md-icon></td></tr></table></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/_topics-list.html","<div id=\"container-topics\"><div layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nlayout=\"row\" flex=\"50\"><md-input-container class=\"md-block full-width\"><label>Buscar</label><md-icon \nmd-font-icon=\"icon-magnify\" class=\"name\"></md-icon><input type=\"text\" name=\"employee\" ng-model=\"vm.topicSearch\">\n</md-input-container></div><div layout=\"row\" layout-align=\"end\" flex=\"50\"><md-button ng-click=\"vm.toDialogTopics()\" \nclass=\"send-button md-accent md-raised m-0\">Nuevo</md-button></div></div><div \nclass=\"md-whiteframe-12dp white-500-bg mb-15\" layout=\"column\"><div layout=\"row\" layout-wrap \nclass=\"table-questionaries\" \nng-repeat=\"topic in vm.topics | filterQuestionText: vm.topicSearch:\'label\':\'description\' | orderBy: \'label\' track by $index\" \nng-if=\"topic.is_active\"><div layout=\"row\" flex=\"80\"><div layout=\"column\" class=\"pl-25\"><span \nclass=\"text-l text-primary\">{{topic.label}}</span> <span class=\"text-m text-secondary\">{{topic.description}}</span>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"20\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!topic.inactive\"><md-icon \nmd-font-icon=\"icon-border-color s18 md-accent-fg cursor-pointer no-margin\" ng-click=\"vm.toDialogTopics(topic)\">\n</md-icon><span class=\"text-m md-accent-fg cursor-pointer\" ng-click=\"vm.toDialogTopics(topic)\">Modificar</span></div>\n<div layout=\"row\" layout-align=\"start center\" ng-if=\"!topic.inactive\"><span \nclass=\"text-m md-primary-fg cursor-pointer\" ng-click=\"vm.toDialogDeleteTopics(topic)\">Inactivar</span></div><div \nlayout=\"row\" layout-align=\"space-around\" ng-if=\"topic.inactive\"><span class=\"text-m md-primary-fg cursor-pointer\">\nInactivando tema...</span></div></div></div></div></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/partials/backup.html","<div ng-if=\"!vm.evaluations\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><div ng-if=\"vm.evaluations\"><div \nclass=\"submenu\" layout=\"row\" layout-align=\"end end\"><md-button class=\"md-raised md-primary-bg btn-capitalize\" \nng-click=\"vm.openEnrollEmployeeDialog($event)\">Evaluación Indicadores</md-button></div><div class=\"md-inline-form\"><div\n layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"25\"><label>Empresa</label><md-select \nng-model=\"vm.search[\'company\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"company in vm.organizationCompanies\" value=\"{{company.id}}\">{{company.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"25\"><label>Gerencia</label><md-select \nng-model=\"vm.search[\'department\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"department in vm.organizationDepartments\" value=\"{{department.id}}\">{{department.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"25\"><label>Área</label><md-select \nng-model=\"vm.search[\'area\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"area in vm.organizationAreas\" value=\"{{area.id}}\">{{area.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"25\"><label>Cargo</label><md-select ng-model=\"vm.search[\'position\']\"><md-option value=\"\">\n----------------</md-option><md-option ng-repeat=\"position in vm.organizationPositions\" value=\"{{position.id}}\">\n{{position.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Nivel</label>\n<md-select ng-model=\"vm.search[\'positionLevel\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"positionLevel in [1, 2, 3, 4, 5]\" value=\"{{positionLevel}}\">{{positionLevel}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"25\"><label>Colaborador</label><input type=\"text\" name=\"employee\" \nng-model=\"vm.search[\'employee\']\"></md-input-container></div></div><div class=\"widget-group\" layout=\"column\" \nlayout-sm=\"row\" layout-gt-sm=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" flex=\"20\" \nng-repeat=\"evProcess in vm.reportEvaluationProcessStatus.data\"><ms-widget-front class=\"white-bg\" layout=\"column\"><div \nclass=\"p-10 md-primary-bg\" layout=\"row\" layout-align=\"space-between center\"><div>{{evProcess.name}} <b>\n({{evProcess.total}})</b></div><a href=\"#\" class=\"white-fg\" ng-click=\"flipWidget()\">Ampliar plazo</a></div><div \nclass=\"text-gray-800\"><div \nng-repeat=\"stage in vm.reportEvaluationProcessStatus.stagesInfo[evProcess.evaluation_processes_id]\"><div class=\"small\" \nlayout=\"row\" ng-if=\"!stage.is_last_stage\"><div class=\"ph-10 pv-5\" \nng-class=\"{\'green-900-fg\': stage.last_stage, \'bb\': !stage.last_stage}\" flex=\"80\">{{stage.name}}</div><div \nclass=\"pr-10 pv-5 text-right\" ng-class=\"{\'green-900-fg\': stage.last_stage, \'bb\': !stage.last_stage}\" flex=\"20\"><b>\n{{evProcess.stages[stage.id] ? evProcess.stages[stage.id] : 0}}</b> <span class=\"secondary-text\">\n({{evProcess.stages[stage.id] ? evProcess.stages[stage.id]/evProcess.total*100 : 0 | number:0}}%)</span></div></div>\n<div ng-if=\"stage.is_last_stage\" layout=\"column\" class=\"mb-15\"><div layout=\"row\"><div class=\"ph-10 pv-5 green-900-fg\" \nflex=\"80\">{{stage.name}}</div><div class=\"pr-10 pv-5 green-900-fg text-right\" flex=\"20\"><b>\n{{evProcess.stages[stage.id] ? evProcess.stages[stage.id] : 0}}</b> <span class=\"secondary-text\">\n({{evProcess.stages[stage.id] ? evProcess.stages[stage.id]/evProcess.total*100 : 0 | number:0}}%)</span></div></div>\n<md-progress-linear class=\"ph-10 md-accent\" md-mode=\"determinate\" \nvalue=\"{{evProcess.stages[stage.id]/evProcess.total*100}}\"></md-progress-linear></div></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 grey-200-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><form name=\"wForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pt-10\"><b>Fecha límite:</b></div><md-datepicker flex ng-model=\"vm.process_deadline\" \nmd-placeholder=\"Fecha límite\" required></md-datepicker><md-button class=\"md-icon-button md-accent\" \nng-click=\"vm.setActiveProcessDeadline($event, evProcess.id); flipWidget()\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip><span>Aceptar</span></md-tooltip></md-button></div></form></ms-widget-back></ms-widget></div>\n<table class=\"dataTable\"><thead><tr><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Colaborador</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Ubicación</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Jefe</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Aprobador</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Jefe Corporativo</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Grupo</span></div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span \nclass=\"column-title\">Proceso</span></div></th></tr></thead><tbody><tr \nng-repeat=\"evaluation in vm.evaluations | filter: vm.search[\'employee\'] | filterByPositionLevel:vm.search[\'positionLevel\'] | filterByCompany:vm.search[\'company\'] | filterByDepartment:vm.search[\'department\'] | filterByArea:vm.search[\'area\'] | filterByPosition:vm.search[\'position\']\">\n<td layout=\"column\"><a href=\"#\" ui-sref=\"app.cstm_evaluation_details({employee_process_id: evaluation.id})\">\n{{evaluation.empleado.name}}</a> <span class=\"secondary-text\">{{evaluation.empleado.cedula}}</span></td><td><div>\n{{evaluation.empresa.name}}</div><div>{{evaluation.cargo.name}}</div><div>{{evaluation.company_department.name}}</div>\n<div>{{evaluation.area.name}}</div><div><b>Nivel:</b> {{evaluation.nivel}}</div></td><td>{{evaluation.chief.name}}</td>\n<td>{{evaluation.approval_chief.name}}</td><td>{{evaluation.corp_chief.name}}</td><td>{{evaluation.grupo}}</td><td>\n<div><b>{{evaluation.evaluation_active_process.evaluation_process.name}} {{evaluation.evaluation_active_process.name}}\n</b></div><div>{{evaluation.evaluation_process_stage.name}}</div><div \nng-class=\"{\'red-fg\' : evaluation.process_deadline < vm.today}\" ng-if=\"evaluation.process_deadline\"><b>Plazo:</b>\n {{evaluation.process_deadline | fecha}}</div></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/organization/employees/organization_employees.html","<div id=\"organization-employees\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span><span class=\"logo-text\">Colaboradores</span></div><div layout=\"row\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.goImport()\">Importar colaboradores</md-button><md-button \nclass=\"md-raised md-primary-bg\" ng-click=\"vm.openEmployeeDialog($event, {})\">Nuevo colaborador</md-button></div></div>\n<div class=\"content\"><md-tabs md-dynamic-height ng-if=\"vm.isDataLoaded\"><md-tab label=\"Colaboradores activos\"><div \nng-include=\"\'app/main/custom_modules/organization/employees/partials/_employees-list.html\'\"></div></md-tab><md-tab \nlabel=\"Colaboradores inactivos\" md-on-select=\"vm.loadInactiveEmployees()\"><div \nng-include=\"\'app/main/custom_modules/organization/employees/partials/_inactive-employees-list.html\'\"></div></md-tab>\n</md-tabs></div></div></div>");
$templateCache.put("app/main/custom_modules/organization/partials/_areas-list.html","<div id=\"employees-list\"><div class=\"submenu\" layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-raised md-primary btn-capitalize\" ng-click=\"vm.goImport(\'area\')\">Importar areas</md-button><md-button \nclass=\"md-raised md-primary-bg btn-capitalize\" ng-click=\"vm.addForm = true\" ng-hide=\"vm.addForm\">Nueva área</md-button>\n</div><div class=\"form-wrapper md-whiteframe-1dp m-20\" flex=\"100\" ng-show=\"vm.addForm\"><form name=\"addForm\" \nclass=\"md-inline-form\" novalidate><md-input-container flex><input type=\"text\" name=\"name\" ng-model=\"vm.newItemName\" \nplaceholder=\"Nombre del área\" required><div ng-messages=\"addForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>El nombre del área es requerida.</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-click=\"vm.addItem(\'area\')\" aria-label=\"Submit\" \nng-disabled=\"addForm.$invalid || addForm.$pristine\">Aceptar</md-button><md-button ng-click=\"vm.addForm = false\" \nclass=\"md-raised md-warn\" aria-label=\"Cancelar\">Cancelar</md-button></form></div><table \nclass=\"dataTable listData row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Área</span></div></th></tr></thead><tbody><tr \nng-repeat=\"area in vm.organizationAreas\"><td><md-menu ng-if=\"!vm.employeeProcess[employee.id]\"><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.currentEdit = area.id; vm.editData = area.name\">Modificar</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item><md-button class=\"md-warn\" \nng-click=\"vm.removeItem($event, \'area\', area)\">Eliminar</md-button></md-menu-item></md-menu-content></md-menu>\n<md-progress-circular ng-disabled=\"!vm.employeeProcess[employee.id]\" ng-if=\"vm.employeeProcess[employee.id]\" \nclass=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></td><td><div ng-if=\"vm.currentEdit !== area.id\">\n{{area.name}}</div><div ng-if=\"vm.currentEdit == area.id\"><md-input-container><input name=\"meta\" \nng-model=\"vm.editData\"></md-input-container><md-button type=\"submit\" ng-click=\"vm.updateItem(\'area\', area.id, area)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"!vm.editData\" ng-if=\"!vm.sendingData\">GUARDAR</md-button>\n<md-button type=\"submit\" ng-click=\"vm.currentEdit = null\" class=\"send-button md-warn md-raised\" \nng-if=\"!vm.sendingData\">CANCELAR</md-button><md-progress-circular ng-disabled=\"!vm.sendingData\" ng-if=\"vm.sendingData\" \nclass=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/organization/partials/_companies-list.html","<div id=\"employees-list\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th><div class=\"table-header\"><span class=\"column-title\">Unidad de negocio</span></div></th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"company in vm.organizationCompanies\"><td>{{company.name}}</td><td><md-menu \nng-if=\"!vm.employeeProcess[employee.id]\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openEmployeeDialog($event, employee)\">Modificar</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteContactConfirm(contact, ev)\">Restablecer contraseña</md-button></md-menu-item><md-divider \nng-if=\"vm.user.groups\"></md-divider><md-menu-item><md-button class=\"md-warn\" \nng-click=\"vm.removeEmployee($event, employee)\">Eliminar</md-button></md-menu-item></md-menu-content></md-menu>\n<md-progress-circular ng-disabled=\"!vm.employeeProcess[employee.id]\" ng-if=\"vm.employeeProcess[employee.id]\" \nclass=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/organization/partials/_departments-list.html","<div id=\"employees-list\"><div class=\"submenu\" layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-raised md-primary btn-capitalize\" ng-click=\"vm.goImport(\'department\')\">Importar gerencia</md-button>\n<md-button class=\"md-raised md-primary-bg btn-capitalize\" ng-click=\"vm.addForm = true\" ng-hide=\"vm.addForm\">\nNueva gerencia</md-button></div><div class=\"form-wrapper md-whiteframe-1dp m-20\" flex=\"100\" ng-show=\"vm.addForm\"><form \nname=\"addForm\" class=\"md-inline-form\" novalidate><md-input-container flex><input type=\"text\" name=\"name\" \nng-model=\"vm.newItemName\" placeholder=\"Nombre de la gerencia\" required><div ng-messages=\"addForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>El nombre de la gerencia es requerida.</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.addItem(\'department\')\" \naria-label=\"Submit\" ng-disabled=\"addForm.$invalid || addForm.$pristine\">Aceptar</md-button><md-button \nng-click=\"vm.addForm = false\" class=\"md-raised md-warn\" aria-label=\"Cancelar\">Cancelar</md-button></form></div><table \nclass=\"dataTable listData row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Gerencia</span></div></th></tr></thead><tbody><tr \nng-repeat=\"department in vm.organizationDepartments\"><td><md-menu ng-if=\"!vm.employeeProcess[employee.id]\"><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.currentEdit = department.id; vm.editData = department.name\">Modificar</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item><md-button class=\"md-warn\" \nng-click=\"vm.removeItem($event, \'department\', department)\">Eliminar</md-button></md-menu-item></md-menu-content>\n</md-menu><md-progress-circular ng-disabled=\"!vm.employeeProcess[employee.id]\" ng-if=\"vm.employeeProcess[employee.id]\" \nclass=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></td><td><div ng-if=\"vm.currentEdit !== department.id\">\n{{department.name}}</div><div ng-if=\"vm.currentEdit == department.id\"><md-input-container><input name=\"meta\" \nng-model=\"vm.editData\"></md-input-container><md-button type=\"submit\" \nng-click=\"vm.updateItem(\'department\', department.id, department)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!vm.editData\" ng-if=\"!vm.sendingData\">GUARDAR</md-button><md-button type=\"submit\" \nng-click=\"vm.currentEdit = null\" class=\"send-button md-warn md-raised\" ng-if=\"!vm.sendingData\">CANCELAR</md-button>\n<md-progress-circular ng-disabled=\"!vm.sendingData\" ng-if=\"vm.sendingData\" class=\"md-accent\" md-diameter=\"25px\">\n</md-progress-circular></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/organization/partials/_orgnization-chart.html","<div class=\"content p-20\"><div layout=\"row\" layout-align=\"end center\"><md-input-container flex=\"25\"><label>\nPeriodo de la plantilla</label><md-select ng-model=\"vm.formPeriodId\" ng-change=\"vm.setFromPeriodId(vm.formPeriodId)\">\n<md-option value=\"\">----------------</md-option><md-option ng-repeat=\"period in vm.periods\" ng-value=\"period.id\">\n{{period.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Periodo a importar\n</label><md-select ng-model=\"vm.period_id_import_elegible\" required \nng-change=\"vm.getDataImportElegible(vm.period_id_import_elegible)\"><md-option ng-repeat=\"period in vm.periods\" \nng-value=\"period.id\">{{period.name}}</md-option></md-select></md-input-container></div><ik-import-data \ntemplate=\"vm.configImportData.templateUrl\" config=\"vm.configImportData.config\"></ik-import-data></div>");
$templateCache.put("app/main/custom_modules/organization/partials/_positions-list.html","<div id=\"employees-list\"><div layout=\"row\" layout-wrap class=\"m-20\"><div layout=\"row\" flex=\"70\"><div \nclass=\"search-input-wrapper full-width\" layout=\"row\" layout-align=\"start center\"><label for=\"search\" \nclass=\"pl-10 pr-10\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float \nclass=\"no-errors no-padding no-margin full-width\"><input id=\"search\" placeholder=\"Buscar\" type=\"text\" \nng-model=\"vm.search_position\"></md-input-container></div></div><div class=\"submenu\" layout=\"row\" \nlayout-align=\"end end\" flex=\"30\"><md-button class=\"md-raised md-primary btn-capitalize\" \nng-click=\"vm.goImport(\'position\')\">Importar cargos</md-button><md-button \nclass=\"md-raised md-primary-bg btn-capitalize\" ng-click=\"vm.addForm = true\" ng-hide=\"vm.addForm\">Nuevo cargo\n</md-button></div></div><div class=\"form-wrapper md-whiteframe-1dp m-20\" flex=\"100\" ng-show=\"vm.addForm\"><form \nname=\"addForm\" class=\"md-inline-form\" novalidate><md-input-container flex><input type=\"text\" name=\"name\" \nng-model=\"vm.newItemName\" placeholder=\"Nombre del cargo\" required><div ng-messages=\"addForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>El nombre del cargo es requerido.</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.addItem(\'position\')\" aria-label=\"Submit\" \nng-disabled=\"addForm.$invalid || addForm.$pristine\">Aceptar</md-button><md-button ng-click=\"vm.addForm = false\" \nclass=\"md-raised md-warn\" aria-label=\"Cancelar\">Cancelar</md-button></form></div><div \nclass=\"container-material md-whiteframe-10dp m-20\"><div class=\"header-material\" \nng-style=\"{\'background-color\':vm.colors.primary}\"><span class=\"text-xl white-fg\">Cargos</span></div><div \nclass=\"container-material\"><div layout=\"row\" layout-align=\"space-between start\" \nng-repeat=\"position in vm.organizationPositions | filter:vm.search_position\" class=\"bb position\" layout-wrap><div \nflex=\"70\"><span class=\"text-m text-primary\" ng-if=\"vm.currentEdit !== position.id\">{{position.name}}</span><div \nlayout=\"column\" ng-if=\"vm.currentEdit == position.id\"><md-input-container class=\"full-width no-margin\"><input \nname=\"meta\" ng-model=\"vm.editData\"></md-input-container><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.updateItem(\'position\', position.id, position)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!vm.editData\" ng-if=\"!vm.sendingData\">GUARDAR</md-button><md-button type=\"submit\" \nng-click=\"vm.currentEdit = null\" class=\"send-button md-warn md-raised\" ng-if=\"!vm.sendingData\">CANCELAR</md-button>\n<md-progress-circular ng-disabled=\"!vm.sendingData\" ng-if=\"vm.sendingData\" class=\"md-accent\" md-diameter=\"25px\">\n</md-progress-circular></div></div></div><div layout=\"row\" layout-align=\"end center\" flex=\"30\"><span \nclass=\"md-accent-fg text-m cursor-pointer mr-5\" ng-click=\"vm.getPositionDetail(position)\" \nng-if=\"vm.enablePositionDetails\">Ver información del cargo</span><md-menu ng-if=\"!vm.employeeProcess[employee.id]\">\n<md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.currentEdit = position.id; vm.editData = position.name\">Modificar Cargo\n</md-button></md-menu-item><md-divider></md-divider><md-menu-item ng-if=\"vm.enablePositionDetails\"><md-button \nng-click=\"vm.getPositionDetailDraft(position)\">Modificar Info. Cargo</md-button></md-menu-item><md-divider \nng-if=\"vm.enablePositionDetails\"></md-divider><md-menu-item><md-button class=\"md-warn\" \nng-click=\"vm.removeItem($event, \'position\', position)\">Eliminar Cargo</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div>");
$templateCache.put("app/main/custom_modules/organization/upload/upload.html","<div id=\"organization-upload\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg ph-20 pt-10\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div></div><div \nclass=\"content p-20\"><ik-import-data template=\"vm.configImportData.templateUrl\" config=\"vm.configImportData.config\">\n</ik-import-data></div></div></div>");
$templateCache.put("app/main/elements/ik-employee-team-card/default/default.html","<div class=\"white-fg\" \nng-style=\"{\'border-top-color\': colors.accent,\'border-top-width\': \'3px\',\n\'border-top-style\': \'solid\'}\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"p-20 h-150\"><div class=\"avatar-wrapper mr-5\"><img \nng-src=\"{{data.empleado.foto}}\" class=\"avatar square big\" alt=\"\"></div><div layout=\"column\"><a href=\"\" \nclass=\"text-m font-weight-600 mb-10\" ui-sref=\"app.employee_profile_team({employee_id: data.empleado.id})\">\n{{data.empleado.name}}</a><div class=\"text-s text-secondary\">{{data.cargo.name}}</div><div \nclass=\"text-s text-secondary\">{{data.company_department.name}} / {{data.area.name}}</div><div \nclass=\"text-s text-secondary\"><b>{{data.empresa.name}}</b></div></div></div><div layout=\"row\" class=\"footer\" \nng-if=\"data.evaluation_process_stage\"><div layout=\"column\" layout-align=\"center start\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-s text-primary mr-5\">Proceso:</span> <span class=\"text-s text-secondary\">\n{{data.evaluation_process_stage.evaluation_process.name}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<span class=\"text-s text-primary mr-5\">Etapa actual:</span> <span class=\"badge-circle mr-5\" \nng-class=\"data.evaluation_process_stage.is_last_stage ? \'complete\' : \'incomplete\'\"></span> <span \nclass=\"text-s text-secondary\">{{data.evaluation_process_stage.name}}</span></div></div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data/default/default.html","<div class=\"md-primary-bg div-radius h-30\" layout=\"row\" layout-align=\"center center\" ng-if=\"data.qualitative_rating\">\n<span class=\"text-l white-fg mr-5\">Resultado de desempeño:</span> <span class=\"text-l white-fg font-weight-600\">\n{{data.qualitative_rating}}</span></div><div class=\"md-whiteframe-4dp mt-10 mb-30\"><div layout=\"row\" \nclass=\"table-header background\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Aspecto</span></th><th class=\"background text-center\"><span class=\"titleTable\">Evaluación</span>\n</th><th class=\"background text-center w-20-p\"><span class=\"titleTable\">Autoevaluación</span></th></tr></thead><tbody>\n<tr ng-repeat=\"row in data.evaluation_hr_modules\" ng-if=\"row.hr_module.has_evaluation\"><td class=\"grey-100-bg\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"text-m text-primary mb-10\">{{row.hr_module.name}} </span><span \nclass=\"text-m text-primary mb-10 ml-10\">({{row.weight }}%)</span></div></td><td \nclass=\"text-m text-secondary text-center\">{{row.final_evaluation }}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">{{row.auto_evaluation }}</td></tr><tr><td class=\"grey-100-bg\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"text-m text-primary mb-10\">Resultado evaluación</span></div></td>\n<td class=\"text-m text-secondary text-center\">{{evFinalCurrent | number: \'2\' }}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">{{evFinalCurrentAuto | number: \'2\'}}</td></tr></tbody></table></div>\n</div><div class=\"mb-15 mt-15\"><div layout=\"row\" layout-align=\"center center\"><hc-chart \noptions=\"data.chartOptions.graph1\"></hc-chart></div><div layout=\"row\" layout-align=\"center center\" class=\"mb-10 mt-10\">\n<span class=\"font-size-20 md-accent-fg\">Comparativo de las evaluaciones del desempeño anteriores</span></div><div \nlayout=\"row\" layout-align=\"space-around center\"><hc-chart options=\"data.chartOptions.graph2\"></hc-chart><hc-chart \noptions=\"data.chartOptions.graph3\"></hc-chart></div></div><div ng-include=\"data.template\" ng-model=\"data\" \nng-repeat=\"(module, data) in data.evaluation_data\" ng-if=\"!data.error\" class=\"mb-30\"></div>");
$templateCache.put("app/main/elements/ik-evaluation-result-card/default/default.html","<div class=\"ik-evaluation-result-card--default\"><div class=\"simple-table-container md-whiteframe-4dp\"><div \nclass=\"table-title\">{{ data.periodo.name }}</div><md-divider></md-divider><table class=\"simple tre\" \nms-responsive-table><thead><tr><th></th><th class=\"text-center\">Resultado</th><th class=\"text-center\">\nResultado ponderado</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"module in data.evaluation_hr_modules\" ng-if=\"module.hr_module.has_evaluation\"><td><span class=\"text-bold\">\n{{module.hr_module.name}}</span></td><td class=\"text-center\">{{module.chief_evaluation }}%</td><td class=\"text-center\">\n{{module.final_evaluation }}%</td></tr><tr><td><span class=\"text-bold\">Resultado final</span></td><td></td><td \nclass=\"text-center\"><span class=\"md-blue-grey-600-bg pv-5 ph-15 brad-5\">{{data.ev_final }}%</span></td></tr></tbody>\n</table><md-divider></md-divider><div class=\"bb\" layout=\"column\"><table class=\"evaluation-net-info\"><tr><th>Negocio\n</th><td>{{data.empresa.name }}</td></tr><tr><th>Cargo</th><td>{{data.cargo.name }}</td></tr><tr><th>Jefe</th><td>\n{{data.chief.name }}</td></tr></table><div layout=\"row\" layout-align=\"center center\" class=\"p-10\"><md-button \nclass=\"md-raised md-re\" ng-click=\"vm.showEvaluation(data.id)\">Ver evaluación</md-button></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-goal-card/default/default.html","<div layout=\"column\" class=\"mtoc\" ng-init=\"key_obj = obj.ObjetivosEmpleado.id\" id=\"card-objetivo\"><div layout=\"row\" \nclass=\"ph-15\"><div flex><p class=\"twp text_nl2br alto\">{{data.name}}</p></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-xs=\"column\"><div layout=\"row\" class=\"p-15 alto_des\" flex=\"30\" flex-xs=\"100\"><div flex><p \nclass=\"twh\">Unidad de medida</p><p class=\"twp text_nl2br\">{{obj.ObjetivosEmpleado.unidad_medida}}</p></div></div>\n<md-divider></md-divider><div layout=\"row\" class=\"p-15 alto_des\" flex=\"40\" flex-xs=\"100\"><div flex><p class=\"twh\">\nCriterio de medición</p><p class=\"twp text_nl2br\">{{obj.ObjetivosEmpleado.criterio_medicion}}</p></div></div>\n<md-divider></md-divider><div layout=\"row\" class=\"p-15 alto_des\" flex=\"30\" flex-xs=\"100\"><div flex><p class=\"twh\">Meta\n</p><p class=\"twp text_nl2br\">{{obj.ObjetivosEmpleado.meta}}</p></div></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-wrap><div flex=\"100\" class=\"text-center pv-10\"><a href=\"javascript:void(0)\" \nng-click=\"vm.mostrar_ev_seg[key_obj] = true\" ng-if=\"!vm.mostrar_ev_seg[key_obj]\">VER EVALUACIÓN DE SEGUIMIENTO</a> <a \nhref=\"javascript:void(0)\" ng-click=\"vm.mostrar_ev_seg[key_obj] = false\" ng-if=\"vm.mostrar_ev_seg[key_obj]\">\nOCULTAR EVALUACIÓN DE SEGUIMIENTO</a></div><p flex=\"100\" class=\"title_ev title_autoev mb-10\" \nng-if=\"vm.mostrar_ev_seg[key_obj]\">EVALUACIÓN DE SEGUIMIENTO</p><div class=\"ph-15\" flex=\"50\" flex-xs=\"100\" \nflex-sm=\"100\" flex-md=\"100\" ng-if=\"vm.mostrar_ev_seg[key_obj]\"><div><div><span class=\"twh\">FECHA: </span>\n{{ ::obj.Evaluacion.seg.colaborador.created | fecha }}</div><div><span class=\"twh\">AUTOEVALUACIÓN: </span>\n{{ vm.estadosSeg[ (( obj.Evaluacion.seg.colaborador.estado | number ) ) ] }}</div><div><p class=\"twh\">\nCOMENTARIOS ACERCA DEL RESULTADO OBTENIDO:</p><p class=\"twp text_nl2br\">\n{{ ::obj.Evaluacion.seg.colaborador.comentario }}</p></div></div></div><div class=\"ph-15\" flex=\"50\" flex-xs=\"100\" \nflex-sm=\"100\" flex-md=\"100\" ng-if=\"vm.mostrar_ev_seg[key_obj]\"><div><div><span class=\"twh\">FECHA: </span>\n{{ ::obj.Evaluacion.seg.jefe.created | fecha }}</div><div><span class=\"twh\">EVALUACIÓN DEL JEFE: </span>\n{{ vm.estadosSeg[ (( obj.Evaluacion.seg.jefe.estado | number ) ) ] }}</div><div><p class=\"twh\">\nCOMENTARIOS ACERCA DEL RESULTADO OBTENIDO:</p><p class=\"twp text_nl2br\">{{ ::obj.Evaluacion.seg.jefe.comentario }}</p>\n</div></div></div></div><div layout=\"row\" layout-wrap><p flex=\"100\" class=\"title_ev title_autoev mb-10\">\nEVALUACIÓN FINAL</p><div class=\"ph-15\" flex=\"50\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"100\"><div><div><span class=\"twh\">\nFECHA: </span>{{ ::obj.Evaluacion.fin.colaborador.created | fecha }}</div><div><span class=\"twh\">AUTOEVALUACIÓN: \n</span>{{ ::obj.Evaluacion.fin.colaborador.estado }}%</div><div><p class=\"twh\">\nCOMENTARIOS ACERCA DEL RESULTADO OBTENIDO:</p><p class=\"twp text_nl2br\">\n{{ ::obj.Evaluacion.fin.colaborador.comentario }}</p></div></div></div><div class=\"ph-15\" flex=\"50\" flex-xs=\"100\" \nflex-sm=\"100\" flex-md=\"100\"><div><div><span class=\"twh\">FECHA: </span>{{ ::obj.Evaluacion.fin.jefe.created | fecha }}\n</div><div><span class=\"twh\">EVALUACIÓN DEL JEFE: </span>{{ ::obj.Evaluacion.fin.jefe.estado }}%</div><div><p \nclass=\"twh\">COMENTARIOS ACERCA DEL RESULTADO OBTENIDO:</p><p class=\"twp text_nl2br\">\n{{ ::obj.Evaluacion.fin.jefe.comentario }}</p></div></div></div></div><div layout=\"row\" class=\"\"><div flex=\"100\"><div \nlayout=\"row\" class=\"sh0\"><div flex=\"{vm.Matricula.estado_obj > 10 ? 50 : 100}\" class=\"br\"><div layout=\"column\"><div>\n<h4>PONDERACIÓN</h4><h1>{{obj.ObjetivosEmpleado.porcentaje}}%</h1></div></div></div><div flex=\"50\" \nng-show=\"vm.Matricula.estado_obj > 10 && vm.Matricula.estado_obj != 16\"><div layout=\"column\"><div><h4>\nEVALUACION DE SEGUIMIENTO</h4><div class=\"white-font\">\n{{ vm.estadosSeg[ (( obj.Evaluacion.seg.jefe.estado | number ) ) ] }} <span ng-hide=\"obj.Evaluacion.seg.jefe.estado\">\nSin resultado</span></div><h1>{{card.expectativa}}</h1></div></div></div><div flex=\"50\" \nng-show=\"vm.Matricula.estado_obj == 16\"><div layout=\"column\"><div><h4>CUMPLIMIENTO PONDERADO</h4><h1>\n{{ ( (obj.ObjetivosEmpleado.porcentaje * obj.Evaluacion.fin.jefe.estado / 100) | number ) }}%</h1></div></div></div>\n</div><div layout=\"row\" class=\"sh1\" ng-show=\"vm.Matricula.estado_obj >= 12\"><div flex=\"50\" class=\"br\"><div \nlayout=\"column\" class=\"shp\"><div><div layout=\"row\"><div flex=\"75\"><p>Evaluación final - Colaborador</p></div><div \nflex=\"33\"><p>{{ obj.Evaluacion.fin.colaborador.estado }}%</p></div></div><div layout=\"row\"><div flex=\"75\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{ obj.Evaluacion.fin.colaborador.estado }}\"></md-progress-linear>\n</div></div></div></div></div><div flex=\"50\"><div layout=\"column\" class=\"shp\"><div ng-if=\"vm.ver_ev_fin_obj\"><div \nlayout=\"row\"><div flex=\"75\"><p>Evaluación final - Jefe</p></div><div flex=\"33\"><p>{{ obj.Evaluacion.fin.jefe.estado }}%\n</p></div></div><div layout=\"row\"><div flex=\"75\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{ obj.Evaluacion.fin.jefe.estado }}\"></md-progress-linear></div></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/default/default.html","<table class=\"simple full-width\" ms-responsive-table><thead><tr><th>Periodo</th><th>Negocio</th><th>Cargo</th><th>Jefe\n</th><th>Resultado</th><th></th></tr></thead><tbody><tr ng-repeat=\"row in data\"><td>{{row.periodo.name}}</td><td>\n{{row.empresa.name}}</td><td>{{row.cargo.name}}</td><td>{{row.chief.name}}</td><td>{{row.ev_final }}%</td><td><a \nhref=\"#\" ng-click=\"vm.showEvaluation(row.id)\">Ver evaluación</a></td></tr></tbody></table>");
$templateCache.put("app/main/elements/ik-import-data/default/default.html","<div id=\"ik-import-data\" flex><div layout=\"row\" layout-align=\"start center\" flex flex-wrap><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"tab\" \nng-style=\"ikImportData.tabSelected.id == 1 ? {\'border-bottom-color\':ikImportData.colors.accent,\'border-bottom-width\': \'1px\',\n        \'border-bottom-style\': \'solid\'} : {}\" \nflex=\"30\" ng-click=\"ikImportData.setStep(1)\"><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-show=\"!ikImportData.tabStep[1].isValid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-show=\"ikImportData.tabStep[1].isValid\"><i class=\"icon-check s16\">\n</i> </span><span class=\"ms-form-wizard-step-text\" \nng-style=\"ikImportData.tabSelected.id == 1 ? {\'color\':ikImportData.colors.accent} : {}\">\n{{ikImportData.config.tab.first ? ikImportData.config.tab.first : \'Plantilla\'}}</span></span></div><div layout=\"row\" \nclass=\"tab\" \nng-style=\"ikImportData.tabSelected.id == 2 ? {\'border-bottom-color\':ikImportData.colors.accent,\'border-bottom-width\': \'1px\',\n        \'border-bottom-style\': \'solid\'} : {}\" \nflex=\"30\" ng-click=\"ikImportData.setStep(2)\"><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-show=\"!ikImportData.tabStep[2].isValid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-show=\"ikImportData.tabStep[2].isValid\"><i class=\"icon-check s16\">\n</i> </span><span class=\"ms-form-wizard-step-text\" \nng-style=\"ikImportData.tabSelected.id == 2 ? {\'color\':ikImportData.colors.accent} : {}\">\n{{ikImportData.config.tab.second ? ikImportData.config.tab.second : \'Carga plantilla\'}}</span></span></div></div><div \nlayout=\"column\" ng-show=\"ikImportData.tabSelected.id == 1\" class=\"pt-10\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-10\"><div layout=\"row\" layout-align=\"start center\" class=\"mr-10\"><span \nclass=\"circle required mr-10\"></span> <span class=\"text-s text-grey\">Requerido</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button no-md-ink class=\"md-primary\" ng-click=\"ikImportData.donwloadFile()\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-download s18 mr-5\"></md-icon>Descargar plantilla\n</md-button></div></div><table class=\"dataTable row-border hover\"><thead><tr><th class=\"md-blue-grey-700-bg\"><div \nclass=\"table-header\"><span class=\"column-title\">Columna</span></div></th><th class=\"md-blue-grey-700-bg\"><div \nclass=\"table-header\"><span class=\"column-title\">Descripción</span></div></th><th class=\"md-blue-grey-700-bg\"><div \nclass=\"table-header\"><span class=\"column-title\">Valor</span></div></th><th class=\"md-blue-grey-700-bg\"><div \nclass=\"table-header\"><span class=\"column-title\">Edición</span></div></th><th class=\"md-blue-grey-700-bg\"><div \nclass=\"table-header\"><span class=\"column-title\">Restricciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key,value) in ikImportData.keysTableStructure track by $index\"><td class=\"grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-alig=\"start\" class=\"mr-10\"><span class=\"circle required mr-10\" \nng-if=\"ikImportData.tableStructure[value].required\"></span></div><span class=\"text-capitalize\">\n{{ikImportData.tableStructure[value].name}}</span></div></td><td><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"descripcion\">{{ikImportData.tableStructure[value].description }}</span></div></td><td class=\"grey-100-bg\"><span \nng-repeat=\"v in ikImportData.tableStructure[value].allowed_data track by $index\">{{v}} <span ng-if=\"!$last\">,</span>\n</span></td><td class=\"text-center\"><span class=\"text-capitalize\">\n{{ikImportData.tableStructure[value].allow_edit ? \'Si\' : \'No\'}}</span></td><td class=\"grey-100-bg text-center\"><md-icon\n md-font-icon=\"icon-information s18\" ng-if=\"ikImportData.tableStructure[value].allowed_data_type\"><md-tooltip \nmd-direction=\"bottom\">{{ikImportData.tableStructure[value].allowed_data_type}}</md-tooltip></md-icon></td></tr></tbody>\n</table></div><div layout=\"column\" ng-show=\"ikImportData.tabSelected.id == 2\" class=\"pt-10\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-20\"><input type=\"file\" id=\"uploadInput\" \nonchange=\"angular.element(this).scope().ikImportData.processImage(this)\"><md-button class=\"md-accent md-raised\" \nng-click=\"ikImportData.uploadFile()\" ng-disabled=\"!ikImportData.uploadFileConfig || ikImportData.loadingFinalize\">\nImportar plantilla</md-button></div><div layout=\"column\" ng-if=\"ikImportData.showAction\"><div \nng-repeat=\"action in ikImportData.importActionData track by $index\" ng-if=\"ikImportData[action] \" layout=\"column\"><div \nclass=\"title-div-collapse\" ng-style=\"{\'background-color\':ikImportData.colorsLicense.importData[action]}\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"ikImportData.selectedUpload[action]\" ng-value=\"true\" class=\"mb-0\"></md-checkbox><span>{{action | filterName}}\n</span></div><i ng-class=\"ikImportData.collapseTable[action] ? \'icon-chevron-up\':\'icon-chevron-down\'\" \nclass=\"cursor-pointer white-fg\" ng-click=\"ikImportData.showCollapse(action);\"></i></div><div \nclass=\"table-header table-scroll-x white-500-bg mt-10 mb-10\" ng-show=\"ikImportData.collapseTable[action]\" ms-scroll>\n<table class=\"tbl-lbl-data md-whiteframe-3dp\"><thead><tr><th class=\"background-grey-soft\" \nng-repeat=\"value in ikImportData.tableHeader track by $index\"><div class=\"table-header\"><span \nclass=\"text-m text-primary\">{{value}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"value in ikImportData[action].tableContent track by $index\" class=\"border-tr\"><td \nng-repeat=\"valueHeader in ikImportData.tableHeader track by $index\"><span class=\"\">{{value[valueHeader]}}</span></td>\n</tr></tbody></table></div></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"ikImportData.showImport\"><div layout=\"row\" layout=\"start center\" class=\"mb-10\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-10\"><span class=\"circle required mr-10\"></span> <span class=\"text-s text-grey\">\nRequerido</span></div><div layout=\"row\" layout-align=\"start center\"><span class=\"circle allow-edit mr-10\"></span> <span\n class=\"text-s text-grey\">Valor no compatible</span></div></div><div \nclass=\"table-header table-scroll-x md-whiteframe-3dp white-500-bg\"><table class=\"tbl-lbl-data\"><thead><tr><th \nclass=\"background-grey-soft\" ng-repeat=\"value in ikImportData.tableHeader track by $index\"><div class=\"table-header\">\n<span class=\"text-m text-primary\">{{value}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"value in ikImportData.importValidationData.tableContent track by $index\" class=\"border-tr\"><td \nng-repeat=\"valueHeader in ikImportData.tableHeader track by $index\"><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-alig=\"start\" class=\"mr-10\"><div ng-repeat=\"error in value.errors[valueHeader].errors\"><span \nclass=\"required circle\" ng-if=\"error == \'required\'\"></span> <span class=\"allow-edit circle\" \nng-if=\"error == \'not-allowed\'\"></span><md-icon md-font-icon=\"icon-information s18\" \nng-if=\"ikImportData.tableStructure[valueHeader][error]\"><md-tooltip md-direction=\"bottom\">\n{{ikImportData.tableStructure[valueHeader][error]}}</md-tooltip></md-icon></div></div><span class=\"\">\n{{value[valueHeader]}}</span></div></td></tr></tbody></table></div></div></div><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" ng-hide=\"vm.formSent\"><md-button class=\"md-raised md-default\" \nng-click=\" ikImportData.saveStep( ikImportData.selectedIndex, \'previous\' ) \" ng-disabled=\"ikImportData.isFirstStep()\">\nAnterior</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"ikImportData.saveStep( ikImportData.selectedIndex, \'next\')\" ng-disabled=\"ikImportData.currentStepInvalid()\" \nng-hide=\"ikImportData.isLastStep()\">Siguiente</md-button><md-button class=\"md-raised md-primary boton_fin\" \nng-click=\"ikImportData.finalizeEvaluationProcess()\" ng-show=\"ikImportData.isLastStep()\" \nng-disabled=\"!ikImportData.currentStepInvalid() || ikImportData.loadingFinalize\">Finalizar</md-button></div></div>");
$templateCache.put("app/main/modules/employee/profile/profile.html","<div id=\"employee-profile\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-around\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"p-15\"><div layout=\"column\"><div class=\"title font-weight-200\">{{vm.employeeProfile.empleado.name}}</div><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"font-weight-200\">\n{{vm.employeeProfile.empresa.name}} - {{vm.employeeProfile.cargo.name}}</span> <span \nclass=\"white-fg ml-5 font-weight-200 cursor-pointer\" ng-click=\"vm.getPositionDetail(vm.employeeProfile.cargo)\" \nng-if=\"vm.enablePositionDetails\">Ver informacion del cargo</span></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"container-breadcrumb\"><div class=\"white-fg mr-10\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon icon-people s16 mr-5\"></i> <span class=\"font-weight-500 mr-5\">Jefe:</span> \n<span class=\"parent font-weight-400\"><a href=\"#\" \nui-sref=\"app.employee_profile_team({employee_id: vm.employeeProfile.chief.id})\" class=\"grey-50-fg\">\n{{vm.employeeProfile.chief.name}}</a></span></div><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.employeeProfile.corp_chief\"><i class=\"icon icon-book s16 mr-5\"></i> <span class=\"font-weight-500 mr-5\">\nJefe corporativo:</span> <span class=\"parent font-weight-400\"><a href=\"#\" \nui-sref=\"app.employee_profile_team({employee_id: vm.employeeProfile.corp_chief.id})\" class=\"grey-50-fg\">\n{{vm.employeeProfile.corp_chief.name}}</a></span></div></div></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height ng-if=\"!vm.edo && !vm.loadingEvo\"><md-tab ng-if=\"!vm.employee_id\"><md-tab-label><span>Inicio</span>\n</md-tab-label><md-tab-body><md-content ng-include=\"\'app/main/modules/employee/profile/tabs/home/home.html\'\" \nclass=\"p-20\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>Evaluación actual</span></md-tab-label>\n<md-tab-body><md-content \nng-include=\"\'app/main/modules/employee/profile/tabs/current_evaluation/current_evaluation.html\'\" class=\"p-20\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"!vm.last_stage_id\"><md-tab-label><span>Evaluaciones anteriores\n</span></md-tab-label><md-tab-body><md-content \nng-include=\"\'app/main/modules/employee/profile/tabs/evaluations_history/evaluations_history.html\'\" class=\"p-20\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"!vm.last_stage_id\"><md-tab-label><span>Equipo de trabajo</span>\n</md-tab-label><md-tab-body><md-content ng-include=\"\'app/main/modules/employee/profile/tabs/work_team/work_team.html\'\" \nclass=\"p-20\"></md-content></md-tab-body></md-tab></md-tabs><div id=\"edo-container\" ng-if=\"vm.edo && !vm.emptyEdo\"><div \nlayout=\"column\" class=\"md-whiteframe-15dp welcome\" ng-if=\"!vm.cuestionaireHasTime\"><md-progress-linear \nmd-mode=\"determinate\" value=\"0\" class=\"progress\"></md-progress-linear><div layout=\"column\" \nlayout-align=\"center center\" class=\"content-welcome\"><span class=\"text-xl text-primary font-weight-500\">\nHa finalizado el tiempo límite para responder el cuestionario: </span><span \nclass=\"text-xl text-primary font-weight-300 mt-15\">{{vm.edo.form.label}}</span></div></div><div layout=\"column\" \nclass=\"md-whiteframe-15dp welcome\" ng-if=\"!vm.cuestionaireStart && vm.cuestionaireHasTime\"><md-progress-linear \nmd-mode=\"determinate\" value=\"0\" class=\"progress\"></md-progress-linear><div layout=\"column\" \nlayout-align=\"center center\" class=\"content-welcome\"><span class=\"text-xl text-primary font-weight-500\">\nBienvenido(a), a continuación podrá responder </span><span class=\"text-xl text-primary\">Las pregunta del cuestionario: \n</span><span class=\"text-xl text-primary font-weight-300 mt-15\">{{vm.edo.form.label}}</span></div><md-divider>\n</md-divider><div layout=\"row\" layout-align=\"center center\" class=\"p-20\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.startCountdown()\">Responder Preguntas</md-button></div></div><div layout=\"column\" \nclass=\"md-whiteframe-15dp contentQuestions\" ng-if=\"vm.cuestionaireStart && vm.cuestionaireHasTime\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{vm.edo.index / vm.edo.total * 100}}\" class=\"progress\"></md-progress-linear><div \nclass=\"header-edo\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"text-xl text-primary font-weight-600\">{{vm.edo.question.question_text}}</span><div class=\"badgeCountQuestions\">\n<span class=\"text-xl text-primary font-weight-600\">Tiempo restante: {{vm.cronometer}}</span>&nbsp;&nbsp; <span \nclass=\"text-m white-fg\">{{vm.edo.index}} de {{vm.edo.total}}</span></div></div></div><div class=\"content-edo\"><form \nnovalidate name=\"questionsForm\"><div layout=\"column\"><div layout=\"column\" class=\"p-20\" \nng-style=\"{\'border-color\':vm.colors.primary}\"><ik-question-type ng-model=\"vm.edo.question\" \ntype=\"vm.edo.question.edo_question_type\" config=\"vm.configQuestionario\"></ik-question-type></div><md-divider>\n</md-divider><div layout=\"row\" layout-align=\"center center\" class=\"p-20\"><md-button class=\"md-warn md-raised\" \nng-if=\"vm.edo.index != 1\" ng-click=\"vm.backQuestion()\">Anterior</md-button><md-button class=\"md-accent md-raised\" \nng-if=\"vm.edo.index != vm.edo.total\" ng-disabled=\"!questionsForm.$valid\" ng-click=\"vm.nextQuestion()\">\nSiguiente {{questionForm.$valid}}</md-button><md-button class=\"md-accent md-raised\" \nng-if=\"vm.edo.index == vm.edo.total\" ng-click=\"vm.nextQuestion(true)\">Finalizar</md-button></div></div></form></div>\n</div></div><div ng-if=\"vm.edo && vm.emptyEdo\" class=\"p-20\"><span class=\"text-m text-primary\">\nNo tiene evaluaciones pendientes por responder</span></div></div></div></div>");
$templateCache.put("app/main/modules/employee/profile/update_password.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-primary-bg\"><div \nclass=\"title\">Actualizar Contraseña</div></header><div class=\"content\"><form name=\"passwordForm\" \nclass=\"md-inline-form\" novalidate><md-input-container class=\"md-icon-float md-block\"><label>Contraseña actual</label>\n<md-icon></md-icon><input name=\"current_pass\" ng-model=\"vm.current_pass\" type=\"password\" required \ncurrent-password-check><div ng-messages=\"passwordForm.current_pass.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>La contraseña actual es requerida.</span></div><div ng-message=\"currentPasswordCheck\"><span>\nLa contraseña actual es inválida.</span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label>Contraseña nueva</label><md-icon></md-icon><input ng-model=\"vm.new_pass\" \nname=\"new_pass\" type=\"password\" required><div ng-messages=\"passwordForm.pw1.$error\" role=\"alert\"><div \nng-message=\"required\"><span>La contraseña es requerida.</span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label>Repetir contraseña nueva</label><md-icon></md-icon><input \nng-model=\"vm.rnew_pass\" id=\"pw2\" name=\"pw2\" type=\"password\" compare=\"vm.new_pass\" required><div \nng-messages=\"passwordForm.pw2.$error\" role=\"alert\"><div ng-message=\"required\"><span>La contraseña es requerida.</span>\n</div><div ng-message=\"compare\"><span>Las contraseñas no coinciden.</span></div></div></md-input-container><div \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"submit\" ng-click=\"vm.changePassword($event)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"passwordForm.$invalid || passwordForm.$pristine\">\n{{vm.changePassButton}}</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/modules/reports/report/report.html","<div id=\"reports\" class=\"page-layout page-layout-simple\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg ph-20 pt-10\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"breadcrumb\"><md-icon md-font-icon=\"icon-home\" class=\"s16 grey-50-fg\"></md-icon>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 grey-50-fg separator\"></md-icon><span class=\"parent\"><a href=\"#\" \nui-sref=\"app.reports\" class=\"grey-50-fg\">Reportes</a></span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 grey-50-fg separator\"></md-icon><span class=\"parent\">{{vm.reportName}}</span></div></div></div><loading-bar \nng-if=\"vm.loadingReportData\"></loading-bar><div class=\"content\" ng-if=\"!vm.loadingReportData\"><div \nclass=\"m-20 md-whiteframe-1dp\" ng-if=\"vm.filters\"><div layout=\"row\" class=\"filtro_criterios p-20\" \nlayout-align=\"start center\" layout-wrap><div flex=\"20\" ng-repeat=\"filter in vm.filters\"><md-input-container \nclass=\"md-block h-50\" md-no-float flex-gt-sm \nng-if=\"filter.type == \'SELECT\' || filter.type == \'SELECT_DATE_RANGE\' && filter.show\"><label>{{filter.name}}</label>\n<md-select ng-model=\"vm.valueFilterTmp[filter.id]\"><md-option ng-repeat=\"option in filter.options\" \nvalue=\"{{option.id}}\">{{option.value}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block h-50\" flex-gt-sm ng-if=\"filter.type == \'TEXT\' && filter.show\"><label>{{filter.name}}</label><input \nng-model=\"vm.valueFilterTmp[filter.id]\"></md-input-container><md-input-container class=\"md-block h-50\" \nng-if=\"(filter.type == \'DATE\' || filter.type == \'DATE_BETWEEN\') && filter.show\"><label>{{filter.name}}</label>\n<md-datepicker ng-model=\"vm.valueFilterTmp[filter.id]\" readonly=\"readonly\" md-placeholder=\"{{filter.name}}\" \nmd-min-date=\"filter.min_date\" md-open-on-focus></md-datepicker></md-input-container><div class=\"md-block\" flex-gt-sm \nng-if=\"filter.type == \'AUTOCOMPLETE\' && filter.show\"><md-autocomplete md-selected-item=\"vm.valueFilterTmp[filter.id]\" \nmd-search-text=\"vm.searchFilter[filter.id]\" md-items=\"data in vm.search(filter.options,vm.searchFilter[filter.id])\" \nmd-item-text=\"data.name\" md-require-match md-floating-label=\"{{filter.name}}\"><md-item-template><span \nmd-highlight-text=\"vm.searchFilter[filter.id]\">{{data.name}}</span></md-item-template><md-not-found>\nNo se encuentran cargos bajo el parametro.</md-not-found></md-autocomplete></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"bb p-20\" layout-wrap><div layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><md-button ng-click=\"vm.filterByCriteria()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg mr-10\">Filtrar\n</md-button><md-button ng-click=\"vm.resetFilter()\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg ml-10\">Limpiar\n</md-button></div><md-button ng-click=\"vm.downloadExcel()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Descargar reporte</md-button>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" ms-responsive-table><thead>\n<tr><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\" ng-repeat=\"(key,value) in vm.headersColumn\"><div \nclass=\"table-header\"><span class=\"column-title\">{{value}}</span></div></th></tr></thead><tbody><tr class=\"h7\" \nng-repeat=\"report in vm.reportData\"><td ng-repeat=\"(key,value) in report\">{{value}}</td></tr></tbody></table></div>\n</div></div>");
$templateCache.put("app/main/modules/users/admin/users_admin.html","<div id=\"users_admin\" class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Usuarios</span></div></div></div><div class=\"content\" ms-scroll><div \nclass=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr class=\"md-accent-bg\"><th></th><th></th><th><div class=\"table-header\"><span class=\"column-title\">Nombre\n</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">NIT</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">Email</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">Sociedades</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">\nAsistente Técnico</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Perfil</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td><md-button class=\"md-icon-button md-accent\" \naria-label=\"Modificar\" ng-click=\"vm.openDialog($event, user)\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon>\n<md-tooltip><span>Modificar</span></md-tooltip></md-button></td><td><img ng-src=\"{{user.ModuleUser.avatar}}\" \nclass=\"avatar\" alt=\"{{user.ModuleUser.name}}\"></td><td>{{ user.ModuleUser.name }}</td><td \nng-bind-html=\" user.ModuleUser.cstm_nit | split:\',\' \"></td><td>{{ user.ModuleUser.email }}</td><td><div \nng-repeat=\"sociedad in user.SociedadsUser\"><li>{{sociedad.cod_sap}}</li></div><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Modificar\" ng-click=\"vm.openDialogSociedades($event, user)\"><md-icon \nmd-font-icon=\"icon-pencil-box\"></md-icon><md-tooltip><span>Definir Sociedades</span></md-tooltip></md-button></td><td>\n{{ user.AsistenteTecnico.name }}</td><td>{{ user.UsersProfile.type }} - {{ user.UsersProfile.name }}</td></tr></tbody>\n</table></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-button\" \nng-click=\"vm.openDialog($event)\" aria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/modules/users/forgot-password/forgot-password.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img \nsrc=\"assets/images/ikano_rh/{{vm.license}}/side-bar-logo.png\"><div class=\"p-10\" layout=\"row\" \nlayout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" layout-align-sm=\"center center\" \nlayout-align-gt-sm=\"center center\" layout-align-md=\"end center\" layout-align-gt-md=\"end center\" \nlayout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nhref=\"/login\" class=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar\n</md-button></div></div></div><div id=\"login-v2\" layout=\"row\" layout-align=\"start\" \nstyle=\"background: url(\'/assets/images/ikano_rh/{{vm.license}}/login-background.jpg\') no-repeat; background-size: 80% 100%\">\n<div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"title\"></div><div class=\"description\" \nng-bind-html=\"vm.licenseData.login_description\"></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\"><img \nsrc=\"assets/images/ikano_rh/{{vm.license}}/login_logo.png\"></div><form name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Correo\" required>\n<div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCorreo requerido</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nng-click=\"vm.sendLink($event)\">Aceptar</md-button></form></div></div></div>");
$templateCache.put("app/main/modules/users/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\" \nstyle=\"background: url(\'/assets/images/ikano_rh/{{vm.license}}/login-background.jpg\') no-repeat; background-size: 80% 100%\">\n<div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"title\"></div><div class=\"description\" \nng-bind-html=\"vm.licenseData.login_description\"></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\"><img \nsrc=\"assets/images/ikano_rh/{{vm.license}}/login_logo.png\"></div><form name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Usuario\" required>\n<div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nUsuario requerido</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Contraseña\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Contraseña requerida</span></div>\n</div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-between center\"><a ui-sref=\"app.users_forgot_password\" class=\"forgot-password md-accent-color\">\nOlvidaste tu contraseña?</a></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"vm.doLogin($event)\">INGRESAR\n</md-button></form></div></div></div>");
$templateCache.put("app/main/modules/users/reset-password/reset-password.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\" \nstyle=\"background: url(\'/assets/images/ikano_rh/{{vm.license}}/login-background.jpg\') no-repeat; background-size: 80% 100%\">\n<div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"title\"></div><div class=\"description\" \nng-bind-html=\"vm.licenseData.login_description\"></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\"><img \nsrc=\"assets/images/ikano_rh/{{vm.license}}/login_logo.png\"></div><form name=\"resetPasswordForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><label>Contraseña nueva</label><input ng-model=\"vm.new_pass\" id=\"pw1\" \nname=\"pw1\" type=\"password\" ng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required>\n<div ng-messages=\"resetPasswordForm.pw1.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLa contraseña es requerida.</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><label>Repetir contraseña nueva\n</label><input ng-model=\"vm.rnew_pass\" id=\"pw2\" name=\"pw2\" type=\"password\" compare=\"vm.new_pass\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><div \nng-messages=\"resetPasswordForm.pw2.$error\" role=\"alert\"><div ng-message=\"required\"><span>La contraseña es requerida.\n</span></div><div ng-message=\"compare\"><span>Las contraseñas no coinciden.</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"Actualizar contraseña\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \nng-click=\"vm.resetPassword($event)\">Aceptar</md-button></form></div></div></div>");
$templateCache.put("app/main/page/admin/content/page_content.html","<span ng-include=\"vm.page_template\"></span>");
$templateCache.put("app/main/page/text/admin/text_admin.html","<div layout=\"column\" layout-align=\"start center\"><form name=\"form1\"><textarea ng-model=\"vm.Text.ModuleText.content\" \nname=\"textContent\" ckeditor=\"vm.editorOptions\" rows=\"100\" required=\"required\">\n    </textarea><br><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"ACEPTAR\">ACEPTAR</md-button>\n</form></div>");
$templateCache.put("app/main/page_layouts/layout-2-col/sidenavs/layout-2-col-sidenav.html","<md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div \nng-repeat-start=\"page_content in vm.page_layout\" ng-include=\"vm.pageModules[page_content.plantilla]\" \nng-if=\"page_content.container_id == 2\" class=\"p-24\"></div><md-divider ng-repeat-end></md-divider></div></md-content>");
$templateCache.put("app/main/page_layouts/layout-2-col-no-header/sidenavs/layout-2-col-no-header-sidenav.html","<md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div \nng-repeat-start=\"page_content in vm.page_layout\" ng-include=\"vm.pageModules[page_content.plantilla]\" \nng-if=\"page_content.container_id == 2\" class=\"ph-24 pv-16\"></div><md-divider ng-repeat-end></md-divider></div>\n</md-content>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/position-detail/templates/attributes/text.html","<div layout=\"column\"><span class=\"text-s font-weight-600 text-primary mb-10\">{{label}}</span> <span \nclass=\"text-s text-secondary\" ng-if=\"!config.edit\">{{valueText}}</span><md-input-container md-no-float \nclass=\"no-errors no-padding no-margin full-width\" ng-if=\"config.edit\"><input type=\"text\" ng-model=\"valueText\" \naria-label=\"prueba\"></md-input-container></div>");
$templateCache.put("app/core/directives/position-detail/templates/attributes/textarea.html","<div layout=\"column\"><span class=\"text-s font-weight-600 text-primary mb-10\">{{label}}</span><div layout=\"column\" \nlayout-align=\"center\" class=\"comments-container\"><div layout=\"row\"><div layout=\"column\" ng-if=\"config.edit\" \nclass=\"w-100-p\"><textarea class=\"comments-input\" ng-model=\"valueText\" ng-attr-rows=\"{{options.options.rows}}\">\n</textarea></div><div layout=\"column\" layout-align=\"center start\" ng-if=\"!config.edit\"><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"valueText\"></div></div></div></div></div>");
$templateCache.put("app/main/custom_modules/HrGoal/templates/admin/admin_data.html","<div class=\"white-bg md-whiteframe-4dp mb-32\"><h2 class=\"p-15 md-accent-fg\">Objetivos</h2><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsNoPaginate\"><thead><tr><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\">Objetivo</span></div></th><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center\">Ponderación</span></div>\n</th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center text-center\">\nResultado</span></div></th></tr></thead><tbody><tr ng-repeat=\"goal in vm.evaluationData.HrGoal\"><td><div>\n{{goal.objetivo}}</div><div><b>Criterio de medición:</b> {{goal.criterio_medicion}}</div><div><b>Meta:</b>\n {{goal.meta}}</div><div><b>Unidad de medida:</b> {{goal.unidad_medida}}</div></td><td class=\"text-center\">\n{{goal.porcentaje}}</td><td class=\"text-center\"><b>{{goal.resultado_final}}%</b></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/HrGoal/templates/admin/admin_data2.html","<div class=\"white-bg md-whiteframe-4dp mb-32\"><h2 class=\"p-15 md-accent-fg\">Objetivos</h2><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsNoPaginate\"><thead><tr><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\">Objetivo</span></div></th><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center\">Ponderación</span></div>\n</th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center text-center\">\nResultado</span></div></th></tr></thead><tbody><tr ng-repeat=\"goal in vm.evaluationHistoryData.HrGoal\"><td><div>\n{{goal.objetivo}}</div><div><b>Criterio de medición:</b> {{goal.criterio_medicion}}</div><div><b>Meta:</b>\n {{goal.meta}}</div><div><b>Unidad de medida:</b> {{goal.unidad_medida}}</div></td><td class=\"text-center\">\n{{goal.porcentaje}}</td><td class=\"text-center\"><b>{{goal.resultado_final}}%</b></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/HrPersonalDevelopment/templates/admin/admin_data.html","<div class=\"white-bg md-whiteframe-4dp mb-32\"><h2 class=\"p-15 md-accent-fg\">Acciones de desarrollo</h2><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsNoPaginate\"><thead><tr><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\">Acción de desarrollo</span></div></th>\n<th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center\">Ponderación</span>\n</div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center\">Resultado\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"goal in vm.evaluationData.HrPersonalDevelopment\"><td><div>\n{{goal.objetivo}}</div><div><b>Criterio de medición:</b> {{goal.criterio_medicion}}</div><div><b>Meta:</b>\n {{goal.meta}}</div><div><b>Unidad de medida:</b> {{goal.unidad_medida}}</div></td><td class=\"text-center\">\n{{goal.porcentaje}}</td><td class=\"text-center\"><b>{{goal.resultado_final}}%</b></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/HrPersonalDevelopment/templates/admin/admin_data2.html","<div class=\"white-bg md-whiteframe-4dp mb-32\"><h2 class=\"p-15 md-accent-fg\">Acciones de desarrollo</h2><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsNoPaginate\"><thead><tr><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\">Acción de desarrollo</span></div></th>\n<th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center\">Ponderación</span>\n</div></th><th class=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title text-center\">Resultado\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"goal in vm.evaluationHistoryData.HrPersonalDevelopment\"><td><div>\n{{goal.objetivo}}</div><div><b>Criterio de medición:</b> {{goal.criterio_medicion}}</div><div><b>Meta:</b>\n {{goal.meta}}</div><div><b>Unidad de medida:</b> {{goal.unidad_medida}}</div></td><td class=\"text-center\">\n{{goal.porcentaje}}</td><td class=\"text-center\"><b>{{goal.resultado_final}}%</b></td></tr></tbody></table></div>");
$templateCache.put("app/main/custom_modules/evaluation/dialogs/add-questions/add-questions-dialog.html","<md-dialog id=\"topics-dialog\" aria-label=\"Enroll Employee\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Preguntas disponibles </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" ng-show=\"!vm.showCreateQuestions\"><div \nclass=\"md-inline-form mb-15\"><div layout=\"row\" flex layout-wrap><md-input-container flex=\"33\"><label>Buscar</label>\n<md-icon md-font-icon=\"icon-magnify\" class=\"name\"></md-icon><input type=\"text\" name=\"employee\" \nng-model=\"vm.topicSearch\"></md-input-container><md-input-container flex=\"33\"><label>Tipo</label><md-select \nng-model=\"vm.type\"><md-option ng-repeat=\"type in vm.type_questions\" ng-value=\"type.id\">{{type.label}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"33\"><label>Tema</label><md-select ng-model=\"vm.topic\">\n<md-option ng-repeat=\"topics in vm.topics\" ng-value=\"topics.id\">{{topics.label}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" class=\"table-header\"><table class=\"tbl-lbl-data\"><tbody><tr \nng-repeat=\"questions in vm.edo_questions |  filterQuestionType: vm.type | filterQuestionsTopics: vm.topic | filter: vm.topicSearch\" \nclass=\"backgroundCell border-tr\" ng-if=\"questions.show\"><td class=\"w-80-p\" \nng-class=\"{\'first-first\':$first,\'end-first\':$last}\"><div layout=\"column\" class=\"pl-25\"><span \nclass=\"text-l text-primary\">{{questions.question_text}}</span><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-m text-secondary font-weight-600 ml-r\">Tipo:</span> <span class=\"text-m text-secondary\">\n{{questions.edo_question_type.label}}</span></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-m text-secondary font-weight-600 ml-r\">Tema:</span> <span class=\"text-m text-secondary\">\n{{questions.edo_topic.label}}</span></div></div></td><td ng-class=\"{\'first-end\':$first,\'end-end\':$last}\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"pr-25\"><md-icon \nmd-font-icon=\"icon-plus s18 cursor-pointer m-0 md-accent-fg \" ng-click=\"vm.selectedQuestion(questions)\"></md-icon><span\n class=\"text-m md-accent-fg cursor-pointer ml-5\" ng-click=\"vm.selectedQuestion(questions)\">Agregar</span></div></td>\n</tr></tbody></table></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/custom_modules/evaluation/dialogs/enroll-employee/enroll-employee-dialog.html","<md-dialog class=\"enroll-employee-dialog\" aria-label=\"Enroll Employee\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Información de la matrícula </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div ng-if=\"!vm.isDataLoaded\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><form \nname=\"dialogForm\" class=\"md-inline-form\" novalidate ng-if=\"vm.isDataLoaded\"><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block md-default-theme md-input-has-value\"><label>Colaborador</label><md-select \nng-model=\"vm.enrollData.empleado_id\" required><md-option ng-repeat=\"employee in ::vm.notEnrolledEmployees\" \nvalue=\"{{employee.id}}\">{{employee.cedula}} - {{employee.name}}</md-option></md-select></md-input-container><div \nlayout=\"row\"><md-input-container class=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Empresa</label>\n<md-select ng-model=\"vm.enrollData.empresa_id\" required><md-option ng-repeat=\"company in ::vm.companies\" \nvalue=\"{{company.id}}\">{{company.value}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Cargo</label><md-select \nng-model=\"vm.enrollData.cargo_id\" required><md-option ng-repeat=\"position in ::vm.positions\" value=\"{{position.id}}\">\n{{position.value}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Gerencia</label><md-select \nng-model=\"vm.enrollData.company_department_id\" required><md-option ng-repeat=\"department in ::vm.departments\" \nvalue=\"{{department.id}}\">{{department.value}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Área</label><md-select \nng-model=\"vm.enrollData.area_id\" required><md-option ng-repeat=\"area in ::vm.areas\" value=\"{{area.id}}\">{{area.value}}\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Nivel</label><md-select \nng-model=\"vm.enrollData.nivel\" required><md-option ng-repeat=\"positionLevel in ::vm.positionLevels\" \nvalue=\"{{positionLevel.id}}\">{{positionLevel.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Grupo</label><md-select \nng-model=\"vm.enrollData.grupo\" required><md-option ng-repeat=\"group in ::vm.groups\" value=\"{{group.id}}\">{{group.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Jefe</label><md-select \nng-model=\"vm.enrollData.jefe_id\" required><md-option ng-repeat=\"employee in ::vm.employees\" value=\"{{employee.id}}\">\n{{employee.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Jefe aprobador</label><md-select \nng-model=\"vm.enrollData.jefe_jefe_id\"><md-option ng-repeat=\"employee in ::vm.employees\" value=\"{{employee.id}}\">\n{{employee.name}}</md-option></md-select></md-input-container></div><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Jefe corporativo</label><md-select \nng-model=\"vm.enrollData.jefe_corporativo_id\"><md-option ng-repeat=\"employee in ::vm.employees\" value=\"{{employee.id}}\">\n{{employee.name}}</md-option></md-select></md-input-container><div layout=\"column\" layout-align=\"center\"><span \nclass=\"text-m text-priamry mb-15\">Seleccione los aspectos que desea evaluar (debe seleccionar al menos uno).</span><div\n class=\"widget-group margin-widgets\" layout=\"row\" layout-align=\"start center\" flex=\"100\" layout-wrap><ms-widget \nclass=\"p-5\" flex=\"100\" flex-xs=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\" ng-repeat=\"module in vm.modules\"><ms-widget-front \nclass=\"white-bg p-10\" \nng-style=\"{\'border-top-color\': vm.colors.accent,\'border-top-width\': \'3px\',\n            \'border-top-style\': \'solid\'}\">\n<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\"><md-checkbox ng-model=\"vm.showModule[module.id]\" \nng-value=\"true\" aria-label=\"employee\" ng-change=\"vm.addModule(module.id)\"></md-checkbox></div><div layout=\"column\">\n<span class=\"text-m md-primary-fg\">{{module.name}}</span><div layout=\"column\" ng-if=\"vm.showModule[module.id]\">\n<md-input-container layout=\"row\"><label>Ponderación</label><md-select ng-model=\"vm.selectedWeight[module.id]\" required>\n<md-option ng-repeat=\"value in vm.percentages\" ng-value=\"value\">{{value}}</md-option></md-select></md-input-container>\n<md-input-container layout=\"row\" ng-if=\"module.module_list_id\"><label>{{module.module_list.label}}</label><md-select \nng-model=\"vm.selectedModuleList[module.id]\" required><md-option ng-repeat=\"value in module.module_list.lists_items\" \nng-value=\"value.id\">{{value.name}}</md-option></md-select></md-input-container></div></div></div></ms-widget-front>\n</ms-widget></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid || !vm.selectedModule.length\" \nng-if=\"!vm.sendingData\">GUARDAR</md-button><md-progress-circular ng-disabled=\"!vm.sendingData\" ng-if=\"vm.sendingData\" \nclass=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/custom_modules/evaluation/dialogs/goal/goal-dialog.html","<md-dialog class=\"log-detail-dialog\" aria-label=\"New Task\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Detalles </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-dialog-content ms-scroll><md-input-container\n class=\"md-block md-default-theme md-input-has-value\"><label>Tipo</label><md-select ng-model=\"vm.goal.obj_type\">\n<md-option ng-repeat=\"tipo in vm.types\" ng-value=\"tipo.id\">{{tipo.value}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>Objetivo</label><textarea name=\"objetivo\" ng-model=\"vm.goal.name\" required \nmd-maxlength=\"500\" maxlength=\"500\"></textarea><div ng-messages=\"dataForm.objetivo.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Dato requerido</span></div></div></md-input-container><md-input-container class=\"md-block\" \nng-repeat=\"additional in vm.additional_data\"><label>{{additional.label}}</label><textarea name=\"meta\" \nng-model=\"vm.goal.additional_data[additional.value]\" required md-maxlength=\"500\" maxlength=\"500\" \nng-if=\"additional.type == \'string\'\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>Meta\n</label><textarea name=\"meta\" ng-model=\"vm.goal.meta\" required md-maxlength=\"500\" maxlength=\"500\"></textarea>\n</md-input-container><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Empresa</label><md-select \nng-model=\"vm.goal.empresa_id\" required><md-option ng-repeat=\"company in vm.companies\" ng-value=\"company.id\">\n{{company.value}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Gerencia</label><md-select \nng-model=\"vm.goal.gerencia_id\"><md-option value=\"\">------------</md-option><md-option \nng-repeat=\"gerencia in vm.CompanyDepartments\" ng-value=\"gerencia.id\">{{gerencia.value}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Área\n</label><md-select ng-model=\"vm.goal.area_id\"><md-option value=\"\">------------</md-option><md-option \nng-repeat=\"area in vm.areas\" ng-value=\"area.id\">{{area.value}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block md-default-theme md-input-has-value\" flex=\"50\"><label>Cargos</label><md-select \nng-model=\"vm.goal.cargo_id\"><md-option value=\"\">------------</md-option><md-option \nng-repeat=\"position in vm.positions\" ng-value=\"position.id\">{{position.name}}</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\">\n<div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"dialogForm.$invalid\" ng-if=\"!vm.sendingData\">Guardar</md-button><md-progress-circular \nng-disabled=\"!vm.sendingData\" ng-if=\"vm.sendingData\" class=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/custom_modules/evaluation/dialogs/matricula-mass/matricula-mass-dialog.html","<md-dialog id=\"matricula-mass-dialog\" aria-label=\"Enroll Employee\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Activar proceso masivamente </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"dialogForm\" novalidate><md-dialog-content class=\"no-padding\"><div layout=\"row\" flex \nlayout-wrap class=\"p-20\"><md-input-container flex=\"33\"><label>Proceso</label><md-select \nng-model=\"vm.search[\'evaluation_active_process_id\']\" \nng-change=\"vm.availableProcessChange(vm.search[\'evaluation_active_process_id\'])\"><md-option \nng-repeat=\"option in vm.availableProcess\" value=\"{{option.id}}\">{{option.evaluation_process.name}} - {{option.name}}\n</md-option></md-select></md-input-container><md-input-container flex=\"33\"><label>Empresa</label><md-select \nng-model=\"vm.search[\'empresa_id\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"company in vm.lists.organizationCompanies\" value=\"{{company.id}}\">{{company.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"33\"><label>Gerencia</label><md-select \nng-model=\"vm.search[\'company_department_id\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"department in vm.lists.organizationDepartments\" value=\"{{department.id}}\">{{department.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"33\"><label>Área</label><md-select \nng-model=\"vm.search[\'area_id\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"area in vm.lists.organizationAreas\" value=\"{{area.id}}\">{{area.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"33\"><label>Cargo</label><md-select ng-model=\"vm.search[\'cargo_id\']\">\n<md-option value=\"\">----------------</md-option><md-option ng-repeat=\"position in vm.lists.organizationPositions\" \nvalue=\"{{position.id}}\">{{position.name}}</md-option></md-select></md-input-container><md-input-container flex=\"33\">\n<label>Nivel</label><md-select ng-model=\"vm.search[\'level_id\']\"><md-option value=\"\">----------------</md-option>\n<md-option ng-repeat=\"positionLevel in vm.lists.organizationPositionsLevels\" ng-value=\"positionLevel.id\">\n{{positionLevel.name}}</md-option></md-select></md-input-container><md-input-container flex=\"33\"><label>Jefe</label>\n<md-select ng-model=\"vm.search[\'chief\']\"><md-option value=\"\">----------------</md-option><md-option \nng-repeat=\"chief in vm.lists.organizationChief\" ng-value=\"chief.id\">{{chief.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"end end\" class=\"p-20\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg text-s cursor-pointer\" ng-if=\"vm.colaborators.length\" \nng-click=\"vm.showActiveFn()\">Activar proceso masivamente</span><md-button class=\"md-raised md-accent btn-capitalize\" \nng-click=\"vm.getColaborators()\" ng-disabled=\"!vm.search[\'evaluation_active_process_id\'] || vm.sendingData\">Buscar\n</md-button></div></div><div ng-if=\"vm.showActive\" class=\"background-color-secondary\"><form name=\"newProcessForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\" layout=\"start center\" flex layout-wrap class=\"p-20\"><table \nclass=\"tbl-lbl-data\"><tr ng-if=\"vm.availableProcessProcessList\"><th><span class=\"text-m\">\n{{vm.availableProcessProcessList.label}}*</span></th><td class=\"text-m text-secondary\"><md-input-container \nclass=\"md-block mt-15\"><label class=\"field_obl\">{{vm.availableProcessProcessList.label}}</label><md-select \nng-model=\"vm.process_lists_item_id\" required><md-option \nng-repeat=\"option in vm.availableProcessProcessList.lists_items\" value=\"{{option.id}}\">{{option.name}}</md-option>\n</md-select></md-input-container></td></tr><tr><th><span class=\"text-m\">Fecha límite*</span></th><td \nclass=\"text-m text-secondary\"><div flex class=\"date-container\"><md-datepicker flex ng-model=\"vm.process_deadline\" \nmd-placeholder=\"Fecha límite\" md-min-date=\"vm.today\" ng-required=\"true\"></md-datepicker></div></td></tr></table>\n<md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"newProcessForm.$invalid || vm.sendingData\"><span ng-if=\"!vm.sendingData\">Guardar</span> <span \nng-if=\"vm.sendingData\">Guardando...</span></md-button></div></form></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.colaborators.length == 0\" class=\"p-20\"><span class=\"text-m text-primary\">\nNo se encontró resultados con los filtros, consulte de nuevo.</span></div><div layout=\"column\" \nng-if=\"vm.colaborators.length\" class=\"p-20\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-secondary text-s font-weight-600\">\nNumero de registros: {{vm.colaborators.length}}</span></div><md-input-container><label>Buscar</label><input \ntype=\"text\" name=\"employee\" ng-model=\"vm.tableFilter\"></md-input-container></div><div layout=\"row\" \nlayout-aling=\"start center\" flex=\"100\" layout-wrap><div class=\"pr-5 pb-5\" flex=\"33\" \nng-repeat=\"colaborator in vm.colaborators | filter: vm.tableFilter\" layout=\"row\"><div class=\"card-employe-container\" \nlayout=\"column\"><span class=\"md-accent-fg text-m\">{{colaborator.empleado.name}}</span><div layout=\"row\" \nlayout-align=\"start start\"><span class=\"text-secondary text-s font-weight-600\">Ubicación:</span> <span \nclass=\"text-secondary text-s ml-5\">{{colaborator.empresa.name}}</span></div><div layout=\"row\" \nlayout-align=\"start start\"><span class=\"text-secondary text-s font-weight-600\">Cargo:</span> <span \nclass=\"text-secondary text-s ml-5\">{{colaborator.cargo.name}}</span></div><div layout=\"row\" layout-align=\"start start\">\n<span class=\"text-secondary text-s font-weight-600\">Área:</span> <span class=\"text-secondary text-s ml-5\">\n{{colaborator.area.name}}</span></div><div layout=\"row\" layout-align=\"start start\"><span \nclass=\"text-secondary text-s font-weight-600\">Gerencia:</span> <span class=\"text-secondary text-s ml-5\">\n{{colaborator.company_department.name}}</span></div><div layout=\"row\" layout-align=\"start start\"><span \nclass=\"text-secondary text-s font-weight-600\">Nivel:</span> <span class=\"text-secondary text-s ml-5\">\n{{colaborator.position_level.name}}</span></div><div layout=\"row\" layout-align=\"start start\"><span \nclass=\"text-secondary text-s font-weight-600\">Proceso:</span> <span class=\"text-secondary text-s ml-5\">\n{{colaborator.evaluation_process_stage.name}}</span></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/custom_modules/evaluation/dialogs/show-image/show-image.html","<md-dialog id=\"topics-dialog\" aria-label=\"Enroll Employee\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.name}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><img src=\"{{vm.url}}\"></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/custom_modules/evaluation/dialogs/topics/topics-dialog.html","<md-dialog id=\"topics-dialog\" aria-label=\"Enroll Employee\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Información del tema </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"dialogForm\" novalidate><md-dialog-content><md-input-container class=\"md-block\"><label>Nombre\n</label><input name=\"meta\" ng-model=\"vm.topic.label\" required></md-input-container><md-input-container \nclass=\"md-block\"><label>Descripción</label><textarea ng-focus=\"true\" ng-model=\"vm.topic.description\" \nmd-maxlength=\"500\" maxlength=\"500\" max-rows=\"15\" rows=\"5\">                    \n              </textarea>\n</md-input-container></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.saveTopic()\" ng-disabled=\"dialogForm.$invalid\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation-details/partials/_current-evaluation.html","<div id=\"current_evaluation\"><div layout=\"row\" layout-align=\"end end\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.donwloadPDF()\">Descargar pdf</md-button></div><div class=\"md-primary-bg div-radius h-30\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.evaluationInfo.qualitative_rating\"><span class=\"text-l white-fg mr-5\">\nResultado de desempeño:</span> <span class=\"text-l white-fg font-weight-600\">{{vm.evaluationInfo.qualitative_rating}}\n</span></div><div class=\"md-whiteframe-4dp mt-10 mb-30\"><div layout=\"row\" class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Aspecto</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Evaluación</span></th><th \nclass=\"background text-center w-20-p\"><span class=\"titleTable\">Autoevaluación</span></th></tr></thead><tbody><tr \nng-repeat=\"row in vm.evaluationInfo.evaluation_hr_modules\" ng-if=\"row.hr_module.has_evaluation\"><td \nclass=\"grey-100-bg\"><div layout=\"row\" layout-align=\"start center\"><span class=\"text-m text-primary mb-10\">\n{{row.hr_module.name}} </span><span class=\"text-m text-primary mb-10 ml-10\">({{row.weight}}%)</span></div></td><td \nclass=\"text-m text-secondary text-center\">{{row.final_evaluation}}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">{{row.auto_evaluation}}</td></tr><tr><td class=\"grey-100-bg\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"text-m text-primary mb-10\">Resultado evaluación</span></div></td>\n<td class=\"text-m text-secondary text-center\">{{vm.evFinalCurrent | number: \'2\' }}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">{{vm.evFinalCurrentAuto | number: \'2\'}}</td></tr></tbody></table>\n</div></div><div ng-repeat=\"currentEvaluation in vm.currentEvaluationData\" ng-if=\"!currentEvaluation.hide\"><div \nclass=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">{{currentEvaluation.title}}</span></div><div \nclass=\"full-width md-whiteframe-4dp mb-30\"><ik-evaluation-result-list ng-model=\"currentEvaluation.data\" \nview-model=\"vm\" template=\"currentEvaluation.template\"></ik-evaluation-result-list></div></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation-details/partials/_evaluation-history-data.html","<div layout=\"row\" layout-align=\"end end\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.showEvaluationHistoryData = false\">Regresar</md-button></div><div \nng-include=\"\'app/main/custom_modules/HrGoal/templates/admin/admin_data2.html\'\"></div><div \nng-include=\"\'app/main/custom_modules/HrPersonalDevelopment/templates/admin/admin_data2.html\'\"></div>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation-details/partials/_evaluation-history.html","<div id=\"evaluation-history\"><loading-bar ng-if=\"vm.loadingEvaluationData\"></loading-bar><div \nng-if=\"!vm.loadingEvaluationData\"><div ng-if=\"vm.evaluationsHistory.length !== 0 && !vm.showEvaluationHistoryData\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.evaluationResultViewType = \'list\'\" aria-label=\"List view\"><md-icon \nmd-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span>Vista tipo lista</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.evaluationResultViewType = \'card\'\" aria-label=\"List view\"><md-icon \nmd-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span>Vista tipo tarjeta</span></md-tooltip></md-button><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ik-evaluation-result-card ng-model=\"evaluation\" \nng-repeat=\"evaluation in vm.evaluationsHistory | filter: vm.search\" template=\"vm.evaluationResultCardTemplate\" \nflex=\"50\" ng-if=\"vm.evaluationResultViewType == \'card\'\" view-model=\"vm\"></ik-evaluation-result-card></div><div \nclass=\"simple-table-container full-width md-whiteframe-4dp\"><ik-evaluation-result-list \nng-model=\"vm.evaluationsHistory\" view-model=\"vm\" template=\"vm.evaluationResultListTemplate\" \nng-if=\"vm.evaluationResultViewType == \'list\'\"></ik-evaluation-result-list></div></div><ms-message type=\"info\" \nng-if=\"!vm.evaluationsHistory.length\">No se encontraron evaluaciones anteriores.</ms-message><div \nng-if=\"vm.showEvaluationHistoryData\"><div layout=\"row\" layout-align=\"end end\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.donwloadPDF(vm.evaluationHistoryData.id)\">Descargar pdf</md-button><md-button class=\"md-warn md-raised\" \nng-click=\"vm.showEvaluationHistoryData = false\">Regresar</md-button></div><ik-evaluation-data \nng-model=\"vm.evaluationHistoryData\" template=\"vm.evaluationDataTemplate\"></ik-evaluation-data></div></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation-details/partials/_evaluation-info.html","<div layout=\"row\" layout-align=\"end end\"><md-button class=\"md-warn md-raised btn-capitalize m-16\" \nng-click=\"vm.deleteEmployeeProcess($event)\" aria-label=\"Remove\" translate>Eliminar matrícula</md-button></div><div \nlayout=\"row\" layout-margin><div flex=\"33\"><div layout=\"column\"><div class=\"md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-primary-bg ph-10 pv-5 h-50\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title text-l\">\nPerfil de competencias</div></header><div class=\"content\"><md-list><md-list-item \nng-repeat=\"skill in vm.skillsProfile track by $index\" ng-class=\"!$last ? \'bb\' : \'\'\"><span class=\"text-m text-primary\">\n{{skill.skill.name}}</span></md-list-item></md-list></div></div></div><div class=\"mt-15\"><div \nclass=\"md-whiteframe-1dp\" layout=\"column\"><header class=\"md-primary-bg ph-10 pv-5 h-50\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title text-l\">Evaluadores de competencias</div><div><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.showForm[\'ev_skills\']\" ng-click=\"vm.enableEditionForm(\'ev_skills\')\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon \nmd-font-icon=\"icon-plus s18\" class=\"white-fg\"></md-icon></md-button></div></header><div class=\"content\"><md-list>\n<md-list-item ng-show=\"vm.showForm[\'ev_skills\']\"><form name=\"formEvSkills\" class=\"w-100-p\"><table class=\"tbl-lbl-data\">\n<tr><th><span class=\"text-m\">Empleado</span></th><td class=\"text-m text-secondary\"><md-input-container \nclass=\"md-block mt-15\"><label class=\"field_obl\">Seleccione</label><md-select ng-model=\"vm.evSkills.employee\" required>\n<md-option ng-repeat=\"employee in vm.listEmployees | orderBy:\'name\'\" ng-value=\"employee.id\">{{employee.name}}\n</md-option></md-select></md-input-container></td></tr><tr><th><span class=\"text-m\">Rol</span></th><td \nclass=\"text-m text-secondary\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Roles</label>\n<md-select ng-model=\"vm.evSkills.rol\" required><md-option \nng-repeat=\"preferences in vm.skill_evaluation_preferences.evaluator_roles_available\" ng-value=\"preferences.key\" \nng-if=\"preferences.key != \'chief\' && preferences.key != \'self\'\">{{preferences.label}}</md-option></md-select>\n</md-input-container></td></tr></table><div layout=\"row\" layout-align=\"center center\"><md-button type=\"submit\" \nng-click=\"vm.evSkills = {};vm.showForm[\'ev_skills\'] = false;\" class=\"send-button md-warn md-raised\">Cancelar\n</md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" ng-click=\"vm.addSkillEvaluator()\" \nng-disabled=\"formEvSkills.$invalid\">Aceptar</md-button></div></form></md-list-item><md-list-item \nng-repeat=\"evaluators in vm.skillsEvaluators track by $index\" ng-class=\"!$last ? \'bb\' : \'\'\" \nng-if=\"!vm.showForm[\'ev_skills\']\"><div layout=\"row\" layout-align=\"space-between center\" class=\"full-width\"><div \nlayout=\"column\" layout-align=\"center start\"><span class=\"text-m text-primary\">{{evaluators.evaluator.name}} </span>\n<span class=\"text-s text-secondary\">{{evaluators.rol.label}}</span></div><div layout=\"row\" class=\"p-5\" \nng-if=\"evaluators.rol.key != \'chief\' && evaluators.rol.key != \'self\'\"><md-icon \nmd-font-icon=\"icon-trash s21 cursor-pointer\" ng-click=\"vm.deleteHrSkillEvaluator(evaluators,$index);\"></md-icon></div>\n</div></md-list-item></md-list></div></div></div><div class=\"mt-15\" layout=\"column\" \nng-if=\"vm.coreValueProfile && vm.coreValueProfile.length\"><div class=\"md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-primary-bg ph-10 pv-5 h-50\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title text-l\">\nPerfil de valores</div></header><div class=\"content\"><md-list><md-list-item \nng-repeat=\"core_value in vm.coreValueProfile track by $index\" ng-class=\"!$last ? \'bb\' : \'\'\"><span \nclass=\"text-m text-primary\">{{core_value.core_value.name}}</span></md-list-item></md-list></div></div></div><div \nclass=\"mt-15\" ng-if=\"vm.coreValueProfile && vm.coreValueProfile.length\"><div class=\"md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-primary-bg ph-10 pv-5 h-50\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"title text-l\">Evaluadores de valores</div></header><div class=\"content\"><md-list><md-list-item \nng-repeat=\"evaluators in vm.coreValueEvaluators track by $index\" ng-class=\"!$last ? \'bb\' : \'\'\"><div layout=\"column\" \nlayout-align=\"center start\"><span class=\"text-m text-primary\">{{evaluators.evaluator.name}} </span><span \nclass=\"text-s text-secondary\">{{evaluators.rol.label}}</span></div></md-list-item></md-list></div></div></div></div>\n<div flex=\"33\"><div class=\"md-whiteframe-1dp\" layout=\"column\"><header class=\"md-primary-bg ph-10 pv-5 h-50\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title text-l\">Información de la matrícula</div><div>\n<md-progress-circular ng-disabled=\"!vm.formLoading[\'mat_info\']\" ng-if=\"vm.formLoading[\'mat_info\']\" class=\"md-accent\" \nmd-diameter=\"25px\"></md-progress-circular><md-button class=\"md-icon-button\" \nng-if=\"!vm.showForm[\'mat_info\'] && !vm.formLoading[\'mat_info\']\" ng-click=\"vm.enableEditionForm(\'mat_info\')\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon \nmd-font-icon=\"icon-border-color s18\" class=\"white-fg\"></md-icon></md-button></div></header><div class=\"content\"><form \nname=\"MatInfoForm\" class=\"md-inline-form\" novalidate><table class=\"tbl-lbl-data\"><tr><th><span class=\"text-m\">Empresa:\n</span></th><td class=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_info\']\">{{vm.evaluationInfo.empresa.name}}\n</div><div ng-if=\"vm.showForm[\'mat_info\'] == true\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">\nEmpresa</label><md-select ng-model=\"vm.evaluationInfo.empresa_id\" required><md-option \nng-repeat=\"option in vm.organizationCompanies\" value=\"{{option.id}}\">{{option.name}}</md-option></md-select>\n</md-input-container></div></td></tr><tr><th><span class=\"text-m\">Cargo:</span></th><td class=\"text-m text-secondary\">\n<div ng-if=\"!vm.showForm[\'mat_info\']\" layout=\"column\"><span>{{vm.evaluationInfo.cargo.name}}</span> <span \nclass=\"text-s md-primary-fg mt-5 cursor-pointer\" ng-click=\"vm.viewPositionDetail(vm.evaluationInfo.cargo_id)\" \nng-if=\"vm.enablePositionDetails\">Ver información del cargo</span></div><div ng-if=\"vm.showForm[\'mat_info\'] == true\">\n<md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Cargo</label><md-select \nng-model=\"vm.evaluationInfo.cargo_id\" required><md-option ng-repeat=\"option in vm.organizationPositions\" \nvalue=\"{{option.id}}\">{{option.name}}</md-option></md-select></md-input-container></div></td></tr><tr><th \nng-if=\"vm.showForm[\'mat_info\'] == true\">Actualizar indicadores</th><td ng-if=\"vm.showForm[\'mat_info\'] == true\" \nclass=\"text-m text-secondary\"><md-input-container class=\"md-block mt-15\"><md-checkbox \nng-model=\"vm.evaluationInfo.updateGoals\" ng-value=\"false\" class=\"m-0\"></md-checkbox></md-input-container></td></tr><tr>\n<th><span class=\"text-m\">Gerencia:</span></th><td class=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_info\']\">\n{{vm.evaluationInfo.company_department.name}}</div><div ng-if=\"vm.showForm[\'mat_info\'] == true\"><md-input-container \nclass=\"md-block mt-15\"><label class=\"field_obl\">Gerencia</label><md-select \nng-model=\"vm.evaluationInfo.company_department_id\" required><md-option \nng-repeat=\"option in vm.organizationDepartments\" value=\"{{option.id}}\">{{option.name}}</md-option></md-select>\n</md-input-container></div></td></tr><tr><th><span class=\"text-m\">Área:</span></th><td class=\"text-m text-secondary\">\n<div ng-if=\"!vm.showForm[\'mat_info\']\">{{vm.evaluationInfo.area.name}}</div><div \nng-if=\"vm.showForm[\'mat_info\'] == true\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Área\n</label><md-select ng-model=\"vm.evaluationInfo.area_id\" required><md-option ng-repeat=\"option in vm.organizationAreas\" \nvalue=\"{{option.id}}\">{{option.name}}</md-option></md-select></md-input-container></div></td></tr><tr><th><span \nclass=\"text-m\">Nivel:</span></th><td class=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_info\']\">\n{{vm.evaluationInfo.position_level.name}}</div><div ng-if=\"vm.showForm[\'mat_info\'] == true\"><md-input-container \nclass=\"md-block mt-15\"><label class=\"field_obl\">Nivel</label><md-select ng-model=\"vm.evaluationInfo.nivel\" required>\n<md-option ng-repeat=\"option in vm.organizationPositionLevels\" value=\"{{option.id}}\">{{option.name}}</md-option>\n</md-select></md-input-container></div></td></tr><tr><th><span class=\"text-m\">Grupo de matrícula:</span></th><td \nclass=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_info\']\">\n{{vm.evaluationInfo.evaluation_employees_group.name}}</div><div ng-if=\"vm.showForm[\'mat_info\'] == true\">\n<md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Grupo de matrícula</label><md-select \nng-model=\"vm.evaluationInfo.grupo\" required><md-option ng-repeat=\"group in vm.groups\" value=\"{{group.id}}\">\n{{group.name}}</md-option></md-select></md-input-container></div></td></tr><tr><th><span class=\"text-m\">Jefe:</span>\n</th><td class=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_info\']\">{{vm.evaluationInfo.chief.name}}</div><div\n ng-if=\"vm.showForm[\'mat_info\'] == true\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Jefe\n</label><md-select ng-model=\"vm.evaluationInfo.jefe_id\" required><md-option \nng-repeat=\"option in vm.organizationEmployees\" value=\"{{option.id}}\">{{option.name}}</md-option></md-select>\n</md-input-container></div></td></tr><tr><th><span class=\"text-m\">Jefe aprobador:</span></th><td \nclass=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_info\']\">{{vm.evaluationInfo.approval_chief.name}}</div><div\n ng-if=\"vm.showForm[\'mat_info\'] == true\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">\nJefe aprobador</label><md-select ng-model=\"vm.evaluationInfo.jefe_jefe_id\"><md-option \nng-repeat=\"option in vm.organizationEmployees\" value=\"{{option.id}}\">{{option.name}}</md-option></md-select>\n</md-input-container><a href=\"#\" class=\"small-link md-warn\" ng-click=\"vm.evaluationInfo.jefe_jefe_id = null\">\nEliminar jefe aprobador</a></div></td></tr><tr><th><span class=\"text-m\">Jefe corporativo:</span></th><td \nclass=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_info\']\">{{vm.evaluationInfo.corp_chief.name}}</div><div \nng-if=\"vm.showForm[\'mat_info\'] == true\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">\nJefe corporativo</label><md-select ng-model=\"vm.evaluationInfo.jefe_corporativo_id\"><md-option \nng-repeat=\"option in vm.organizationEmployees\" value=\"{{option.id}}\">{{option.name}}</md-option></md-select>\n</md-input-container><a href=\"#\" class=\"small-link md-warn\" ng-click=\"vm.evaluationInfo.jefe_corporativo_id = null\">\nEliminar jefe corporativo</a></div></td></tr></table><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.showForm[\'mat_info\'] == true\"><md-button type=\"submit\" ng-click=\"vm.showForm[\'mat_info\'] = false\" \nclass=\"send-button md-warn md-raised\">Cancelar</md-button><md-button type=\"submit\" \nng-click=\"vm.saveMatInfoStructure($event)\" class=\"send-button md-accent md-raised\" ng-disabled=\"MatInfoForm.$invalid\">\nAceptar</md-button></div></form></div></div><div class=\"md-whiteframe-1dp mt-15\" layout=\"column\"><header \nclass=\"md-primary-bg ph-10 pv-5 h-50\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title text-l\">\nMódulos</div><div><md-button class=\"md-icon-button\" ng-if=\"!vm.showForm[\'mat_module\']\" \nng-click=\"vm.enableEditionForm(\'mat_module\')\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon md-font-icon=\"icon-plus s18\" class=\"white-fg\"></md-icon>\n</md-button></div></header><div class=\"content\"><md-list><md-list-item ng-show=\"vm.showForm[\'mat_module\']\"><form \nname=\"formModulo\" class=\"w-100-p\"><table class=\"tbl-lbl-data\"><tr><th><span class=\"text-m\">Modulo</span></th><td \nclass=\"text-m text-secondary\" ng-if=\"!vm.editform.mat_module\"><md-input-container class=\"md-block mt-15\"><label \nclass=\"field_obl\">Modulo</label><md-select ng-model=\"vm.moduleSelected.module\" required><md-option \nng-repeat=\"option in vm.hr_modules_free\" ng-value=\"option\">{{option.name}}</md-option></md-select></md-input-container>\n</td><td class=\"text-m text-secondary\" ng-if=\"vm.editform.mat_module\"><span>{{vm.moduleSelected.module.name}}</span>\n</td></tr><tr ng-if=\"vm.moduleSelected.module\"><th><span class=\"text-m\">Ponderación</span></th><td \nclass=\"text-m text-secondary\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Ponderación</label>\n<input name=\"meta\" ng-model=\"vm.moduleSelected.weigth\" type=\"number\" required></md-input-container></td></tr><tr \nng-if=\"vm.moduleSelected.module.module_list_id\"><th><span class=\"text-m\">Lista</span></th><td \nclass=\"text-m text-secondary\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Lista</label>\n<md-select ng-model=\"vm.moduleSelected.list\" required><md-option \nng-repeat=\"option in vm.moduleSelected.module.module_list.lists_items\" ng-value=\"option.id\">{{option.name}}</md-option>\n</md-select></md-input-container></td></tr></table><div layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"submit\" ng-click=\"vm.moduleSelected = {};vm.enableEditionForm(\'mat_module\');vm.editform.mat_module = false;\" \nclass=\"send-button md-warn md-raised\">Cancelar</md-button><md-button type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.addHrModule()\" ng-disabled=\"formModulo.$invalid\">Aceptar\n</md-button></div></form></md-list-item><md-list-item ng-repeat=\"module in vm.hr_modules_assing track by $index\" \nng-class=\"!$last ? \'bb\' : \'\'\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-wrap \nng-show=\"!vm.showForm[\'mat_module\']\"><div layout=\"column\" layout-align=\"center start\" flex=\"80\"><span \nclass=\"text-m text-primary\">{{module.hr_module.name}}</span><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-s text-secondary font-weight-600\">Peso: </span><span class=\"text-s text-secondary ml-5\">{{module.weight}}\n</span></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"module.module_list_item_id\"><span \nclass=\"text-s text-secondary font-weight-600\">Valor seleccionado: </span><span class=\"text-s text-secondary ml-5\">\n{{module.module_list_item.name}}</span></div></div><div layout=\"row\" layout-align=\"start center\" flex=\"20\"><md-icon \nmd-font-icon=\"icon-border-color s18 cursor-pointer\" ng-click=\"vm.editModulo(module)\"></md-icon><md-icon \nmd-font-icon=\"icon-trash s18 cursor-pointer\" ng-click=\"vm.deleteHrModule(module.hr_module,$event);\"></md-icon></div>\n</md-list-item></md-list></div></div></div><div flex=\"33\"><div layout=\"column\"><div class=\"md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-primary-bg ph-10 pv-5 h-50\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"title text-l\">Proceso actual</div><div><md-progress-circular ng-disabled=\"!vm.formLoading[\'mat_process\']\" \nng-if=\"vm.formLoading[\'mat_process\']\" class=\"md-accent\" md-diameter=\"25px\"></md-progress-circular><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.showForm[\'mat_process\'] && !vm.formLoading[\'mat_process\']\" \nng-click=\"vm.enableEditionForm(\'mat_process\')\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon md-font-icon=\"icon-border-color s18\" class=\"white-fg\">\n</md-icon></md-button></div></header><div class=\"content\"><form name=\"MatProcessForm\" class=\"md-inline-form\" \nnovalidate><table class=\"tbl-lbl-data\"><tr><th><span class=\"text-m\">Proceso actual:</span></th><td \nclass=\"text-m text-secondary\"><div>\n{{vm.evaluationInfo.evaluation_active_process.evaluation_process.name}} {{vm.evaluationInfo.evaluation_active_process.name}} \n<span ng-if=\"vm.evaluationInfo.process_lists_item_id\">&nbsp;/&nbsp; {{vm.evaluationInfo.process_lists_item.name}}\n</span></div></td></tr><tr><th><span class=\"text-m\">Etapa actual:</span></th><td class=\"text-m text-secondary\"><div \nng-if=\"!vm.showForm[\'mat_process\']\">{{vm.evaluationInfo.evaluation_process_stage.name}}</div><div \nng-if=\"vm.showForm[\'mat_process\'] == true\"><md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">\nMover a etapa</label><md-select ng-model=\"vm.evaluationInfo.evaluation_process_stage_id\" required><md-option \nng-repeat=\"option in vm.processStagesOptions\" value=\"{{option.id}}\">{{option.value}}</md-option></md-select>\n</md-input-container></div></td></tr><tr><th><span class=\"text-m\">Fecha límite:</span></th><td \nclass=\"text-m text-secondary\"><div ng-if=\"!vm.showForm[\'mat_process\']\">{{vm.evaluationInfo.process_deadline | fecha}}\n</div><div ng-if=\"vm.showForm[\'mat_process\'] == true\"><div><md-datepicker flex \nng-model=\"vm.evaluationInfo.process_deadline\" md-placeholder=\"Fecha límite\"></md-datepicker></div></div></td></tr>\n</table><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.showForm[\'mat_process\'] == true\"><md-button \ntype=\"submit\" ng-click=\"vm.showForm[\'mat_process\'] = false\" class=\"send-button md-warn md-raised\">Cancelar</md-button>\n<md-button type=\"submit\" ng-click=\"vm.saveMatProcess($event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"MatProcessForm.$invalid || MatProcessForm.$pristine\">Aceptar</md-button></div></form></div></div></div>\n<div class=\"mt-15\"><div class=\"md-whiteframe-1dp\" layout=\"column\"><header class=\"md-primary-bg ph-10 pv-5 h-50\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title text-l\">Activar nuevo proceso</div></header><div \nclass=\"content p-10\"><p class=\"mb-25 text-m text-primary\">\nPor favor seleccione el proceso que desea activar para el colaborador. Recuerde que al iniciar este proceso, cancelará cualquier proceso en el que se encuentre actualmente el colaborador.\n</p><div class=\"msg-min-warning m-16 p-15\" \nng-if=\"vm.evaluationInfo.evaluation_process_stage && !vm.evaluationInfo.evaluation_process_stage.is_last_stage\"><span \nclass=\"text-m\">Sé debe finalizar el proceso actual para habilitar un nuevo proceso.</span></div><form \nname=\"newProcessForm\" class=\"md-inline-form\" novalidate \nng-if=\"!vm.evaluationInfo.evaluation_process_stage_id || vm.evaluationInfo.evaluation_process_stage.is_last_stage\">\n<table class=\"tbl-lbl-data\"><tr><th><span class=\"text-m\">Proceso*</span></th><td class=\"text-m text-secondary\">\n<md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">Proceso a activar</label><md-select \nng-model=\"vm.new_process\" required ng-change=\"vm.availableProcessChange(vm.new_process)\"><md-option \nng-repeat=\"option in vm.availableProcess\" value=\"{{option.id}}\">{{option.evaluation_process.name}} - {{option.name}}\n</md-option></md-select></md-input-container></td></tr><tr ng-if=\"vm.availableProcessProcessList\"><th><span \nclass=\"text-m\">{{vm.availableProcessProcessList.label}}*</span></th><td class=\"text-m text-secondary\">\n<md-input-container class=\"md-block mt-15\"><label class=\"field_obl\">{{vm.availableProcessProcessList.label}}</label>\n<md-select ng-model=\"vm.process_lists_item_id\" required><md-option \nng-repeat=\"option in vm.availableProcessProcessList.lists_items\" value=\"{{option.id}}\">{{option.name}}</md-option>\n</md-select></md-input-container></td></tr><tr><th><span class=\"text-m\">Fecha límite*</span></th><td \nclass=\"text-m text-secondary\"><div flex class=\"date-container\"><md-datepicker flex ng-model=\"vm.process_deadline\" \nmd-placeholder=\"Fecha límite\" md-min-date=\"vm.today\" ng-required=\"true\"></md-datepicker></div></td></tr></table><div \nclass=\"text-center\"><md-button type=\"submit\" ng-click=\"vm.activateNewProcess($event)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"newProcessForm.$invalid || newProcessForm.$pristine\">Aceptar\n</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation-details/partials/_evaluation-log.html","<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\">Fecha y hora</span></div></th><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\">Colaborador</span></div></th><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\">Acción</span></div></th><th \nclass=\"md-blue-grey-700-bg\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"dataLog in vm.evaluationLog\"><td>{{dataLog.created_at}}</td><td><div ng-if=\"dataLog.user\">\n{{dataLog.user.empleado.name}}</div><div ng-if=\"!dataLog.user\">{{dataLog.usuario_sistema}}</div></td><td>\n{{dataLog.action_name}}</td><td><md-button ng-click=\"vm.openLogDetailDialog($event, dataLog)\">Ver detalles</md-button>\n</td></tr></tbody></table>");
$templateCache.put("app/main/custom_modules/organization/employees/partials/_employees-list.html","<div ng-if=\"vm.employees === null\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><div id=\"employees-list\" \nng-if=\"vm.employees !== null\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th><div class=\"table-header\"><span class=\"column-title\">Colaborador</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title text-center\">Usuario</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title text-center text-center\">Email</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"employee in vm.employees\"><td>{{employee.name}}</td><td>{{employee.cedula}}</td><td>{{employee.correo}}</td>\n<td><md-menu ng-if=\"!vm.sendindData[employee.id]\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openEmployeeDialog($event, employee)\">Modificar</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.resetPassword(ev,employee)\">Restablecer contraseña</md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item><md-button class=\"md-warn\" ng-click=\"vm.removeEmployee($event, employee)\">Eliminar</md-button>\n</md-menu-item></md-menu-content></md-menu><md-progress-circular ng-disabled=\"!vm.sendindData[employee.id]\" \nng-if=\"vm.sendindData[employee.id]\" class=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></td></tr></tbody>\n</table></div>");
$templateCache.put("app/main/custom_modules/organization/employees/partials/_inactive-employees-list.html","<div ng-if=\"vm.inactiveEmployees === null\" ng-include=\"\'app/main/utils/loading-data.html\'\"></div><div \nid=\"employees-list\" ng-if=\"vm.inactiveEmployees !== null\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th><div class=\"table-header\"><span class=\"column-title\">Colaborador</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title text-center\">Usuario</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title text-center text-center\">Email</span></div></th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"employee in vm.inactiveEmployees\"><td>{{employee.name}}</td><td>{{employee.cedula}}</td><td>\n{{employee.correo}}</td><td><md-button class=\"md-accent\" ng-click=\"vm.activateEmployee($event, employee)\" \nng-if=\"!vm.sendindData[employee.id]\">Activar</md-button><md-progress-circular \nng-disabled=\"!vm.sendindData[employee.id]\" ng-if=\"vm.sendindData[employee.id]\" class=\"md-accent\" md-diameter=\"25px\">\n</md-progress-circular></td></tr></tbody></table></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrAssistantObjective/default/default.html","<div class=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">{{data.hr_module.name}}</span></div><div \nclass=\"md-whiteframe-4dp mtoc assistantMultiple\"><div layout=\"row\" layout-align=\"end center\" class=\"p-20 white-500-bg\">\n<div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"(key,title) in data.data.title track by $index\" \nclass=\"mr-5\"><span class=\"badge-circle mr-5 text-uppercase\" ng-style=\"{\'background-color\':title.selected_value}\">\n{{title.label | onlyCapitalize}}</span> <span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div \nclass=\"column\" ng-repeat=\"section in data.data.sections track by $index\" class=\"mb-15\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-weight-400 mb-5 p-20\"><span class=\"md-primary-fg text-xl font-weight-600\">\n{{$index + 1}}. {{section.name}}</span></div><div class=\"backgroundValue p-20\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/template/multiple.html\'\" \nng-init=\"questions = section.questions;info = data.data.info;title = data.data.title\"></div></div></div><div \nlayout=\"column\" layout-align=\"end\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-weight-400 mb-5 p-20\"><span class=\"md-primary-fg text-xl font-weight-600\">Acciones de desarrollo</span>\n</div><div class=\"backgroundValue p-20\"><div ng-repeat=\"section in data.data.personal_developments track by $index\" \nlayout=\"column\"><div class=\"md-inline-form w-100-p\" layout=\"row\" layout-align=\"space-between start\" layout-wrap><div \nlayout=\"column\" flex=\"50\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg mr-5 text-m font-weight-600\">Objetivo</span></div><div class=\"text-s text-secondary comment-read\" \nng-bind-html=\"section.goal\"></div></div><div layout=\"row\" layout-algin=\"start end\" flex=\"50\"><md-input-container \nclass=\"w-100-p\"><label>Responsable</label><md-select ng-model=\"section.responsibility\" disabled=\"disabled\"><md-option \nng-repeat=\"personal in data.data.personal_development_responsable_list\" ng-value=\"personal.id\">{{personal.value}}\n</md-option></md-select></md-input-container></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrCoreValue/default/default.html","<div ng-if=\"data.skillStructure.results_by_role.body\"><div class=\"mb-15\"><span \nclass=\"text-xl md-primary-fg font-weight-500\">{{data.hr_module.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp default-skill-evaluation-approval\"><div class=\"mb-15 p-20\" \nng-if=\"data.skillStructure.results_by_role.body\"><div layout=\"row\" class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Competencia</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Jefe</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Autoevaluación</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.skillStructure.results_by_role.body\"><td class=\"grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-m text-primary mb-10\">{{row.name}}</span></div></td><td \nclass=\"text-m text-secondary text-center\">{{row.data.chief}}</td><td class=\"text-m text-secondary text-center\">\n{{row.data.self}}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"p-20 white-500-bg\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"(key,title) in data.skillStructure.titleObj track by $index\" class=\"mr-5\"><span \nclass=\"badge-circle mr-5 text-uppercase\" ng-style=\"{\'background-color\':title.selected_value}\">\n{{title.label | onlyCapitalize}}</span> <span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div \nng-repeat=\"approval in data.skillStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"detail-skill md-primary-fg\">{{approval.skillDetail.core_value.name}}</span>\n</div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = approval.skillDescriptors;title = data.skillStructure.titleObj;info = approval.dataBody;config = {onlyview:true,colors:data.skillStructure.titleObjColor}\">\n</div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrFinalComment/default/default.html","<div ng-if=\"data.comments.length\"><div class=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">\n{{data.hr_module.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg add-comment no-radius\"><div class=\"column\" \nng-repeat=\"comment in data.comments track by $index\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-weight-400 mb-5 m-20 bb pb-10\"><span class=\"md-primary-fg text-xl font-weight-600\">{{comment.label}}</span>\n</div><div class=\"p-20 comments-container\" layout=\"column\"><span class=\"text-m text-primary mb-15\">\n{{comment.description}}</span><div layout=\"column\" ng-repeat=\"empleado in comment.empleados\"><div layout=\"column\">\n<ik-employee-info data=\"empleado\" comment=\"empleado.comment\" class=\"personalize\"></ik-employee-info></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrGeneralInformation/default/default.html","<div ng-if=\"data.intereses_adversions.length\"><div class=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">\n{{data.hr_module.name}}</span></div><div class=\"md-whiteframe-4dp\"><div class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Intereses</span></th><th \nclass=\"background text-center w-30-p\"><span class=\"titleTable\">Aversiones</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.intereses_adversions\"><td class=\"grey-100-bg\"><div layout=\"column\" layout-align=\"center start\">\n<span class=\"text-m text-primary mb-10\">{{row.intereses}}</span></div></td><td \nclass=\"text-m text-secondary w-30-p text-center\">{{row.adversiones}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrGoal/default/default.html","<div ng-if=\"data.employee_goals.length\"><div class=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">\n{{data.hr_module.name}}</span></div><div class=\"md-whiteframe-4dp\"><div class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Objetivo</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Meta</span></th><th class=\"background text-center w-10-p\"><span\n class=\"titleTable\">Ponderación</span></th><th class=\"background text-center w-10-p\"><span class=\"titleTable\">Resultado\n</span></th></tr></thead><tbody><tr ng-repeat=\"row in data.employee_goals\"><td class=\"grey-100-bg\"><div \nlayout=\"column\" layout-align=\"center start\"><span class=\"text-m text-primary mb-10\">\n{{row.objetivo_id ? row.objetivo.name : row.name}}</span><div layout=\"column\" layout-align=\"center start\" class=\"mb-5\" \nng-if=\"row.strategic_goal\"><span class=\"md-accent-fg text-m font-weight-600\">Objetivo Estratégico</span> <span \nclass=\"text-s text-secondary\">{{row.strategic_goal.label}}</span></div><div layout=\"column\" \nlayout-align=\"center start\" class=\"mb-5\" ng-repeat=\"additional in data.goals_additional_data\" \nng-if=\"row.additional_data[additional.value]\"><span class=\"md-accent-fg text-m font-weight-600\">{{additional.label}}\n</span> <span class=\"text-s text-secondary\">{{row.additional_data[additional.value]}}</span></div></div><div \nlayout=\"column\" ng-if=\"row.goals_evaluations_data[0]\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"row.goals_evaluations_data[0].corporate_goals_evaluation_id ? row.goals_evaluations_data[0].chief_comment : row.goals_evaluations_data[0].colla_comment\">\n<span class=\"text-s mt-15 font-weight-600\">COMENTARIOS DE LAS EVALUACIONES</span></div><div layout=\"column\" \nlayout-align=\"center start\" class=\"mb-10\" ng-if=\"row.goals_evaluations_data[0].colla_comment\"><span \nclass=\"text-primary text-m font-weight-300\">Autoevaluación:</span> <span class=\"text-s text-secondary\">\n{{row.goals_evaluations_data[0].colla_comment}}</span></div><div layout=\"column\" layout-align=\"center start\" \nclass=\"mb-10\" ng-if=\"row.goals_evaluations_data[0].chief_comment\"><span class=\"text-primary text-m font-weight-300\">\nComentarios del jefe:</span> <span class=\"text-s text-secondary\">{{row.goals_evaluations_data[0].chief_comment}}</span>\n</div><div layout=\"column\" layout-align=\"center start\" class=\"mb-10\" \nng-if=\"row.goals_evaluations_data[0].corporate_goals_evaluation_id\"><span class=\"text-primary text-m font-weight-300\">\nComentarios del negocio:</span> <span class=\"text-s text-secondary\">\n{{row.goals_evaluations_data[0].corporate_goals_evaluation.comment}}</span></div></div></td><td \nclass=\"text-m text-secondary w-30-p\">{{row.objetivo_id ? row.objetivo.meta : row.meta}}</td><td \nclass=\"text-m text-secondary w-10-p text-center\">{{row.porcentaje+\"%\"}}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">\n{{(row.goals_evaluations_data.length ? row.goals_evaluations_data[0].final_num_result ? row.goals_evaluations_data[0].final_num_result : row.goals_evaluations_data[0].final_result_lists_item_id ? row.goals_evaluations_data[0].final_result_lists_item.name : \'\' : \'--\' ) | number:0}}\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrPersonalDevelopment/default/default.html","<div ng-if=\"data.personal_development.length\"><div class=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">\n{{data.hr_module.name}}</span></div><div class=\"md-whiteframe-4dp\"><div class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Acción de desarrollo</span>\n</th><th class=\"background text-center w-10-p\"><span class=\"titleTable\">Ponderación</span></th><th \nclass=\"background text-center w-10-p\"><span class=\"titleTable\">Resultado</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.personal_development\"><td class=\"grey-100-bg\"><div layout=\"column\" layout-align=\"center start\">\n<span class=\"text-m text-primary mb-10\">{{row.objetive}}</span><div layout=\"column\" layout-align=\"center start\" \nclass=\"mb-5\"><span class=\"md-accent-fg text-m font-weight-600\">Competencia </span><span class=\"text-s text-secondary\">\n{{row.skill.name}}</span></div><div layout=\"column\" layout-align=\"center start\" class=\"mb-5\"><span \nclass=\"md-accent-fg text-m font-weight-600\">Como lo voy a lograr </span><span class=\"text-s text-secondary\">\n{{row.how_to_achieve_it}}</span></div><div layout=\"column\" layout-align=\"center start\" class=\"mb-5\" \nng-repeat=\"additional in data.goals_additional_data\" ng-if=\"row.additional_data[additional.value]\"><span \nclass=\"md-accent-fg text-m font-weight-600\">{{additional.label}}</span> <span class=\"text-s text-secondary\">\n{{row.additional_data[additional.value]}}</span></div></div><div layout=\"column\" ng-if=\"row.evaluation_history[0]\"><div\n layout=\"row\" layout-align=\"center center\"><span class=\"text-s mt-15 font-weight-600\">COMENTARIOS DE LAS EVALUACIONES\n</span></div><div layout=\"column\" layout-align=\"center start\" class=\"mb-10\"><span \nclass=\"text-primary text-m font-weight-300\">Autoevaluación:</span> <span class=\"text-s text-secondary\">\n{{row.evaluation_history[0].colla_comment}}</span></div><div layout=\"column\" layout-align=\"center start\" class=\"mb-10\" \nng-if=\"row.evaluation_history[0].chief_comment\"><span class=\"text-primary text-m font-weight-300\">Comentarios del jefe:\n</span> <span class=\"text-s text-secondary\">{{row.evaluation_history[0].chief_comment}}</span></div></div></td><td \nclass=\"text-m text-secondary w-10-p text-center\">{{row.weight | number: 0}}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">\n{{(row.evaluation_history.length ? row.evaluation_history[0].final_result_lists_item_id ? row.evaluation_history[0].final_result_lists_item.name : row.evaluation_history[0].final_num_result : \'--\') | number:0}}\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrPoll/default/default.html","<div ng-if=\"data.movilidad.length\"><div class=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">\n{{data.hr_module.name}}</span></div><div class=\"md-whiteframe-4dp\"><div class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Pregunta</span></th><th \nclass=\"background text-center w-10-p\"><span class=\"titleTable\">Respuesta</span></th><th \nclass=\"background text-center w-20-p\"><span class=\"titleTable\">Comentario</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.movilidad\"><td class=\"grey-100-bg w-30-p\"><div layout=\"column\" layout-align=\"center start\"><span\n class=\"text-m text-primary mb-10\">{{row.name}}</span></div></td><td class=\"w-40-p text-justify\"><div \nng-if=\"row.result_list_item\"><span class=\"text-m text-secondary\">{{row.result_list_item.name}}</span></div><div \nng-if=\"!row.result_list_item\"><span class=\"text-m text-secondary\">{{row.result_text}}</span></div></td><td \nclass=\"text-justify w-20-p text-m text-secondary w-30-p\">{{row.comment ? row.comment : \'N/A\'}}</td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/elements/ik-evaluation-data-module/HrSkill/default/default.html","<div ng-if=\"data.skillStructure.results_by_role.body\"><div class=\"mb-15\"><span \nclass=\"text-xl md-primary-fg font-weight-500\">{{data.hr_module.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp default-skill-evaluation-approval\"><div class=\"mb-15 p-20\" \nng-if=\"data.skillStructure.results_by_role.body\"><div layout=\"row\" class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Competencia</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Jefe</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Autoevaluación</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.skillStructure.results_by_role.body\"><td class=\"grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-m text-primary mb-10\">{{row.name}}</span></div></td><td \nclass=\"text-m text-secondary text-center\">{{row.data.chief}}</td><td class=\"text-m text-secondary text-center\">\n{{row.data.self}}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"p-20 white-500-bg\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"(key,title) in data.skillStructure.titleObj track by $index\" class=\"mr-5\"><span \nclass=\"badge-circle mr-5 text-uppercase\" ng-style=\"{\'background-color\':title.selected_value}\">\n{{title.label | onlyCapitalize}}</span> <span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div \nng-repeat=\"approval in data.skillStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"detail-skill md-primary-fg\">{{approval.skillDetail.skill.name}}</span></div><div\n class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = approval.skillDescriptors;title = data.skillStructure.titleObj;info = approval.dataBody;config = {onlyview:true,colors:data.skillStructure.titleObjColor}\">\n</div></div></div><div layout=\"column\" class=\"p-20 white-500-bg\" \nng-if=\"data.skills_approver_comments && data.skills_approver_comments.length\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-weight-400 mb-5 m-20 bb pb-10\"><span \nclass=\"md-primary-fg text-xl font-weight-600\">Comentarios generales</span></div><div layout=\"column\" \nng-repeat=\"approve_comment in data.skills_approver_comments\"><div layout=\"column\" class=\"p-20\"><ik-employee-info \ndata=\"approve_comment\" comment=\"approve_comment.approver_comment\" class=\"personalize\" key=\"approver\">\n</ik-employee-info></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/template/multiple.html","<div class=\"assistantSingle\"><div class=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><td class=\"w-70-p\"><span \nclass=\"titleTable text-capitalize text-center\">Comportamiento</span></td><td \nng-repeat=\"(key,title) in info track by $index\" class=\"background text-center\" \nng-class=\"$first ? \'first-first\' : $last ? \'first-end\' : \'\'\"><span class=\"titleTable text-capitalize\">\n{{title.empleado.name}}</span></td></tr></thead><tbody><tr ng-repeat=\"question in questions track by $index\"><td \nclass=\"w-70-p\"><span class=\"text-m text-primary\">{{question.name}}</span></td><td \nng-repeat=\"(key,data) in info track by $index\" class=\"background text-center\" \nng-class=\"$parent.$last && $first ? \'end-first\' : $parent.$last && $last ? \'end-end\' : \'\'\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"data.evaluation[question.question_statement_id]\"><div class=\"badge-circle\" \nng-style=\"{\'background-color\':title[data.evaluation[question.question_statement_id]].selected_value}\">\n{{title[data.evaluation[question.question_statement_id]].label | onlyCapitalize:\'No aplica\'}}</div></div><span \nclass=\"text-m text-secondary text-capitalize\" ng-if=\"!title[data.evaluation[question.question_statement_id]]\">No aplica\n</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/template/single.html","<div class=\"assistantSingle\"><div class=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><td class=\"w-70-p\"><span \nclass=\"titleTable text-capitalize text-center\">Comportamiento</span></td><td \nng-repeat=\"title in data.assistants.title track by $index\" class=\"background text-center\" \nng-class=\"$first ? \'first-first\' : $last ? \'first-end\' : \'\'\"><span class=\"titleTable text-capitalize\">{{title.label}}\n</span></td></tr></thead><tbody><tr ng-repeat=\"question in section.questions track by $index\"><td class=\"w-70-p\"><span \nclass=\"text-m text-primary\">{{question.name}}</span></td><td \nng-repeat=\"title in data.assistants.title track by $index\" class=\"background text-center\" \nng-class=\"$parent.$last && $first ? \'end-first\' : $parent.$last && $last ? \'end-end\' : \'\'\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"config.onlyView && data.formData[question.question_statement_id] == title.value\" \nclass=\"md-primary-fg\"></md-icon><input type=\"radio\" ng-model=\"data.formData[question.question_statement_id]\" \nng-value=\"title.value\" ng-if=\"!config.onlyView\"></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-poll/template/input-numeric.html","<div layout=\"column\" class=\"comments-container\"><input type=\"number\" class=\"comments-input\" \nng-model=\"data.formData[row.id].result\" required><div class=\"h-20\"></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-poll/template/input-select.html","<md-input-container class=\"md-block md-default-theme md-input-has-value\"><label class=\"ph field_obl\">\n{{row.answer_list.label}}</label><md-select class=\"pp mt-10\" ng-model=\"data.formData[row.id].result\" required>\n<md-option ng-repeat=\"value in row.answer_list.lists_items\" ng-value=\"value.id\">{{value.name}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-poll/template/input-text.html","<div layout=\"column\" class=\"comments-container\"><textarea class=\"comments-input\" \nng-model=\"data.formData[row.id].result\" required maxlength=\"500\" rows=\"4\"></textarea><div layout=\"row\" \nlayout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{data.formData[row.id].result.length ? data.formData[row.id].result.length : 0}}</span> <span \nclass=\"text-xs text-secondary\">/500</span></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/template/etapas-novacion.html","<div class=\"skillContent\"><div class=\"table-header md-whiteframe-13dp border-radius-15\"><table class=\"tbl-lbl-data\">\n<thead><tr><td ng-repeat=\"title in titles track by $index\" class=\"background text-center\" \nng-class=\"$first ? \'first-first\' : $last ? \'first-end\' : \'\'\"><span class=\"titleTable text-capitalize\">{{title.label}}\n</span></td></tr></thead><tbody><tr ng-repeat=\"skill in body track by $index\" \nng-class=\"{\'backgroundCell\' : $odd,\'white-bg\':$even}\"><td ng-repeat=\"title in titles track by $index\" \nclass=\"text-center cursor-pointer\" ng-class=\"{\'end-first\' :$parent.$last && $first,\'end-end\': $parent.$last && $last}\" \nng-click=\"vm.selectedCell(skill,title)\"><div layout=\"column\" layout-align=\"space-between center\" class=\"h-250\"><span \nclass=\"text-m text-primary text-justify\">{{skill.stages[title.value]}}</span><div><md-icon md-font-icon=\"icon-check\" \nng-if=\"config.onlyview && info.dataBody.descriptors_result[skill.id] == title.value\" class=\"md-primary-fg\"></md-icon>\n<label class=\"container-radio-button\"><input type=\"radio\" ng-model=\"vm.formData[skill.id]\" ng-value=\"title.value\" \nng-if=\"!config.onlyview\"> <span class=\"checkmark-radio-button\"></span></label></div></div></td></tr></tbody></table>\n</div><div layout=\"row\" layout-align=\"center center\" ng-if=\"!config.onlyview\" class=\"text-center p-1-em mt-10 mb-5\">\n<span class=\"text-m text-primary font-weight-600\">\nPor favor ingrese las fortalezas y oportunidades de mejora del colaborador para esta competencia.</span></div><div \nlayout=\"column\" layout-align=\"center\" class=\"comments-container p-1-em\"><div layout=\"row\"><div layout=\"column\" \nng-if=\"!config.onlyview\" class=\"w-100-p\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg mr-5 text-m font-weight-600\">Fortalezas <span \nng-required=\"vm.validation.positive_comment.required\">*</span></span></div><textarea class=\"comments-input\" \nng-model=\"vm.positive_comment\" ng-required=\"vm.validation.positive_comment.required\" maxlength=\"500\" rows=\"5\">\n</textarea><div layout=\"row\" layout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{vm.positive_comment.length ? vm.positive_comment.length : 0}}</span> <span class=\"text-xs text-secondary\">/500</span>\n</div></div><div layout=\"column\" layout-align=\"center start\" ng-if=\"config.onlyview\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-5\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Fortalezas</span></div>\n<div class=\"text-s text-secondary comment-read\" ng-bind-html=\"info.dataBody.positive_comment\"></div></div></div><div \nlayout=\"row\" class=\"mt-10\"><div layout=\"column\" ng-if=\"!config.onlyview\" class=\"w-100-p\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Oportunidad de mejora <span \nng-required=\"vm.validation.negative_comment.required\">*</span></span></div><textarea class=\"comments-input\" \nng-model=\"vm.negative_comment\" ng-required=\"vm.validation.negative_comment.required\" maxlength=\"500\" rows=\"5\">\n</textarea><div layout=\"row\" layout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{vm.negative_comment.length ? vm.negative_comment.length : 0}}</span> <span class=\"text-xs text-secondary\">/500</span>\n</div></div><div layout=\"column\" layout-align=\"center start\" ng-if=\"config.onlyview\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-5\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Oportunidad de mejora\n</span></div><div class=\"text-s text-secondary comment-read\" ng-bind-html=\"info.dataBody.negative_comment\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html","<div class=\"skillContentAproval\"><div class=\"table-header mb-5\"><table class=\"tbl-lbl-data\"><thead><tr><td \nclass=\"w-70-p\"><span class=\"titleTable text-capitalize text-center\">Nombre</span></td><td \nng-repeat=\"bodyData in info track by $index\" class=\"background text-center\" \nng-class=\"$first ? \'first-first\' : $last ? \'first-end\' : \'\'\"><span class=\"titleTable text-capitalize\">\n{{bodyData.skills_evaluator ? bodyData.skills_evaluator.evaluator.name : bodyData.core_value_evaluator.evaluator.name}}\n</span></td></tr></thead><tbody><tr ng-repeat=\"skill in body track by $index\"><td class=\"w-70-p\"><span \nclass=\"text-m text-primary\">{{skill.name}}</span></td><td ng-repeat=\"data in info track by $index\" \nclass=\"background text-center\" \nng-class=\"$parent.$last && $first ? \'end-first\' : $parent.$last && $last ? \'end-end\' : \'\'\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"config.colors && title[data.descriptors_result[skill.id]]\"><div \nclass=\"badge-circle\" ng-style=\"{\'background-color\':title[data.descriptors_result[skill.id]].selected_value}\" \nng-class=\"{\'text-uppercase\':config.colors[data.descriptors_result[skill.id]]}\">\n{{title[data.descriptors_result[skill.id]].label | onlyCapitalize:\'No aplica\'}}</div></div><span \nclass=\"text-m text-secondary text-capitalize\" ng-if=\"config.colors && !title[data.descriptors_result[skill.id]]\">\nNo aplica</span> <span class=\"text-m text-secondary text-capitalize\" ng-if=\"!config.colors\">\n{{title[data.descriptors_result[skill.id]] | onlyCapitalize:\'No aplica\'}}</span></td></tr></tbody></table></div><div \nng-repeat=\"data in info track by $index\" class=\"p-1-em\"><ik-employee-info \ndata=\"data.skills_evaluator ? data.skills_evaluator : data.core_value_evaluator\" ng-if=\"!config.hideevaluator\">\n</ik-employee-info><div layout=\"column\" layout-align=\"center start\" class=\"comments\"><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"config.onlyview\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg mr-5 text-m font-weight-600\">Fortalezas</span></div><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"data.positive_comment\"></div></div><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"config.onlyview\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg mr-5 text-m font-weight-600\">Oportunidad de mejora</span></div><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"data.negative_comment\"></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill.html","<div class=\"skillContent\"><div class=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><td class=\"w-70-p\"><span \nclass=\"titleTable text-capitalize text-center\">Nombre</span></td><td ng-repeat=\"title in title track by $index\" \nclass=\"background text-center\" ng-class=\"$first ? \'first-first\' : $last ? \'first-end\' : \'\'\"><span \nclass=\"titleTable text-capitalize\">{{title.label}}</span></td></tr></thead><tbody><tr \nng-repeat=\"skill in body track by $index\"><td class=\"w-70-p\"><span class=\"text-m text-primary\">{{skill.name}}</span>\n</td><td ng-repeat=\"title in title track by $index\" class=\"background text-center\" \nng-class=\"$parent.$last && $first ? \'end-first\' : $parent.$last && $last ? \'end-end\' : \'\'\"><md-icon \nmd-font-icon=\"icon-check\" ng-if=\"config.onlyview && info.dataBody.descriptors_result[skill.id] == title.value\" \nclass=\"md-primary-fg\"></md-icon><input type=\"radio\" ng-model=\"vm.formData[skill.id]\" ng-value=\"title.value\" \nng-if=\"!config.onlyview\"></td></tr></tbody></table></div><div ng-if=\"vm.has_extra_fields\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!config.onlyview\" class=\"text-center p-1-em mt-10 mb-5\"><span \nclass=\"text-m text-primary font-weight-600\">\nPor favor ingrese las fortalezas y oportunidades de mejora del colaborador para esta competencia.</span></div><div \nlayout=\"column\" layout-align=\"center\" class=\"comments-container p-1-em\"><div layout=\"row\"><div layout=\"column\" \nng-if=\"!config.onlyview\" class=\"w-100-p\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg mr-5 text-m font-weight-600\">Fortalezas <span ng-if=\"vm.validation.positive_comment.required\">*\n</span></span></div><textarea class=\"comments-input\" ng-model=\"vm.positive_comment\" \nng-required=\"vm.validation.positive_comment.required\" maxlength=\"500\" rows=\"5\"></textarea><div layout=\"row\" \nlayout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{vm.positive_comment.length ? vm.positive_comment.length : 0}}</span> <span class=\"text-xs text-secondary\">/500</span>\n</div></div><div layout=\"column\" layout-align=\"center start\" ng-if=\"config.onlyview\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-5\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Fortalezas</span></div>\n<div class=\"text-s text-secondary comment-read\" ng-bind-html=\"info.dataBody.positive_comment\"></div></div></div><div \nlayout=\"row\" class=\"mt-10\"><div layout=\"column\" ng-if=\"!config.onlyview\" class=\"w-100-p\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Oportunidad de mejora <span \nng-if=\"vm.validation.negative_comment.required\">*</span></span></div><textarea class=\"comments-input\" \nng-model=\"vm.negative_comment\" ng-required=\"vm.validation.negative_comment.required\" maxlength=\"500\" rows=\"5\">\n</textarea><div layout=\"row\" layout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{vm.negative_comment.length ? vm.negative_comment.length : 0}}</span> <span class=\"text-xs text-secondary\">/500</span>\n</div></div><div layout=\"column\" layout-align=\"center start\" ng-if=\"config.onlyview\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-5\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Oportunidad de mejora\n</span></div><div class=\"text-s text-secondary comment-read\" ng-bind-html=\"info.dataBody.negative_comment\"></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrAssistantObjective/default.html","<div layout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg assistantMultiple\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"p-20 white-500-bg\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"(key,title) in data.title track by $index\" class=\"mr-5\"><span class=\"badge-circle mr-5 text-uppercase\" \nng-style=\"{\'background-color\':title.selected_value}\">{{title.label | onlyCapitalize}}</span> <span \nclass=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div class=\"column\" \nng-repeat=\"section in data.sections track by $index\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-weight-400 mb-5 p-20\"><span class=\"md-primary-fg text-xl font-weight-600\">{{$index + 1}}. {{section.name}}\n</span></div><div class=\"backgroundValue p-20\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/template/multiple.html\'\" \nng-init=\"questions = section.questions;info = data.info;title = data.title\"></div></div></div><div layout=\"column\" \nlayout-align=\"end\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start center\" class=\"font-weight-400 mb-5 p-20\"><span \nclass=\"md-primary-fg text-xl font-weight-600\">Acciones de desarrollo</span></div><div class=\"backgroundValue p-20\"><div\n ng-repeat=\"section in data.personal_developments track by $index\" layout=\"column\"><div class=\"md-inline-form w-100-p\" \nlayout=\"row\" layout-align=\"space-between start\" layout-wrap><div layout=\"column\" flex=\"50\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Objetivo</span></div><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"section.goal\"></div></div><div layout=\"row\" \nlayout-algin=\"start end\" flex=\"50\"><md-input-container class=\"w-100-p\"><label>Responsable</label><md-select \nng-model=\"section.responsibility\" disabled=\"disabled\"><md-option \nng-repeat=\"personal in data.personal_development_responsable_list\" ng-value=\"personal.id\">{{personal.value}}\n</md-option></md-select></md-input-container></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrCoreValue/default.html","<div class=\"mb-15\"><div class=\"mb-15\"><div layout=\"column\" class=\"mtoc md-whiteframe-3dp\"><div class=\"mb-15 p-20\" \nng-if=\"data.skillStructure.results_by_role.body\"><div layout=\"row\" class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Competencia</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Jefe</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Autoevaluación</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.skillStructure.results_by_role.body\"><td class=\"grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-m text-primary mb-10\">{{row.name}}</span></div></td><td \nclass=\"text-m text-secondary text-center\">{{row.data.chief}}</td><td class=\"text-m text-secondary text-center\">\n{{row.data.self}}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"p-20 white-500-bg\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"(key,title) in data.skillStructure.titleObj track by $index\" class=\"mr-5\"><span \nclass=\"badge-circle mr-5 text-uppercase\" ng-style=\"{\'background-color\':title.selected_value}\">\n{{title.label | onlyCapitalize}}</span> <span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div \nng-repeat=\"approval in data.skillStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"detail-skill md-primary-fg\">{{approval.skillDetail.core_value.name}}</span>\n</div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = approval.skillDescriptors;title = data.skillStructure.titleObj;info = approval.dataBody;config = {onlyview:true,colors:data.skillStructure.titleObjColor}\">\n</div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrFinalComment/default.html","<div layout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg add-comment no-radius\"><div class=\"column\" \nng-repeat=\"comment in data.comments track by $index\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-weight-400 mb-5 m-20 bb pb-10\"><span class=\"md-primary-fg text-xl font-weight-600\">{{comment.label}}</span>\n</div><div class=\"p-20 comments-container\" layout=\"column\"><span class=\"text-m text-primary mb-15\">\n{{comment.description}}</span><div layout=\"column\" ng-repeat=\"empleado in comment.empleados\"><div layout=\"column\">\n<ik-employee-info data=\"empleado\" comment=\"empleado.comment\" class=\"personalize\"></ik-employee-info></div></div></div>\n</div></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrGeneralInformation/default.html","<div class=\"table-header background\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Intereses</span></th><th class=\"background text-center w-30-p\"><span class=\"titleTable\">Aversiones\n</span></th></tr></thead><tbody><tr ng-repeat=\"row in data.intereses_adversions\"><td class=\"grey-100-bg\"><div \nlayout=\"column\" layout-align=\"center start\"><span class=\"text-m text-primary mb-10\">{{row.intereses}}</span></div></td>\n<td class=\"text-m text-secondary w-30-p text-center\">{{row.adversiones}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrGoal/default.html","<div class=\"table-header background\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Objetivo</span></th><th class=\"background text-center\"><span class=\"titleTable\">Meta</span></th><th \nclass=\"background text-center w-20-p\"><span class=\"titleTable\">Evaluación actual</span></th><th \nclass=\"background text-center w-10-p\"><span class=\"titleTable\">Ponderación</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.employee_goals\"><td class=\"grey-100-bg w-40-p\"><div layout=\"column\" layout-align=\"center start\">\n<span class=\"text-m text-primary mb-10\">{{row.objetivo_id ? row.objetivo.name : row.name}}</span><div layout=\"column\" \nlayout-align=\"center start\" class=\"mb-5\" ng-if=\"row.strategic_goal\"><span class=\"md-accent-fg text-m font-weight-400\">\nObjetivo Estratégico</span> <span class=\"text-s text-secondary\">{{row.strategic_goal.label}}</span></div><div \nlayout=\"column\" layout-align=\"center start\" class=\"mb-5\" ng-repeat=\"additional in data.goals_additional_data\"><span \nclass=\"md-accent-fg text-m font-weight-400\">{{additional.label}}</span> <span class=\"text-s text-secondary\">\n{{row.objetivo_id ? row.objetivo.additional_data[additional.value] : row.additional_data[additional.value]}}</span>\n</div></div><div layout=\"column\" ng-if=\"row.goals_evaluations_data[0]\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"row.goals_evaluations_data[0].corporate_goals_evaluation_id ? row.goals_evaluations_data[0].chief_comment : row.goals_evaluations_data[0].colla_comment\">\n<span class=\"text-s mt-15 font-weight-600\">COMENTARIOS DE LAS EVALUACIONES</span></div><div layout=\"column\" \nlayout-align=\"center start\" class=\"mb-10\" ng-if=\"row.goals_evaluations_data[0].colla_comment\"><span \nclass=\"text-primary text-m font-weight-300\">Autoevaluación:</span> <span class=\"text-s text-secondary\">\n{{row.goals_evaluations_data[0].colla_comment}}</span></div><div layout=\"column\" layout-align=\"center start\" \nclass=\"mb-10\" ng-if=\"row.goals_evaluations_data[0].chief_comment\"><span class=\"text-primary text-m font-weight-300\">\nComentarios del jefe:</span> <span class=\"text-s text-secondary\">{{row.goals_evaluations_data[0].chief_comment}}</span>\n</div><div layout=\"column\" layout-align=\"center start\" class=\"mb-10\" \nng-if=\"row.goals_evaluations_data[0].corporate_goals_evaluation_id\"><span class=\"text-primary text-m font-weight-300\">\nComentarios del negocio:</span> <span class=\"text-s text-secondary\">\n{{row.goals_evaluations_data[0].corporate_goals_evaluation.comment}}</span></div></div></td><td \nclass=\"text-m text-secondary w-30-p\">{{row.objetivo_id ? row.objetivo.meta : row.meta}}</td><td class=\"w-20-p\"><div \nng-if=\"!row.goals_evaluations_data[0]\"><i class=\"text-secondary text-m\">No se han realizado evaluaciones</i></div><div \nlayout=\"column\" layout-aling=\"center start\" \nng-if=\"row.goals_evaluations_data[0] && !row.goals_evaluations_data[0].corporate_goals_evaluation_id\"><span \nclass=\"text-m md-primary-fg font-weight-600\">Autoevaluación</span><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':row.goals_evaluations_data[0].colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"row.goals_evaluations_data[0].colla_result_lists_item_id && row.goals_evaluations_data[0].colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{row.goals_evaluations_data[0].colla_num_result ? row.goals_evaluations_data[0].colla_num_result : row.goals_evaluations_data[0].colla_result_lists_item_id ? row.goals_evaluations_data[0].colla_result_lists_item.name : \'\' }}\n</span></div><span class=\"text-m md-primary-fg font-weight-600\" \nng-if=\"row.goals_evaluations_data[0].chief_num_result || row.goals_evaluations_data[0].chief_result_lists_item_id\">\nEvaluación jefe</span><div layout=\"row\" layout-align=\"start center\"><span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':row.goals_evaluations_data[0].chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"row.goals_evaluations_data[0].chief_result_lists_item_id && row.goals_evaluations_data[0].chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{row.goals_evaluations_data[0].chief_num_result ? row.goals_evaluations_data[0].chief_num_result : row.goals_evaluations_data[0].chief_result_lists_item_id ? row.goals_evaluations_data[0].chief_result_lists_item.name : \'\'}}\n</span></div></div><div layout=\"column\" layout-aling=\"center start\" class=\"mt-10\" \nng-if=\"row.goals_evaluations_data[0] && row.goals_evaluations_data[0].corporate_goals_evaluation_id \"><span \nclass=\"text-m md-primary-fg font-weight-600\">Evaluación del negocio</span><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':row.goals_evaluations_data[0].corporate_goals_evaluation.result_lists_item.additional_data.selected_color}\" \nng-if=\"row.goals_evaluations_data[0].corporate_goals_evaluation.result_lists_item_id && row.goals_evaluations_data[0].corporate_goals_evaluation.result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{row.goals_evaluations_data[0].corporate_goals_evaluation.numerical_result ? row.goals_evaluations_data[0].corporate_goals_evaluation.numerical_result : row.goals_evaluations_data[0].corporate_goals_evaluation.result_lists_item_id ? row.goals_evaluations_data[0].corporate_goals_evaluation.result_lists_item.name : \'--\'}}\n</span></div></div></td><td class=\"text-center text-m text-secondary w-10-p\">{{row.porcentaje | number: 0}}%</td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrGoalIndicator/default.html","<div id=\"hr-goal-indicator-follow-up-evaluation-default\" class=\"mb-20\"><div \nclass=\"table-header md-whiteframe-3dp white-500-bg\"><table class=\"tbl-lbl-data\"><thead><tr><th \nclass=\"background text-center\"><span class=\"titleTable\">Indicador</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Meta</span></th><th class=\"background text-center\"><span class=\"titleTable\">Resultado</span></th><th\n class=\"background text-center\"><span class=\"titleTable\">Cumplimiento</span></th></tr></thead><tbody><tr \nng-repeat=\"evaluation in data.employee_indicators\"><td class=\"w-40-p grey-100-bg\"><div layout=\"column\" \nlayout-align=\"center start\"><span class=\"text-m text-grey\">\n{{evaluation.objetivo ? evaluation.objetivo.name : evaluation.name}}</span></div></td><td class=\"w-20-p text-center\">\n<span class=\"text-m text-grey\">{{evaluation.objetivo ? evaluation.objetivo.meta : evaluation.meta}}</span></td><td \nclass=\"text-center\"><div ng-if=\"!evaluation.goals_indicators_data[0]\"><i class=\"text-grey text-s\">\nNo se han realizado evaluaciones</i></div><span class=\"text-m text-grey\" ng-if=\"evaluation.goals_indicators_data[0]\">\n{{evaluation.goals_indicators_data[0].chief_result_lists_item_id ? evaluation.goals_indicators_data[0].chief_result_lists_item.name : evaluation.goals_indicators_data[0].chief_num_result}}\n</span></td><td class=\"text-center\"><div ng-if=\"!evaluation.goals_indicators_data[0]\"><i class=\"text-grey text-s\">\nNo se han realizado evaluaciones</i></div><span class=\"text-m text-grey\" ng-if=\"evaluation.goals_indicators_data[0]\">\n{{evaluation.goals_indicators_data[0].chief_fulfillment}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrPersonalDevelopment/default.html","<div class=\"table-header background\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Acción de desarrollo</span></th><th class=\"background text-center w-20-p\"><span class=\"titleTable\">\nEvaluación actual</span></th><th class=\"background text-center w-10-p\"><span class=\"titleTable\">Ponderación</span></th>\n</tr></thead><tbody><tr ng-repeat=\"row in data.personal_development\"><td class=\"grey-100-bg\"><div layout=\"column\" \nlayout-align=\"center start\"><span class=\"text-m text-primary mb-5\">{{row.objetive}}</span><div layout=\"column\" \nlayout-align=\"center start\" class=\"mb-5\"><span class=\"text-m md-accent-fg font-weight-400\">Competencia </span><span \nclass=\"text-s text-secondary\">{{row.skill.name}}</span></div><div layout=\"column\" layout-align=\"center start\" \nclass=\"mb-5\"><span class=\"text-m md-accent-fg font-weight-400\">Como lo voy a lograr </span><span \nclass=\"text-s text-secondary\">{{row.how_to_achieve_it}}</span></div><div layout=\"column\" layout-align=\"center start\" \nclass=\"mb-5\" ng-repeat=\"additional in data.personal_dev_additional_data\" ng-if=\"row.additional_data[additional.value]\">\n<span class=\"text-m md-accent-fg font-weight-400\">{{additional.label}}</span> <span class=\"text-s text-secondary\">\n{{row.additional_data[additional.value]}}</span></div></div><div layout=\"column\" ng-if=\"row.evaluation_history[0]\"><div\n layout=\"row\" layout-align=\"center center\"><span class=\"text-s mt-15 font-weight-600\">COMENTARIOS DE LAS EVALUACIONES\n</span></div><div layout=\"column\" layout-align=\"center start\" class=\"mb-10\"><span \nclass=\"text-primary text-m font-weight-300\">Autoevaluación:</span> <span class=\"text-s text-secondary\">\n{{row.evaluation_history[0].colla_comment}}</span></div><div layout=\"column\" layout-align=\"center start\" class=\"mb-10\" \nng-if=\"row.evaluation_history[0].chief_comment\"><span class=\"text-primary text-m font-weight-300\">Comentarios del jefe:\n</span> <span class=\"text-s text-secondary\">{{row.evaluation_history[0].chief_comment}}</span></div></div></td><td \nclass=\"w-20-p\"><div ng-if=\"!row.evaluation_history[0]\"><i class=\"text-secondary text-m\">\nNo se han realizado evaluaciones</i></div><div layout=\"column\" layout-aling=\"center start\" \nng-if=\"row.evaluation_history[0]\"><span class=\"text-m md-primary-fg font-weight-600\">Autoevaluación</span><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':row.evaluation_history[0].colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"row.evaluation_history[0].colla_result_lists_item_id && row.evaluation_history[0].colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{row.evaluation_history[0].colla_num_result ? row.evaluation_history[0].colla_num_result : row.evaluation_history[0].colla_result_lists_item_id ? row.evaluation_history[0].colla_result_lists_item.name : \'--\' }}\n</span></div></div><div layout=\"column\" layout-aling=\"center start\" class=\"mt-10\" \nng-if=\"row.evaluation_history[0] && (row.evaluation_history[0].chief_result_lists_item_id || row.evaluation_history[0].chief_num_result)\">\n<span class=\"text-m md-primary-fg font-weight-600\">Evaluación jefe</span><div layout=\"row\" layout-align=\"start center\">\n<span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':row.evaluation_history[0].chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"row.evaluation_history[0].chief_result_lists_item_id && row.evaluation_history[0].chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{row.evaluation_history[0].chief_num_result ? row.evaluation_history[0].chief_num_result : row.evaluation_history[0].chief_result_lists_item_id ? row.evaluation_history[0].chief_result_lists_item.name : \'--\' }}\n</span></div></div></td><td class=\"text-center text-m text-secondary w-10-p\">{{row.weight | number: 0}}%</td></tr>\n</tbody></table></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrPoll/default.html","<div class=\"table-header background\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Pregunta</span></th><th class=\"background text-center w-10-p\"><span class=\"titleTable\">Respuesta\n</span></th><th class=\"background text-center w-20-p\"><span class=\"titleTable\">Comentario</span></th></tr></thead>\n<tbody><tr ng-repeat=\"row in data.movilidad\"><td class=\"grey-100-bg w-30-p\"><div layout=\"column\" \nlayout-align=\"center start\"><span class=\"text-m text-primary mb-10\">{{row.name}}</span></div></td><td \nclass=\"w-40-p text-justify\"><div ng-if=\"row.result_list_item\"><span class=\"text-m text-secondary\">\n{{row.result_list_item.name}}</span></div><div ng-if=\"!row.result_list_item\"><span class=\"text-m text-secondary\">\n{{row.result_text}}</span></div></td><td class=\"text-justify w-20-p text-m text-secondary w-30-p\">\n{{row.comment ? row.comment : \'N/A\'}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/elements/ik-hr-goal-result-list/currentEvaluation/HrSkill/default.html","<div class=\"mb-15\"><div class=\"mb-15\"><div layout=\"column\" class=\"mtoc md-whiteframe-3dp\"><div class=\"mb-15 p-20\" \nng-if=\"data.skillStructure.results_by_role.body\"><div layout=\"row\" class=\"table-header background\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Competencia</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Jefe</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Autoevaluación</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.skillStructure.results_by_role.body\"><td class=\"grey-100-bg\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-m text-primary mb-10\">{{row.name}}</span></div></td><td \nclass=\"text-m text-secondary text-center\">{{row.data.chief}}</td><td class=\"text-m text-secondary text-center\">\n{{row.data.self}}</td></tr></tbody></table></div></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"p-20 white-500-bg\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"(key,title) in data.skillStructure.titleObj track by $index\" class=\"mr-5\"><span \nclass=\"badge-circle mr-5 text-uppercase\" ng-style=\"{\'background-color\':title.selected_value}\">\n{{title.label | onlyCapitalize}}</span> <span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div \nng-repeat=\"approval in data.skillStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"detail-skill md-primary-fg\">{{approval.skillDetail.skill.name}}</span></div><div\n class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = approval.skillDescriptors;title = data.skillStructure.titleObj;info = approval.dataBody;config = {onlyview:true,colors:data.skillStructure.titleObjColor}\">\n</div></div></div><div layout=\"column\" class=\"p-20 white-500-bg\" \nng-if=\"data.skills_approver_comments && data.skills_approver_comments.length\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-weight-400 mb-5 m-20 bb pb-10\"><span \nclass=\"md-primary-fg text-xl font-weight-600\">Comentarios generales</span></div><div layout=\"column\" \nng-repeat=\"approve_comment in data.skills_approver_comments\"><div layout=\"column\" class=\"p-20\"><ik-employee-info \ndata=\"approve_comment\" comment=\"approve_comment.approver_comment\" class=\"personalize\" key=\"approver\">\n</ik-employee-info></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/employee/profile/dialog/picture-dialog.html","<md-dialog class=\"picture-dialog\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title pt-8\">Imagen de perfil</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"column\" layout-align=\"center\"><input type=\"file\" id=\"uploadInput\" \non-file-change=\"handleFileSelect\" class=\"ng-hide\"><md-button id=\"uploadButton\" class=\"md-raised md-primary\" \nng-click=\"vm.selectProfilePicture()\">Seleccionar imagen de perfil</md-button></div><div class=\"original-image\">\n<img-crop image=\"vm.userInfo.ModuleUser.avatar\" area-type=\"circle\" result-image=\"vm.myCroppedImage\"></img-crop></div>\n<div class=\"ng-hide\"><img ng-src=\"{{vm.myCroppedImage}}\"></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.savePicture()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate-attr-aria-label=\"TODO.SAVE\">ACEPTAR</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/misc/dialog/documents/documents-dialog.html","<md-dialog id=\"documents-dialog\" aria-label=\"Enroll Employee\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Biblioteca </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.documents.length\" \nclass=\"message-empty\"><span class=\"text-m\">No hay documentos actualmente.</span></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"bb mb-15\" ng-if=\"vm.documents.length\"><div layout=\"row\" layout-align=\"start start\">\n<label for=\"search\" class=\"pt-10\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container \nmd-no-float class=\"m-0 w-200\"><input id=\"search\" placeholder=\"Buscar\" type=\"text\" ng-model=\"vm.searchDocument\">\n</md-input-container></div></div><div layout=\"column\" ng-repeat=\"document in vm.documents\" class=\"mb-15\"><div \nlayout=\"row\" class=\"mb-15\" ng-if=\"document.document.length\"><span class=\"text-category-size md-accent-fg text-bold\">\n{{document.category_name}}</span></div><div layout=\"column\" \nclass=\"p-10 md-whiteframe-2dp white-bg mb-15 border-radius\" \nng-repeat=\"doc in document.document | filter:vm.searchDocument\" layout-wrap><div layout=\"row\" \nlayout-align=\"space-between\" class=\"bb mb-10 p-5\"><span class=\"text-l text-primary text-bold\">{{doc.document_name}}\n</span> <a ng-click=\"vm.donwloadDocument(doc)\" class=\"cursor-pointer\"><md-icon \nmd-font-icon=\"icon-download s18 mr-5 md-accent\"></md-icon><span class=\"text-m\">Descargar</span></a></div><span \nclass=\"text-m text-secondary p-5\">{{doc.description}}</span></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/modules/users/dialogs/change-password/change-password.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase\">{{vm.title}}</div>\n</div></div></md-toolbar><md-dialog-content class=\"p-10 w-500\" layout-padding><div class=\"p-10\"><md-input-container \nclass=\"md-block\" md-no-float><label>Nueva contraseña</label><input type=\"{{vm.password_type}}\" name=\"password\" \nminlength=\"6\" maxlength=\"40\" ng-model=\"vm.form.password\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><md-icon \nng-click=\"vm.showPassword(\'password_type\')\" class=\"icon {{vm.password_icon}} h2 cursor-pointer\" \nstyle=\"display:inline-block\"></md-icon><div ng-messages=\"form.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Campo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password\']\" class=\"h6 pt-5 pb-5 red-500-fg\">{{vm.errors[\'password\']}}</div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Confirmar nueva contraseña</label><input \ntype=\"{{vm.password_confirm_type}}\" name=\"password_confirm\" minlength=\"6\" maxlength=\"40\" \nng-model=\"vm.form.password_confirm\" ng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" \nrequired><md-icon ng-click=\"vm.showPassword(\'password_confirm_type\')\" \nclass=\"icon {{vm.password_confirm_icon}} h2 cursor-pointer\" style=\"display:inline-block\"></md-icon><div \nng-messages=\"form.password_confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido</span></div>\n<div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password_confirm\']\" class=\"h6 pt-5 pb-5 red-500-fg\">\n{{vm.errors[\'password_confirm\']}}</div></md-input-container></div></md-dialog-content><md-dialog-actions \nclass=\"bt h-80\" layout=\"column\"><div ng-if=\"vm.message\" class=\"p-5 red-500-fg h5\">{{vm.message | capitalize}}</div><div\n class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nng-click=\"vm.closeDialog()\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"text-center\"><md-button ng-click=\"vm.changePassword()\" aria-label=\"Guardar\" \ntype=\"submit\" ng-disabled=\"form.$invalid || form.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/page/admin/dialogs/page/page-dialog.html","<md-dialog class=\"new-page-dialog\" aria-label=\"New Page\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title pt-8\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{vm.page.Page.menu_name}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block\"><label>Título</label><input ng-model=\"vm.page.Page.menu_name\" type=\"text\" \nng-required></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Layout</label><md-select \nng-model=\"vm.page.Page.template\"><md-option ng-repeat=\"template in vm.templates\" value=\"{{template.template}}\">\n{{template.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<label>Ubicación</label><md-select ng-model=\"vm.page_order\"><md-option value=\"-1\">\n---------------------------------------------</md-option><md-option value=\"0\">Al inicio</md-option><md-option \nng-repeat=\"page in vm.page_menu\" value=\"{{page.Page.id}}\">{{page.Page.menu_name}}</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newPage\" ng-click=\"vm.savePage()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">\nACEPTAR</md-button><md-button type=\"submit\" ng-if=\"vm.newPage\" ng-click=\"vm.addNewPage()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">ACEPTAR</md-button></div><div layout=\"row\"><md-button class=\"md-icon-button md-warn\" \nng-if=\"!vm.newPage\" ng-click=\"vm.deletePageConfirm($event)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span>DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/custom_modules/evaluation/evaluation-details/dialogs/evaluation-log-detail/evaluation-log-detail-dialog.html","<md-dialog class=\"log-detail-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\"><span class=\"title pt-8\">\nDetalles</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><b>Usuario:</b> {{vm.logData.user.empleado.name}}</div><div><b>Fecha:\n</b> {{vm.logData.created}}</div><pre>{{vm.logContent}}</pre></md-dialog-content></md-dialog>");
$templateCache.put("app/main/custom_modules/organization/employees/dialogs/employee/employee-dialog.html","<md-dialog class=\"log-detail-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between\"><span class=\"title pt-8\">\nDetalles</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-dialog-content ms-scroll><md-input-container\n class=\"md-block\"><label>Documento</label><input name=\"meta\" ng-model=\"vm.employee.cedula\" required>\n</md-input-container><md-input-container class=\"md-block\"><label>Nombre</label><input name=\"meta\" \nng-model=\"vm.employee.name\" required></md-input-container><md-input-container class=\"md-block\"><label>Email</label>\n<input name=\"meta\" ng-model=\"vm.employee.correo\"></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid\" \nng-if=\"!vm.sendingData\">GUARDAR</md-button><md-progress-circular ng-disabled=\"!vm.sendingData\" ng-if=\"vm.sendingData\" \nclass=\"md-accent\" md-diameter=\"25px\"></md-progress-circular></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/assistant-evaluation/default/default.html","<div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">\nPor favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div></div><div \nng-if=\"!data.error\"><div layout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg assistantSingle\"><div \nclass=\"column\" ng-repeat=\"section in data.assistants.sections track by $index\" class=\"mb-15\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-weight-400 mb-5 p-20\"><span class=\"md-primary-fg text-xl font-weight-600\">\n{{$index + 1}}. {{section.name}}</span></div><div class=\"backgroundValue p-20\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/template/single.html\'\"></div></div></div>\n<div layout=\"column\" layout-align=\"end\" class=\"mb-15\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-weight-400 mb-5 p-20\"><span class=\"md-primary-fg text-xl font-weight-600\">Acciones de desarrollo</span>\n</div><div class=\"backgroundValue p-20\"><div ng-repeat=\"section in data.countComments track by $index\" layout=\"column\">\n<div layout=\"row\" layout-align=\"end end\" ng-if=\"section.id && !$first\"><span \nclass=\"text-s md-accent-fg cursor-pointer\" ng-if=\"!section.delete\" ng-click=\"section.delete = true;\">Eliminar</span> \n<span class=\"text-s md-accent-fg cursor-pointer\" ng-if=\"section.delete\" ng-click=\"section.delete = false;\">Cancelar\n</span></div><div class=\"md-inline-form w-100-p\" layout=\"row\" layout-align=\"space-between end\" layout-wrap \nng-if=\"!section.delete\"><div layout=\"column\" flex=\"50\" class=\"p-10\"><div layout=\"row\" layout-align=\"start center\"><span\n class=\"md-accent-fg mr-5 text-m font-weight-600\">Objetivo <span ng-if=\"$first\">*</span></span></div><textarea \nclass=\"comments-input\" ng-model=\"section.goal\" maxlength=\"500\" rows=\"5\" ng-required=\"$first\"></textarea><div \nlayout=\"row\" layout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{section.goal.length ? section.goal.length : 0}}</span> <span class=\"text-xs text-secondary\">/500</span></div></div>\n<div layout=\"row\" layout-algin=\"start end\" flex=\"50\" class=\"p-10\"><md-input-container class=\"w-100-p\"><label>\nResponsable</label><md-select ng-model=\"section.responsibility\" ng-required=\"$first\"><md-option \nng-repeat=\"personal in data.personal_development_responsable_list\" ng-value=\"personal.id\">{{personal.value}}\n</md-option></md-select></md-input-container></div></div><div class=\"md-inline-form w-100-p\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap ng-if=\"section.delete\"><div layout=\"column\" flex=\"50\" class=\"p-10\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Objetivo</span></div>\n<div class=\"text-s text-secondary comment-read\" ng-bind-html=\"section.goal\"></div></div><div layout=\"row\" \nlayout-algin=\"start end\" flex=\"50\" class=\"p-10\"><md-input-container class=\"w-100-p\"><label>Responsable</label>\n<md-select ng-model=\"section.responsibility\" disabled=\"disabled\"><md-option \nng-repeat=\"personal in data.personal_development_responsable_list\" ng-value=\"personal.id\">{{personal.value}}\n</md-option></md-select></md-input-container></div></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-core-value/value-evaluation/default/default.html","<div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">\nPor favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div></div><div \nng-if=\"!data.error\"><div class=\"mb-15\"><div layout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg\"><div \nclass=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><td class=\"background titleTable text-center\">Competencia\n</td><td class=\"background titleTable text-center\">Estado</td><td class=\"background titleTable text-center\" \nng-if=\"data.isBoss\">Evaluaciones 360</td><td class=\"background titleTable text-center\" ng-if=\"data.isBoss\">\nAutoevaluación</td><td class=\"background titleTable text-center\">Resultado</td><td class=\"background\"></td></tr>\n</thead><tbody><tr ng-repeat=\"skill in data.core_values\" ng-if=\"skill.show\"><td class=\"text-grey text-m\">{{skill.name}}\n</td><td class=\"text-center text-m\"><span class=\"badge-status\" ng-class=\"skill.estado ? \'complete\' : \'incomplete\'\">\n{{skill.estado ? \'Evaluado\' : \'Sin evaluar\'}}</span></td><td class=\"text-center\" ng-if=\"data.isBoss\"><a \nng-click=\"vm.callFunc(\'HrCoreValue\', \'open_valueEvaluationChief\', [$event, skill, data])\" class=\"cursor-pointer\">Ver\n</a></td><td class=\"text-center text-m text-secondary\" ng-if=\"data.isBoss\">{{skill.autoResult | number:0}}</td><td \nclass=\"text-center text-m text-secondary\">{{skill.result | number:0}}</td><td class=\"text-center text-m\"><a \nng-click=\"vm.callFunc(\'HrCoreValue\', \'open_valueEvaluationSingle\', [$event, skill, data])\" class=\"mr-5 cursor-pointer\">\nEvaluar</a></td></tr></tbody></table></div></div><div ng-if=\"data.comments.length > 0 && data.isBoss\" class=\"mt-15\">\n<div ng-repeat=\"comments in data.comments\" class=\"container-comments\"><div layout=\"row\" layout-align=\"start start\"><div\n class=\"avatar-wrapper\"><img ng-src=\"{{comments.empleado.foto}}\" class=\"avatar square big\"></div><div layout=\"column\" \nclass=\"w-100-p\"><div class=\"nombre\">{{comments.empleado.name}}</div><div class=\"date grey-400-fg\">\n{{comments.created_at| formatMoment : \'MMM DD, YYYY\'}}</div><md-divider class=\"mt-10 mb-10\"></md-divider><span \nclass=\"comment grey-500-fg\">{{comments.comment}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-core-value/value-evaluation-approval/default/default.html","<div class=\"mb-15 default-skill-evaluation-approval\"><div class=\"mb-15\"><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp\"><div layout=\"row\" layout-align=\"end center\" class=\"p-20 white-500-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"(key,title) in data.approvalStructure.titleObj track by $index\" \nclass=\"mr-5\"><span class=\"badge-circle mr-5\" ng-style=\"{\'background-color\':title.selected_value}\">\n{{title.label | onlyCapitalize}}</span> <span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div \nng-repeat=\"approval in data.approvalStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"detail-skill md-primary-fg\">{{approval.skillDetail.core_value.name}}</span>\n</div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = approval.skillDescriptors;title = data.approvalStructure.titleObj;info = approval.dataBody;config = {onlyview:true,colors:data.approvalStructure.titleColor}\">\n</div></div></div><md-divider></md-divider><ik-skill-approval-comments ng-model=\"data\" allow-comment=\"true\">\n</ik-skill-approval-comments></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-final-comment/add-comment/default/default.html","<div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">\nPor favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div></div><div \nng-if=\"!data.error\"><div layout=\"row\" layout-align=\"center center\" class=\"md-whiteframe-10dp mb-15\" \nng-if=\"data.config.showCommentHistory\"><div class=\"table-header white-500-bg full-width\"><table class=\"tbl-lbl-data\">\n<thead><tr><td class=\"background titleTable text-center w-30-p\">Empleado</td><td \nclass=\"background titleTable text-center\" ng-repeat=\"title in data.titleComments | orderBy: \'order\' track by $index\">\n{{title.title}}</td></tr></thead><tbody><tr ng-repeat=\"comment in data.other_comments \"><td class=\"w-30-p grey-100-bg\">\n<span class=\"text-m text-primary\">{{comment.empleado.name}}</span></td><td \nng-repeat=\"title in data.titleComments | orderBy: \'order\' track by $index\"><span class=\"text-m text-primary\">\n{{comment[title.key]}}</span></td></tr></tbody></table></div></div><div layout=\"column\" class=\"mtoc add-comment\" \nng-repeat=\"comment in data.comments | orderBy: \'order\' track by $index\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"font-weight-400 mb-5\"><span class=\"md-accent-fg text-m font-weight-600\">{{comment.label}}</span> <span \nclass=\"md-accent-fg text-m font-weight-600\" ng-if=\"comment.required\">*</span></div><div class=\"comments-container\" \nlayout=\"column\"><textarea class=\"comments-input\" ng-model=\"data.formData[comment.key]\" ng-required=\"comment.required\" \nmaxlength=\"500\" rows=\"5\">\n                                        </textarea><div layout=\"row\" \nlayout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{data.formData[comment.key].length ? data.formData[comment.key].length : 0}}</span> <span \nclass=\"text-xs text-secondary\">/500</span></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-approval/default/default.html","<div id=\"goal-approval-default\" class=\"p-20\"><div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div \nclass=\"mb-10\">Por favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div>\n</div><div ng-if=\"!data.error\"><div ng-repeat=\"goal in data.goals_data\" class=\"mb-20\"><div layout=\"column\" \nclass=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"column\" class=\"pv-10 ph-15\"><span \nclass=\"field-pending-evaluate mb-10\" ng-if=\"objetivo.ObjetivosEmpleado.aprobado == \'0\'\">\nSe han solicitado ajustes para este objetivo en esta revisión</span> <span class=\"field-pending-evaluate mb-10\" \nng-if=\"objetivo.ObjetivosEmpleado.aprobado_historico == \'0\' && objetivo.ObjetivosEmpleado.aprobado == \'1\'\">\nEn la última revisión se solicitaron ajustes sobre este objetivo</span><h2 class=\"m-15 md-accent-fg text-l\">\n{{goal.additional_info.cont_label}}. {{goal.goals_type.singular_label}}</h2><div layout=\"row\" class=\"ph-15\"><div flex>\n<p class=\"text-m text-primary\" ng-bind-html=\"goal.objetivo_id ? goal.objetivo.name : goal.name\"></p></div></div>\n<md-divider></md-divider><div><div layout=\"row\" layout-xs=\"column\" class=\"goal-info-section\" \nng-if=\"goal.strategic_goal\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"start start\" class=\"p-15\"><div>\n<span class=\"text-primary text-m font-weight-600\">Objetivo Estratégico: </span><span class=\"text-s text-secondary\">\n{{goal.strategic_goal.label}}</span></div></div></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-xs=\"column\" class=\"goal-info-section\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"start start\" \nclass=\"p-15\"><div ng-repeat=\"extra_data in data.goals_additional_data\"><div><label \nclass=\"text-primary text-m font-weight-600\">{{extra_data.label}}:</label><span class=\"text-secondary text-s\">\n{{goal.additional_data[extra_data.value]}}</span></div></div></div><md-divider></md-divider><div layout=\"column\" \nclass=\"p-15\" flex=\"25\" flex-xs=\"100\"><label class=\"text-primary text-m font-weight-600\">Meta</label><div \nclass=\"text-secondary text-s\">{{goal.objetivo_id ? goal.objetivo.meta : goal.meta}}</div></div><md-divider>\n</md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" layout-align=\"start start\"><label \nclass=\"text-primary text-m font-weight-600\">Ponderación</label><div class=\"text-secondary text-s\">\n{{goal.porcentaje ? goal.porcentaje+\"%\" : \"\"}}</div></div></div></div><md-divider></md-divider>\n<ik-goal-approval-comments ng-model=\"goal\" allow-comment=\"true\"></ik-goal-approval-comments></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-evaluation/default/default.html","<div id=\"hr-goal-goal-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div ng-repeat=\"goal in data.goals_data\" \nclass=\"mb-20\"><div layout=\"column\" class=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"row\" \nlayout-align=\"end end\" class=\"ph-15 pt-10 pb-5\"><div class=\"field-pending-evaluate\" \nng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id ? data.boss ? !goal.goal_evaluation_data.chief_comment : !goal.goal_evaluation_data.colla_comment : false\">\n*Pendiente por evaluar</div></div><div layout=\"column\" class=\"pv-10 ph-15\"><span class=\"msg_min_warning mb-10\" \nng-if=\"objetivo.ObjetivosEmpleado.aprobado == \'0\'\">Se han solicitado ajustes para este objetivo en esta revisión</span>\n <span class=\"msg_min_info mb-10\" \nng-if=\"objetivo.ObjetivosEmpleado.aprobado_historico == \'0\' && objetivo.ObjetivosEmpleado.aprobado == \'1\'\">\nEn la última revisión se solicitaron ajustes sobre este objetivo</span> <span class=\"md-accent-fg text-l\">\n{{goal.additional_info.cont_label}}. {{goal.goals_type.singular_label}}</span><div layout=\"row\"><div flex><p \nclass=\"text-m text-primary\" ng-bind-html=\"goal.name\"></p></div></div></div><md-divider></md-divider><div><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section\" ng-if=\"goal.strategic_goal\"><div layout=\"column\" flex=\"50\" \nflex-xs=\"100\" layout-align=\"start start\" class=\"p-15\"><div><span class=\"text-primary text-m font-weight-600\">\nObjetivo Estratégico: </span><span class=\"text-s text-secondary\">{{goal.strategic_goal.label}}</span></div></div></div>\n</div><md-divider></md-divider><div><div layout=\"row\" layout-xs=\"column\" class=\"goal-info-section\"><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"start start\" class=\"p-15\"><div \nng-repeat=\"extra_data in data.goals_additional_data\"><div><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-secondary text-s\">{{goal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\"><label \nclass=\"text-primary text-m font-weight-600\">Meta</label><div class=\"text-secondary text-s\">{{goal.meta}}</div></div>\n<md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" layout-align=\"start start\"><label \nclass=\"text-primary text-m font-weight-600\">Ponderación</label><div class=\"text-secondary text-s\">\n{{goal.porcentaje ? goal.porcentaje+\"%\" : \"\"}}</div></div></div></div><md-divider></md-divider><div layout=\"row\" \nclass=\"grey-100-bg\" ng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div flex=\"50\" class=\"p-15\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">Autoevaluación:</span> \n<span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.goal_evaluation_data.colla_result_lists_item_id && goal.goal_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.colla_num_result ? goal.goal_evaluation_data.colla_num_result : goal.goal_evaluation_data.colla_result_lists_item_id ? goal.goal_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</p></div><md-divider>\n</md-divider><div flex=\"50\" class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\" ng-if=\"goal.goal_evaluation_data.chief_num_result \">\nEvaluación del jefe:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.goal_evaluation_data.chief_result_lists_item_id && goal.goal_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.chief_num_result ? goal.goal_evaluation_data.chief_num_result : goal.goal_evaluation_data.chief_result_lists_item_id ? goal.goal_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</p></div></div><div \nlayout=\"column\" ng-if=\"goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div layout=\"row\"><div flex=\"50\" \nclass=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">\nComentario autoevaluación:</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</p>\n</div><md-divider></md-divider><div flex=\"50\" class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\" ng-if=\"goal.goal_evaluation_data.chief_comment \">Comentario del jefe:\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</p></div></div><div \nlayout=\"row\" class=\"grey-100-bg\"><div class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\">Evaluación del negocio:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.corporate_goals_evaluation.result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.corporate_goals_evaluation.result_lists_item_id && goal.corporate_goals_evaluation.result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.corporate_goals_evaluation.numerical_result ? goal.corporate_goals_evaluation.numerical_result : goal.corporate_goals_evaluation.result_lists_item_id ? goal.corporate_goals_evaluation.result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{goal.corporate_goals_evaluation.comment}}</p></div></div></div>\n<md-divider></md-divider><ik-goal-comments-modal ng-if=\"goal.goals_type.type_name != \'fixed\'\" ng-model=\"goal\" \nallow-comment=\"data.config.sendComment\" config=\"data.config\" \nfn-save=\"vm.callFunc(\'HrGoal\', \'sendComments\', [$event, goal, data, \'colab\'])\"></ik-goal-comments-modal><md-divider>\n</md-divider><div class=\"text-center p-10 card-actions\"><a href=\"#\" \nng-click=\"vm.callFunc(\'HrGoal\', \'openEvaluationCommentDialog\', [$event, goal, data, \'colab\'])\" \nng-if=\"goal.goals_type.type_name == \'fixed\'\">Comentario opcional</a> <a href=\"#\" \nng-click=\"vm.callFunc(\'HrGoal\', \'openEvaluationGoalDialog\', [$event, goal, data, \'colab\'])\" \nng-if=\"goal.goals_type.type_name != \'fixed\'\">Evaluar objetivo</a></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-evaluation-approval/default/default.html","<div id=\"hr-goal-goal-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div ng-repeat=\"goal in data.goals_data\" \nclass=\"mb-20\"><div layout=\"column\" class=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"row\" \nlayout-align=\"end end\" class=\"ph-15 pt-10 pb-5\"><div class=\"field-pending-evaluate\" \nng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id ? data.boss ? !goal.goal_evaluation_data.chief_comment : !goal.goal_evaluation_data.colla_comment : false\">\n*Pendiente por evaluar</div></div><div layout=\"column\" class=\"pv-10 ph-15\"><span class=\"msg_min_warning mb-10\" \nng-if=\"objetivo.ObjetivosEmpleado.aprobado == \'0\'\">Se han solicitado ajustes para este objetivo en esta revisión</span>\n <span class=\"msg_min_info mb-10\" \nng-if=\"objetivo.ObjetivosEmpleado.aprobado_historico == \'0\' && objetivo.ObjetivosEmpleado.aprobado == \'1\'\">\nEn la última revisión se solicitaron ajustes sobre este objetivo</span> <span class=\"md-accent-fg text-l\">\n{{goal.additional_info.cont_label}}. {{goal.goals_type.singular_label}}</span><div layout=\"row\"><div flex><p \nclass=\"text-m text-primary\" ng-bind-html=\"goal.name\"></p></div></div></div><md-divider></md-divider><div><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section\" ng-if=\"goal.strategic_goal\"><div layout=\"column\" flex=\"50\" \nflex-xs=\"100\" layout-align=\"start start\" class=\"p-15\"><div><span class=\"text-primary text-m font-weight-600\">\nObjetivo Estratégico: </span><span class=\"text-s text-secondary\">{{goal.strategic_goal.label}}</span></div></div></div>\n</div><md-divider></md-divider><div><div layout=\"row\" layout-xs=\"column\" class=\"goal-info-section\"><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"start start\" class=\"p-15\"><div \nng-repeat=\"extra_data in data.goals_additional_data\"><div><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-secondary text-s\">{{goal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\"><label \nclass=\"text-primary text-m font-weight-600\">Meta</label><div class=\"text-secondary text-s\">{{goal.meta}}</div></div>\n<md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" layout-align=\"start start\"><label \nclass=\"text-primary text-m font-weight-600\">Ponderación</label><div class=\"text-secondary text-s\">\n{{goal.porcentaje ? goal.porcentaje+\"%\" : \"\"}}</div></div></div></div><md-divider></md-divider><div layout=\"row\" \nclass=\"grey-100-bg\" ng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div flex=\"50\" class=\"p-15\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">Autoevaluación:</span> \n<span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.goal_evaluation_data.colla_result_lists_item_id && goal.goal_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.colla_num_result ? goal.goal_evaluation_data.colla_num_result : goal.goal_evaluation_data.colla_result_lists_item_id ? goal.goal_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</p></div><md-divider>\n</md-divider><div flex=\"50\" class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\" \nng-if=\"goal.goal_evaluation_data.chief_num_result || goal.goal_evaluation_data.chief_result_lists_item_id\">\nEvaluación del jefe:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.goal_evaluation_data.chief_result_lists_item_id && goal.goal_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.chief_num_result ? goal.goal_evaluation_data.chief_num_result : goal.goal_evaluation_data.chief_result_lists_item_id ? goal.goal_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</p></div></div><div \nlayout=\"column\" ng-if=\"goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div layout=\"row\"><div flex=\"50\" \nclass=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">\nComentario autoevaluación:</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</p>\n</div><md-divider></md-divider><div flex=\"50\" class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\" ng-if=\"goal.goal_evaluation_data.chief_comment \">Comentario del jefe:\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</p></div></div><div \nlayout=\"row\" class=\"grey-100-bg\"><div class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\">Evaluación del negocio:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.corporate_goals_evaluation.result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.corporate_goals_evaluation.result_lists_item_id && goal.corporate_goals_evaluation.result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.corporate_goals_evaluation.numerical_result ? goal.corporate_goals_evaluation.numerical_result : goal.corporate_goals_evaluation.result_lists_item_id ? goal.corporate_goals_evaluation.result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{goal.corporate_goals_evaluation.comment}}</p></div></div></div>\n<md-divider></md-divider><ik-goal-comments-modal ng-if=\"goal.goals_type.type_name != \'fixed\'\" ng-model=\"goal\" \nallow-comment=\"data.config.sendComment\" config=\"data.config\" \nfn-save=\"vm.callFunc(\'HrGoal\', \'sendComments\', [$event, goal, data, \'colab\'])\"></ik-goal-comments-modal><md-divider>\n</md-divider></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-follow-up-evaluation/default/default.html","<div id=\"hr-goal-goal-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div ng-repeat=\"goal in data.goals_data\" \nclass=\"mb-20\"><div layout=\"column\" class=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"row\" \nlayout-align=\"end end\" class=\"ph-15 pt-10 pb-5\"><div class=\"field-pending-evaluate\" \nng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id ? data.boss ? !goal.goal_evaluation_data.chief_comment : !goal.goal_evaluation_data.colla_comment : false\">\n*Pendiente por evaluar</div></div><div layout=\"column\" class=\"pv-10 ph-15\"><span class=\"msg_min_warning mb-10\" \nng-if=\"objetivo.ObjetivosEmpleado.aprobado == \'0\'\">Se han solicitado ajustes para este objetivo en esta revisión</span>\n <span class=\"msg_min_info mb-10\" \nng-if=\"objetivo.ObjetivosEmpleado.aprobado_historico == \'0\' && objetivo.ObjetivosEmpleado.aprobado == \'1\'\">\nEn la última revisión se solicitaron ajustes sobre este objetivo</span> <span class=\"md-accent-fg text-l\">\n{{goal.additional_info.cont_label}}. {{goal.goals_type.singular_label}}</span><div layout=\"row\"><div flex><p \nclass=\"text-m text-primary\" ng-bind-html=\"goal.name\"></p></div></div></div><md-divider></md-divider><div><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section\" ng-if=\"goal.strategic_goal\"><div layout=\"column\" flex=\"50\" \nflex-xs=\"100\" layout-align=\"start start\" class=\"p-15\"><div><span class=\"text-primary text-m font-weight-600\">\nObjetivo Estratégico: </span><span class=\"text-s text-secondary\">{{goal.strategic_goal.label}}</span></div></div></div>\n</div><md-divider></md-divider><div><div layout=\"row\" layout-xs=\"column\" class=\"goal-info-section\"><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"start start\" class=\"p-15\"><div \nng-repeat=\"extra_data in data.goals_additional_data\"><div><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-secondary text-s\">{{goal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\"><label \nclass=\"text-primary text-m font-weight-600\">Meta</label><div class=\"text-secondary text-s\">{{goal.meta}}</div></div>\n<md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" layout-align=\"start start\"><label \nclass=\"text-primary text-m font-weight-600\">Ponderación</label><div class=\"text-secondary text-s\">\n{{goal.porcentaje ? goal.porcentaje+\"%\" : \"\"}}</div></div></div></div><md-divider></md-divider><div layout=\"row\" \nclass=\"grey-100-bg\" ng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div flex=\"50\" class=\"p-15\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">Autoevaluación:</span> \n<span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.goal_evaluation_data.colla_result_lists_item_id && goal.goal_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.colla_num_result ? goal.goal_evaluation_data.colla_num_result : goal.goal_evaluation_data.colla_result_lists_item_id ? goal.goal_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</p></div><md-divider>\n</md-divider><div flex=\"50\" class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\" ng-if=\"goal.goal_evaluation_data.chief_num_result\">\nEvaluación del jefe:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.goal_evaluation_data.chief_result_lists_item_id && goal.goal_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.chief_num_result ? goal.goal_evaluation_data.chief_num_result : goal.goal_evaluation_data.chief_result_lists_item_id ? goal.goal_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</p></div></div><div \nlayout=\"column\" ng-if=\"goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div layout=\"row\"><div flex=\"50\" \nclass=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">\nComentario opcional:</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</p></div>\n<md-divider></md-divider><div flex=\"50\" class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\" ng-if=\"goal.goal_evaluation_data.chief_comment \">Comentario del jefe:\n</span></div><p class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</p></div></div><div \nlayot=\"row\" class=\"grey-100-bg\"><div class=\"p-15\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg text-m font-weight-600 mr-5\">Evaluación del negocio:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.corporate_goals_evaluation.result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.corporate_goals_evaluation.result_lists_item_id && goal.corporate_goals_evaluation.result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.corporate_goals_evaluation.numerical_result ? goal.corporate_goals_evaluation.numerical_result : goal.corporate_goals_evaluation.result_lists_item_id ? goal.corporate_goals_evaluation.result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{goal.corporate_goals_evaluation.comment}}</p></div></div></div>\n<md-divider></md-divider><ik-goal-comments-modal ng-if=\"goal.goals_type.type_name != \'fixed\'\" ng-model=\"goal\" \nallow-comment=\"data.config.sendComment\" config=\"data.config\" \nfn-save=\"vm.callFunc(\'HrGoal\', \'sendComments\', [$event, goal, data, \'colab\'])\"></ik-goal-comments-modal><md-divider>\n</md-divider><div class=\"text-center p-10 card-actions\"><a href=\"#\" \nng-click=\"vm.callFunc(\'HrGoal\', \'openEvaluationCommentDialog\', [$event, goal, data, \'colab\'])\" \nng-if=\"goal.goals_type.type_name == \'fixed\'\">Comentario opcional</a> <a href=\"#\" \nng-click=\"vm.callFunc(\'HrGoal\', \'openEvaluationGoalDialog\', [$event, goal, data, \'colab\'])\" \nng-if=\"goal.goals_type.type_name != \'fixed\'\">Evaluar objetivo</a></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-inscription/default/default.html","<div id=\"goal-inscription-default\" class=\"p-20\"><div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div \nclass=\"mb-10\">Por favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div>\n</div><div ng-if=\"!data.error\" class=\"mb-20\"><div class=\"msg_warning mb-10 text-m text-primary\" \nng-if=\"vm.tieneAjustesJefe[\'objetivos\']\">\nSe han solicitado ajustes a algunos de sus objetivos matriculados, por favor realice los cambios necesarios y envíelos de nuevo a su jefe para ser aprobados\n</div><div layout=\"column\" ng-repeat=\"goal in data.goals_data\" class=\"mb-20\"><div layout=\"column\" \nclass=\"goal-card md-whiteframe-3dp white-500-bg\"><div class=\"ph-15 pt-10 pb-5\" layout=\"row\" layout-align=\"end end\"><div\n layout=\"row\" class=\"mr-5\"><div class=\"field-pending-evaluate mr-5\" \nng-if=\"goal.additional_info.required && goal.additional_info.goal_type_info.type_name != \'fixed\' && !goal.id\">\n*Objetivo requerido</div><div class=\"field-pending-evaluate mr-5\" ng-if=\"goal.aprobado == \'0\'\">\n*Se solicitaron ajustes sobre este objetivo</div><div class=\"field-pending-evaluate\" \nng-if=\"!goal.name && !goal.objetivo_id && goal.additional_info.required\">*Pendiente por ingresar</div></div><div \nng-click=\"vm.callFunc(\'HrGoal\', \'openSelectGoalDialog\', [$event, goal, data])\" \nng-if=\"goal.additional_info.goal_type_info.type_name == \'list\'\" class=\"mr-5\"><div \nng-if=\"!goal.name && !goal.objetivo_id\" class=\"text-m text-undeline cursor-pointer md-primary-fg\">Seleccionar objetivo\n</div><div ng-if=\"goal.name || goal.objetivo_id\" class=\"text-m text-undeline cursor-pointer md-primary-fg\">\nModificar objetivo</div></div><div ng-click=\"vm.callFunc(\'HrGoal\', \'openInputGoalDialog\', [$event, goal, data])\" \nng-if=\"goal.additional_info.goal_type_info.type_name == \'input\'\" class=\"mr-5\"><div \nng-if=\"!goal.name && !goal.objetivo_id\" class=\"text-m text-undeline cursor-pointer md-primary-fg\">Ingresar objetivo\n</div><div ng-if=\"goal.name || goal.objetivo_id\" class=\"text-m text-undeline cursor-pointer md-primary-fg\">\nModificar objetivo</div></div><div ng-click=\"vm.callFunc(\'HrGoal\', \'deleteGoal\', [goal, data])\" \nng-if=\"goal.additional_info.goal_type_info.type_name != \'fixed\' && goal.id\" \nclass=\"mr-5 text-m text-undeline cursor-pointer md-warn-fg\">Eliminar objetivo</div></div><h2 \nclass=\"m-15 md-accent-fg text-l\">\n{{goal.additional_info.cont_label}}. {{goal.additional_info.goal_type_info.singular_label}}</h2><div layout=\"row\" \nclass=\"ph-15\"><div flex><p class=\"text-m text-primary\" \nng-bind-html=\"goal.objetivo_id ? goal.objetivo.name : goal.name\"></p></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\" class=\"p-15\"><div ng-repeat=\"extra_data in data.goals_additional_data\"><div><label \nclass=\"text-primary text-m font-weight-600\">{{extra_data.label}}:</label><span class=\"text-secondary text-s\">\n{{goal.additional_data[extra_data.value]}}</span></div></div></div><md-divider></md-divider><div layout=\"column\" \nclass=\"p-15\" flex=\"25\" flex-xs=\"100\"><label class=\"text-primary text-m font-weight-600\">Meta</label><div \nclass=\"text-secondary text-s\">{{goal.objetivo_id ? goal.objetivo.meta : goal.meta}}</div></div><md-divider>\n</md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" layout-align=\"start start\"><label \nclass=\"text-primary text-m font-weight-600\">Ponderación</label><div class=\"text-secondary text-s\">\n{{goal.porcentaje ? goal.porcentaje+\"%\" : \"\"}}</div></div></div><md-divider></md-divider><ik-goal-approval-comments \nng-model=\"goal\" allow-comment=\"false\"></ik-goal-approval-comments><div layout=\"column\" flex=\"100\" class=\"p-15\" \nng-if=\"vm.comentariosObj[ objetivo.id ].length > 0\"><div \nng-if=\"objetivo.aprobado == \'1\' && !vm.verAjustesObj[objetivo.id]\" ng-click=\"vm.verAjustesObj[objetivo.id] = true\" \nclass=\"cursor-pointer md-accent-fg\">Ver ajustes solicitados anteriormente para este objetivo</div><div \nng-if=\"objetivo.aprobado == \'0\' || vm.verAjustesObj[objetivo.id]\" flex=\"100\" \nng-include=\"\'app/main/desempeno/templates/comentarios.html\'\" \nonload=\"comentarios = vm.comentariosObj[ objetivo.id ]; jefes = vm.jefes\"></div></div></div></div><div \nng-if=\"data.goals_weight != 100\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10 text-l\">\nPor favor verifique la siguiente información:</div><div class=\"font-weight-300 text-m\">\n* La suma de las ponderaciones de sus objetivos no suma 100%, recuerde verificar esta información para poder finalizar el proceso\n</div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal-indicator/goal-evaluation/default/default.html","<div id=\"hr-goal-indicator-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\"><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.callFunc(\'HrGoalIndicator\', \'goImportar\', [$event,data])\">Ingresar resultado de indicadores</md-button>\n</div></div><div layout=\"column\" ng-repeat=\"indicator in data.employee_indicators\" class=\"mb-15\"><div layout=\"row\" \nclass=\"mb-10\"><span class=\"text-xl md-primary-fg\">{{indicator.empleado.name}}</span></div><md-divider class=\"mb-10\">\n</md-divider><div class=\"table-header md-whiteframe-3dp white-500-bg\"><table class=\"tbl-lbl-data\"><thead><tr><th \nclass=\"background text-center\"><span class=\"titleTable\">Indicador</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Meta</span></th><th class=\"background text-center\"><span class=\"titleTable\">Resultado</span></th><th\n class=\"background text-center\"><span class=\"titleTable\">Cumplimiento</span></th></tr></thead><tbody><tr \nng-repeat=\"evaluation in indicator.evaluations\"><td class=\"w-40-p grey-100-bg\"><span class=\"text-m text-grey\">\n{{evaluation.objetivo ? evaluation.objetivo.name : evaluation.name }}</span></td><td class=\"w-20-p text-center\"><span \nclass=\"text-m text-grey\">{{evaluation.objetivo ? evaluation.objetivo.meta : evaluation.meta}}</span></td><td \nclass=\"text-center\"><span class=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_result_lists_item_id ? evaluation.goals_indicators_data.chief_result_lists_item.name : evaluation.goals_indicators_data.chief_num_result}}\n</span></td><td class=\"text-center\"><span class=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_fulfillment}}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal-indicator/goal-follow-up-evaluation/default/default.html","<div id=\"hr-goal-indicator-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"mb-30\"><div layout=\"column\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.callFunc(\'HrGoalIndicator\', \'goImportar\', [$event,data])\">Evaluación Indicadores</md-button></div></div>\n<div layout=\"column\" ng-repeat=\"indicator in data.employee_indicators\" class=\"mb-15\"><div \nclass=\"table-header md-whiteframe-3dp white-500-bg\"><div class=\"background-grey-soft border-soft-top\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"p-10 border-soft-top-left\" flex=\"80\"><span class=\"text-xl md-primary-fg\">\n{{indicator.empleado.name}}</span> <span class=\"text-xl md-primary-fg\">({{indicator.empleado.cedula}})</span></div>\n</div><table class=\"tbl-lbl-data\"><thead><tr><th class=\"text-center\"><span class=\"black-fg\">Indicador</span></th><th \nclass=\"text-center\"><span class=\"black-fg\">Meta</span></th><th class=\"text-center\"><span class=\"black-fg\">Resultado\n</span></th><th class=\"text-center\"><span class=\"black-fg\">Cumplimiento</span></th><th class=\"text-center\"><span \nclass=\"black-fg\">Comentarios</span></th></tr></thead><tbody><tr ng-repeat=\"evaluation in indicator.evaluations\"><td \nclass=\"w-40-p\"><span class=\"text-m text-grey\">{{evaluation.objetivo ? evaluation.objetivo.name : evaluation.name }}\n</span></td><td class=\"w-20-p text-center\"><span class=\"text-m text-grey\">\n{{evaluation.objetivo ? evaluation.objetivo.meta : evaluation.meta}}</span></td><td class=\"text-center\"><span \nclass=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_result_lists_item_id ? evaluation.goals_indicators_data.chief_result_lists_item.name : evaluation.goals_indicators_data.chief_num_result}}\n</span></td><td class=\"text-center\"><span class=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_fulfillment}}</span></td><td class=\"text-center\"><span \nclass=\"text-m text-grey\">{{evaluation.goals_indicators_data.chief_comment}}</span></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal-indicator/goal-inscription/default/default.html","<div id=\"hr-goal-indicator-inscription-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"mb-30\"><div layout=\"column\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.callFunc(\'HrGoalIndicator\', \'goImportGoalInscription\', [$event,data])\">Evaluación Indicadores</md-button>\n</div></div><div layout=\"column\" ng-repeat=\"er in data.errors track by $index\" class=\"mb-15\" \nng-if=\"data.errors.length\"><div layout=\"row\" class=\"mb-5\"><span class=\"text-xl md-primary-fg\">\n{{er.employee.empleado.name}}</span></div><md-divider class=\"mb-10\"></md-divider><div class=\"table-header\"><table \nclass=\"tbl-lbl-data\"><thead><tr><th class=\"background-error text-center\"><span class=\"titleTable white-fg\">Error</span>\n</th><th class=\"background-error\"><span class=\"titleTable white-fg\">Descripción</span></th></tr></thead><tbody><tr \nng-repeat=\"(key,value) in er.error track by $index\"><td class=\"w-20-p grey-100-bg\"><span class=\"text-m\">{{key}}</span>\n</td><td class=\"w-60-p text-center\"><div layout=\"column\" layout-align=\"center start\"><span class=\"text-m text-grey\" \nng-repeat=\"val in value track by $index\">{{val}}</span></div></td></tr></tbody></table></div></div><div \nlayout=\"column\" ng-repeat=\"employee in data.employee_goals\" class=\"mb-15\"><div \nclass=\"table-header md-whiteframe-3dp white-500-bg\"><div class=\"background-grey-soft border-soft-top\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"p-10 border-soft-top-left\" flex=\"80\"><span class=\"text-xl md-primary-fg\">\n{{employee.empleado.name}}</span> <span class=\"text-xl md-primary-fg\">({{employee.empleado.cedula}})</span></div><div \nclass=\"p-10 md-accent-bg border-soft-top-right\" flex=\"20\"><span class=\"text-l white-fg mr-5\">Total ponderación:</span> \n<span class=\"text-l twhite-fg\">{{employee.employee.total_percentage}}</span></div></div><table class=\"tbl-lbl-data\">\n<thead><tr><th class=\"text-center\"><span class=\"black-fg\">Indicador</span></th><th class=\"text-center\"><span \nclass=\"black-fg\">Meta</span></th><th class=\"text-center\"><span class=\"black-fg\">Ponderación</span></th></tr></thead>\n<tbody><tr ng-repeat=\"evaluation in employee.objetivos_empleado\"><td class=\"w-40-p\"><span class=\"text-m text-grey\">\n{{evaluation.objetivo ? evaluation.objetivo.name : evaluation.name }}</span></td><td class=\"w-20-p text-center\"><span \nclass=\"text-m text-grey\">{{evaluation.objetivo ? evaluation.objetivo.meta : evaluation.meta}}</span></td><td \nclass=\"text-center\"><span class=\"text-m text-grey\">{{(evaluation.porcentaje ? evaluation.porcentaje : 0) | number:0}}\n</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-approval/default/default.html","<div id=\"hr-personal-inscription-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div \nng-repeat=\"personal in data.personal_data\" class=\"mb-20\"><div layout=\"column\" \nclass=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"column\" class=\"pv-10 ph-15\"><div layout=\"row\"><div flex>\n<p class=\"text-m text-primary\" ng-bind-html=\"personal.objetive\"></p></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section mt-10\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\"><div><span class=\"text-primary text-m font-weight-600\">Competencia relacionada: </span><span\n class=\"text-s text-secondary\">{{personal.skill.name}}</span></div><div><span \nclass=\"text-primary text-m font-weight-600\">Como lo voy a lograr: </span><span class=\"text-s text-secondary\">\n{{personal.how_to_achieve_it}}</span></div><div ng-repeat=\"extra_data in data.personal_dev_additional_data\"><div \nng-if=\"personal.additional_data[extra_data.value]\"><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-s text-secondary\">{{personal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" \nlayout-align=\"start start\"><label class=\"text-primary text-m font-weight-600\">Ponderación</label><div \nclass=\"text-s text-secondary\">{{personal.weight ? personal.weight : \"\" | number:0}}%</div></div></div><md-divider>\n</md-divider><ik-goal-approval-comments ng-model=\"personal\" allow-comment=\"true\"></ik-goal-approval-comments></div>\n</div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-evaluation/default/default.html","<div id=\"hr-personal-goal-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div \nng-repeat=\"personal in data.personal_data\" class=\"mb-20\"><div layout=\"column\" \nclass=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"column\" class=\"pv-10 ph-15\"><div layout=\"row\"><div flex>\n<p class=\"text-m text-primary\" ng-bind-html=\"personal.objetive\"></p></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section mt-10\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\"><div><span class=\"text-primary text-m font-weight-600\">Competencia relacionada: </span><span\n class=\"text-s text-secondary\">{{personal.skill.name}}</span></div><div><span \nclass=\"text-primary text-m font-weight-600\">Como lo voy a lograr: </span><span class=\"text-s text-secondary\">\n{{personal.how_to_achieve_it}}</span></div><div ng-repeat=\"extra_data in data.personal_dev_additional_data\"><div \nng-if=\"personal.additional_data[extra_data.value]\"><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-s text-secondary\">{{personal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" \nlayout-align=\"start start\"><label class=\"text-primary text-m font-weight-600\">Ponderación</label><div \nclass=\"text-s text-secondary\">{{personal.weight ? personal.weight : \"\" | number:0}}%</div></div></div></div>\n<md-divider></md-divider><div layout=\"row\" class=\"grey-100-bg\"><div flex=\"50\" class=\"p-15\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">Autoevaluación:</span> <span \nclass=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.colla_result_lists_item_id && personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.colla_num_result ? personal.personal_dev_evaluation_data.colla_num_result : personal.personal_dev_evaluation_data.colla_result_lists_item_id ? personal.personal_dev_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><p class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.colla_comment}}</p></div>\n<md-divider></md-divider><div flex=\"50\" class=\"p-15\" \nng-if=\"personal.personal_dev_evaluation_data.chief_num_result || personal.personal_dev_evaluation_data.chief_result_lists_item_id\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">\nEvaluación del jefe:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.chief_result_lists_item && personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.chief_num_result ? personal.personal_dev_evaluation_data.chief_num_result : personal.personal_dev_evaluation_data.chief_result_lists_item_id ? personal.personal_dev_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.chief_comment}}</p></div></div>\n<md-divider></md-divider><ik-goal-comments-modal ng-model=\"personal\" allow-comment=\"data.config.sendComment\" \nconfig=\"data.config\" fn-save=\"vm.callFunc(\'HrPersonalDevelopment\', \'sendComments\', [$event, personal, data, \'colab\'])\">\n</ik-goal-comments-modal><div class=\"text-center p-10 card-actions\"><a href=\"#\" \nng-click=\"vm.callFunc(\'HrPersonalDevelopment\', \'openEvaluationPersonalDialog\', [$event, personal, data, \'colab\'])\">\nEvaluar acción</a></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-evaluation-approval/default/default.html","<div id=\"hr-personal-goal-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div \nng-repeat=\"personal in data.personal_data\" class=\"mb-20\"><div layout=\"column\" \nclass=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"column\" class=\"pv-10 ph-15\"><div layout=\"row\"><div flex>\n<p class=\"text-m text-primary\" ng-bind-html=\"personal.objetive\"></p></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section mt-10\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\"><div><span class=\"text-primary text-m font-weight-600\">Competencia relacionada: </span><span\n class=\"text-s text-secondary\">{{personal.skill.name}}</span></div><div><span \nclass=\"text-primary text-m font-weight-600\">Como lo voy a lograr: </span><span class=\"text-s text-secondary\">\n{{personal.how_to_achieve_it}}</span></div><div ng-repeat=\"extra_data in data.personal_dev_additional_data\"><div \nng-if=\"personal.additional_data[extra_data.value]\"><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-s text-secondary\">{{personal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" \nlayout-align=\"start start\"><label class=\"text-primary text-m font-weight-600\">Ponderación</label><div \nclass=\"text-s text-secondary\">{{personal.weight ? personal.weight : \"\" | number:0}}%</div></div></div></div>\n<md-divider></md-divider><div layout=\"row\" class=\"grey-100-bg\"><div flex=\"50\" class=\"p-15\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">Autoevaluación:</span> <span \nclass=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.colla_result_lists_item_id && personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.colla_num_result ? personal.personal_dev_evaluation_data.colla_num_result : personal.personal_dev_evaluation_data.colla_result_lists_item_id ? personal.personal_dev_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><p class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.colla_comment}}</p></div>\n<md-divider></md-divider><div flex=\"50\" class=\"p-15\" \nng-if=\"personal.personal_dev_evaluation_data.chief_num_result || personal.personal_dev_evaluation_data.chief_result_lists_item_id\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">\nEvaluación del jefe:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.chief_result_lists_item && personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.chief_num_result ? personal.personal_dev_evaluation_data.chief_num_result : personal.personal_dev_evaluation_data.chief_result_lists_item_id ? personal.personal_dev_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.chief_comment}}</p></div></div>\n<md-divider></md-divider><ik-goal-comments-modal ng-model=\"personal\" allow-comment=\"data.config.sendComment\" \nconfig=\"data.config\" fn-save=\"vm.callFunc(\'HrPersonalDevelopment\', \'sendComments\', [$event, personal, data, \'colab\'])\">\n</ik-goal-comments-modal></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-follow-up-evaluation/default/default.html","<div id=\"hr-personal-goal-follow-up-evaluation-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div \nng-repeat=\"personal in data.personal_data\" class=\"mb-20\"><div layout=\"column\" \nclass=\"goal-card md-whiteframe-3dp white-500-bg\"><div layout=\"column\" class=\"pv-10 ph-15\"><div layout=\"row\"><div flex>\n<p class=\"text-m text-primary\" ng-bind-html=\"personal.objetive\"></p></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-xs=\"column\" class=\"goal-info-section mt-10\"><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\"><div><span class=\"text-primary text-m font-weight-600\">Competencia relacionada: </span><span\n class=\"text-s text-secondary\">{{personal.skill.name}}</span></div><div><span \nclass=\"text-primary text-m font-weight-600\">Como lo voy a lograr: </span><span class=\"text-s text-secondary\">\n{{personal.how_to_achieve_it}}</span></div><div ng-repeat=\"extra_data in data.personal_dev_additional_data\"><div \nng-if=\"personal.additional_data[extra_data.value]\"><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-s text-secondary\">{{personal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" \nlayout-align=\"start start\"><label class=\"text-primary text-m font-weight-600\">Ponderación</label><div \nclass=\"text-s text-secondary\">{{personal.weight ? personal.weight : \"\" | number:0}}%</div></div></div></div>\n<md-divider></md-divider><div layout=\"row\" class=\"grey-100-bg\"><div flex=\"50\" class=\"p-15\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">Autoevaluación:</span> <span \nclass=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.colla_result_lists_item_id && personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.colla_num_result ? personal.personal_dev_evaluation_data.colla_num_result : personal.personal_dev_evaluation_data.colla_result_lists_item_id ? personal.personal_dev_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><p class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.colla_comment}}</p></div>\n<md-divider></md-divider><div flex=\"50\" class=\"p-15\" \nng-if=\"personal.personal_dev_evaluation_data.chief_num_result || personal.personal_dev_evaluation_data.chief_result_lists_item_id\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"md-accent-fg text-m font-weight-600 mr-5\">\nEvaluación del jefe:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.chief_result_lists_item && personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.chief_num_result ? personal.personal_dev_evaluation_data.chief_num_result : personal.personal_dev_evaluation_data.chief_result_lists_item_id ? personal.personal_dev_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><p class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.chief_comment}}</p></div></div>\n<md-divider></md-divider><ik-goal-comments-modal ng-model=\"personal\" allow-comment=\"data.config.sendComment\" \nconfig=\"data.config\" fn-save=\"vm.callFunc(\'HrPersonalDevelopment\', \'sendComments\', [$event, personal, data, \'colab\'])\">\n</ik-goal-comments-modal><md-divider></md-divider><div class=\"text-center p-10 card-actions\"><a href=\"#\" \nng-click=\"vm.callFunc(\'HrPersonalDevelopment\', \'openEvaluationPersonalDialog\', [$event, personal, data, \'colab\'])\">\nEvaluar acción</a></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-inscription/default/default.html","<div id=\"hr-personal-inscription-default\" class=\"mb-20\"><div ng-if=\"data.error\" \nclass=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">Por favor verifique la siguiente información:</div><div \nclass=\"font-weight-300\">{{data.error}}</div></div><div ng-if=\"!data.error\"><div layout=\"row\" layout-align=\"end end\" \nclass=\"mb-15\" ng-if=\"data.evaluation_preferences.max_registration_per_user >  data.personal_data.length\"><md-button \ntype=\"submit\" ng-click=\"vm.callFunc(\'HrPersonalDevelopment\', \'openInscriptionPersonalDialog\', [$event, {}, data])\" \nclass=\"send-button md-accent md-raised m-0\">Crear nueva acción</md-button></div><div \nng-repeat=\"personal in data.personal_data\" class=\"mb-20\"><div layout=\"column\" \nclass=\"goal-card md-whiteframe-3dp white-500-bg\"><div class=\"ph-15 pt-10 pb-5\" layout=\"row\" layout-align=\"end end\"><div\n ng-click=\"vm.callFunc(\'HrPersonalDevelopment\', \'openInscriptionPersonalDialog\', [$event, personal, data])\"><div \nclass=\"text-m text-undeline cursor-pointer md-primary-fg\">Modificar acción</div></div></div><div layout=\"column\" \nclass=\"pv-10 ph-15\"><div layout=\"row\"><div flex><p class=\"text-m text-primary\" ng-bind-html=\"personal.objetive\"></p>\n</div></div><md-divider></md-divider><div layout=\"row\" layout-xs=\"column\" class=\"goal-info-section mt-10\"><div \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"start start\"><div \nng-if=\"data.evaluation_preferences.required_skill\"><span class=\"text-primary text-m font-weight-600\">\nCompetencia relacionada: </span><span class=\"text-s text-secondary\">{{personal.skill.name}}</span></div><div><span \nclass=\"text-primary text-m font-weight-600\">Como lo voy a lograr: </span><span class=\"text-s text-secondary\">\n{{personal.how_to_achieve_it}}</span></div><div ng-repeat=\"extra_data in data.personal_dev_additional_data\"><div \nng-if=\"personal.additional_data[extra_data.value]\"><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-s text-secondary\">{{personal.additional_data[extra_data.value]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"p-15\" flex=\"25\" flex-xs=\"100\" \nlayout-align=\"start start\"><label class=\"text-primary text-m font-weight-600\">Ponderación</label><div \nclass=\"text-s text-secondary\">{{personal.weight ? personal.weight : \"\" | number:0}}%</div></div></div><md-divider>\n</md-divider><ik-goal-approval-comments ng-model=\"personal\" allow-comment=\"false\"></ik-goal-approval-comments></div>\n</div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-poll/poll-evaluation/default/default.html","<div class=\"md-whiteframe-4dp poll-evaluation\"><div class=\"table-header background\"><table class=\"tbl-lbl-data\"><thead>\n<tr><th class=\"background text-center w-30\"><span class=\"titleTable\">Pregunta</span></th><th \nclass=\"background text-center w-30-p\"><span class=\"titleTable\">Respuesta</span></th><th \nclass=\"background text-center w-30-p\"><span class=\"titleTable\">Comentario</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.movilidad\"><td class=\"grey-100-bg w-30-p\"><div layout=\"column\" layout-align=\"center start\"><span\n class=\"text-m text-primary mb-10\">{{row.name ? row.name : \'\'}}</span></div></td><td \nclass=\"text-m text-secondary w-40-p border-td\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-poll/template/input-\'+row.answer_type+\'.html\'\"></div></td><td\n class=\"w-30-p border-td\"><div layout=\"column\" class=\"comments-container full-width\" ng-if=\"row.comment_is_required\">\n<textarea class=\"comments-input\" ng-model=\"data.formData[row.id].comment\" maxlength=\"500\" rows=\"4\"></textarea><div \nlayout=\"row\" layout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{data.formData[row.id].comment.length ? data.formData[row.id].comment.length : 0}}</span> <span \nclass=\"text-xs text-secondary\">/500</span></div></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"comments-container\" ng-if=\"!row.comment_is_required\"><span class=\"text-m text-secondary\">N/A</span></div></td>\n</tr></tbody></table></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-evaluation/default/default.html","<div ng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/default/default.html\'\">\n</div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-evaluation/etapas_novacion/default.html","<div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/etapas_novacion/default.html\'\">\n</div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-evaluation-approval/default/default.html","<div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation-approval/default/default.html\'\">\n</div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/default/default.html","<div class=\"mb-15\"><div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">\nPor favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div></div><div \nng-if=\"!data.error\"><div layout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg\"><div class=\"table-header\"><table \nclass=\"tbl-lbl-data\"><thead><tr><td class=\"background titleTable text-center\">Competencia</td><td \nclass=\"background titleTable text-center\">Estado</td><td class=\"background titleTable text-center\" ng-if=\"data.isBoss\">\nEvaluaciones 360</td><td class=\"background titleTable text-center\" ng-if=\"data.isBoss\">Autoevaluación</td><td \nclass=\"background titleTable text-center\">Resultado</td><td class=\"background\"></td></tr></thead><tbody><tr \nng-repeat=\"skill in data.skills\" ng-if=\"skill.show\"><td class=\"text-grey text-m\">{{skill.name}}</td><td \nclass=\"text-center text-m\"><span class=\"badge-status\" ng-class=\"skill.estado ? \'complete\' : \'incomplete\'\">\n{{skill.estado ? \'Evaluado\' : \'Sin evaluar\'}}</span></td><td class=\"text-center\" ng-if=\"data.isBoss\"><a \nng-click=\"vm.callFunc(\'HrSkill\', \'open_skillFollowUpEvaluationChief\', [$event, skill, data])\" class=\"cursor-pointer\">\nVer</a></td><td class=\"text-center text-m text-secondary\" ng-if=\"data.isBoss\">{{skill.autoResult | number:0}}</td><td \nclass=\"text-center text-m text-secondary\">{{skill.result | number:0}}</td><td class=\"text-center text-m\"><a \nng-click=\"vm.callFunc(\'HrSkill\', \'open_skillFollowUpEvaluationSingle\', [$event, skill, data])\" \nclass=\"mr-5 cursor-pointer\" ng-if=\"data.isDefault\">Evaluar</a> <a \nng-click=\"vm.callFunc(\'HrSkill\', \'open_skillFollowUpEvaluationSingleEtapasNovacion\', [$event, skill, data])\" \nclass=\"mr-5 cursor-pointer\" ng-if=\"!data.isDefault\">Evaluar</a></td></tr></tbody></table></div></div><div \nng-if=\"data.comments.length > 0 && data.isBoss\" class=\"mt-15\"><div ng-repeat=\"comments in data.comments\" \nclass=\"container-comments\"><div layout=\"row\" layout-align=\"start start\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{comments.empleado.foto}}\" class=\"avatar square big\"></div><div layout=\"column\" class=\"w-100-p\"><div \nclass=\"nombre\">{{comments.empleado.name}}</div><div class=\"date grey-400-fg\">\n{{comments.created_at| formatMoment : \'MMM DD, YYYY\'}}</div><md-divider class=\"mt-10 mb-10\"></md-divider><span \nclass=\"comment grey-500-fg\">{{comments.comment}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/etapas_novacion/default.html","<div class=\"mb-15\"><div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\"><div class=\"mb-10\">\nPor favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div></div><div \nng-if=\"!data.error\"><div layout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg\"><div class=\"table-header\"><table \nclass=\"tbl-lbl-data\"><thead><tr><td class=\"background titleTable text-center\">Competencia</td><td \nclass=\"background titleTable text-center\">Estado</td><td class=\"background titleTable text-center\" ng-if=\"data.isBoss\">\nEvaluaciones 360</td><td class=\"background titleTable text-center\" ng-if=\"data.isBoss\">Autoevaluación</td><td \nclass=\"background titleTable text-center\">Resultado</td><td class=\"background\"></td></tr></thead><tbody><tr \nng-repeat=\"skill in data.skills\" ng-if=\"skill.show\"><td class=\"text-grey text-m\">{{skill.name}}</td><td \nclass=\"text-center text-m\"><span class=\"badge-status\" ng-class=\"skill.estado ? \'complete\' : \'incomplete\'\">\n{{skill.estado ? \'Evaluado\' : \'Sin evaluar\'}}</span></td><td class=\"text-center\" ng-if=\"data.isBoss\"><a \nng-click=\"vm.callFunc(\'HrSkill\', \'open_skillFollowUpEvaluationChief\', [$event, skill, data])\" class=\"cursor-pointer\">\nVer</a></td><td class=\"text-center text-m text-secondary\" ng-if=\"data.isBoss\">{{skill.autoResult | number:0}}</td><td \nclass=\"text-center text-m text-secondary\">{{skill.result | number:0}}</td><td class=\"text-center text-m\"><a \nng-click=\"vm.callFunc(\'HrSkill\', \'open_skillFollowUpEvaluationSingleEtapasNovacion\', [$event, skill, data])\" \nclass=\"mr-5 cursor-pointer\">Evaluar</a></td></tr></tbody></table></div></div><div \nng-if=\"data.comments.length > 0 && data.isBoss\" class=\"mt-15\"><div ng-repeat=\"comments in data.comments\" \nclass=\"container-comments\"><div layout=\"row\" layout-align=\"start start\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{comments.empleado.foto}}\" class=\"avatar square big\"></div><div layout=\"column\" class=\"w-100-p\"><div \nclass=\"nombre\">{{comments.empleado.name}}</div><div class=\"date grey-400-fg\">\n{{comments.created_at| formatMoment : \'MMM DD, YYYY\'}}</div><md-divider class=\"mt-10 mb-10\"></md-divider><span \nclass=\"comment grey-500-fg\">{{comments.comment}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation-approval/default/default.html","<div class=\"mb-15 default-skill-evaluation-approval\"><div ng-if=\"data.error\" class=\"brad-5 p-15 red-100-bg red-900-fg\">\n<div class=\"mb-10\">Por favor verifique la siguiente información:</div><div class=\"font-weight-300\">{{data.error}}</div>\n</div><div ng-if=\"!data.error\"><div class=\"mb-15\"><div layout=\"column\" class=\"mtoc md-whiteframe-3dp\"><div \nlayout=\"row\" layout-align=\"end center\" class=\"p-20 white-500-bg\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"(key,title) in data.approvalStructure.titleObj track by $index\" class=\"mr-5\"><span \nclass=\"badge-circle mr-5\" ng-style=\"{\'background-color\':title.selected_value}\">{{title.label | onlyCapitalize}}</span> \n<span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div \nng-repeat=\"approval in data.approvalStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"detail-skill md-primary-fg\">{{approval.skillDetail.skill.name}}</span></div><div\n class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = approval.skillDescriptors;title = data.approvalStructure.titleObj;info = approval.dataBody;config = {onlyview:true,colors:data.approvalStructure.titleColor}\">\n</div></div></div><md-divider></md-divider><div layout=\"column\" class=\"white-bg\"><div layout=\"row\" class=\"p-20\"><div \nlayout=\"column\" class=\"w-100-p\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-accent-fg mr-5 text-m font-weight-600\">Comentario general</span></div><textarea class=\"comments-input\" \nng-model=\"data.skills_approver_comment.approver_comment\" maxlength=\"500\" rows=\"5\"></textarea><div layout=\"row\" \nlayout-align=\"end center\"><span class=\"text-xs text-secondary\">\n{{data.skills_approver_comment.approver_comment.length ? data.skills_approver_comment.approver_comment.length : 0}}\n</span> <span class=\"text-xs text-secondary\">/500</span></div></div></div><ik-skill-approval-comments ng-model=\"data\" \nallow-comment=\"true\"></ik-skill-approval-comments></div></div></div></div></div>");
$templateCache.put("app/main/modules/employee/profile/tabs/current_evaluation/current_evaluation.html","<div id=\"current_evaluation\" class=\"mt-15\"><div layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.backToPerfil()\" ng-if=\"vm.last_stage_id\">Regresar a mi perfil</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.donwloadPDF()\">Descargar pdf</md-button></div><div \nclass=\"md-primary-bg div-radius h-30\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.currentEvaluation.qualitative_rating\"><span class=\"text-l white-fg mr-5\">Resultado de desempeño:</span> <span\n class=\"text-l white-fg font-weight-600\">{{vm.currentEvaluation.qualitative_rating}}</span></div><div \nclass=\"md-whiteframe-4dp mt-10 mb-30\"><div layout=\"row\" class=\"table-header background\"><table class=\"tbl-lbl-data\">\n<thead><tr><th class=\"background text-center\"><span class=\"titleTable\">Aspecto</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Evaluación</span></th><th \nclass=\"background text-center w-20-p\"><span class=\"titleTable\">Autoevaluación</span></th></tr></thead><tbody><tr \nng-repeat=\"row in vm.currentEvaluation.evaluation_hr_modules\" ng-if=\"row.hr_module.has_evaluation\"><td \nclass=\"grey-100-bg\"><div layout=\"row\" layout-align=\"start center\"><span class=\"text-m text-primary mb-10\">\n{{row.hr_module.name}} </span><span class=\"text-m text-primary mb-10 ml-10\">({{row.weight }}%)</span></div></td><td \nclass=\"text-m text-secondary text-center\">{{row.final_evaluation }}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">{{row.auto_evaluation }}</td></tr><tr><td class=\"grey-100-bg\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"text-m text-primary mb-10\">Resultado evaluación</span></div></td>\n<td class=\"text-m text-secondary text-center\">{{vm.evFinalCurrent | number: \'2\' }}</td><td \nclass=\"text-center text-m text-secondary w-10-p\">{{vm.evFinalCurrentAuto | number: \'2\' }}</td></tr></tbody></table>\n</div></div><div ng-repeat=\"currentEvaluation in vm.currentEvaluationData\" ng-if=\"!currentEvaluation.hide\"><div \nclass=\"mb-15\"><span class=\"text-xl md-primary-fg font-weight-500\">{{currentEvaluation.title}}</span></div><div \nclass=\"full-width md-whiteframe-4dp mb-30\"><ik-evaluation-result-list ng-model=\"currentEvaluation.data\" \nview-model=\"vm\" template=\"currentEvaluation.template\"></ik-evaluation-result-list></div></div></div>");
$templateCache.put("app/main/modules/employee/profile/tabs/evaluations_history/evaluations_history.html","<div id=\"evaluation-history\"><loading-bar ng-if=\"vm.loadingEvaluationData\"></loading-bar><div \nng-if=\"!vm.loadingEvaluationData\"><div ng-if=\"vm.evaluationsHistory.length !== 0 && !vm.showEvaluationHistoryData\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.evaluationResultViewType = \'list\'\" aria-label=\"List view\"><md-icon \nmd-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span>Vista tipo lista</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.evaluationResultViewType = \'card\'\" aria-label=\"List view\"><md-icon \nmd-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span>Vista tipo tarjeta</span></md-tooltip></md-button><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ik-evaluation-result-card ng-model=\"evaluation\" \nng-repeat=\"evaluation in vm.evaluationsHistory | filter: vm.search\" template=\"vm.evaluationResultCardTemplate\" \nflex=\"50\" ng-if=\"vm.evaluationResultViewType == \'card\'\" view-model=\"vm\"></ik-evaluation-result-card></div><div \nclass=\"simple-table-container full-width md-whiteframe-4dp\"><ik-evaluation-result-list \nng-model=\"vm.evaluationsHistory\" view-model=\"vm\" template=\"vm.evaluationResultListTemplate\" \nng-if=\"vm.evaluationResultViewType == \'list\'\"></ik-evaluation-result-list></div></div><ms-message type=\"info\" \nng-if=\"!vm.evaluationsHistory.length\">No se encontraron evaluaciones anteriores.</ms-message><div \nng-if=\"vm.showEvaluationHistoryData\"><div layout=\"row\" layout-align=\"end end\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.donwloadPDF(vm.evaluationData.id)\">Descargar pdf</md-button><md-button class=\"md-warn md-raised\" \nng-click=\"vm.showEvaluationHistoryData = false\">Regresar</md-button></div><ik-evaluation-data \nng-model=\"vm.evaluationData\" template=\"vm.evaluationDataTemplate\"></ik-evaluation-data></div></div></div>");
$templateCache.put("app/main/modules/employee/profile/tabs/home/home.html","<div id=\"profile-home\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"row\" flex=\"100\" layout-wrap><div flex=\"100\">\n<div layout=\"row\" layout-align=\"space-between center\"><div class=\"md-primary-fg title\">Mis actividades pendientes</div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\" class=\"pl-10 pr-10\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float \nclass=\"no-errors no-padding no-margin\"><input id=\"search\" placeholder=\"Buscar colaborador...\" type=\"text\" \nng-model=\"vm.search_employee\"></md-input-container></div></div><div class=\"activities-pending mt-5\"><div layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget ng-repeat=\"message in vm.messages\" ng-if=\"!message.status\" class=\"p-5\" flex=\"100\" \nflex-xs=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\" flex-xl=\"33\"><ms-widget-front class=\"white-bg\" \nng-style=\"{\'border-top-color\': vm.colors.accent,\'border-top-width\': \'3px\',\n                \'border-top-style\': \'solid\'}\">\n<div class=\"p-20 border-bottom h-150\" layout=\"column\" layout-align=\"space-between\"><span class=\"text-m text-primary\">\n{{message.message_template.body}}</span><md-divider class=\"mt-15 mb-15\"></md-divider><div class=\"button-message\" \nlayout=\"row\" layout-align=\"end center\"><md-button md-no-ink class=\"md-primary\" \nng-if=\"message.message_template.action.type == \'button\'\" \nng-click=\"vm.sendMessage(message,message.message_template.action.button.value)\">\n{{message.message_template.action.button.label}}</md-button></div></div></ms-widget-front></ms-widget></div><div \nng-repeat=\"periodActivities in vm.pendingActivities\"><div ng-repeat=\"rolActivities in periodActivities\"><div \nng-repeat=\"activity in rolActivities\"><div layout-align=\"start center\" class=\"mb-5 text-l\"><span \nclass=\"name-activities\">{{activity.period.name}} {{activity.process_name}}: <strong>{{activity.name}}</strong></span> \n<span class=\"ml-15 badge-number-activities\">{{activity.content.length}}</span></div><md-divider></md-divider><div \nclass=\"widget-group margin-widgets\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-repeat=\"employee in activity.content | filter: vm.search_employee\" class=\"p-5\" \nng-init=\"employee_data = employee.evaluation.matricula\" flex=\"100\" flex-xs=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" \nflex-sm=\"100\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><ms-widget-front \nclass=\"white-bg\" \nng-style=\"{\'border-top-color\': vm.colors.accent,\'border-top-width\': \'3px\',\n                  \'border-top-style\': \'solid\'}\">\n<div class=\"pl-16 pr-16 pt-5 pb-5 border-bottom h-100\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"md-hue-3 brad-5 p-10 h-80\"><div class=\"avatar-wrapper mr-5\"><img \nng-src=\"{{employee_data.empleado.foto}}\" class=\"avatar square big\" alt=\"\"></div><div class=\"cursor-pointer\" \nlayout=\"column\"><div class=\"employee-name\"><a href=\"\" \nng-click=\"vm.goToProcess(employee.evaluation.matricula.id,employee.process)\">{{employee_data.empleado.name}}</a></div>\n<div class=\"employee-charge mb-5\">{{employee_data.cargo.name}}</div><div class=\"date-container\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"date-text mr-5\">Fecha límite:</span> <span \nclass=\"date-value grey-500-fg text-capitalize\">{{employee.process.deadline | fecha}}</span></div></div></div></div>\n</ms-widget-front></ms-widget></div></div></div></div><div ng-if=\"!vm.haveActivies && !vm.messages.length\" \nng-include=\"\'app/core/template/not-found.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/modules/employee/profile/tabs/work_team/work_team.html","<div id=\"equipo\" layout=\"row\" layout-xs=\"column\" layout-wrap ng-if=\"vm.workTeam.length !== 0\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ik-employee-team-card ng-model=\"employee\" \nng-repeat=\"employee in vm.workTeam | filter: vm.search\" template=\"vm.employeeCardTemplate\" flex=\"33\">\n</ik-employee-team-card></div></div><ms-message type=\"info\" ng-if=\"vm.workTeam.length == 0\">\nNo tiene colaboradores a cargo</ms-message>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-goal/dialogs/comment-goal-dialog/index.html","<md-dialog id=\"comment-goal-dialog\" aria-label=\"Objetivo\"><form name=\"dataForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">Objetivo </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"grey-100-bg p-20\"><md-input-container\n class=\"md-block\"><label>Comentarios</label><textarea name=\"comments\" ng-model=\"vm.comments\" required \nmd-maxlength=\"500\" maxlength=\"500\"></textarea><div ng-messages=\"dataForm.comments.$error\" \nng-show=\"dataForm.comments.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Dato requerido</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\">\n<div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.saveEvaluation()\" \nng-disabled=\"dataForm.$invalid || vm.evaluation == -1 || vm.saving\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-goal/dialogs/evaluation-goal-dialog/evaluation-goal-dialog.html","<md-dialog id=\"evaluation-goal-dialog\" aria-label=\"Objetivo\"><form name=\"dataForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">Objetivo </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20\"><div ng-bind-html=\"vm.goal.name\" class=\"mr-5 mb-10 text-m text-primary\"></div><div layout=\"column\"><span \nclass=\"md-primary-fg text-m font-weight-600\">Meta</span> <span class=\"text-s text-secondary\">{{vm.goal.meta}}</span>\n</div></div><div class=\"grey-100-bg p-20\"><md-input-container class=\"md-block\"><label>Comentarios</label><textarea \nname=\"comments\" ng-model=\"vm.comments\" required md-maxlength=\"500\" maxlength=\"500\"></textarea><div \nng-messages=\"dataForm.comments.$error\" ng-show=\"dataForm.comments.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Dato requerido</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" ng-if=\"vm.evaluation_type == \'numeric\'\"><label class=\"text-s\">\nEvaluación del objetivo</label><md-select class=\"mt-10\" ng-model=\"vm.evaluation\" required><md-option ng-value=\"-1\" \nng-selected=\"vm.selectedDefault\">--- Seleccione ---</md-option><md-option ng-repeat=\"value in ::vm.weights\" \nvalue=\"{{value}}\">{{value}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" ng-if=\"vm.evaluation_type == \'lists\'\"><div \nclass=\"text-s font-weight-300\">{{vm.result_type.result_list.label}} <span \nng-if=\"vm.result_type.result_list.description\" class=\"icon-question-mark-circle cursor-pointer ml-5\"><md-tooltip \nmd-direction=\"top\">{{vm.result_type.result_list.description}}</md-tooltip></span></div><md-select class=\"mt-10\" \nng-model=\"vm.evaluation\" required><md-option ng-value=\"-1\" ng-selected=\"vm.selectedDefault\">--- Seleccione ---\n</md-option><md-option ng-repeat=\"value in vm.result_type.result_list.lists_items \" ng-value=\"value.id\">{{value.name}}\n</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.saveEvaluation()\" \nng-disabled=\"dataForm.$invalid || vm.evaluation == -1 || vm.saving\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-goal/dialogs/input-goal-dialog/input-goal-dialog.html","<md-dialog id=\"input-goal-dialog\" aria-label=\"Objetivo\"><form name=\"dataForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">Objetivo </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"p-20\"><md-input-container \nclass=\"md-block\"><label class=\"ph field_obl\">Objetivo</label><textarea name=\"objetivo\" class=\"pp\" \nng-model=\"vm.goal.name\" required md-maxlength=\"500\" maxlength=\"500\"></textarea><div \nng-messages=\"dataForm.objetivo.$error\" ng-show=\"dataForm.objetivo.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Dato requerido</span></div></div></md-input-container><md-input-container class=\"md-block\" \nng-repeat=\"extra_data in ::vm.module_data.goals_additional_data\"><label class=\"ph field_obl\">{{extra_data.label}}\n</label><textarea name=\"meta\" class=\"pp\" ng-model=\"vm.goal.additional_data[extra_data.value]\" \nng-required=\"extra_data.required\" md-maxlength=\"500\" maxlength=\"500\"></textarea></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"ph field_obl\">Meta</label><textarea name=\"meta\" class=\"pp\" \nng-model=\"vm.goal.meta\" required md-maxlength=\"500\" maxlength=\"500\"></textarea></md-input-container><md-input-container\n class=\"md-block md-default-theme md-input-has-value\"><label class=\"ph field_obl\">Ponderación</label><md-select \nclass=\"pp mt-10\" ng-model=\"vm.goal.porcentaje\" required><md-option ng-repeat=\"value in ::vm.weights\" ng-value=\"value\">\n{{value}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions class=\"bt\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button type=\"submit\" ng-click=\"vm.saveGoal()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"dataForm.$invalid || vm.savingData\">\n{{ vm.savingData ? \'GUARDANDO\' : \'GUARDAR\' }}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-goal/dialogs/select-goal-list-dialog/select-goal-list-dialog.html","<md-dialog id=\"select-goal-list-dialog\" aria-label=\"Objetivo\"><form name=\"dataForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">Objetivo </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"mt-8 search-input-wrapper p-20\" layout=\"row\" \nlayout-align=\"start center\"><label for=\"search\" class=\"pt-0 pl-10 pr-10 pb-15\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></label><md-input-container md-no-float class=\"no-padding no-margin\" flex=\"100\"><input id=\"search\" \nplaceholder=\"Buscar objetivo...\" type=\"text\" ng-model=\"vm.search_obj\"></md-input-container></div><div layout=\"column\" \nng-repeat=\"companyGoal in vm.companyGoals | filter: vm.search_obj\" class=\"p-20\"><div layout=\"column\" \nlayout-align=\"center start\" class=\"b brad-5 p-15 mb-10\"><div layout=\"row\"><div class=\"mr-10\"><md-radio-group \nng-model=\"vm.goal.objetivo_id\" required ng-if=\"vm.objetivos_seleccionados.indexOf(companyGoal.id) == -1\">\n<md-radio-button ng-value=\"companyGoal.id\" ng-click=\"vm.setObj(objLista.Objetivo)\" aria-label=\"opt\"></md-radio-button>\n</md-radio-group></div><div layout=\"column\" layout-align=\"center start\"><div \nng-if=\"vm.objetivos_seleccionados.indexOf(objLista.Objetivo.id) >= 0\" class=\"ph-5 md-accent-bg\">\nEste objetivo ya esta incluido en su matrícula</div><div class=\"text-l md-accent-fg\" class=\"mb-5\">\n{{ companyGoal.name }}</div><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"extra_data in ::vm.module_data.goals_additional_data\" class=\"mb-5\"><span \nclass=\"text-primary text-m font-weight-600 mr-5\">{{extra_data.label}}: </span><span class=\"text-secondary text-s\">\n{{ companyGoal.additional_data[extra_data.value] }}</span></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-primary text-m font-weight-600 mr-5\">Meta: </span><span class=\"text-secondary text-s\">\n{{ companyGoal.meta }}</span></div></div></div><div layout=\"column\" ng-if=\"vm.goal.objetivo_id == companyGoal.id\" \nclass=\"mt-10\"><div class=\"text-m text-primary\">Seleccione la ponderación</div><md-input-container \nclass=\"md-block mt-15\"><label class=\"field_obl\">Ponderación</label><md-select ng-model=\"vm.goal.porcentaje\" required>\n<md-option ng-repeat=\"value in ::vm.weights\" value=\"{{value}}\">{{value}}</md-option></md-select></md-input-container>\n</div></div></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"p-5\"><md-button type=\"submit\" ng-click=\"vm.saveGoal()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"dataForm.$invalid || vm.savingData\">{{ vm.savingData ? \'GUARDANDO\' : \'GUARDAR\' }}</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-goal-indicator/dialogs/importar-dialog/importar-dialog.html","<md-dialog id=\"importar-dialog\" aria-label=\"Objetivo\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.title}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><ik-import-data template=\"vm.configImportData.templateUrl\" \nconfig=\"vm.configImportData.config\" setfunction=\"vm.importData(data)\"></ik-import-data></md-dialog-content></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-personal-development/dialogs/evaluation-personal-dialog/evaluation-personal-dialog.html","<md-dialog id=\"evaluation-personal-dialog\" aria-label=\"Objetivo\"><form name=\"dataForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">Acción de desarrollo </span><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"p-20\"><div ng-bind-html=\"vm.personal.objetive\" class=\"mr-5 detail-goal\">\n</div></div><div class=\"grey-100-bg p-20\"><md-input-container class=\"md-block\"><label>Comentarios</label><textarea \nname=\"comments\" ng-model=\"vm.comments\" required md-maxlength=\"500\" maxlength=\"500\"></textarea><div \nng-messages=\"dataForm.comments.$error\" ng-show=\"dataForm.comments.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Dato requerido</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" ng-if=\"vm.evaluation_type == \'numeric\'\"><label class=\"text-s\">\nEvaluación del objetivo</label><md-select class=\"mt-10\" ng-model=\"vm.evaluation\" required><md-option ng-value=\"-1\" \nng-selected=\"vm.selectedDefault\">--- Seleccione ---</md-option><md-option ng-repeat=\"value in ::vm.weights\" \nvalue=\"{{value}}\">{{value}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value\" ng-if=\"vm.evaluation_type == \'lists\'\"><div \nclass=\"text-s font-weight-300\">{{vm.result_type.result_list.label}} <span \nng-if=\"vm.result_type.result_list.description\" class=\"icon-question-mark-circle cursor-pointer ml-5\"><md-tooltip \nmd-direction=\"top\">{{vm.result_type.result_list.description}}</md-tooltip></span></div><md-select class=\"mt-10\" \nng-model=\"vm.evaluation\" required><md-option ng-value=\"-1\" ng-selected=\"vm.selectedDefault\">--- Seleccione ---\n</md-option><md-option ng-repeat=\"value in vm.result_type.result_list.lists_items \" ng-value=\"value.id\">{{value.name}}\n</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.saveEvaluation()\" \nng-disabled=\"dataForm.$invalid || vm.evaluation == -1 || vm.saving\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-personal-development/dialogs/inscription-goal-list-dialog/inscription-goal-list-dialog.html","<md-dialog id=\"inscription-goal-list-dialog\" aria-label=\"Objetivo\"><form name=\"dataForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">Acción </span><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nng-include=\"vm.templatePath\"></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button class=\"md-raised\" ng-click=\"vm.closeDialog()\" \naria-label=\"Delete\">CANCELAR</md-button></div><div class=\"p-5\"><md-button type=\"submit\" ng-click=\"vm.saveGoal()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"dataForm.$invalid || vm.saving\">GUARDAR</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-skill/dialogs/chief/chief-dialog.html","<md-dialog id=\"chief-dialog-skill\" aria-label=\"Objetivo\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.skill.name}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div><div class=\"p-20\"><span class=\"text-m text-primary\">{{vm.skill.description}}\n</span></div><div layout=\"row\" layout-align=\"end center\" class=\"p-20\"><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"(key,title) in vm.titleObj track by $index\" class=\"mr-5\"><span \nclass=\"badge-circle mr-5\" ng-style=\"{\'background-color\':title.selected_value}\">{{title.label | onlyCapitalize}}</span> \n<span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = vm.bodyTable;title = vm.titleObj;info = vm.formData.dataBody;config = {onlyview:true,colors:vm.titleColor}\">\n</div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-skill/dialogs/etapas_novacion/default.html","<md-dialog id=\"etapa-novacion-dialog\"><form name=\"dataForm\" class=\"md-inline-form\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"text-truncate h2\">{{vm.skill.name}} </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div class=\"p-20\"><span class=\"text-m text-primary\">\n{{vm.skill.description}}</span></div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/etapas-novacion.html\'\" \nng-init=\"body = vm.bodyTable;titles = vm.titleTable\"></div></div></div></md-dialog-content><md-dialog-actions \nclass=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" \naria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"p-5\"><md-button ng-click=\"vm.saveEvaluation()\" ng-disabled=\"dataForm.$invalid\" \naria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-skill/dialogs/single/single-dialog.html","<md-dialog id=\"single-dialog\"><form name=\"dataForm\" class=\"md-inline-form\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"text-truncate h2\">{{vm.skill.name}} </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div class=\"p-20\"><span class=\"text-m text-primary\">\n{{vm.skill.description}}</span></div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill.html\'\" \nng-init=\"body = vm.bodyTable;title = vm.titleTable\"></div></div></div></md-dialog-content><md-dialog-actions \nclass=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" \naria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"p-5\"><md-button ng-click=\"vm.saveEvaluation()\" ng-disabled=\"dataForm.$invalid\" \naria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-value/dialogs/chief/chief-dialog.html","<md-dialog id=\"chief-dialog-core_value\" aria-label=\"Objetivo\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.skill.name}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div><div class=\"p-20\"><span class=\"text-m text-primary\">{{vm.skill.description}}\n</span></div><div layout=\"row\" layout-align=\"end center\" class=\"p-20\"><div layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"(key,title) in vm.titleObj track by $index\" class=\"mr-5\"><span \nclass=\"badge-circle mr-5\" ng-style=\"{\'background-color\':title.selected_value}\">{{title.label | onlyCapitalize}}</span> \n<span class=\"text-primary text-m mr-5\">{{title.label}}</span></div></div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill-approbe.html\'\" \nng-init=\"body = vm.bodyTable;title = vm.titleObj;info = vm.formData.dataBody;config = {onlyview:true,colors:vm.titleColor}\">\n</div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-value/dialogs/single/single-dialog.html","<md-dialog id=\"single-dialog\"><form name=\"dataForm\" class=\"md-inline-form\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"text-truncate h2\">{{vm.skill.name}} </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div class=\"p-20\"><span class=\"text-m text-primary\">\n{{vm.skill.description}}</span></div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill.html\'\" \nng-init=\"body = vm.bodyTable;title = vm.titleTable\"></div></div></div></md-dialog-content><md-dialog-actions \nclass=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" \naria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"p-5\"><md-button ng-click=\"vm.saveEvaluation()\" ng-disabled=\"dataForm.$invalid\" \naria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/users/admin/dialogs/sociedades/sociedad-dialog.html","<md-dialog class=\"precio-azucar-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title pt-8\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{vm.user.ModuleUser.name}}</div></div></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>Buscar Sociedad</label><input \nng-model=\"keyword\" type=\"text\"></md-input-container><div class=\"demo-select-all-checkboxes bb\" flex=\"100\" \nng-repeat=\"item in vm.Sociedades | filter: keyword\"><md-checkbox ng-checked=\"vm.exists(item)\" \nng-click=\"vm.toggle(item)\">{{ item.COD_SAP }} - {{ item.SOC_NOMBRE }}</md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.asignarSociedades()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\">\nACEPTAR</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/users/admin/dialogs/usuario/usuario-dialog.html","<md-dialog class=\"precio-azucar-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between\"><span class=\"title pt-8\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><img ng-src=\"{{vm.user.ModuleUser.avatar}}\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.user.ModuleUser.name}}\"><div class=\"contact-name\">\n{{vm.user.ModuleUser.name}}</div></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label>Perfil de usuario</label><md-select ng-model=\"vm.user.ModuleUser.users_profile_id\" ng-required>\n<md-option ng-repeat=\"user_profile in vm.user_profiles\" value=\"{{user_profile.UsersProfile.id}}\">\n{{user_profile.UsersProfile.type}} - {{user_profile.UsersProfile.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>Nombre</label><input ng-model=\"vm.user.ModuleUser.name\" type=\"text\" \nng-required></md-input-container><md-input-container class=\"md-block\"><label>Correo electrónico</label><input \nng-model=\"vm.user.ModuleUser.email\" type=\"email\" ng-required></md-input-container><md-input-container class=\"md-block\">\n<label>Teléfono</label><input ng-model=\"vm.user.ModuleUser.telefono\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Celular</label><input ng-model=\"vm.user.ModuleUser.celular\" type=\"text\">\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.showField(\'nit\')\"><label>NIT</label><input \nng-model=\"vm.user.ModuleUser.cstm_nit\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"vm.showField(\'asistente_tecnico\')\"><label>Asistente técnico</label><md-select \nng-model=\"vm.user.ModuleUser.asistente_tecnico_id\"><md-option ng-repeat=\"asistente in vm.asistentes_tecnicos\" \nvalue=\"{{asistente.ModuleUser.id}}\">{{asistente.ModuleUser.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.showField(\'imagen_asistente\')\"><input type=\"file\" nv-file-select \nuploader=\"vm.uploaderProfileImage\"><br></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newUser\" ng-click=\"vm.saveUser()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid\" aria-label=\"SAVE\">ACEPTAR</md-button><md-button type=\"submit\" ng-if=\"vm.newUser\" \nng-click=\"vm.addNewUser()\" class=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid\" \naria-label=\"Add User\">ACEPTAR</md-button></div><div layout=\"row\"><md-button class=\"md-icon-button md-warn\" \nng-if=\"!vm.newUser\" ng-click=\"vm.deleteUserConfirm($event)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span>ELIMINAR</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/assistant-evaluation/summary/default/default.html","<div class=\"mb-20 assistantSingle\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div class=\"mb-15\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div ng-if=\"!summary.errors.length\" \nng-repeat=\"section in data.assistants.sections track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"md-primary-fg text-l font-weight-600\">{{$index + 1}}. {{section.name}}</span>\n</div><div class=\"backgroundValue p-20\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-assistant-objective/template/single.html\'\" \nng-init=\"config = {onlyView:true}\"></div></div></div><div layout=\"column\" layout-align=\"end\" class=\"mb-15\"><div \nlayout=\"column\" layout-align=\"center start\" class=\"p-20 white-500-bg\"><span \nclass=\"md-primary-fg text-l font-weight-600\">Acciones de desarrollo</span></div><div class=\"backgroundValue p-20\"><div \nng-repeat=\"section in data.countComments track by $index\" layout=\"column\" \nng-if=\"section.goal || section.responsibility\"><div class=\"md-inline-form w-100-p\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div layout=\"column\" flex=\"50\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"md-accent-fg mr-5 text-m font-weight-600\">Objetivo</span></div><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"section.goal\"></div></div><div layout=\"row\" \nlayout-algin=\"start end\" flex=\"50\"><md-input-container class=\"w-100-p\"><label>Responsable</label><md-select \nng-model=\"section.responsibility\" disabled=\"disabled\"><md-option \nng-repeat=\"personal in data.personal_development_responsable_list\" ng-value=\"personal.id\">{{personal.value}}\n</md-option></md-select></md-input-container></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-core-value/value-evaluation/summary/default/default.html","<div class=\"mb-20 resume-skill-evaluation\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div class=\"mb-15\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div ng-if=\"!summary.errors.length && info.skillDescriptors\" \nng-repeat=\"info in data.sumaryStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"md-primary-fg text-l font-weight-600\">{{info.skillDetail.skill.name}}</span>\n</div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill.html\'\" \nng-init=\"body = info.skillDescriptors;title = data.sumaryStructure.title;config = {onlyview:true,hideevaluator:true}\">\n</div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-core-value/value-evaluation-approval/summary/default/default.html","<div class=\"mb-15 summary-skill-evaluation-approval\"><div class=\"mb-15\"><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp p-20 white-500-bg\"><div class=\"skill-approbe\" layout=\"row\" layout-align=\"start center\" \nng-if=\"data.aprobado\"><div class=\"text-l mr-5 md-primary-fg\">Competencias aprobadas</div><div><span \nclass=\"badge-status complete\">Aprobadas</span></div></div><div layout=\"column\" ng-if=\"!data.aprobado\"><div \nclass=\"skill-noapprobe mb-5\" layout=\"row\" layout-align=\"start center\"><div class=\"text-l mr-5 md-primary-fg\">\nCompetencias no aprobadas</div><div><span class=\"badge-status incomplete\">No aprobadas</span></div></div><md-divider>\n</md-divider><div layout=\"column\" class=\"mt-5\"><div class=\"twp\"><div><strong>{{ data.lastComment.empleado.name }}\n</strong><div class=\"secondary-text font-size-14\">{{data.lastComment.created_at | fecha}}</div></div><p \nclass=\"text_nl2br\">{{ data.lastComment.comment }}</p></div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-final-comment/add-comment/summary/default/default.html","<div class=\"mb-20 assistantSingle\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div class=\"mb-15\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div ng-if=\"!summary.errors.length\" layout=\"column\" class=\"p-20 white-bg\"><div layout=\"column\" \nclass=\"mtoc add-comment\" ng-repeat=\"comment in data.comments | orderBy: \'order\' track by $index\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-weight-400 mb-5\"><span class=\"md-accent-fg text-m font-weight-600\">\n{{comment.label}}</span></div><div class=\"comments-container\" layout=\"column\"><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"data.formData[comment.key]\"></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-approval/summary/default/default.html","<div id=\"hr-goal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><div id=\"summary-goal-evaluation-default\" ng-if=\"!summary.errors.length\">\n<div class=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Objetivo</span></th><th class=\"background text-center\"><span class=\"titleTable\">Meta</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Ponderación</span></th></tr></thead><tbody><tr \nng-repeat=\"goal in data.goals_data\" ng-if=\"goal.name || goal.objetivo_id\"><td class=\"w-60-p grey-100-bg\"><div \nng-bind-html=\"goal.name\" class=\"text-m text-primary mb-15\"></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\" class=\"mb-15\"><div ng-repeat=\"extra_data in data.goals_additional_data\"><div><span \nclass=\"text-primary text-m font-weight-600\">{{extra_data.label}}:</span> <span class=\"text-s text-secondary\">\n{{goal.additional_data[extra_data.value]}}</span></div></div></div><div layout=\"column\" ng-if=\"!goal.aprobado\"><span \nclass=\"text-m md-accent-fg font-weight-600\">Ajustes solicitados</span> <span class=\"text-s text-secondary\">\n{{goal.rejected_comment}}</span></div></td><td class=\"w-20-p text-center text-m text-secondary\">{{goal.meta}}</td><td \nclass=\"text-center w-20-p text-m text-secondary\">{{goal.porcentaje}}%</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-evaluation/summary/default/default.html","<div id=\"hr-goal-goal-follow-up-evaluation-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\">\n<div class=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div \nlayout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" \nng-if=\"summary.errors.length\"></ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" \nng-if=\"!summary.errors.length\"><div class=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th \nclass=\"background text-center\"><span class=\"titleTable\">Objetivo</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Meta</span></th><th class=\"background text-center\"><span class=\"titleTable\">Ponderación</span></th>\n</tr></thead><tbody><tr ng-repeat=\"goal in data.goals_data\"><td class=\"w-60-p grey-100-bg\"><div \nng-bind-html=\"goal.name\" class=\"text-m text-primary\"></div><div layout=\"column\" class=\"mt-20\" \nng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div layout=\"column\" layout-align=\"center start\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span class=\"md-primary-fg mr-5 text-m font-weight-600\">\nAutoevaluación</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.colla_result_lists_item.additional_data.selected_color}\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.colla_num_result ? goal.goal_evaluation_data.colla_num_result : goal.goal_evaluation_data.colla_result_lists_item_id ? goal.goal_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><span class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</span></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"goal.goal_evaluation_data.chief_num_result\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-5\"><span class=\"md-primary-fg mr-5 text-m font-weight-600\">Evaluación jefe</span>\n <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.chief_result_lists_item.additional_data.selected_color}\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.chief_num_result ? goal.goal_evaluation_data.chief_num_result : goal.goal_evaluation_data.chief_result_lists_item_id ? goal.goal_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><span class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</span></div></div><div \nlayout=\"column\" class=\"mt-20\" ng-if=\"goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div layout=\"column\" \nlayout-align=\"center start\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span \nclass=\"md-primary-fg mr-5 text-m font-weight-600\">Autoevaluación</span></div><span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.colla_comment}}</span></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"goal.goal_evaluation_data.chief_comment\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span \nclass=\"md-primary-fg mr-5 text-m font-weight-600\">Evaluación jefe</span></div><span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.chief_comment}}</span></div><div layout=\"column\" layout-align=\"center start\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span class=\"md-primary-fg text-m font-weight-600 mr-5\">\nEvaluación del negocio:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.corporate_goals_evaluation.result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.corporate_goals_evaluation.result_lists_item_id && goal.corporate_goals_evaluation.result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.corporate_goals_evaluation.numerical_result ? goal.corporate_goals_evaluation.numerical_result : goal.corporate_goals_evaluation.result_lists_item_id ? goal.corporate_goals_evaluation.result_lists_item.name : \'\'}}\n</span></div><span class=\"text-s text-secondary\">{{goal.corporate_goals_evaluation.comment}}</span></div></div></td><td\n class=\"w-20-p text-center text-m text-secondary\">{{goal.meta}}</td><td \nclass=\"text-center w-20-p text-m text-secondary\">{{goal.porcentaje}}%</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-evaluation-approval/summary/default/default.html","<div id=\"hr-goal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg p-20\"><div id=\"summary-goal-evaluation-default\" \nng-if=\"!summary.errors.length\"><div class=\"table-header\"><table class=\"tbl-lbl-data\"><tbody><tr \nng-repeat=\"goal in data.goals_data\" ng-if=\"goal.name || goal.objetivo_id\"><td class=\"w-80-p\"><div \nng-bind-html=\"goal.name\" class=\"text-m text-primary mr-5\"></div></td><td><div class=\"text-s mr-5\" \nng-class=\"goal.aprobado ? \'md-primary-fg\': \'md-warn-fg\'\">{{goal.aprobado ? \'Aprobado\': \'No aprobado\'}}</div></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-follow-up-evaluation/sumary/default/default.html","");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-follow-up-evaluation/summary/default/default.html","<div id=\"hr-goal-goal-follow-up-evaluation-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\">\n<div class=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div \nlayout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" \nng-if=\"summary.errors.length\"></ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" \nng-if=\"!summary.errors.length\"><div class=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th \nclass=\"background text-center\"><span class=\"titleTable\">Objetivo</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Meta</span></th><th class=\"background text-center\"><span class=\"titleTable\">Ponderación</span></th>\n</tr></thead><tbody><tr ng-repeat=\"goal in data.goals_data\"><td class=\"w-60-p grey-100-bg\"><div \nng-bind-html=\"goal.name\" class=\"text-m text-primary\"></div><div layout=\"column\" class=\"mt-20\" \nng-if=\"!goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div layout=\"column\" layout-align=\"center start\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span class=\"md-primary-fg mr-5 text-m font-weight-600\">\nAutoevaluación</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.colla_result_lists_item.additional_data.selected_color}\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.colla_num_result ? goal.goal_evaluation_data.colla_num_result : goal.goal_evaluation_data.colla_result_lists_item_id ? goal.goal_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><span class=\"text-s text-secondary\">{{goal.goal_evaluation_data.colla_comment}}</span></div><div \nlayout=\"column\" layout-align=\"center start\" \nng-if=\"goal.goal_evaluation_data.chief_num_result || goal.goal_evaluation_data.chief_result_lists_item_id\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span class=\"md-primary-fg mr-5 text-m font-weight-600\">\nEvaluación jefe</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.goal_evaluation_data.chief_result_lists_item.additional_data.selected_color}\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.chief_num_result ? goal.goal_evaluation_data.chief_num_result : goal.goal_evaluation_data.chief_result_lists_item_id ? goal.goal_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><span class=\"text-s text-secondary\">{{goal.goal_evaluation_data.chief_comment}}</span></div></div><div \nlayout=\"column\" class=\"mt-20\" ng-if=\"goal.goal_evaluation_data.corporate_goals_evaluation_id\"><div layout=\"column\" \nlayout-align=\"center start\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span \nclass=\"md-primary-fg mr-5 text-m font-weight-600\">Autoevaluación</span></div><span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.colla_comment}}</span></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"goal.goal_evaluation_data.chief_comment\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span \nclass=\"md-primary-fg mr-5 text-m font-weight-600\">Evaluación jefe</span></div><span class=\"text-s text-secondary\">\n{{goal.goal_evaluation_data.chief_comment}}</span></div><div layout=\"column\" layout-align=\"center start\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-5\"><span class=\"md-primary-fg text-m font-weight-600 mr-5\">\nEvaluación del negocio:</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':goal.corporate_goals_evaluation.result_lists_item.additional_data.selected_color}\" \nng-if=\"goal.corporate_goals_evaluation.result_lists_item_id && goal.corporate_goals_evaluation.result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{goal.corporate_goals_evaluation.numerical_result ? goal.corporate_goals_evaluation.numerical_result : goal.corporate_goals_evaluation.result_lists_item_id ? goal.corporate_goals_evaluation.result_lists_item.name : \'\'}}\n</span></div><span class=\"text-s text-secondary\">{{goal.corporate_goals_evaluation.comment}}</span></div></div></td><td\n class=\"w-20-p text-center text-m text-secondary\">{{goal.meta}}</td><td \nclass=\"text-center w-20-p text-m text-secondary\">{{goal.porcentaje}}%</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal/goal-inscription/summary/default/default.html","<div id=\"hr-goal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" ng-if=\"!summary.errors.length\"><div \nclass=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Objetivo</span></th><th class=\"background text-center\"><span class=\"titleTable\">Meta</span></th><th \nclass=\"background text-center\"><span class=\"titleTable\">Ponderación</span></th></tr></thead><tbody><tr \nng-repeat=\"goal in data.goals_data\" ng-if=\"goal.name || goal.objetivo_id\"><td class=\"w-60-p grey-100-bg\"><div \nng-bind-html=\"goal.name\" class=\"text-m text-primary\"></div></td><td class=\"w-20-p text-center text-m text-secondary\">\n{{goal.meta}}</td><td class=\"text-center w-20-p text-m text-secondary\">{{goal.porcentaje}}%</td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal-indicator/goal-evaluation/summary/default/default.html","<div id=\"hr-goal-goal-follow-up-evaluation-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\">\n<div class=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div \nlayout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" \nng-if=\"summary.errors.length\"></ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" \nng-if=\"!summary.errors.length\"><div layout=\"column\" ng-repeat=\"indicator in data.employee_indicators\" class=\"mb-15\">\n<div layout=\"row\" class=\"mb-10 p-10\"><span class=\"text-l md-primary-fg\">{{indicator.empleado.name}}</span></div><div \nclass=\"table-header white-500-bg\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Indicador</span></th><th class=\"background text-center\"><span class=\"titleTable\">Meta</span></th><th\n class=\"background text-center\"><span class=\"titleTable\">Resultado</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Cumplimiento</span></th></tr></thead><tbody><tr ng-repeat=\"evaluation in indicator.evaluations\"><td \nclass=\"w-40-p grey-100-bg\"><span class=\"text-m text-grey\">\n{{evaluation.objetivo ? evaluation.objetivo.name : evaluation.name }}</span></td><td class=\"w-20-p text-center\"><span \nclass=\"text-m text-grey\">{{evaluation.objetivo ? evaluation.objetivo.meta : evaluation.meta}}</span></td><td \nclass=\"text-center\"><span class=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_result_lists_item_id ? evaluation.goals_indicators_data.chief_result_lists_item.name : evaluation.goals_indicators_data.chief_num_result}}\n</span></td><td class=\"text-center\"><span class=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_fulfillment}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal-indicator/goal-follow-up-evaluation/summary/default/default.html","<div id=\"hr-goal-goal-follow-up-evaluation-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\">\n<div class=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div \nlayout=\"column\" class=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" \nng-if=\"summary.errors.length\"></ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" \nng-if=\"!summary.errors.length\"><div layout=\"column\" ng-repeat=\"indicator in data.employee_indicators\" class=\"mb-15\">\n<div layout=\"row\" class=\"mb-10 p-10\"><span class=\"text-l md-primary-fg\">{{indicator.empleado.name}}</span></div><div \nclass=\"table-header white-500-bg\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Indicador</span></th><th class=\"background text-center\"><span class=\"titleTable\">Meta</span></th><th\n class=\"background text-center\"><span class=\"titleTable\">Resultado</span></th><th class=\"background text-center\"><span \nclass=\"titleTable\">Cumplimiento</span></th></tr></thead><tbody><tr ng-repeat=\"evaluation in indicator.evaluations\"><td \nclass=\"w-40-p grey-100-bg\"><span class=\"text-m text-grey\">\n{{evaluation.objetivo ? evaluation.objetivo.name : evaluation.name }}</span></td><td class=\"w-20-p text-center\"><span \nclass=\"text-m text-grey\">{{evaluation.objetivo ? evaluation.objetivo.meta : evaluation.meta}}</span></td><td \nclass=\"text-center\"><span class=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_result_lists_item_id ? evaluation.goals_indicators_data.chief_result_lists_item.name : evaluation.goals_indicators_data.chief_num_result}}\n</span></td><td class=\"text-center\"><span class=\"text-m text-grey\">\n{{evaluation.goals_indicators_data.chief_fulfillment}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-goal-indicator/goal-inscription/summary/default/default.html","<div id=\"hr-goal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary></div><div id=\"summary-goal-evaluation-default\" ng-if=\"!summary.errors.length\"><div \nlayout=\"column\" ng-repeat=\"employee in data.employee_goals\" class=\"mb-15\"><div \nclass=\"table-header md-whiteframe-3dp white-500-bg\"><div class=\"background-grey-soft border-soft-top\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"p-10 border-soft-top-left\" flex=\"80\"><span class=\"text-xl md-primary-fg\">\n{{employee.empleado.name}}</span></div><div class=\"p-10 md-accent-bg border-soft-top-right\" flex=\"20\"><span \nclass=\"text-l white-fg mr-5\">Total ponderación:</span> <span class=\"text-l twhite-fg\">\n{{employee.employee.total_percentage}}</span></div></div><table class=\"tbl-lbl-data\"><thead><tr><th \nclass=\"text-center\"><span class=\"black-fg\">Indicador</span></th><th class=\"text-center\"><span class=\"black-fg\">Meta\n</span></th><th class=\"text-center\"><span class=\"black-fg\">Ponderación</span></th></tr></thead><tbody><tr \nng-repeat=\"evaluation in employee.objetivos_empleado\"><td class=\"w-40-p\"><span class=\"text-m text-grey\">\n{{evaluation.objetivo ? evaluation.objetivo.name : evaluation.name }}</span></td><td class=\"w-20-p text-center\"><span \nclass=\"text-m text-grey\">{{evaluation.objetivo ? evaluation.objetivo.meta : evaluation.meta}}</span></td><td \nclass=\"text-center\"><span class=\"text-m text-grey\">{{(evaluation.porcentaje ? evaluation.porcentaje : 0) | number:0}}\n</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-approval/summary/default/default.html","<div id=\"hr-personal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" ng-if=\"!summary.errors.length\"><div \nclass=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Acciones de desarrollo</span></th><th class=\"background text-center\"><span class=\"titleTable\">\nPonderación</span></th></tr></thead><tbody><tr ng-repeat=\"personal in data.personal_data\"><td class=\"grey-100-bg\"><div \nng-bind-html=\"personal.objetive\" class=\"text-primary text-m mb-15\"></div><div layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"start start\" class=\"mb-15\"><div><span class=\"text-primary text-m font-weight-600\">\nCompetencia relacionada: </span><span class=\"text-s text-secondary\">{{personal.skill.name}}</span></div><div><span \nclass=\"text-primary text-m font-weight-600\">Como lo voy a lograr: </span><span class=\"text-s text-secondary\">\n{{personal.how_to_achieve_it}}</span></div><div ng-repeat=\"extra_data in data.personal_dev_additional_data\"><div \nng-if=\"personal.additional_data[extra_data.value]\"><label class=\"text-primary text-m font-weight-600\">\n{{extra_data.label}}:</label><span class=\"text-s text-secondary\">{{personal.additional_data[extra_data.value]}}</span>\n</div></div></div><div layout=\"column\" ng-if=\"!personal.aprobado\"><span class=\"text-m md-accent-fg font-weight-600\">\nAjustes solicitados</span> <span class=\"text-s text-secondary\">{{personal.rejected_comment}}</span></div></td><td \nclass=\"text-center text-m text-secondary\">{{personal.porcentaje}}%</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-evaluation/summary/default/default.html","<div id=\"hr-personal-goal-follow-up-evaluation-summary\" class=\"mb-20\" \nng-if=\"vm.allowFinalize || summary.errors.length\"><div class=\"font-weight-400 mb-5\"><span \nclass=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" ng-if=\"!summary.errors.length\"><div \nclass=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Acciones de desarrollo</span></th><th class=\"background text-center\"><span class=\"titleTable\">\nPonderación</span></th></tr></thead><tbody><tr ng-repeat=\"personal in data.personal_data\"><td class=\"grey-100-bg\"><div \nng-bind-html=\"personal.objetive\" class=\"text-primary text-m\"></div><div layout=\"column\" class=\"mt-20\"><div \nlayout=\"column\" layout-align=\"center start\" class=\"mb-10\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-5\">\n<span class=\"md-primary-fg mr-5 text-m font-weight-600 mr-5\">Autoevaluación</span> <span \nclass=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.colla_result_lists_item_id && personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.colla_num_result ? personal.personal_dev_evaluation_data.colla_num_result : personal.personal_dev_evaluation_data.colla_result_lists_item_id ? personal.personal_dev_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><span class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.colla_comment}}</span></div>\n<div layout=\"column\" layout-align=\"center start\" class=\"mb-10\" \nng-if=\"personal.personal_dev_evaluation_data.chief_num_result || personal.personal_dev_evaluation_data.chief_result_lists_item_id\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"md-primary-fg mr-5 text-m font-weight-600 mr-5\">\nEvaluación jefe</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.chief_result_lists_item && personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.chief_num_result ? personal.personal_dev_evaluation_data.chief_num_result : personal.personal_dev_evaluation_data.chief_result_lists_item_id ? personal.personal_dev_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><span class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.chief_comment}}</span></div>\n</div></td><td class=\"text-center text-m text-secondary\">{{personal.porcentaje}}%</td></tr></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-evaluation-approval/summary/default/default.html","<div id=\"hr-goal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg p-20\"><div id=\"summary-goal-evaluation-default\" \nng-if=\"!summary.errors.length\"><div class=\"table-header\"><table class=\"tbl-lbl-data\"><tbody><tr \nng-repeat=\"personal in data.personal_data\"><td class=\"w-80-p\"><div ng-bind-html=\"personal.objetive\" \nclass=\"text-m text-primary mr-5\"></div></td><td><div class=\"text-s mr-5\" \nng-class=\"personal.aprobado ? \'md-primary-fg\': \'md-warn-fg\'\">{{personal.aprobado ? \'Aprobado\': \'No aprobado\'}}</div>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-follow-up-evaluation/summary/default/default.html","<div id=\"hr-personal-goal-follow-up-evaluation-summary\" class=\"mb-20\" \nng-if=\"vm.allowFinalize || summary.errors.length\"><div class=\"font-weight-400 mb-5\"><span \nclass=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" ng-if=\"!summary.errors.length\"><div \nclass=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Acciones de desarrollo</span></th><th class=\"background text-center\"><span class=\"titleTable\">\nPonderación</span></th></tr></thead><tbody><tr ng-repeat=\"personal in data.personal_data\"><td class=\"grey-100-bg\"><div \nng-bind-html=\"personal.objetive\" class=\"text-primary text-m\"></div><div layout=\"column\" class=\"mt-20\"><div \nlayout=\"column\" layout-align=\"center start\" class=\"mb-10\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-5\">\n<span class=\"md-primary-fg mr-5 text-m font-weight-600 mr-5\">Autoevaluación</span> <span \nclass=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.colla_result_lists_item_id && personal.personal_dev_evaluation_data.colla_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.colla_num_result ? personal.personal_dev_evaluation_data.colla_num_result : personal.personal_dev_evaluation_data.colla_result_lists_item_id ? personal.personal_dev_evaluation_data.colla_result_lists_item.name : \'\' }}\n</span></div><span class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.colla_comment}}</span></div>\n<div layout=\"column\" layout-align=\"center start\" class=\"mb-10\" \nng-if=\"personal.personal_dev_evaluation_data.chief_num_result || personal.personal_dev_evaluation_data.chief_result_lists_item_id\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"md-primary-fg mr-5 text-m font-weight-600 mr-5\">\nEvaluación jefe</span> <span class=\"badge-circle small mr-5\" \nng-style=\"{\'background-color\':personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data.selected_color}\" \nng-if=\"personal.personal_dev_evaluation_data.chief_result_lists_item && personal.personal_dev_evaluation_data.chief_result_lists_item.additional_data\">\n</span> <span class=\"text-s text-secondary\">\n{{personal.personal_dev_evaluation_data.chief_num_result ? personal.personal_dev_evaluation_data.chief_num_result : personal.personal_dev_evaluation_data.chief_result_lists_item_id ? personal.personal_dev_evaluation_data.chief_result_lists_item.name : \'\'}}\n</span></div><span class=\"text-s text-secondary\">{{personal.personal_dev_evaluation_data.chief_comment}}</span></div>\n</div></td><td class=\"text-center text-m text-secondary\">{{personal.porcentaje}}%</td></tr></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-personal-development/goal-inscription/summary/default/default.html","<div id=\"hr-personal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div id=\"summary-goal-evaluation-default\" ng-if=\"!summary.errors.length\"><div \nclass=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Acciones de desarrollo</span></th><th class=\"background text-center\"><span class=\"titleTable\">\nPonderación</span></th></tr></thead><tbody><tr ng-repeat=\"personal in data.personal_data\"><td class=\"grey-100-bg\"><div \nng-bind-html=\"personal.objetive\" class=\"text-primary text-m\"></div></td><td class=\"text-center text-m text-secondary\">\n{{personal.porcentaje}}%</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-poll/poll-evaluation/summary/default/default.html","<div id=\"hr-goal-goal-inscription-summary\" class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp white-500-bg\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div id=\"summary-poll-evaluation-default\" ng-if=\"!summary.errors.length\"><div \nclass=\"table-header\"><table class=\"tbl-lbl-data\"><thead><tr><th class=\"background text-center\"><span \nclass=\"titleTable\">Pregunta</span></th><th class=\"background text-center\"><span class=\"titleTable\">Respuesta</span>\n</th><th class=\"background text-center\"><span class=\"titleTable\">Comentario</span></th></tr></thead><tbody><tr \nng-repeat=\"row in data.movilidad\"><td class=\"grey-100-bg w-30-p\"><div layout=\"column\" layout-align=\"center start\"><span\n class=\"text-m text-primary mb-10\">{{row.name}}</span></div></td><td class=\"w-40-p text-justify\"><div \nng-if=\"row.answer_type == \'select\'\"><span class=\"text-m text-secondary\" \nng-repeat=\"item in row.answer_list.lists_items | filter:data.formData[row.id].result:strict\">{{item.name}}</span></div>\n<div ng-if=\"row.answer_type != \'select\'\"><span class=\"text-m text-secondary\">{{data.formData[row.id].result}}</span>\n</div></td><td class=\"text-justify w-20-p text-m text-secondary w-30-p\">\n{{data.formData[row.id].comment ? data.formData[row.id].comment : \'N/A\'}}</td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-evaluation/summary/default/default.html","<div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/summary/default/default.html\'\">\n</div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-evaluation/summary/etapas_novacion/default.html","<div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/summary/etapas_novacion/default.html\'\">\n</div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-evaluation-approval/summary/default/default.html","<div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation-approval/summary/default/default.html\'\">\n</div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/summary/default/default.html","<div class=\"mb-20 resume-skill-evaluation\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div class=\"mb-15\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div ng-if=\"!summary.errors.length && info.skillDescriptors\" \nng-repeat=\"info in data.sumaryStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"md-primary-fg text-l font-weight-600\">{{info.skillDetail.skill.name}}</span>\n</div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill.html\'\" \nng-init=\"body = info.skillDescriptors;title = data.sumaryStructure.title;config = {onlyview:true,hideevaluator:true}\">\n</div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation/summary/etapas_novacion/default.html","<div class=\"mb-20 resume-skill-evaluation\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div class=\"mb-15\"><div \nclass=\"font-weight-400 mb-5\"><span class=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp\"><ik-evaluation-summary ng-model=\"summary\" ng-if=\"summary.errors.length\">\n</ik-evaluation-summary><div ng-if=\"!summary.errors.length && info.skillDescriptors\" \nng-repeat=\"info in data.sumaryStructure.body track by $index\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"p-20 white-500-bg\"><span class=\"md-primary-fg text-l font-weight-600\">{{info.skillDetail.skill.name}}</span>\n</div><div class=\"backgroundValue\"><div \nng-include=\"\'app/main/elements/ik-hr-evaluation-action/hr-skill/template/skill.html\'\" \nng-init=\"body = info.skillDescriptors;title = data.sumaryStructure.title;config = {onlyview:true,hideevaluator:true}\">\n</div></div></div></div></div></div>");
$templateCache.put("app/main/elements/ik-hr-evaluation-action/hr-skill/skill-follow-up-evaluation-approval/summary/default/default.html","<div class=\"mb-20\" ng-if=\"vm.allowFinalize || summary.errors.length\"><div \nclass=\"mb-15 summary-skill-evaluation-approval\"><div class=\"mb-15\"><div class=\"font-weight-400 mb-5\"><span \nclass=\"md-primary-fg text-xl\">{{summary.name}}</span></div><div layout=\"column\" \nclass=\"mtoc md-whiteframe-3dp p-20 white-500-bg\"><div class=\"skill-approbe\" layout=\"row\" layout-align=\"start center\" \nng-if=\"data.aprobado\"><div class=\"text-l mr-5 md-primary-fg\">Competencias aprobadas</div><div><span \nclass=\"badge-status complete\">Aprobadas</span></div></div><div layout=\"column\" ng-if=\"!data.aprobado\"><div \nclass=\"skill-noapprobe mb-5\" layout=\"row\" layout-align=\"start center\"><div class=\"text-l mr-5 md-primary-fg\">\nCompetencias no aprobadas</div><div><span class=\"badge-status incomplete\">No aprobadas</span></div></div><md-divider>\n</md-divider><div layout=\"column\" class=\"mt-5\"><div class=\"twp\"><div><strong>{{ data.lastComment.empleado.name }}\n</strong><div class=\"secondary-text font-size-14\">{{data.lastComment.created_at | fecha}}</div></div><p \nclass=\"text_nl2br\">{{ data.lastComment.comment }}</p></div></div></div><div layout=\"column\" \nclass=\"mtoc add-comment mt-15\" ng-if=\"data.skills_approver_comment.approver_comment\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"font-weight-400 mb-5\"><span class=\"md-accent-fg text-m font-weight-600\">\nComentario general</span></div><div class=\"comments-container\" layout=\"column\"><div \nclass=\"text-s text-secondary comment-read\" ng-bind-html=\"data.skills_approver_comment.approver_comment\"></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-personal-development/dialogs/inscription-goal-list-dialog/template/default/default.html","<div class=\"p-20\"><md-input-container class=\"md-block mb-10\"><label class=\"ph field_obl\">Objetivo</label><textarea \nname=\"meta\" class=\"pp\" ng-model=\"vm.dataForm.objetive\" required md-maxlength=\"500\" maxlength=\"500\"></textarea>\n</md-input-container><md-input-container class=\"md-block mb-10\" \nng-if=\"vm.module_data.evaluation_preferences.required_skill\"><label class=\"ph field_obl\">Habilidad</label><md-select \nclass=\"pp mt-10\" ng-model=\"vm.dataForm.skill_id\" required><md-option \nng-repeat=\"value in vm.module_data.skills_profile\" ng-value=\"value.skill_id\">{{value.skill.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block mb-10\"><label class=\"ph field_obl\">\nComo lo voy a lograr</label><textarea name=\"meta\" class=\"pp\" ng-model=\"vm.dataForm.how_to_achieve_it\" required \nmd-maxlength=\"500\" maxlength=\"500\"></textarea></md-input-container><md-input-container class=\"md-block mb-10\" \nng-repeat=\"extra_data in vm.module_data.personal_dev_additional_data\"><label class=\"ph field_obl\">{{extra_data.label}}\n</label><textarea name=\"meta\" class=\"pp\" ng-model=\"vm.dataForm.additional_data[extra_data.value]\" \nng-required=\"extra_data.required\" md-maxlength=\"500\" maxlength=\"500\"></textarea></md-input-container>\n<md-input-container class=\"md-block md-default-theme md-input-has-value mb-10\"><label class=\"ph field_obl\">Ponderación\n</label><md-select class=\"pp mt-10\" ng-model=\"vm.dataForm.weight\" required><md-option ng-repeat=\"value in vm.weights\" \nng-value=\"value\">{{value}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/modules/hr-evaluation-modules/hr-personal-development/dialogs/inscription-goal-list-dialog/template/manuelita/default.html","<div class=\"p-20\"><md-input-container class=\"md-block mb-20\"><label class=\"ph field_obl\">Acción de desarrollo</label>\n<textarea name=\"meta\" class=\"pp\" ng-model=\"vm.dataForm.objetive\" required md-maxlength=\"500\" maxlength=\"500\">\n</textarea></md-input-container><md-input-container class=\"md-block mb-20\" \nng-if=\"vm.module_data.evaluation_preferences.required_skill\"><label class=\"ph field_obl\">Competencia</label><md-select \nclass=\"pp mt-10\" ng-model=\"vm.dataForm.skill_id\" required><md-option \nng-repeat=\"value in vm.module_data.skills_profile\" ng-value=\"value.skill_id\">{{value.skill.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block mb-20\"><label class=\"ph field_obl\">Plazo de acción\n</label><md-select class=\"pp mt-10\" ng-model=\"vm.dataForm.additional_data[\'action_deadline\']\" \nng-required=\"extra_data.required\" ng-change=\"vm.change(extra_data.value)\"><md-option ng-repeat=\"value in vm.auxYears\" \nng-value=\"value.id\">{{value.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block mb-20\"><label class=\"ph field_obl\">Como lo voy a lograr</label><textarea name=\"meta\" class=\"pp\" \nng-model=\"vm.dataForm.how_to_achieve_it\" required md-maxlength=\"500\" maxlength=\"500\"></textarea></md-input-container>\n<md-input-container class=\"md-block mb-20\" ng-if=\"vm.dataForm.additional_data[\'action_deadline\'] == 2\"><label \nclass=\"ph field_obl\">Meta para el segundo año</label><textarea name=\"meta\" class=\"pp\" \nng-model=\"vm.dataForm.additional_data[\'how_to_achieve_it2\']\" ng-required=\"extra_data.required\" md-maxlength=\"500\" \nmaxlength=\"500\"></textarea></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-has-value mb-20\"><label class=\"ph field_obl\">Ponderación</label><md-select \nclass=\"pp mt-10\" ng-model=\"vm.dataForm.weight\" required><md-option ng-repeat=\"value in vm.weights\" ng-value=\"value\">\n{{value}}</md-option></md-select></md-input-container></div>");}]);